import ot, { createContext as kt, useContext as pt, useMemo as K, useCallback as Q, useState as L, useEffect as Y, forwardRef as fn, useRef as qe, useImperativeHandle as Pa, Fragment as Sa, Suspense as Ut, Component as Dd, useLayoutEffect as Ld, Children as Id } from "react";
import { cva as Gt, cx as ct } from "class-variance-authority";
import $d from "clsx";
import { twMerge as Fd } from "tailwind-merge";
import { useTranslation as Zi } from "next-i18next";
import { Close as or, ErrorNotFilled as Bd, MessageInfo as Vd, ThumbsUp as qd, InfoPay as Wd, Search as Hd, Open as el, Download as Ln, Plus as cn, ArrowUpStroked as _r, Photo as Ud, CloseOutlined as Ta, CheckmarkOutlined as Gd, Bizz as Kd, CarSideView as Hr, Information as tl, CheckmarkFilled as Ea, CheckCircle as Yd, Edit as xo, OpenLinkInNew as Qd, BizzKmtoll as ka, Card as Xd, ArrowUp as Aa, ArrowRightLeft as Jd, Bankcard as Zd, Success as eu, Error as nl, Customer as tu, Warning as rl, InfoFilled as nu, Chain as ru, Undo as bo, Car as sl, Check as ir, Calendar as su, Upload as au, Trash as ou, ArrowRight as iu } from "@oresundsbron/icons";
import { Trans as lu } from "react-i18next";
import { Typography as M, Button as be, Card as nt, Box as ne, Input as me, Banner as Le, LoadingButton as et, HeadingNumber as cu, Grid as ht, Select as Oe, ReadOnlyField as Pt, Spinner as Ur, Steps as Rr, Label as xs, InputError as tr, RadioGroup as Rt, Link as Gr, Well as du, Accordion as vo, RadioGroupExpander as bs } from "@oresundsbron/bridge-ui";
import { useForm as Se, submitWithValidation as Kt, FormStoreProvider as zt, useSubscribe as He, useStepForm as Oa, withFormStore as uu, useFormStore as vs, Steps as mu, Selectors as yo } from "@oresundsbron/use-form";
import { constants as pe, addReceiptFormParser as fu, commuterVehicleParser as pu, commuterInformationParser as hu, CustomerType as In, termsOfAgreement as gu, addContractParser as xu, businessCommuter as bu, licensePlateParser as vu, addRecognitionParser as yu, editRecognitionFormParser as ju, changePasswordParser as al, WeightCategory as Ke, VehicleTypeId as ys, singleBizzOrderFlowParser as Cu, Co2VehicleGroup as Xe, tollCollectVehicleInfoHGVParser as ol, tollCollectVehicleInfoHGVParserWithOptionalVinNo as il, tollCollectVehicleInfoParser as ll, Co2VehicleSubgroup as cl, Co2EmissionClass as ze, summaryParser as dl, isBusiness as wu, newPassword as Nu, privateContactInformationParserV2 as Pu, paymentEntryParser as ul, termsOfAgreementParser as Su, businessContactInformationParser as Tu, invoiceParser as Eu } from "@oresundsbron/validators";
import * as Jt from "@radix-ui/react-alert-dialog";
import { useTypeSafeQuery as De, BackendQueryKeys as xe, useTypeSafeMutation as ke, ApiProvider as ku, useTypeSafePrefetch as jo } from "@oresundsbron/api";
import { subMonths as Au, isAfter as Ou, format as Dt, isBefore as _u, addDays as Ru, subYears as Mu } from "date-fns";
import { useQueryClient as Ye, QueryClientProvider as zu } from "@tanstack/react-query";
import * as it from "@radix-ui/react-dropdown-menu";
import { Grid as nn, ThemeProvider as Du, FilterableTable as _a, Button as Mt, Collapsable as Lu, Pagination as Kr, Spinner as Tt, Field as yt, Dropdown as Mr, Option as zr, Input as en, useMultiStepModalContext as wn, Form as Yr, ModalContent as Yt, Typography as de, ModalAction as It, Modal as lr, ModalHeader as cr, MultiStepPanel as Iu, MultiStepProvider as $u, Box as lt, RadioButtons as Fu, Notice as Lt, Step as dr, MultiStepModalButtons as pn, Column as Rn, InputAdornment as Bu, MultiStepModal as ml, BannerCard as Vu, DisplayInput as xn } from "@oresundsbron/design-system";
import { constants as on } from "@oresundsbron/utilities";
import * as vt from "@radix-ui/react-dialog";
import qu from "react-gtm-module";
import { Issuer as nr } from "@oresundsbron/type-safeguards";
import { useTheme as Wu } from "@emotion/react";
import fl from "react-dom";
import { Link as Hu } from "@radix-ui/react-navigation-menu";
import Vn from "zustand";
import * as zn from "@radix-ui/react-accordion";
import { debounce as Uu } from "lodash";
import { z as Gu } from "zod";
import { appendErrors as Ku, useForm as Nn } from "react-hook-form";
import { validateFieldsNatively as Yu, toNestErrors as Qu } from "@hookform/resolvers";
import { defaultCO2EmissionClassValue as Dn, numberOfAxelsOptions as pl, Co2CutoffDate as Dr } from "@oresundsbron/vehicle-info-service";
import { DayPicker as Xu } from "react-day-picker";
import { Lens as gt } from "monocle-ts";
function qn(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var la = { exports: {} }, Qn = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Co;
function Ju() {
  if (Co) return Qn;
  Co = 1;
  var t = ot, n = Symbol.for("react.element"), r = Symbol.for("react.fragment"), s = Object.prototype.hasOwnProperty, a = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function i(c, l, d) {
    var u, m = {}, f = null, p = null;
    d !== void 0 && (f = "" + d), l.key !== void 0 && (f = "" + l.key), l.ref !== void 0 && (p = l.ref);
    for (u in l) s.call(l, u) && !o.hasOwnProperty(u) && (m[u] = l[u]);
    if (c && c.defaultProps) for (u in l = c.defaultProps, l) m[u] === void 0 && (m[u] = l[u]);
    return { $$typeof: n, type: c, key: f, ref: p, props: m, _owner: a.current };
  }
  return Qn.Fragment = r, Qn.jsx = i, Qn.jsxs = i, Qn;
}
var Xn = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var wo;
function Zu() {
  return wo || (wo = 1, process.env.NODE_ENV !== "production" && function() {
    var t = ot, n = Symbol.for("react.element"), r = Symbol.for("react.portal"), s = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), i = Symbol.for("react.provider"), c = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), d = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), m = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), b = Symbol.iterator, h = "@@iterator";
    function g(E) {
      if (E === null || typeof E != "object")
        return null;
      var Z = b && E[b] || E[h];
      return typeof Z == "function" ? Z : null;
    }
    var v = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function y(E) {
      {
        for (var Z = arguments.length, fe = new Array(Z > 1 ? Z - 1 : 0), Ne = 1; Ne < Z; Ne++)
          fe[Ne - 1] = arguments[Ne];
        x("error", E, fe);
      }
    }
    function x(E, Z, fe) {
      {
        var Ne = v.ReactDebugCurrentFrame, Ie = Ne.getStackAddendum();
        Ie !== "" && (Z += "%s", fe = fe.concat([Ie]));
        var Ve = fe.map(function(Me) {
          return String(Me);
        });
        Ve.unshift("Warning: " + Z), Function.prototype.apply.call(console[E], console, Ve);
      }
    }
    var j = !1, w = !1, C = !1, P = !1, N = !1, R;
    R = Symbol.for("react.module.reference");
    function T(E) {
      return !!(typeof E == "string" || typeof E == "function" || E === s || E === o || N || E === a || E === d || E === u || P || E === p || j || w || C || typeof E == "object" && E !== null && (E.$$typeof === f || E.$$typeof === m || E.$$typeof === i || E.$$typeof === c || E.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      E.$$typeof === R || E.getModuleId !== void 0));
    }
    function z(E, Z, fe) {
      var Ne = E.displayName;
      if (Ne)
        return Ne;
      var Ie = Z.displayName || Z.name || "";
      return Ie !== "" ? fe + "(" + Ie + ")" : fe;
    }
    function D(E) {
      return E.displayName || "Context";
    }
    function A(E) {
      if (E == null)
        return null;
      if (typeof E.tag == "number" && y("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof E == "function")
        return E.displayName || E.name || null;
      if (typeof E == "string")
        return E;
      switch (E) {
        case s:
          return "Fragment";
        case r:
          return "Portal";
        case o:
          return "Profiler";
        case a:
          return "StrictMode";
        case d:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof E == "object")
        switch (E.$$typeof) {
          case c:
            var Z = E;
            return D(Z) + ".Consumer";
          case i:
            var fe = E;
            return D(fe._context) + ".Provider";
          case l:
            return z(E, E.render, "ForwardRef");
          case m:
            var Ne = E.displayName || null;
            return Ne !== null ? Ne : A(E.type) || "Memo";
          case f: {
            var Ie = E, Ve = Ie._payload, Me = Ie._init;
            try {
              return A(Me(Ve));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var S = Object.assign, _ = 0, $, q, U, W, G, ee, ue;
    function ce() {
    }
    ce.__reactDisabledLog = !0;
    function re() {
      {
        if (_ === 0) {
          $ = console.log, q = console.info, U = console.warn, W = console.error, G = console.group, ee = console.groupCollapsed, ue = console.groupEnd;
          var E = {
            configurable: !0,
            enumerable: !0,
            value: ce,
            writable: !0
          };
          Object.defineProperties(console, {
            info: E,
            log: E,
            warn: E,
            error: E,
            group: E,
            groupCollapsed: E,
            groupEnd: E
          });
        }
        _++;
      }
    }
    function se() {
      {
        if (_--, _ === 0) {
          var E = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: S({}, E, {
              value: $
            }),
            info: S({}, E, {
              value: q
            }),
            warn: S({}, E, {
              value: U
            }),
            error: S({}, E, {
              value: W
            }),
            group: S({}, E, {
              value: G
            }),
            groupCollapsed: S({}, E, {
              value: ee
            }),
            groupEnd: S({}, E, {
              value: ue
            })
          });
        }
        _ < 0 && y("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var H = v.ReactCurrentDispatcher, O;
    function ae(E, Z, fe) {
      {
        if (O === void 0)
          try {
            throw Error();
          } catch (Ie) {
            var Ne = Ie.stack.trim().match(/\n( *(at )?)/);
            O = Ne && Ne[1] || "";
          }
        return `
` + O + E;
      }
    }
    var ge = !1, je;
    {
      var I = typeof WeakMap == "function" ? WeakMap : Map;
      je = new I();
    }
    function F(E, Z) {
      if (!E || ge)
        return "";
      {
        var fe = je.get(E);
        if (fe !== void 0)
          return fe;
      }
      var Ne;
      ge = !0;
      var Ie = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ve;
      Ve = H.current, H.current = null, re();
      try {
        if (Z) {
          var Me = function() {
            throw Error();
          };
          if (Object.defineProperty(Me.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Me, []);
            } catch (Xt) {
              Ne = Xt;
            }
            Reflect.construct(E, [], Me);
          } else {
            try {
              Me.call();
            } catch (Xt) {
              Ne = Xt;
            }
            E.call(Me.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Xt) {
            Ne = Xt;
          }
          E();
        }
      } catch (Xt) {
        if (Xt && Ne && typeof Xt.stack == "string") {
          for (var Re = Xt.stack.split(`
`), dt = Ne.stack.split(`
`), Ge = Re.length - 1, Qe = dt.length - 1; Ge >= 1 && Qe >= 0 && Re[Ge] !== dt[Qe]; )
            Qe--;
          for (; Ge >= 1 && Qe >= 0; Ge--, Qe--)
            if (Re[Ge] !== dt[Qe]) {
              if (Ge !== 1 || Qe !== 1)
                do
                  if (Ge--, Qe--, Qe < 0 || Re[Ge] !== dt[Qe]) {
                    var Nt = `
` + Re[Ge].replace(" at new ", " at ");
                    return E.displayName && Nt.includes("<anonymous>") && (Nt = Nt.replace("<anonymous>", E.displayName)), typeof E == "function" && je.set(E, Nt), Nt;
                  }
                while (Ge >= 1 && Qe >= 0);
              break;
            }
        }
      } finally {
        ge = !1, H.current = Ve, se(), Error.prepareStackTrace = Ie;
      }
      var On = E ? E.displayName || E.name : "", go = On ? ae(On) : "";
      return typeof E == "function" && je.set(E, go), go;
    }
    function We(E, Z, fe) {
      return F(E, !1);
    }
    function oe(E) {
      var Z = E.prototype;
      return !!(Z && Z.isReactComponent);
    }
    function le(E, Z, fe) {
      if (E == null)
        return "";
      if (typeof E == "function")
        return F(E, oe(E));
      if (typeof E == "string")
        return ae(E);
      switch (E) {
        case d:
          return ae("Suspense");
        case u:
          return ae("SuspenseList");
      }
      if (typeof E == "object")
        switch (E.$$typeof) {
          case l:
            return We(E.render);
          case m:
            return le(E.type, Z, fe);
          case f: {
            var Ne = E, Ie = Ne._payload, Ve = Ne._init;
            try {
              return le(Ve(Ie), Z, fe);
            } catch {
            }
          }
        }
      return "";
    }
    var _e = Object.prototype.hasOwnProperty, $e = {}, ie = v.ReactDebugCurrentFrame;
    function ye(E) {
      if (E) {
        var Z = E._owner, fe = le(E.type, E._source, Z ? Z.type : null);
        ie.setExtraStackFrame(fe);
      } else
        ie.setExtraStackFrame(null);
    }
    function we(E, Z, fe, Ne, Ie) {
      {
        var Ve = Function.call.bind(_e);
        for (var Me in E)
          if (Ve(E, Me)) {
            var Re = void 0;
            try {
              if (typeof E[Me] != "function") {
                var dt = Error((Ne || "React class") + ": " + fe + " type `" + Me + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof E[Me] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw dt.name = "Invariant Violation", dt;
              }
              Re = E[Me](Z, Me, Ne, fe, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ge) {
              Re = Ge;
            }
            Re && !(Re instanceof Error) && (ye(Ie), y("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Ne || "React class", fe, Me, typeof Re), ye(null)), Re instanceof Error && !(Re.message in $e) && ($e[Re.message] = !0, ye(Ie), y("Failed %s type: %s", fe, Re.message), ye(null));
          }
      }
    }
    var Ae = Array.isArray;
    function J(E) {
      return Ae(E);
    }
    function Pe(E) {
      {
        var Z = typeof Symbol == "function" && Symbol.toStringTag, fe = Z && E[Symbol.toStringTag] || E.constructor.name || "Object";
        return fe;
      }
    }
    function Te(E) {
      try {
        return te(E), !1;
      } catch {
        return !0;
      }
    }
    function te(E) {
      return "" + E;
    }
    function B(E) {
      if (Te(E))
        return y("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Pe(E)), te(E);
    }
    var k = v.ReactCurrentOwner, X = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Ce, Ee, Fe;
    Fe = {};
    function _t(E) {
      if (_e.call(E, "ref")) {
        var Z = Object.getOwnPropertyDescriptor(E, "ref").get;
        if (Z && Z.isReactWarning)
          return !1;
      }
      return E.ref !== void 0;
    }
    function qt(E) {
      if (_e.call(E, "key")) {
        var Z = Object.getOwnPropertyDescriptor(E, "key").get;
        if (Z && Z.isReactWarning)
          return !1;
      }
      return E.key !== void 0;
    }
    function wd(E, Z) {
      if (typeof E.ref == "string" && k.current && Z && k.current.stateNode !== Z) {
        var fe = A(k.current.type);
        Fe[fe] || (y('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', A(k.current.type), E.ref), Fe[fe] = !0);
      }
    }
    function Nd(E, Z) {
      {
        var fe = function() {
          Ce || (Ce = !0, y("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Z));
        };
        fe.isReactWarning = !0, Object.defineProperty(E, "key", {
          get: fe,
          configurable: !0
        });
      }
    }
    function Pd(E, Z) {
      {
        var fe = function() {
          Ee || (Ee = !0, y("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", Z));
        };
        fe.isReactWarning = !0, Object.defineProperty(E, "ref", {
          get: fe,
          configurable: !0
        });
      }
    }
    var Sd = function(E, Z, fe, Ne, Ie, Ve, Me) {
      var Re = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: E,
        key: Z,
        ref: fe,
        props: Me,
        // Record the component responsible for creating this element.
        _owner: Ve
      };
      return Re._store = {}, Object.defineProperty(Re._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Re, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ne
      }), Object.defineProperty(Re, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ie
      }), Object.freeze && (Object.freeze(Re.props), Object.freeze(Re)), Re;
    };
    function Td(E, Z, fe, Ne, Ie) {
      {
        var Ve, Me = {}, Re = null, dt = null;
        fe !== void 0 && (B(fe), Re = "" + fe), qt(Z) && (B(Z.key), Re = "" + Z.key), _t(Z) && (dt = Z.ref, wd(Z, Ie));
        for (Ve in Z)
          _e.call(Z, Ve) && !X.hasOwnProperty(Ve) && (Me[Ve] = Z[Ve]);
        if (E && E.defaultProps) {
          var Ge = E.defaultProps;
          for (Ve in Ge)
            Me[Ve] === void 0 && (Me[Ve] = Ge[Ve]);
        }
        if (Re || dt) {
          var Qe = typeof E == "function" ? E.displayName || E.name || "Unknown" : E;
          Re && Nd(Me, Qe), dt && Pd(Me, Qe);
        }
        return Sd(E, Re, dt, Ie, Ne, k.current, Me);
      }
    }
    var ps = v.ReactCurrentOwner, co = v.ReactDebugCurrentFrame;
    function An(E) {
      if (E) {
        var Z = E._owner, fe = le(E.type, E._source, Z ? Z.type : null);
        co.setExtraStackFrame(fe);
      } else
        co.setExtraStackFrame(null);
    }
    var hs;
    hs = !1;
    function gs(E) {
      return typeof E == "object" && E !== null && E.$$typeof === n;
    }
    function uo() {
      {
        if (ps.current) {
          var E = A(ps.current.type);
          if (E)
            return `

Check the render method of \`` + E + "`.";
        }
        return "";
      }
    }
    function Ed(E) {
      return "";
    }
    var mo = {};
    function kd(E) {
      {
        var Z = uo();
        if (!Z) {
          var fe = typeof E == "string" ? E : E.displayName || E.name;
          fe && (Z = `

Check the top-level render call using <` + fe + ">.");
        }
        return Z;
      }
    }
    function fo(E, Z) {
      {
        if (!E._store || E._store.validated || E.key != null)
          return;
        E._store.validated = !0;
        var fe = kd(Z);
        if (mo[fe])
          return;
        mo[fe] = !0;
        var Ne = "";
        E && E._owner && E._owner !== ps.current && (Ne = " It was passed a child from " + A(E._owner.type) + "."), An(E), y('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', fe, Ne), An(null);
      }
    }
    function po(E, Z) {
      {
        if (typeof E != "object")
          return;
        if (J(E))
          for (var fe = 0; fe < E.length; fe++) {
            var Ne = E[fe];
            gs(Ne) && fo(Ne, Z);
          }
        else if (gs(E))
          E._store && (E._store.validated = !0);
        else if (E) {
          var Ie = g(E);
          if (typeof Ie == "function" && Ie !== E.entries)
            for (var Ve = Ie.call(E), Me; !(Me = Ve.next()).done; )
              gs(Me.value) && fo(Me.value, Z);
        }
      }
    }
    function Ad(E) {
      {
        var Z = E.type;
        if (Z == null || typeof Z == "string")
          return;
        var fe;
        if (typeof Z == "function")
          fe = Z.propTypes;
        else if (typeof Z == "object" && (Z.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        Z.$$typeof === m))
          fe = Z.propTypes;
        else
          return;
        if (fe) {
          var Ne = A(Z);
          we(fe, E.props, "prop", Ne, E);
        } else if (Z.PropTypes !== void 0 && !hs) {
          hs = !0;
          var Ie = A(Z);
          y("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Ie || "Unknown");
        }
        typeof Z.getDefaultProps == "function" && !Z.getDefaultProps.isReactClassApproved && y("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Od(E) {
      {
        for (var Z = Object.keys(E.props), fe = 0; fe < Z.length; fe++) {
          var Ne = Z[fe];
          if (Ne !== "children" && Ne !== "key") {
            An(E), y("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ne), An(null);
            break;
          }
        }
        E.ref !== null && (An(E), y("Invalid attribute `ref` supplied to `React.Fragment`."), An(null));
      }
    }
    function ho(E, Z, fe, Ne, Ie, Ve) {
      {
        var Me = T(E);
        if (!Me) {
          var Re = "";
          (E === void 0 || typeof E == "object" && E !== null && Object.keys(E).length === 0) && (Re += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var dt = Ed();
          dt ? Re += dt : Re += uo();
          var Ge;
          E === null ? Ge = "null" : J(E) ? Ge = "array" : E !== void 0 && E.$$typeof === n ? (Ge = "<" + (A(E.type) || "Unknown") + " />", Re = " Did you accidentally export a JSX literal instead of a component?") : Ge = typeof E, y("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ge, Re);
        }
        var Qe = Td(E, Z, fe, Ie, Ve);
        if (Qe == null)
          return Qe;
        if (Me) {
          var Nt = Z.children;
          if (Nt !== void 0)
            if (Ne)
              if (J(Nt)) {
                for (var On = 0; On < Nt.length; On++)
                  po(Nt[On], E);
                Object.freeze && Object.freeze(Nt);
              } else
                y("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              po(Nt, E);
        }
        return E === s ? Od(Qe) : Ad(Qe), Qe;
      }
    }
    function _d(E, Z, fe) {
      return ho(E, Z, fe, !0);
    }
    function Rd(E, Z, fe) {
      return ho(E, Z, fe, !1);
    }
    var Md = Rd, zd = _d;
    Xn.Fragment = s, Xn.jsx = Md, Xn.jsxs = zd;
  }()), Xn;
}
process.env.NODE_ENV === "production" ? la.exports = Ju() : la.exports = Zu();
var e = la.exports;
const em = [
  "relative",
  "isolate",
  "inline-flex",
  "cursor-pointer",
  "items-center",
  "justify-center",
  "gap-2",
  "border-2",
  "text-sm",
  "font-bold",
  "w-max-content",
  "text-center",
  "break-words",
  "overflow-hidden",
  "aria-disabled:pointer-events-none",
  "aria-disabled:select-none",
  "aria-disabled:opacity-60",
  "rounded-full",
  "overflow-hidden",
  "leading-5",
  "focus-visible:outline",
  "focus-visible:border-black",
  "focus-visible:outline-8",
  "focus-visible:outline-offset-4"
], tm = Gt([...em], {
  variants: {
    intent: {
      primary: "bg-primary-700 border-primary-700 text-white hover:bg-primary-900 hover:border-primary-900 focus-visible:outline-primary-700/30",
      outline: "border-primary-700 text-primary-700 hover:bg-primary-700 hover:text-white",
      ghost: "bg-transparent border-transparent text-primary-700 underline hover:text-primary-900 hover:bg-neutral-100 focus-visible:text-primary-900 focus-visible:outline-neutral-200",
      danger: "border-red-600 text-red-600 hover:bg-red-600 hover:text-white focus-visible:bg-red-600 focus-visible:text-white focus-visible:outline-red-100"
    },
    disabled: {
      true: "opacity-30 pointer-events-none"
    },
    size: {
      default: "font-semibold text-sm py-3 px-6",
      sm: "font-semibold text-xs py-2 px-4",
      lg: "font-bold text-lg py-6 px-8"
    }
  }
}), nm = (...t) => Fd($d(...t)), Q0 = ({
  intent: t,
  size: n,
  children: r,
  disabled: s,
  startIcon: a,
  endIcon: o,
  loading: i,
  className: c,
  ...l
}) => /* @__PURE__ */ e.jsxs(
  "button",
  {
    className: nm(
      "p-4",
      tm({ intent: t, size: n, disabled: s }),
      c
    ),
    disabled: s || i,
    ...l,
    children: [
      i ? /* @__PURE__ */ e.jsx(Wn, { className: "absolute h-5 w-5" }) : null,
      a ? /* @__PURE__ */ e.jsx("span", { children: a }) : null,
      /* @__PURE__ */ e.jsx("span", { className: i ? "invisible" : "", children: r }),
      o ? /* @__PURE__ */ e.jsx("span", { children: o }) : null
    ]
  }
), vn = ot.forwardRef(
  ({ label: t, heading: n, disabled: r, error: s, className: a, onChange: o, ...i }, c) => {
    const l = `cb-${Math.random().toString(36).substring(2, 9)}`;
    return /* @__PURE__ */ e.jsx("div", { className: ct(a, r ? "opacity-30" : void 0), children: /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-3 pr-3", children: [
      /* @__PURE__ */ e.jsx("span", { className: "block text-sm font-medium text-neutral-950", children: n }),
      /* @__PURE__ */ e.jsxs("div", { className: "flex items-center", children: [
        /* @__PURE__ */ e.jsx(
          "input",
          {
            id: l,
            ref: c,
            onChange: o,
            disabled: r,
            ...i,
            className: "border-1 hover:ring-inset-2 hover:border-1 checked:bg-primary-800 checked:ring-primary-400 hover:border-primary-500 h-4 w-4 flex-shrink-0 cursor-pointer appearance-none rounded border border-neutral-500 checked:border-2 checked:border-white checked:ring-2 hover:checked:border-white",
            type: "checkbox"
          }
        ),
        /* @__PURE__ */ e.jsx(
          "label",
          {
            htmlFor: l,
            className: "ml-3 flex gap-3 text-sm text-neutral-900",
            children: t && /* @__PURE__ */ e.jsx("p", { children: t })
          }
        )
      ] }),
      s && /* @__PURE__ */ e.jsx("span", { className: "w-fit rounded-md bg-red-50 px-4 py-2 text-sm text-red-600", children: s })
    ] }) });
  }
);
vn.displayName = "Checkbox";
const X0 = ({ text: t, onClick: n }) => /* @__PURE__ */ e.jsx(
  "button",
  {
    className: `
        bg-primary-500
        hover:bg-primary-700 
        rounded 
        px-4 py-2 
        font-bold 
        text-white
      `,
    onClick: n,
    children: t
  }
);
function bt(t = !1, n, r) {
  const { data: s, error: a, refetch: o } = De(
    xe.Agreements(
      n ? {
        contractNo: n
      } : {}
    ),
    ({ Contract: i }) => n ? i.byContractNo(n) : i.contractList,
    { suspense: t, enabled: !r || !!n }
  );
  return { data: s, error: a, refetch: o };
}
const Qr = kt(
  void 0
), ve = () => {
  const t = pt(Qr);
  if (!t)
    throw new Error("useNextContext must be used within a NextProvider");
  return t;
};
function hn() {
  var s;
  const { data: t } = bt(), { query: n } = ve(), r = n.contract;
  return r || ((s = t == null ? void 0 : t.paymentAgreement) == null ? void 0 : s.contractNo);
}
function ur() {
  const t = hn();
  return De(
    xe.PeriodCard({
      contractNo: t
    }),
    ({ PeriodCard: n }) => n.byContract(t),
    {
      enabled: !!t,
      retry: 0
    }
  );
}
function Ra(t) {
  return De(
    xe.PeriodCard({
      contractNo: t
    }),
    ({ PeriodCard: n }) => n.byContract(t),
    {
      enabled: !!t,
      retry: 0
    }
  );
}
function Ma(t = !1, n, r) {
  const { data: s, error: a, refetch: o } = De(
    xe.BusinessContractsList,
    ({ Contract: i }) => i.businessContracts({ hideClosedVehicles: r }),
    {
      suspense: t,
      onSuccess(i) {
        n == null || n(i);
      }
    }
  );
  return { data: s, error: a, refetch: o };
}
const rm = () => typeof window > "u", sm = {
  sv: "SE",
  da: "DK",
  de: "DE"
}, am = () => (rm() ? "" : window.navigator.language) || "", dn = (t) => {
  const n = sm[t], r = am();
  return n || r || "";
}, Mn = ["DK", "SE", "DE", "NO"], hl = (t) => ({
  compare: (n, r) => {
    const s = Mn.indexOf(t(n) || ""), a = Mn.indexOf(t(r) || ""), o = s !== -1, i = a !== -1;
    return o && i ? s - a : o ? -1 : i ? 1 : 0;
  }
}), gl = (t) => (n) => ({
  compare: (r, s) => {
    const a = t(r) === dn(n), o = t(s) === dn(n);
    return a === o ? 0 : a ? -1 : 1;
  }
}), xl = (t) => ({
  compare: (n, r) => {
    const s = t(n), a = t(r);
    return s.localeCompare(a);
  }
}), bl = (t, n) => (r, s) => {
  const a = hl(
    (c) => c.value
  ).compare(r, s);
  if (a !== 0) return a;
  const o = gl(
    (c) => c.value
  )(t).compare(r, s);
  return o !== 0 ? o : xl(
    (c) => n ? c.value : c.key
  ).compare(r, s);
};
function $t(t = !1) {
  const { locale: n } = ve(), { data: r } = De(
    xe.CountryList({ locale: n }),
    (s) => s.Country.list(n || ""),
    { staleTime: 1 / 0 }
  );
  return K(() => {
    const s = bl(n || "", t);
    return (r || []).slice().sort(s);
  }, [r, n, t]);
}
const om = (t) => t.map((n) => ({ ...n, label: n.key }));
function vl() {
  const { locale: t } = ve(), { data: n } = De(
    xe.CountryList({ locale: t }),
    (r) => r.Country.list(t || ""),
    { staleTime: 1 / 0 }
  );
  return K(() => {
    const r = bl(t || "", !1), s = (n || []).slice().sort(r), a = om(s), o = a.filter((c) => Mn.includes(c.value)).sort(
      (c, l) => Mn.indexOf(c.value) - Mn.indexOf(l.value)
    ), i = a.filter(
      (c) => !Mn.includes(c.value)
    );
    return [
      {
        children: o,
        group: { label: "form.labels.popular" }
      },
      {
        children: i,
        group: { label: "form.labels.countries" }
      }
    ];
  }, [n, t]);
}
function im() {
  const { locale: t } = ve(), n = K(
    () => new Intl.DisplayNames([t || ""], { type: "region", style: "short" }),
    [t]
  );
  return Q(
    (r) => {
      try {
        return n.of(r) || void 0;
      } catch {
        return;
      }
    },
    [n]
  );
}
function tt({ suspense: t } = { suspense: !0 }) {
  const n = Ye(), r = hn(), { data: s, isLoading: a } = De(
    xe.CustomerInformation(),
    ({ Customer: l }) => l.get,
    { suspense: t, staleTime: 1 / 0 }
  ), { mutateAsync: o, isLoading: i } = ke(
    ["customerInformationMutation"],
    ({ Customer: l }) => l.updateCustomer,
    {
      onSuccess: () => {
        const l = r;
        n.invalidateQueries(xe.CustomerInformation()), n.invalidateQueries(xe.Agreements({})), n.invalidateQueries(
          xe.Agreements({ contractNo: l })
        ), n.invalidateQueries(xe.BusinessCommutersList), n.invalidateQueries(xe.PaymentAgreementList), n.invalidateQueries(xe.BusinessContractsList);
      }
    }
  ), c = Q(
    async (l) => {
      try {
        return await o({ ...s, ...l }), { success: !0 };
      } catch (d) {
        return { success: !1, error: d.error ?? "Unknown Error" };
      }
    },
    [s, o]
  );
  return {
    customerInformation: s,
    updateCustomer: c,
    isLoading: a,
    isUpdating: i
  };
}
const za = kt(void 0), V = (t, n) => {
  const r = pt(za);
  if (!r)
    throw new Error(
      "useTranslation must be used within an TranslationProvider"
    );
  const { i18n: s } = r;
  return Zi(t, { ...n, i18n: s });
};
function At() {
  const { locale: t } = ve(), { t: n } = V(["common"], {
    nsMode: "fallback"
  }), { data: r } = De(
    xe.ClimateList({ locale: t }),
    (c) => c.Climate.list(t || ""),
    { staleTime: 1 / 0 }
  ), s = K(
    () => (r == null ? void 0 : r.fuelTypeHybridIDs) || [],
    [r == null ? void 0 : r.fuelTypeHybridIDs]
  ), a = K(
    () => ((r == null ? void 0 : r.fuelTypes) || []).map((c) => ({
      label: n(`fuelTypes.${c.key}`),
      value: c.value,
      tariffClassification: c.tariffClassification
    })),
    [r == null ? void 0 : r.fuelTypes, n]
  ), o = K(
    () => ((r == null ? void 0 : r.emissionClasses) || []).map((c) => ({
      label: n(`emissionClasses.${c.key}`),
      value: c.value
    })),
    [r == null ? void 0 : r.emissionClasses, n]
  ), i = K(
    () => ((r == null ? void 0 : r.co2EmissionClasses) || []).map(({ key: c, value: l }) => ({
      label: n(`co2EmissionClass.${c}`),
      value: l
    })),
    [r == null ? void 0 : r.co2EmissionClasses, n]
  );
  return {
    fuelTypes: a,
    fuelTypeHybridIDs: s,
    emissionClasses: o,
    co2EmissionClasses: i
  };
}
function lm() {
  const { data: t, isLoading: n } = De(
    xe.InvoiceStatuses(),
    ({ Customer: r }) => r.invoiceStatuses(),
    { keepPreviousData: !0 }
  );
  return {
    data: t,
    isLoading: n
  };
}
function Xr(t = !1, n) {
  const { customerInformation: r } = tt(), s = (r == null ? void 0 : r.customerType) === "business-commuter", {
    data: a,
    error: o,
    refetch: i
  } = De(
    xe.PaymentAgreementList,
    ({ Contract: c }) => c.paymentAgreementList,
    {
      suspense: t,
      onSuccess(c) {
        n == null || n(c);
      },
      enabled: !s
    }
  );
  return { contracts: a, error: o, refetch: i };
}
function Pn() {
  const { mutateAsync: t } = ke(
    ["validate", "alpr"],
    (n) => n.Alpr.validate
  );
  return Q(
    (n) => async (r) => {
      try {
        await t(r);
        return;
      } catch {
        return n;
      }
    },
    [t]
  );
}
function yl() {
  const { tokens: t } = Wu(), [n, r] = L({
    isMobile: !1,
    isTablet: !1,
    isDesktop: !1
  });
  return Y(() => {
    function s() {
      var a;
      r({
        isMobile: window.matchMedia("screen and (max-width: 639px)").matches,
        isTablet: window.matchMedia(
          `screen and (min-width: ${(a = t == null ? void 0 : t.breakpoints) == null ? void 0 : a.sm})`
        ).matches,
        isDesktop: window.matchMedia("screen and (max-width: 1200px)").matches
      });
    }
    return window.addEventListener("resize", s), s(), () => window.removeEventListener("resize", s);
  }, [r, t]), n;
}
function Jr(t) {
  const { country: n, licensePlate: r } = t || {};
  return De(
    xe.VehicleInfo(t),
    ({ VehicleInfo: s }) => s.getBilvVehicleInfo(n, r),
    {
      enabled: !!t && !!n && !!r,
      retry: 0
    }
  );
}
function Zr() {
  const { data: t } = De(
    xe.CountryListBvSupported(),
    (n) => n.VehicleInfo.getBilvEnableCountries()
  );
  return t;
}
const jl = kt(
  void 0
), J0 = ({
  children: t
}) => {
  const [n, r] = L(!0), s = pt(Qr);
  return Y(() => {
    const a = () => {
      r(!0);
    };
    return s == null || s.events.on("routeChangeStart", a), () => {
      s == null || s.events.off("routeChangeStart", a);
    };
  }, [s == null ? void 0 : s.events]), /* @__PURE__ */ e.jsx(jl.Provider, { value: { isBannerVisible: n, setBannerVisible: r }, children: t });
}, Da = () => {
  const t = pt(jl), n = pt(Qr);
  if (!t)
    throw new Error(
      `useBanner must be used within a BannerVisibilityProvider. Route: ${n == null ? void 0 : n.pathname}`
    );
  return t;
};
function Cl() {
  const { data: t, isLoading: n } = De(
    ["getVerifyContactDetailsDate"],
    ({ Customer: a }) => a.getVerifyContactDetailsDate()
  );
  let r = !1;
  if (!n && t) {
    const a = t == null ? void 0 : t.verifiedContactDetailsDate, o = Au(/* @__PURE__ */ new Date(), 6);
    r = !(a && Ou(new Date(a), o));
  }
  const { mutateAsync: s } = ke(
    ["setVerifyContactDetailsDate"],
    (a) => a.Customer.setVerifyContactDetailsDate
  );
  return { contactDetailsNeedsValidation: r, setVerifyContactDetailsDate: s };
}
const Z0 = () => {
  const { t } = V(["account"], { fallbackLng: "en" });
  return /* @__PURE__ */ e.jsx("p", { children: t("agreement.action.add") });
}, rt = fn(
  ({
    label: t,
    description: n,
    error: r,
    required: s = !1,
    className: a,
    classNames: o,
    disabled: i = !1,
    type: c = "text",
    icon: l,
    ...d
  }, u) => /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: `${a} ${(o == null ? void 0 : o.wrapper) || ""} ${i ? "opacity-30" : ""} `,
      children: [
        t && /* @__PURE__ */ e.jsxs(
          "label",
          {
            className: `block text-sm font-medium ${(o == null ? void 0 : o.label) || ""} ${r ? "text-red-500" : "text-neutral-950"} ${i ? "text-neutral-400" : ""}`,
            children: [
              t,
              s && /* @__PURE__ */ e.jsx("span", { children: " *" }),
              n && /* @__PURE__ */ e.jsx("p", { className: "mt-2 text-sm font-normal text-neutral-800", children: n })
            ]
          }
        ),
        /* @__PURE__ */ e.jsxs("div", { className: "relative", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "relative", children: [
            /* @__PURE__ */ e.jsx(
              "input",
              {
                ...d,
                ref: u,
                type: c,
                className: `border-1 relative mt-2 flex h-[48px] w-full appearance-none items-center justify-end rounded-[4px] border bg-white px-3 py-4 text-base font-normal focus:border-0 focus:outline-neutral-900 focus:ring-offset-1 focus-visible:ring  
                ${(o == null ? void 0 : o.input) || ""}
                ${l ? "pr-10" : ""}
                ${r ? "border-red-500" : "border-neutral-500"} 
                ${i ? "cursor-not-allowed border-neutral-300 bg-neutral-200" : ""}
                `,
                tabIndex: 0,
                disabled: i
              }
            ),
            l && /* @__PURE__ */ e.jsx(
              "span",
              {
                className: "absolute right-0 top-0  flex h-full items-center justify-center p-3",
                children: l
              }
            )
          ] }),
          r && /* @__PURE__ */ e.jsx("p", { className: "mt-2 rounded-[4px] bg-red-50 p-2 text-base font-normal text-red-600", children: r })
        ] })
      ]
    }
  )
);
rt.displayName = "InputField";
const La = () => /* @__PURE__ */ e.jsx("div", { className: "flex h-dvh items-center justify-center bg-white p-20 opacity-50", children: /* @__PURE__ */ e.jsx(Wn, { className: "m-auto" }) }), Wn = ({ className: t }) => /* @__PURE__ */ e.jsx(
  "span",
  {
    className: ct(
      "border-b-primary-600 inline-block h-24 w-24 animate-spin rounded-full border-8 border-solid border-neutral-200",
      t
    )
  }
), st = ({
  colorMode: t,
  children: n,
  dismiss: r = !1,
  size: s = "small",
  hideIcon: a = !1,
  className: o,
  title: i
}) => {
  const [c, l] = L(!0), d = () => {
    l(!1);
  };
  if (!c)
    return null;
  const u = (g = "information") => {
    switch (g) {
      case "information":
        return "bg-blue-100 text-blue-800 ";
      case "success":
        return "bg-green-100 text-green-800 ";
      case "warning":
        return "bg-yellow-100 text-yellow-800 ";
      case "error":
        return "bg-red-100 text-red-800";
    }
  }, m = (g) => {
    switch (g) {
      case "big":
        return {
          container: "gap-8 ",
          textAndTitle: "text-base flex flex-col gap-4",
          iconSize: 48,
          titleSize: "text-[30px]",
          padding: "p-8"
        };
      default:
        return {
          container: "gap-4",
          textAndTitle: "text-sm",
          iconSize: 16,
          titleSize: "",
          padding: "p-4"
        };
    }
  }, f = (g = "information") => {
    switch (g) {
      case "information":
        return /* @__PURE__ */ e.jsx(Wd, { width: p.iconSize, height: p.iconSize });
      case "success":
        return /* @__PURE__ */ e.jsx(
          qd,
          {
            width: p.iconSize,
            height: p.iconSize
          }
        );
      case "warning":
        return /* @__PURE__ */ e.jsx(
          Vd,
          {
            width: p.iconSize,
            height: p.iconSize
          }
        );
      case "error":
        return /* @__PURE__ */ e.jsx(
          Bd,
          {
            width: p.iconSize,
            height: p.iconSize
          }
        );
    }
  }, p = m(s), b = u(t), h = f(t);
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: `flex justify-between ${p.padding} )} 
        rounded-xl  ${b} ${p.container} ${o}`,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: `flex gap-4 ${p.container}`, children: [
          !a && /* @__PURE__ */ e.jsx("div", { children: h }),
          /* @__PURE__ */ e.jsxs("div", { className: `max-w-prose  ${p.textAndTitle}`, children: [
            /* @__PURE__ */ e.jsxs("span", { className: `font-semibold ${p.titleSize}`, children: [
              i,
              " "
            ] }),
            n
          ] })
        ] }),
        r ? /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
          or,
          {
            height: 16,
            width: 16,
            className: "cursor-pointer self-end",
            onClick: d
          }
        ) }) : null
      ]
    }
  ) });
}, wl = ({
  label: t,
  description: n,
  placeholder: r,
  className: s,
  disabled: a,
  setQuery: o,
  query: i,
  ...c
}) => /* @__PURE__ */ e.jsx("div", { className: `${s} ${a ? "opacity-32" : ""}`, children: /* @__PURE__ */ e.jsxs("label", { className: "block text-sm font-medium text-neutral-950", children: [
  t,
  n && /* @__PURE__ */ e.jsx("p", { className: "mt-2 text-sm font-normal text-neutral-800", children: n }),
  /* @__PURE__ */ e.jsxs("div", { className: "relative", children: [
    /* @__PURE__ */ e.jsx(
      "input",
      {
        ...c,
        value: i,
        onChange: (l) => o(l.target.value),
        className: "border-1 search-cancel:appearance-none relative mt-2 flex h-[48px] w-full appearance-none items-center justify-end rounded-[4px] border border-neutral-500 bg-white px-3 py-4 focus:border-0 focus:border-none focus:border-neutral-950 focus:outline-neutral-900 focus:ring-offset-1 focus-visible:ring [&::-webkit-search-cancel-button]:hidden",
        type: "search",
        disabled: a,
        tabIndex: 0,
        placeholder: r
      }
    ),
    /* @__PURE__ */ e.jsx("div", { className: "absolute right-0 top-4 pr-3", children: /* @__PURE__ */ e.jsx(Hd, { className: "h-4 w-4" }) })
  ] })
] }) }), mt = fn(
  ({
    label: t,
    description: n,
    options: r,
    className: s,
    classNames: a,
    placeholder: o,
    onChange: i,
    required: c = !1,
    disabled: l = !1,
    error: d,
    initialValue: u,
    resetValueOnOptionsChange: m
  }, f) => {
    const [p, b] = L(!1), h = qe(!1), [g, v] = L(u), y = r.find((N) => N.value === g), x = qe(null), j = () => {
      l || b(!p);
    }, w = (N) => {
      l || (v(N.value), b(!1), i == null || i(N.value));
    }, C = (N) => {
      x.current && !x.current.contains(N.target) && b(!1);
    }, P = (N, R) => {
      (N.key === "Enter" || N.key === " ") && w(R);
    };
    return Pa(f, () => x.current), Y(() => {
      v(u);
    }, [u]), Y(() => (document.addEventListener("mousedown", C), () => {
      document.removeEventListener("mousedown", C);
    }), []), Y(() => {
      h.current && m ? v(void 0) : h.current = !0;
    }, [r, m]), /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: `${(a == null ? void 0 : a.wrapper) || ""} ${s} ${l ? "opacity-32" : ""}`,
        ref: x,
        children: [
          t && /* @__PURE__ */ e.jsxs(
            "label",
            {
              className: `block text-sm font-medium text-neutral-950 ${(a == null ? void 0 : a.label) || ""}
            ${d ? "text-red-500" : "text-neutral-950"} ${l ? "text-neutral-400" : ""} `,
              children: [
                t,
                c && /* @__PURE__ */ e.jsx("span", { children: " *" }),
                n && /* @__PURE__ */ e.jsx(
                  "p",
                  {
                    className: `mt-2 text-sm font-normal text-neutral-800 ${l ? "text-neutral-300" : ""}`,
                    children: n
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ e.jsxs("div", { className: "relative", children: [
            /* @__PURE__ */ e.jsxs(
              "button",
              {
                type: "button",
                tabIndex: 0,
                className: `active-visible:z-10 border-1 active-visible:ring relative mt-2 flex h-[48px] w-full items-center justify-between rounded-[4px] border border-neutral-500 bg-white py-2 pl-3 focus:z-10 focus:border-neutral-950 focus:outline-neutral-900 focus:ring-offset-2 focus-visible:z-10 focus-visible:ring active:border-neutral-500 active:outline-neutral-900 active:ring-offset-2 ${(a == null ? void 0 : a.button) || ""} ${l ? "cursor-not-allowed border-neutral-300 bg-neutral-200" : "cursor-pointer"} ${p ? "z-10 border-2 border-neutral-950 outline-neutral-950 ring ring-offset-2" : ""}
            } ${d ? " border-1 border-red-500 " : ""}
               `,
                onClick: j,
                disabled: l,
                children: [
                  /* @__PURE__ */ e.jsx(
                    "div",
                    {
                      className: `flex items-center truncate ${l ? "text-neutral-400" : ""}
                `,
                      children: y ? y.label : o
                    }
                  ),
                  /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
                    el,
                    {
                      role: "button",
                      className: `pointer-events-none flex h-6 w-6 items-center pr-3 align-middle ${l ? "text-neutral-200" : "text-neutral-500"}`
                    }
                  ) })
                ]
              }
            ),
            p && /* @__PURE__ */ e.jsx(
              "div",
              {
                role: "listbox",
                "aria-activedescendant": y != null && y.value ? `option-${y.value}` : void 0,
                className: `absolute left-0 top-12 z-10 mt-1 max-h-60 w-full overflow-y-auto rounded-md border-2 border-neutral-950 bg-white ${(a == null ? void 0 : a.dropdown) || ""}`,
                children: r == null ? void 0 : r.map((N, R) => /* @__PURE__ */ e.jsx(
                  "div",
                  {
                    tabIndex: 0,
                    role: "option",
                    "aria-selected": (y == null ? void 0 : y.value) === N.value,
                    className: `cursor-pointer p-2 hover:bg-neutral-50 ${(a == null ? void 0 : a.option) || ""} ${(y == null ? void 0 : y.value) === N.value ? "bg-neutral-100" : ""}`,
                    onClick: () => w(N),
                    onKeyDown: (T) => P(T, N),
                    children: N.label
                  },
                  R
                ))
              }
            ),
            d && /* @__PURE__ */ e.jsx("p", { className: "mt-2 rounded-[4px] bg-red-50 p-2 font-normal text-red-600", children: d })
          ] })
        ]
      }
    );
  }
);
mt.displayName = "Select";
const Lr = ({ status: t }) => {
  const { t: n } = V("account"), r = (s) => {
    switch (s) {
      case "blocked":
        return "bg-red-50 text-red-700";
      case "closed":
        return "bg-red-50 text-red-700";
      case "open":
        return "bg-green-50 text-green-800";
      case "pending":
        return "bg-yellow-50 text-yellow-800";
      default:
        return "Missing string";
    }
  };
  return /* @__PURE__ */ e.jsx(
    "div",
    {
      className: `flex w-fit items-center justify-center rounded-xl px-2 text-xs font-medium ${r(
        t
      )}`,
      children: n(`kmtoll.landing.bizzList.bizzStatus.${t}`)
    }
  );
}, Jn = "showAll";
function cm({
  option: t,
  selectedOptions: n,
  handleOptionClick: r,
  handleCheckBox: s,
  mode: a
}) {
  return t != null && t.label ? /* @__PURE__ */ e.jsx(
    "div",
    {
      className: "flex items-center gap-3 border-b-2 px-3 py-4 last:border-b-0 ",
      children: /* @__PURE__ */ e.jsxs("label", { className: "flex items-center gap-3", children: [
        /* @__PURE__ */ e.jsx(
          "input",
          {
            className: "border-1 hover:ring-inset-2 hover:border-1 h-4 w-4 flex-shrink-0 cursor-pointer appearance-none rounded-sm border border-neutral-500 checked:border-2 checked:border-white checked:bg-blue-800 checked:ring-2 checked:ring-blue-400 hover:border-blue-500 hover:checked:border-white ",
            type: "checkbox",
            checked: n.some(
              (o) => o.value === t.value
            ),
            onChange: (o) => r(o, t),
            onKeyDown: (o) => s(o, t)
          }
        ),
        a === "bizzStatus" && t.value !== Jn ? /* @__PURE__ */ e.jsx(Lr, { status: t.value }) : t.label
      ] })
    },
    t.value
  ) : null;
}
function dm({
  label: t,
  options: n,
  className: r,
  onChange: s,
  mode: a = "default",
  showAll: o
}, i) {
  const [c, l] = L(!1), { t: d, ready: u } = V(["account", "common"]), m = K(() => {
    const y = d("filter.showAll");
    return y !== "filter.showAll" ? {
      value: Jn,
      label: y
    } : null;
  }, [u]), f = K(() => o ? [m, ...n] : n, [o, m, n]), [p, b] = L(o && m ? [m] : []);
  Y(() => {
    o && m && b([m]);
  }, [m]);
  const h = qe(null);
  Pa(i, () => ({
    resetSelection() {
      b(o && m ? [m] : []), s([]);
    }
  })), Y(() => {
    const y = (x) => {
      h.current && !h.current.contains(x.target) && l(!1);
    };
    return document.addEventListener("mousedown", y), () => {
      document.removeEventListener("mousedown", y);
    };
  }, []);
  const g = (y, x) => {
    y.stopPropagation();
    const j = p.some(
      (C) => C.value === x.value
    );
    let w;
    j ? w = p.filter(
      (C) => C.value !== x.value
    ) : x.value === Jn ? w = [x] : w = [
      ...p.filter((C) => C.value !== Jn),
      x
    ], w.length === 0 && (w = o && m ? [m] : []), b(w), s(
      w.filter((C) => C.value !== Jn).map((C) => C.value)
    );
  }, v = (y, x) => {
    y.key === "Enter" && g(y, x);
  };
  return /* @__PURE__ */ e.jsxs("div", { className: `${r}`, ref: h, children: [
    /* @__PURE__ */ e.jsx("label", { className: "block text-sm font-medium text-neutral-950", children: t }),
    /* @__PURE__ */ e.jsxs("div", { className: "relative", children: [
      /* @__PURE__ */ e.jsxs(
        "button",
        {
          tabIndex: 0,
          className: `border-1 active-visible:ring mt-2 flex h-12 w-full cursor-pointer items-center justify-between rounded-sm border border-neutral-500 bg-white py-2 pl-3 focus:border-neutral-950 focus:outline-neutral-900 focus:ring-offset-2 focus-visible:ring active:border-neutral-500 active:outline-neutral-900 active:ring-offset-2 ${c ? "border-2 border-neutral-950 outline-neutral-950 ring ring-offset-2" : ""}`,
          onClick: () => l(!c),
          children: [
            /* @__PURE__ */ e.jsx("div", { className: "flex overflow-hidden", children: p.length > 1 ? /* @__PURE__ */ e.jsxs("div", { className: "flex items-center truncate", children: [
              /* @__PURE__ */ e.jsx("span", { children: p.slice(0, 2).map((y) => y.label).join(", ") }),
              /* @__PURE__ */ e.jsx("span", { children: `...(${p.length}st)` })
            ] }) : p.map((y, x) => /* @__PURE__ */ e.jsxs(
              "div",
              {
                className: `${x < p.length - 1 ? "mr-1" : ""}`,
                children: [
                  y.label,
                  x < p.length - 1 && ","
                ]
              },
              y.value
            )) }),
            /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
              el,
              {
                role: "button",
                className: "pointer-events-none flex h-6 w-6 items-center pr-3 align-middle text-neutral-500"
              }
            ) })
          ]
        }
      ),
      c && /* @__PURE__ */ e.jsx("div", { className: "absolute left-0 top-12 z-10 mt-1 w-full rounded-md border-2 border-neutral-950 bg-white", children: f == null ? void 0 : f.map((y, x) => /* @__PURE__ */ e.jsx(
        cm,
        {
          option: y,
          handleCheckBox: v,
          handleOptionClick: g,
          selectedOptions: p,
          mode: a
        },
        x
      )) })
    ] })
  ] });
}
const Ia = ot.forwardRef(dm), he = ({
  ns: t,
  children: n,
  ...r
}) => {
  const { t: s, ready: a } = V(t), o = pt(za);
  if (!o)
    throw new Error(
      "useTranslation must be used within an TranslationProvider"
    );
  const { i18n: i } = o;
  return !i || !a ? /* @__PURE__ */ e.jsx(e.Fragment, { children: r.i18nKey || n }) : /* @__PURE__ */ e.jsx(lu, { ...r, t: s, i18n: i, children: n });
};
function $a(t = 20, {
  searchText: n,
  agreements: r,
  status: s,
  productType: a,
  hideCommuter: o
} = {}) {
  const [i, c] = L(1), l = {
    page: i,
    pageSize: t,
    searchText: n,
    status: s,
    contractNo: r,
    productType: a,
    hideCommuter: o
  }, d = hn(), { data: u, isLoading: m } = De(
    xe.Recognitions({ ...l, contractNo: d }),
    ({ Recognitions: g }) => g.list(l),
    { keepPreviousData: !0 }
  ), f = im(), { emissionClasses: p, fuelTypes: b } = At();
  return !u || m ? {
    loading: m,
    recognitions: [],
    totalRecognitions: 0,
    page: i,
    pages: 1,
    setPage: c
  } : {
    loading: !1,
    recognitions: u.recognitions.map(
      ({ fuelType: g, emissionClass: v, ...y }) => ({
        ...y,
        fuelType: b.find(({ value: x }) => Number(x) === g),
        emissionClass: p.find(
          ({ value: x }) => Number(x) === v
        ),
        country: f(y.countryCode) ?? "-"
      })
    ),
    page: i,
    pages: u.pages,
    totalRecognitions: u.totalRecognitions,
    setPage: c
  };
}
var ca = { exports: {} }, Et = {};
Et._ = Et._interop_require_default = um;
function um(t) {
  return t && t.__esModule ? t : { default: t };
}
var gr = { exports: {} }, js = {}, No;
function Nl() {
  return No || (No = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function n(i, c) {
      for (var l in c) Object.defineProperty(i, l, {
        enumerable: !0,
        get: c[l]
      });
    }
    n(t, {
      assign: function() {
        return o;
      },
      searchParamsToUrlQuery: function() {
        return r;
      },
      urlQueryToSearchParams: function() {
        return a;
      }
    });
    function r(i) {
      const c = {};
      return i.forEach((l, d) => {
        typeof c[d] > "u" ? c[d] = l : Array.isArray(c[d]) ? c[d].push(l) : c[d] = [
          c[d],
          l
        ];
      }), c;
    }
    function s(i) {
      return typeof i == "string" || typeof i == "number" && !isNaN(i) || typeof i == "boolean" ? String(i) : "";
    }
    function a(i) {
      const c = new URLSearchParams();
      return Object.entries(i).forEach((l) => {
        let [d, u] = l;
        Array.isArray(u) ? u.forEach((m) => c.append(d, s(m))) : c.set(d, s(u));
      }), c;
    }
    function o(i) {
      for (var c = arguments.length, l = new Array(c > 1 ? c - 1 : 0), d = 1; d < c; d++)
        l[d - 1] = arguments[d];
      return l.forEach((u) => {
        Array.from(u.keys()).forEach((m) => i.delete(m)), u.forEach((m, f) => i.append(f, m));
      }), i;
    }
  }(js)), js;
}
var Cs = {}, $n = {};
function Pl(t) {
  if (typeof WeakMap != "function") return null;
  var n = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (Pl = function(s) {
    return s ? r : n;
  })(t);
}
$n._ = $n._interop_require_wildcard = mm;
function mm(t, n) {
  if (!n && t && t.__esModule) return t;
  if (t === null || typeof t != "object" && typeof t != "function") return { default: t };
  var r = Pl(n);
  if (r && r.has(t)) return r.get(t);
  var s = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var o in t)
    if (o !== "default" && Object.prototype.hasOwnProperty.call(t, o)) {
      var i = a ? Object.getOwnPropertyDescriptor(t, o) : null;
      i && (i.get || i.set) ? Object.defineProperty(s, o, i) : s[o] = t[o];
    }
  return s.default = t, r && r.set(t, s), s;
}
var Po;
function Sl() {
  return Po || (Po = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function n(l, d) {
      for (var u in d) Object.defineProperty(l, u, {
        enumerable: !0,
        get: d[u]
      });
    }
    n(t, {
      formatUrl: function() {
        return o;
      },
      formatWithValidation: function() {
        return c;
      },
      urlObjectKeys: function() {
        return i;
      }
    });
    const s = /* @__PURE__ */ $n._(Nl()), a = /https?|ftp|gopher|file/;
    function o(l) {
      let { auth: d, hostname: u } = l, m = l.protocol || "", f = l.pathname || "", p = l.hash || "", b = l.query || "", h = !1;
      d = d ? encodeURIComponent(d).replace(/%3A/i, ":") + "@" : "", l.host ? h = d + l.host : u && (h = d + (~u.indexOf(":") ? "[" + u + "]" : u), l.port && (h += ":" + l.port)), b && typeof b == "object" && (b = String(s.urlQueryToSearchParams(b)));
      let g = l.search || b && "?" + b || "";
      return m && !m.endsWith(":") && (m += ":"), l.slashes || (!m || a.test(m)) && h !== !1 ? (h = "//" + (h || ""), f && f[0] !== "/" && (f = "/" + f)) : h || (h = ""), p && p[0] !== "#" && (p = "#" + p), g && g[0] !== "?" && (g = "?" + g), f = f.replace(/[?#]/g, encodeURIComponent), g = g.replace("#", "%23"), "" + m + h + f + g + p;
    }
    const i = [
      "auth",
      "hash",
      "host",
      "hostname",
      "href",
      "path",
      "pathname",
      "port",
      "protocol",
      "query",
      "search",
      "slashes"
    ];
    function c(l) {
      return process.env.NODE_ENV === "development" && l !== null && typeof l == "object" && Object.keys(l).forEach((d) => {
        i.includes(d) || console.warn("Unknown key passed via urlObject into url.format: " + d);
      }), o(l);
    }
  }(Cs)), Cs;
}
var ws = {}, So;
function fm() {
  return So || (So = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "omit", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    function n(r, s) {
      const a = {};
      return Object.keys(r).forEach((o) => {
        s.includes(o) || (a[o] = r[o]);
      }), a;
    }
  }(ws)), ws;
}
var Ns = {}, To;
function es() {
  return To || (To = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function n(j, w) {
      for (var C in w) Object.defineProperty(j, C, {
        enumerable: !0,
        get: w[C]
      });
    }
    n(t, {
      DecodeError: function() {
        return b;
      },
      MiddlewareNotFoundError: function() {
        return y;
      },
      MissingStaticPage: function() {
        return v;
      },
      NormalizeError: function() {
        return h;
      },
      PageNotFoundError: function() {
        return g;
      },
      SP: function() {
        return f;
      },
      ST: function() {
        return p;
      },
      WEB_VITALS: function() {
        return r;
      },
      execOnce: function() {
        return s;
      },
      getDisplayName: function() {
        return l;
      },
      getLocationOrigin: function() {
        return i;
      },
      getURL: function() {
        return c;
      },
      isAbsoluteUrl: function() {
        return o;
      },
      isResSent: function() {
        return d;
      },
      loadGetInitialProps: function() {
        return m;
      },
      normalizeRepeatedSlashes: function() {
        return u;
      },
      stringifyError: function() {
        return x;
      }
    });
    const r = [
      "CLS",
      "FCP",
      "FID",
      "INP",
      "LCP",
      "TTFB"
    ];
    function s(j) {
      let w = !1, C;
      return function() {
        for (var P = arguments.length, N = new Array(P), R = 0; R < P; R++)
          N[R] = arguments[R];
        return w || (w = !0, C = j(...N)), C;
      };
    }
    const a = /^[a-zA-Z][a-zA-Z\d+\-.]*?:/, o = (j) => a.test(j);
    function i() {
      const { protocol: j, hostname: w, port: C } = window.location;
      return j + "//" + w + (C ? ":" + C : "");
    }
    function c() {
      const { href: j } = window.location, w = i();
      return j.substring(w.length);
    }
    function l(j) {
      return typeof j == "string" ? j : j.displayName || j.name || "Unknown";
    }
    function d(j) {
      return j.finished || j.headersSent;
    }
    function u(j) {
      const w = j.split("?");
      return w[0].replace(/\\/g, "/").replace(/\/\/+/g, "/") + (w[1] ? "?" + w.slice(1).join("?") : "");
    }
    async function m(j, w) {
      if (process.env.NODE_ENV !== "production") {
        var C;
        if ((C = j.prototype) != null && C.getInitialProps) {
          const R = '"' + l(j) + '.getInitialProps()" is defined as an instance method - visit https://nextjs.org/docs/messages/get-initial-props-as-an-instance-method for more information.';
          throw new Error(R);
        }
      }
      const P = w.res || w.ctx && w.ctx.res;
      if (!j.getInitialProps)
        return w.ctx && w.Component ? {
          pageProps: await m(w.Component, w.ctx)
        } : {};
      const N = await j.getInitialProps(w);
      if (P && d(P))
        return N;
      if (!N) {
        const R = '"' + l(j) + '.getInitialProps()" should resolve to an object. But found "' + N + '" instead.';
        throw new Error(R);
      }
      return process.env.NODE_ENV !== "production" && Object.keys(N).length === 0 && !w.ctx && console.warn("" + l(j) + " returned an empty object from `getInitialProps`. This de-optimizes and prevents automatic static optimization. https://nextjs.org/docs/messages/empty-object-getInitialProps"), N;
    }
    const f = typeof performance < "u", p = f && [
      "mark",
      "measure",
      "getEntriesByName"
    ].every((j) => typeof performance[j] == "function");
    class b extends Error {
    }
    class h extends Error {
    }
    class g extends Error {
      constructor(w) {
        super(), this.code = "ENOENT", this.name = "PageNotFoundError", this.message = "Cannot find module for page: " + w;
      }
    }
    class v extends Error {
      constructor(w, C) {
        super(), this.message = "Failed to load static file for page: " + w + " " + C;
      }
    }
    class y extends Error {
      constructor() {
        super(), this.code = "ENOENT", this.message = "Cannot find the middleware module";
      }
    }
    function x(j) {
      return JSON.stringify({
        message: j.message,
        stack: j.stack
      });
    }
  }(Ns)), Ns;
}
var xr = { exports: {} }, Ps = {}, Eo;
function Tl() {
  return Eo || (Eo = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "removeTrailingSlash", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    function n(r) {
      return r.replace(/\/$/, "") || "/";
    }
  }(Ps)), Ps;
}
var Ss = {}, ko;
function Fa() {
  return ko || (ko = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "parsePath", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    function n(r) {
      const s = r.indexOf("#"), a = r.indexOf("?"), o = a > -1 && (s < 0 || a < s);
      return o || s > -1 ? {
        pathname: r.substring(0, o ? a : s),
        query: o ? r.substring(a, s > -1 ? s : void 0) : "",
        hash: s > -1 ? r.slice(s) : ""
      } : {
        pathname: r,
        query: "",
        hash: ""
      };
    }
  }(Ss)), Ss;
}
var Ao;
function ts() {
  return Ao || (Ao = 1, function(t, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "normalizePathTrailingSlash", {
      enumerable: !0,
      get: function() {
        return a;
      }
    });
    const r = Tl(), s = Fa(), a = (o) => {
      if (!o.startsWith("/") || process.env.__NEXT_MANUAL_TRAILING_SLASH)
        return o;
      const { pathname: i, query: c, hash: l } = (0, s.parsePath)(o);
      return process.env.__NEXT_TRAILING_SLASH ? /\.[^/]+\/?$/.test(i) ? "" + (0, r.removeTrailingSlash)(i) + c + l : i.endsWith("/") ? "" + i + c + l : i + "/" + c + l : "" + (0, r.removeTrailingSlash)(i) + c + l;
    };
    (typeof n.default == "function" || typeof n.default == "object" && n.default !== null) && typeof n.default.__esModule > "u" && (Object.defineProperty(n.default, "__esModule", { value: !0 }), Object.assign(n.default, n), t.exports = n.default);
  }(xr, xr.exports)), xr.exports;
}
var Ts = {}, br = { exports: {} }, Es = {}, Oo;
function El() {
  return Oo || (Oo = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "pathHasPrefix", {
      enumerable: !0,
      get: function() {
        return r;
      }
    });
    const n = Fa();
    function r(s, a) {
      if (typeof s != "string")
        return !1;
      const { pathname: o } = (0, n.parsePath)(s);
      return o === a || o.startsWith(a + "/");
    }
  }(Es)), Es;
}
var _o;
function pm() {
  return _o || (_o = 1, function(t, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "hasBasePath", {
      enumerable: !0,
      get: function() {
        return a;
      }
    });
    const r = El(), s = process.env.__NEXT_ROUTER_BASEPATH || "";
    function a(o) {
      return (0, r.pathHasPrefix)(o, s);
    }
    (typeof n.default == "function" || typeof n.default == "object" && n.default !== null) && typeof n.default.__esModule > "u" && (Object.defineProperty(n.default, "__esModule", { value: !0 }), Object.assign(n.default, n), t.exports = n.default);
  }(br, br.exports)), br.exports;
}
var Ro;
function kl() {
  return Ro || (Ro = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "isLocalURL", {
      enumerable: !0,
      get: function() {
        return s;
      }
    });
    const n = es(), r = pm();
    function s(a) {
      if (!(0, n.isAbsoluteUrl)(a)) return !0;
      try {
        const o = (0, n.getLocationOrigin)(), i = new URL(a, o);
        return i.origin === o && (0, r.hasBasePath)(i.pathname);
      } catch {
        return !1;
      }
    }
  }(Ts)), Ts;
}
var ks = {}, As = {}, Mo;
function hm() {
  return Mo || (Mo = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "getSortedRoutes", {
      enumerable: !0,
      get: function() {
        return r;
      }
    });
    class n {
      insert(a) {
        this._insert(a.split("/").filter(Boolean), [], !1);
      }
      smoosh() {
        return this._smoosh();
      }
      _smoosh(a) {
        a === void 0 && (a = "/");
        const o = [
          ...this.children.keys()
        ].sort();
        this.slugName !== null && o.splice(o.indexOf("[]"), 1), this.restSlugName !== null && o.splice(o.indexOf("[...]"), 1), this.optionalRestSlugName !== null && o.splice(o.indexOf("[[...]]"), 1);
        const i = o.map((c) => this.children.get(c)._smoosh("" + a + c + "/")).reduce((c, l) => [
          ...c,
          ...l
        ], []);
        if (this.slugName !== null && i.push(...this.children.get("[]")._smoosh(a + "[" + this.slugName + "]/")), !this.placeholder) {
          const c = a === "/" ? "/" : a.slice(0, -1);
          if (this.optionalRestSlugName != null)
            throw new Error('You cannot define a route with the same specificity as a optional catch-all route ("' + c + '" and "' + c + "[[..." + this.optionalRestSlugName + ']]").');
          i.unshift(c);
        }
        return this.restSlugName !== null && i.push(...this.children.get("[...]")._smoosh(a + "[..." + this.restSlugName + "]/")), this.optionalRestSlugName !== null && i.push(...this.children.get("[[...]]")._smoosh(a + "[[..." + this.optionalRestSlugName + "]]/")), i;
      }
      _insert(a, o, i) {
        if (a.length === 0) {
          this.placeholder = !1;
          return;
        }
        if (i)
          throw new Error("Catch-all must be the last part of the URL.");
        let c = a[0];
        if (c.startsWith("[") && c.endsWith("]")) {
          let u = function(m, f) {
            if (m !== null && m !== f)
              throw new Error("You cannot use different slug names for the same dynamic path ('" + m + "' !== '" + f + "').");
            o.forEach((p) => {
              if (p === f)
                throw new Error('You cannot have the same slug name "' + f + '" repeat within a single dynamic path');
              if (p.replace(/\W/g, "") === c.replace(/\W/g, ""))
                throw new Error('You cannot have the slug names "' + p + '" and "' + f + '" differ only by non-word symbols within a single dynamic path');
            }), o.push(f);
          }, l = c.slice(1, -1), d = !1;
          if (l.startsWith("[") && l.endsWith("]") && (l = l.slice(1, -1), d = !0), l.startsWith("...") && (l = l.substring(3), i = !0), l.startsWith("[") || l.endsWith("]"))
            throw new Error("Segment names may not start or end with extra brackets ('" + l + "').");
          if (l.startsWith("."))
            throw new Error("Segment names may not start with erroneous periods ('" + l + "').");
          if (i)
            if (d) {
              if (this.restSlugName != null)
                throw new Error('You cannot use both an required and optional catch-all route at the same level ("[...' + this.restSlugName + ']" and "' + a[0] + '" ).');
              u(this.optionalRestSlugName, l), this.optionalRestSlugName = l, c = "[[...]]";
            } else {
              if (this.optionalRestSlugName != null)
                throw new Error('You cannot use both an optional and required catch-all route at the same level ("[[...' + this.optionalRestSlugName + ']]" and "' + a[0] + '").');
              u(this.restSlugName, l), this.restSlugName = l, c = "[...]";
            }
          else {
            if (d)
              throw new Error('Optional route parameters are not yet supported ("' + a[0] + '").');
            u(this.slugName, l), this.slugName = l, c = "[]";
          }
        }
        this.children.has(c) || this.children.set(c, new n()), this.children.get(c)._insert(a.slice(1), o, i);
      }
      constructor() {
        this.placeholder = !0, this.children = /* @__PURE__ */ new Map(), this.slugName = null, this.restSlugName = null, this.optionalRestSlugName = null;
      }
    }
    function r(s) {
      const a = new n();
      return s.forEach((o) => a.insert(o)), a.smoosh();
    }
  }(As)), As;
}
var Os = {}, _s = {}, Rs = {}, Ms = {}, zo;
function gm() {
  return zo || (zo = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "ensureLeadingSlash", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    function n(r) {
      return r.startsWith("/") ? r : "/" + r;
    }
  }(Ms)), Ms;
}
var zs = {}, Do;
function xm() {
  return Do || (Do = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function n(o, i) {
      for (var c in i) Object.defineProperty(o, c, {
        enumerable: !0,
        get: i[c]
      });
    }
    n(t, {
      DEFAULT_SEGMENT_KEY: function() {
        return a;
      },
      PAGE_SEGMENT_KEY: function() {
        return s;
      },
      isGroupSegment: function() {
        return r;
      }
    });
    function r(o) {
      return o[0] === "(" && o.endsWith(")");
    }
    const s = "__PAGE__", a = "__DEFAULT__";
  }(zs)), zs;
}
var Lo;
function bm() {
  return Lo || (Lo = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function n(i, c) {
      for (var l in c) Object.defineProperty(i, l, {
        enumerable: !0,
        get: c[l]
      });
    }
    n(t, {
      normalizeAppPath: function() {
        return a;
      },
      normalizeRscURL: function() {
        return o;
      }
    });
    const r = gm(), s = xm();
    function a(i) {
      return (0, r.ensureLeadingSlash)(i.split("/").reduce((c, l, d, u) => !l || (0, s.isGroupSegment)(l) || l[0] === "@" || (l === "page" || l === "route") && d === u.length - 1 ? c : c + "/" + l, ""));
    }
    function o(i) {
      return i.replace(
        /\.rsc($|\?)/,
        // $1 ensures `?` is preserved
        "$1"
      );
    }
  }(Rs)), Rs;
}
var Io;
function Al() {
  return Io || (Io = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function n(i, c) {
      for (var l in c) Object.defineProperty(i, l, {
        enumerable: !0,
        get: c[l]
      });
    }
    n(t, {
      INTERCEPTION_ROUTE_MARKERS: function() {
        return s;
      },
      extractInterceptionRouteInformation: function() {
        return o;
      },
      isInterceptionRouteAppPath: function() {
        return a;
      }
    });
    const r = bm(), s = [
      "(..)(..)",
      "(.)",
      "(..)",
      "(...)"
    ];
    function a(i) {
      return i.split("/").find((c) => s.find((l) => c.startsWith(l))) !== void 0;
    }
    function o(i) {
      let c, l, d;
      for (const u of i.split("/"))
        if (l = s.find((m) => u.startsWith(m)), l) {
          [c, d] = i.split(l, 2);
          break;
        }
      if (!c || !l || !d)
        throw new Error(`Invalid interception route: ${i}. Must be in the format /<intercepting route>/(..|...|..)(..)/<intercepted route>`);
      switch (c = (0, r.normalizeAppPath)(c), l) {
        case "(.)":
          c === "/" ? d = `/${d}` : d = c + "/" + d;
          break;
        case "(..)":
          if (c === "/")
            throw new Error(`Invalid interception route: ${i}. Cannot use (..) marker at the root level, use (.) instead.`);
          d = c.split("/").slice(0, -1).concat(d).join("/");
          break;
        case "(...)":
          d = "/" + d;
          break;
        case "(..)(..)":
          const u = c.split("/");
          if (u.length <= 2)
            throw new Error(`Invalid interception route: ${i}. Cannot use (..)(..) marker at the root level or one level up.`);
          d = u.slice(0, -2).concat(d).join("/");
          break;
        default:
          throw new Error("Invariant: unexpected marker");
      }
      return {
        interceptingRoute: c,
        interceptedRoute: d
      };
    }
  }(_s)), _s;
}
var $o;
function vm() {
  return $o || ($o = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "isDynamicRoute", {
      enumerable: !0,
      get: function() {
        return s;
      }
    });
    const n = Al(), r = /\/\[[^/]+?\](?=\/|$)/;
    function s(a) {
      return (0, n.isInterceptionRouteAppPath)(a) && (a = (0, n.extractInterceptionRouteInformation)(a).interceptedRoute), r.test(a);
    }
  }(Os)), Os;
}
var Fo;
function ym() {
  return Fo || (Fo = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function n(a, o) {
      for (var i in o) Object.defineProperty(a, i, {
        enumerable: !0,
        get: o[i]
      });
    }
    n(t, {
      getSortedRoutes: function() {
        return r.getSortedRoutes;
      },
      isDynamicRoute: function() {
        return s.isDynamicRoute;
      }
    });
    const r = hm(), s = vm();
  }(ks)), ks;
}
var Ds = {}, Ls = {}, Bo;
function jm() {
  return Bo || (Bo = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "getRouteMatcher", {
      enumerable: !0,
      get: function() {
        return r;
      }
    });
    const n = es();
    function r(s) {
      let { re: a, groups: o } = s;
      return (i) => {
        const c = a.exec(i);
        if (!c)
          return !1;
        const l = (u) => {
          try {
            return decodeURIComponent(u);
          } catch {
            throw new n.DecodeError("failed to decode param");
          }
        }, d = {};
        return Object.keys(o).forEach((u) => {
          const m = o[u], f = c[m.pos];
          f !== void 0 && (d[u] = ~f.indexOf("/") ? f.split("/").map((p) => l(p)) : m.repeat ? [
            l(f)
          ] : l(f));
        }), d;
      };
    }
  }(Ls)), Ls;
}
var Is = {}, $s = {}, Vo;
function Cm() {
  return Vo || (Vo = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "escapeStringRegexp", {
      enumerable: !0,
      get: function() {
        return s;
      }
    });
    const n = /[|\\{}()[\]^$+*?.-]/, r = /[|\\{}()[\]^$+*?.-]/g;
    function s(a) {
      return n.test(a) ? a.replace(r, "\\$&") : a;
    }
  }($s)), $s;
}
var qo;
function wm() {
  return qo || (qo = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function n(h, g) {
      for (var v in g) Object.defineProperty(h, v, {
        enumerable: !0,
        get: g[v]
      });
    }
    n(t, {
      getNamedMiddlewareRegex: function() {
        return b;
      },
      getNamedRouteRegex: function() {
        return p;
      },
      getRouteRegex: function() {
        return d;
      },
      parseParameter: function() {
        return c;
      }
    });
    const r = Al(), s = Cm(), a = Tl(), o = "nxtP", i = "nxtI";
    function c(h) {
      const g = h.startsWith("[") && h.endsWith("]");
      g && (h = h.slice(1, -1));
      const v = h.startsWith("...");
      return v && (h = h.slice(3)), {
        key: h,
        repeat: v,
        optional: g
      };
    }
    function l(h) {
      const g = (0, a.removeTrailingSlash)(h).slice(1).split("/"), v = {};
      let y = 1;
      return {
        parameterizedRoute: g.map((x) => {
          const j = r.INTERCEPTION_ROUTE_MARKERS.find((C) => x.startsWith(C)), w = x.match(/\[((?:\[.*\])|.+)\]/);
          if (j && w) {
            const { key: C, optional: P, repeat: N } = c(w[1]);
            return v[C] = {
              pos: y++,
              repeat: N,
              optional: P
            }, "/" + (0, s.escapeStringRegexp)(j) + "([^/]+?)";
          } else if (w) {
            const { key: C, repeat: P, optional: N } = c(w[1]);
            return v[C] = {
              pos: y++,
              repeat: P,
              optional: N
            }, P ? N ? "(?:/(.+?))?" : "/(.+?)" : "/([^/]+?)";
          } else
            return "/" + (0, s.escapeStringRegexp)(x);
        }).join(""),
        groups: v
      };
    }
    function d(h) {
      const { parameterizedRoute: g, groups: v } = l(h);
      return {
        re: new RegExp("^" + g + "(?:/)?$"),
        groups: v
      };
    }
    function u() {
      let h = 0;
      return () => {
        let g = "", v = ++h;
        for (; v > 0; )
          g += String.fromCharCode(97 + (v - 1) % 26), v = Math.floor((v - 1) / 26);
        return g;
      };
    }
    function m(h) {
      let { interceptionMarker: g, getSafeRouteKey: v, segment: y, routeKeys: x, keyPrefix: j } = h;
      const { key: w, optional: C, repeat: P } = c(y);
      let N = w.replace(/\W/g, "");
      j && (N = "" + j + N);
      let R = !1;
      (N.length === 0 || N.length > 30) && (R = !0), isNaN(parseInt(N.slice(0, 1))) || (R = !0), R && (N = v()), j ? x[N] = "" + j + w : x[N] = w;
      const T = g ? (0, s.escapeStringRegexp)(g) : "";
      return P ? C ? "(?:/" + T + "(?<" + N + ">.+?))?" : "/" + T + "(?<" + N + ">.+?)" : "/" + T + "(?<" + N + ">[^/]+?)";
    }
    function f(h, g) {
      const v = (0, a.removeTrailingSlash)(h).slice(1).split("/"), y = u(), x = {};
      return {
        namedParameterizedRoute: v.map((j) => {
          const w = r.INTERCEPTION_ROUTE_MARKERS.some((P) => j.startsWith(P)), C = j.match(/\[((?:\[.*\])|.+)\]/);
          if (w && C) {
            const [P] = j.split(C[0]);
            return m({
              getSafeRouteKey: y,
              interceptionMarker: P,
              segment: C[1],
              routeKeys: x,
              keyPrefix: g ? i : void 0
            });
          } else return C ? m({
            getSafeRouteKey: y,
            segment: C[1],
            routeKeys: x,
            keyPrefix: g ? o : void 0
          }) : "/" + (0, s.escapeStringRegexp)(j);
        }).join(""),
        routeKeys: x
      };
    }
    function p(h, g) {
      const v = f(h, g);
      return {
        ...d(h),
        namedRegex: "^" + v.namedParameterizedRoute + "(?:/)?$",
        routeKeys: v.routeKeys
      };
    }
    function b(h, g) {
      const { parameterizedRoute: v } = l(h), { catchAll: y = !0 } = g;
      if (v === "/")
        return {
          namedRegex: "^/" + (y ? ".*" : "") + "$"
        };
      const { namedParameterizedRoute: x } = f(h, !1);
      let j = y ? "(?:(/.*)?)" : "";
      return {
        namedRegex: "^" + x + j + "$"
      };
    }
  }(Is)), Is;
}
var Wo;
function Nm() {
  return Wo || (Wo = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "interpolateAs", {
      enumerable: !0,
      get: function() {
        return s;
      }
    });
    const n = jm(), r = wm();
    function s(a, o, i) {
      let c = "";
      const l = (0, r.getRouteRegex)(a), d = l.groups, u = (
        // Try to match the dynamic route against the asPath
        (o !== a ? (0, n.getRouteMatcher)(l)(o) : "") || // Fall back to reading the values from the href
        // TODO: should this take priority; also need to change in the router.
        i
      );
      c = a;
      const m = Object.keys(d);
      return m.every((f) => {
        let p = u[f] || "";
        const { repeat: b, optional: h } = d[f];
        let g = "[" + (b ? "..." : "") + f + "]";
        return h && (g = (p ? "" : "/") + "[" + g + "]"), b && !Array.isArray(p) && (p = [
          p
        ]), (h || f in u) && // Interpolate group into data URL if present
        (c = c.replace(g, b ? p.map(
          // these values should be fully encoded instead of just
          // path delimiter escaped since they are being inserted
          // into the URL and we expect URL encoded segments
          // when parsing dynamic route params
          (v) => encodeURIComponent(v)
        ).join("/") : encodeURIComponent(p)) || "/");
      }) || (c = ""), {
        params: m,
        result: c
      };
    }
  }(Ds)), Ds;
}
var Ho;
function Pm() {
  return Ho || (Ho = 1, function(t, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "resolveHref", {
      enumerable: !0,
      get: function() {
        return u;
      }
    });
    const r = Nl(), s = Sl(), a = fm(), o = es(), i = ts(), c = kl(), l = ym(), d = Nm();
    function u(m, f, p) {
      let b, h = typeof f == "string" ? f : (0, s.formatWithValidation)(f);
      const g = h.match(/^[a-zA-Z]{1,}:\/\//), v = g ? h.slice(g[0].length) : h;
      if ((v.split("?", 1)[0] || "").match(/(\/\/|\\)/)) {
        console.error("Invalid href '" + h + "' passed to next/router in page: '" + m.pathname + "'. Repeated forward-slashes (//) or backslashes \\ are not valid in the href.");
        const x = (0, o.normalizeRepeatedSlashes)(v);
        h = (g ? g[0] : "") + x;
      }
      if (!(0, c.isLocalURL)(h))
        return p ? [
          h
        ] : h;
      try {
        b = new URL(h.startsWith("#") ? m.asPath : m.pathname, "http://n");
      } catch {
        b = new URL("/", "http://n");
      }
      try {
        const x = new URL(h, b);
        x.pathname = (0, i.normalizePathTrailingSlash)(x.pathname);
        let j = "";
        if ((0, l.isDynamicRoute)(x.pathname) && x.searchParams && p) {
          const C = (0, r.searchParamsToUrlQuery)(x.searchParams), { result: P, params: N } = (0, d.interpolateAs)(x.pathname, x.pathname, C);
          P && (j = (0, s.formatWithValidation)({
            pathname: P,
            hash: x.hash,
            query: (0, a.omit)(C, N)
          }));
        }
        const w = x.origin === b.origin ? x.href.slice(x.origin.length) : x.href;
        return p ? [
          w,
          j || w
        ] : w;
      } catch {
        return p ? [
          h
        ] : h;
      }
    }
    (typeof n.default == "function" || typeof n.default == "object" && n.default !== null) && typeof n.default.__esModule > "u" && (Object.defineProperty(n.default, "__esModule", { value: !0 }), Object.assign(n.default, n), t.exports = n.default);
  }(gr, gr.exports)), gr.exports;
}
var vr = { exports: {} }, Fs = {}, Bs = {}, Uo;
function Ol() {
  return Uo || (Uo = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "addPathPrefix", {
      enumerable: !0,
      get: function() {
        return r;
      }
    });
    const n = Fa();
    function r(s, a) {
      if (!s.startsWith("/") || !a)
        return s;
      const { pathname: o, query: i, hash: c } = (0, n.parsePath)(s);
      return "" + a + o + i + c;
    }
  }(Bs)), Bs;
}
var Go;
function Sm() {
  return Go || (Go = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "addLocale", {
      enumerable: !0,
      get: function() {
        return s;
      }
    });
    const n = Ol(), r = El();
    function s(a, o, i, c) {
      if (!o || o === i) return a;
      const l = a.toLowerCase();
      return !c && ((0, r.pathHasPrefix)(l, "/api") || (0, r.pathHasPrefix)(l, "/" + o.toLowerCase())) ? a : (0, n.addPathPrefix)(a, "/" + o);
    }
  }(Fs)), Fs;
}
var Ko;
function Tm() {
  return Ko || (Ko = 1, function(t, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "addLocale", {
      enumerable: !0,
      get: function() {
        return s;
      }
    });
    const r = ts(), s = function(a) {
      for (var o = arguments.length, i = new Array(o > 1 ? o - 1 : 0), c = 1; c < o; c++)
        i[c - 1] = arguments[c];
      return process.env.__NEXT_I18N_SUPPORT ? (0, r.normalizePathTrailingSlash)(Sm().addLocale(a, ...i)) : a;
    };
    (typeof n.default == "function" || typeof n.default == "object" && n.default !== null) && typeof n.default.__esModule > "u" && (Object.defineProperty(n.default, "__esModule", { value: !0 }), Object.assign(n.default, n), t.exports = n.default);
  }(vr, vr.exports)), vr.exports;
}
var Vs = {}, Yo;
function _l() {
  return Yo || (Yo = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "RouterContext", {
      enumerable: !0,
      get: function() {
        return s;
      }
    });
    const s = (/* @__PURE__ */ Et._(ot)).default.createContext(null);
    process.env.NODE_ENV !== "production" && (s.displayName = "RouterContext");
  }(Vs)), Vs;
}
var qs = {}, Qo;
function Em() {
  return Qo || (Qo = 1, function(t) {
    "use client";
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function n(d, u) {
      for (var m in u) Object.defineProperty(d, m, {
        enumerable: !0,
        get: u[m]
      });
    }
    n(t, {
      AppRouterContext: function() {
        return a;
      },
      GlobalLayoutRouterContext: function() {
        return i;
      },
      LayoutRouterContext: function() {
        return o;
      },
      MissingSlotContext: function() {
        return l;
      },
      TemplateContext: function() {
        return c;
      }
    });
    const s = /* @__PURE__ */ Et._(ot), a = s.default.createContext(null), o = s.default.createContext(null), i = s.default.createContext(null), c = s.default.createContext(null);
    process.env.NODE_ENV !== "production" && (a.displayName = "AppRouterContext", o.displayName = "LayoutRouterContext", i.displayName = "GlobalLayoutRouterContext", c.displayName = "TemplateContext");
    const l = s.default.createContext(/* @__PURE__ */ new Set());
  }(qs)), qs;
}
var yr = { exports: {} }, jr = { exports: {} }, Xo;
function Rl() {
  return Xo || (Xo = 1, function(t, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    });
    function r(o, i) {
      for (var c in i) Object.defineProperty(o, c, {
        enumerable: !0,
        get: i[c]
      });
    }
    r(n, {
      cancelIdleCallback: function() {
        return a;
      },
      requestIdleCallback: function() {
        return s;
      }
    });
    const s = typeof self < "u" && self.requestIdleCallback && self.requestIdleCallback.bind(window) || function(o) {
      let i = Date.now();
      return self.setTimeout(function() {
        o({
          didTimeout: !1,
          timeRemaining: function() {
            return Math.max(0, 50 - (Date.now() - i));
          }
        });
      }, 1);
    }, a = typeof self < "u" && self.cancelIdleCallback && self.cancelIdleCallback.bind(window) || function(o) {
      return clearTimeout(o);
    };
    (typeof n.default == "function" || typeof n.default == "object" && n.default !== null) && typeof n.default.__esModule > "u" && (Object.defineProperty(n.default, "__esModule", { value: !0 }), Object.assign(n.default, n), t.exports = n.default);
  }(jr, jr.exports)), jr.exports;
}
var Jo;
function km() {
  return Jo || (Jo = 1, function(t, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "useIntersection", {
      enumerable: !0,
      get: function() {
        return d;
      }
    });
    const r = ot, s = Rl(), a = typeof IntersectionObserver == "function", o = /* @__PURE__ */ new Map(), i = [];
    function c(u) {
      const m = {
        root: u.root || null,
        margin: u.rootMargin || ""
      }, f = i.find((g) => g.root === m.root && g.margin === m.margin);
      let p;
      if (f && (p = o.get(f), p))
        return p;
      const b = /* @__PURE__ */ new Map(), h = new IntersectionObserver((g) => {
        g.forEach((v) => {
          const y = b.get(v.target), x = v.isIntersecting || v.intersectionRatio > 0;
          y && x && y(x);
        });
      }, u);
      return p = {
        id: m,
        observer: h,
        elements: b
      }, i.push(m), o.set(m, p), p;
    }
    function l(u, m, f) {
      const { id: p, observer: b, elements: h } = c(f);
      return h.set(u, m), b.observe(u), function() {
        if (h.delete(u), b.unobserve(u), h.size === 0) {
          b.disconnect(), o.delete(p);
          const v = i.findIndex((y) => y.root === p.root && y.margin === p.margin);
          v > -1 && i.splice(v, 1);
        }
      };
    }
    function d(u) {
      let { rootRef: m, rootMargin: f, disabled: p } = u;
      const b = p || !a, [h, g] = (0, r.useState)(!1), v = (0, r.useRef)(null), y = (0, r.useCallback)((j) => {
        v.current = j;
      }, []);
      (0, r.useEffect)(() => {
        if (a) {
          if (b || h) return;
          const j = v.current;
          if (j && j.tagName)
            return l(j, (C) => C && g(C), {
              root: m == null ? void 0 : m.current,
              rootMargin: f
            });
        } else if (!h) {
          const j = (0, s.requestIdleCallback)(() => g(!0));
          return () => (0, s.cancelIdleCallback)(j);
        }
      }, [
        b,
        f,
        m,
        h,
        v.current
      ]);
      const x = (0, r.useCallback)(() => {
        g(!1);
      }, []);
      return [
        y,
        h,
        x
      ];
    }
    (typeof n.default == "function" || typeof n.default == "object" && n.default !== null) && typeof n.default.__esModule > "u" && (Object.defineProperty(n.default, "__esModule", { value: !0 }), Object.assign(n.default, n), t.exports = n.default);
  }(yr, yr.exports)), yr.exports;
}
var Cr = { exports: {} }, wr = { exports: {} }, Ws = {}, Zo;
function Am() {
  return Zo || (Zo = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "normalizeLocalePath", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    function n(r, s) {
      let a;
      const o = r.split("/");
      return (s || []).some((i) => o[1] && o[1].toLowerCase() === i.toLowerCase() ? (a = i, o.splice(1, 1), r = o.join("/") || "/", !0) : !1), {
        pathname: r,
        detectedLocale: a
      };
    }
  }(Ws)), Ws;
}
var ei;
function Om() {
  return ei || (ei = 1, function(t, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "normalizeLocalePath", {
      enumerable: !0,
      get: function() {
        return r;
      }
    });
    const r = (s, a) => process.env.__NEXT_I18N_SUPPORT ? Am().normalizeLocalePath(s, a) : {
      pathname: s,
      detectedLocale: void 0
    };
    (typeof n.default == "function" || typeof n.default == "object" && n.default !== null) && typeof n.default.__esModule > "u" && (Object.defineProperty(n.default, "__esModule", { value: !0 }), Object.assign(n.default, n), t.exports = n.default);
  }(wr, wr.exports)), wr.exports;
}
var Nr = { exports: {} }, Hs = {}, ti;
function _m() {
  return ti || (ti = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "detectDomainLocale", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    function n(r, s, a) {
      if (r) {
        a && (a = a.toLowerCase());
        for (const c of r) {
          var o, i;
          const l = (o = c.domain) == null ? void 0 : o.split(":", 1)[0].toLowerCase();
          if (s === l || a === c.defaultLocale.toLowerCase() || (i = c.locales) != null && i.some((d) => d.toLowerCase() === a))
            return c;
        }
      }
    }
  }(Hs)), Hs;
}
var ni;
function Rm() {
  return ni || (ni = 1, function(t, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "detectDomainLocale", {
      enumerable: !0,
      get: function() {
        return r;
      }
    });
    const r = function() {
      for (var s = arguments.length, a = new Array(s), o = 0; o < s; o++)
        a[o] = arguments[o];
      if (process.env.__NEXT_I18N_SUPPORT)
        return _m().detectDomainLocale(...a);
    };
    (typeof n.default == "function" || typeof n.default == "object" && n.default !== null) && typeof n.default.__esModule > "u" && (Object.defineProperty(n.default, "__esModule", { value: !0 }), Object.assign(n.default, n), t.exports = n.default);
  }(Nr, Nr.exports)), Nr.exports;
}
var ri;
function Mm() {
  return ri || (ri = 1, function(t, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "getDomainLocale", {
      enumerable: !0,
      get: function() {
        return a;
      }
    });
    const r = ts(), s = process.env.__NEXT_ROUTER_BASEPATH || "";
    function a(o, i, c, l) {
      if (process.env.__NEXT_I18N_SUPPORT) {
        const d = Om().normalizeLocalePath, u = Rm().detectDomainLocale, m = i || d(o, c).detectedLocale, f = u(l, void 0, m);
        if (f) {
          const p = "http" + (f.http ? "" : "s") + "://", b = m === f.defaultLocale ? "" : "/" + m;
          return "" + p + f.domain + (0, r.normalizePathTrailingSlash)("" + s + b + o);
        }
        return !1;
      } else
        return !1;
    }
    (typeof n.default == "function" || typeof n.default == "object" && n.default !== null) && typeof n.default.__esModule > "u" && (Object.defineProperty(n.default, "__esModule", { value: !0 }), Object.assign(n.default, n), t.exports = n.default);
  }(Cr, Cr.exports)), Cr.exports;
}
var Pr = { exports: {} }, si;
function zm() {
  return si || (si = 1, function(t, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    }), Object.defineProperty(n, "addBasePath", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const r = Ol(), s = ts(), a = process.env.__NEXT_ROUTER_BASEPATH || "";
    function o(i, c) {
      return (0, s.normalizePathTrailingSlash)(process.env.__NEXT_MANUAL_CLIENT_BASE_PATH && !c ? i : (0, r.addPathPrefix)(i, a));
    }
    (typeof n.default == "function" || typeof n.default == "object" && n.default !== null) && typeof n.default.__esModule > "u" && (Object.defineProperty(n.default, "__esModule", { value: !0 }), Object.assign(n.default, n), t.exports = n.default);
  }(Pr, Pr.exports)), Pr.exports;
}
var Sr = { exports: {} }, ai;
function Dm() {
  return ai || (ai = 1, function(t, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    });
    function r(p, b) {
      for (var h in b) Object.defineProperty(p, h, {
        enumerable: !0,
        get: b[h]
      });
    }
    r(n, {
      ACTION_FAST_REFRESH: function() {
        return l;
      },
      ACTION_NAVIGATE: function() {
        return a;
      },
      ACTION_PREFETCH: function() {
        return c;
      },
      ACTION_REFRESH: function() {
        return s;
      },
      ACTION_RESTORE: function() {
        return o;
      },
      ACTION_SERVER_ACTION: function() {
        return d;
      },
      ACTION_SERVER_PATCH: function() {
        return i;
      },
      PrefetchCacheEntryStatus: function() {
        return m;
      },
      PrefetchKind: function() {
        return u;
      },
      isThenable: function() {
        return f;
      }
    });
    const s = "refresh", a = "navigate", o = "restore", i = "server-patch", c = "prefetch", l = "fast-refresh", d = "server-action";
    var u;
    (function(p) {
      p.AUTO = "auto", p.FULL = "full", p.TEMPORARY = "temporary";
    })(u || (u = {}));
    var m;
    (function(p) {
      p.fresh = "fresh", p.reusable = "reusable", p.expired = "expired", p.stale = "stale";
    })(m || (m = {}));
    function f(p) {
      return p && (typeof p == "object" || typeof p == "function") && typeof p.then == "function";
    }
    (typeof n.default == "function" || typeof n.default == "object" && n.default !== null) && typeof n.default.__esModule > "u" && (Object.defineProperty(n.default, "__esModule", { value: !0 }), Object.assign(n.default, n), t.exports = n.default);
  }(Sr, Sr.exports)), Sr.exports;
}
(function(t, n) {
  "use client";
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), Object.defineProperty(n, "default", {
    enumerable: !0,
    get: function() {
      return C;
    }
  });
  const r = Et, s = e, a = /* @__PURE__ */ r._(ot), o = Pm(), i = kl(), c = Sl(), l = es(), d = Tm(), u = _l(), m = Em(), f = km(), p = Mm(), b = zm(), h = Dm(), g = /* @__PURE__ */ new Set();
  function v(P, N, R, T, z, D) {
    if (typeof window > "u" || !D && !(0, i.isLocalURL)(N))
      return;
    if (!T.bypassPrefetchedCheck) {
      const S = (
        // Let the link's locale prop override the default router locale.
        typeof T.locale < "u" ? T.locale : "locale" in P ? P.locale : void 0
      ), _ = N + "%" + R + "%" + S;
      if (g.has(_))
        return;
      g.add(_);
    }
    (async () => D ? P.prefetch(N, z) : P.prefetch(N, R, T))().catch((S) => {
      if (process.env.NODE_ENV !== "production")
        throw S;
    });
  }
  function y(P) {
    const R = P.currentTarget.getAttribute("target");
    return R && R !== "_self" || P.metaKey || P.ctrlKey || P.shiftKey || P.altKey || // triggers resource download
    P.nativeEvent && P.nativeEvent.which === 2;
  }
  function x(P, N, R, T, z, D, A, S, _) {
    const { nodeName: $ } = P.currentTarget;
    if ($.toUpperCase() === "A" && (y(P) || // app-router supports external urls out of the box so it shouldn't short-circuit here as support for e.g. `replace` is added in the app-router.
    !_ && !(0, i.isLocalURL)(R)))
      return;
    P.preventDefault();
    const U = () => {
      const W = A ?? !0;
      "beforePopState" in N ? N[z ? "replace" : "push"](R, T, {
        shallow: D,
        locale: S,
        scroll: W
      }) : N[z ? "replace" : "push"](T || R, {
        scroll: W
      });
    };
    _ ? a.default.startTransition(U) : U();
  }
  function j(P) {
    return typeof P == "string" ? P : (0, c.formatUrl)(P);
  }
  const C = /* @__PURE__ */ a.default.forwardRef(function(N, R) {
    let T;
    const { href: z, as: D, children: A, prefetch: S = null, passHref: _, replace: $, shallow: q, scroll: U, locale: W, onClick: G, onMouseEnter: ee, onTouchStart: ue, legacyBehavior: ce = !1, ...re } = N;
    T = A, ce && (typeof T == "string" || typeof T == "number") && (T = /* @__PURE__ */ (0, s.jsx)("a", {
      children: T
    }));
    const se = a.default.useContext(u.RouterContext), H = a.default.useContext(m.AppRouterContext), O = se ?? H, ae = !se, ge = S !== !1, je = S === null ? h.PrefetchKind.AUTO : h.PrefetchKind.FULL;
    if (process.env.NODE_ENV !== "production") {
      let J = function(X) {
        return new Error("Failed prop type: The prop `" + X.key + "` expects a " + X.expected + " in `<Link>`, but got `" + X.actual + "` instead." + (typeof window < "u" ? `
Open your browser's console to view the Component stack trace.` : ""));
      };
      Object.keys({
        href: !0
      }).forEach((X) => {
        if (X === "href" && (N[X] == null || typeof N[X] != "string" && typeof N[X] != "object"))
          throw J({
            key: X,
            expected: "`string` or `object`",
            actual: N[X] === null ? "null" : typeof N[X]
          });
      }), Object.keys({
        as: !0,
        replace: !0,
        scroll: !0,
        shallow: !0,
        passHref: !0,
        prefetch: !0,
        locale: !0,
        onClick: !0,
        onMouseEnter: !0,
        onTouchStart: !0,
        legacyBehavior: !0
      }).forEach((X) => {
        const Ce = typeof N[X];
        if (X === "as") {
          if (N[X] && Ce !== "string" && Ce !== "object")
            throw J({
              key: X,
              expected: "`string` or `object`",
              actual: Ce
            });
        } else if (X === "locale") {
          if (N[X] && Ce !== "string")
            throw J({
              key: X,
              expected: "`string`",
              actual: Ce
            });
        } else if (X === "onClick" || X === "onMouseEnter" || X === "onTouchStart") {
          if (N[X] && Ce !== "function")
            throw J({
              key: X,
              expected: "`function`",
              actual: Ce
            });
        } else if ((X === "replace" || X === "scroll" || X === "shallow" || X === "passHref" || X === "prefetch" || X === "legacyBehavior") && N[X] != null && Ce !== "boolean")
          throw J({
            key: X,
            expected: "`boolean`",
            actual: Ce
          });
      });
      const k = a.default.useRef(!1);
      N.prefetch && !k.current && !ae && (k.current = !0, console.warn("Next.js auto-prefetches automatically based on viewport. The prefetch attribute is no longer needed. More: https://nextjs.org/docs/messages/prefetch-true-deprecated"));
    }
    if (process.env.NODE_ENV !== "production" && ae && !D) {
      let J;
      if (typeof z == "string" ? J = z : typeof z == "object" && typeof z.pathname == "string" && (J = z.pathname), J && J.split("/").some((Te) => Te.startsWith("[") && Te.endsWith("]")))
        throw new Error("Dynamic href `" + J + "` found in <Link> while using the `/app` router, this is not supported. Read more: https://nextjs.org/docs/messages/app-dir-dynamic-href");
    }
    const { href: I, as: F } = a.default.useMemo(() => {
      if (!se) {
        const Te = j(z);
        return {
          href: Te,
          as: D ? j(D) : Te
        };
      }
      const [J, Pe] = (0, o.resolveHref)(se, z, !0);
      return {
        href: J,
        as: D ? (0, o.resolveHref)(se, D) : Pe || J
      };
    }, [
      se,
      z,
      D
    ]), We = a.default.useRef(I), oe = a.default.useRef(F);
    let le;
    if (ce)
      if (process.env.NODE_ENV === "development") {
        G && console.warn('"onClick" was passed to <Link> with `href` of `' + z + '` but "legacyBehavior" was set. The legacy behavior requires onClick be set on the child of next/link'), ee && console.warn('"onMouseEnter" was passed to <Link> with `href` of `' + z + '` but "legacyBehavior" was set. The legacy behavior requires onMouseEnter be set on the child of next/link');
        try {
          le = a.default.Children.only(T);
        } catch {
          throw T ? new Error("Multiple children were passed to <Link> with `href` of `" + z + "` but only one child is supported https://nextjs.org/docs/messages/link-multiple-children" + (typeof window < "u" ? ` 
Open your browser's console to view the Component stack trace.` : "")) : new Error("No children were passed to <Link> with `href` of `" + z + "` but one child is required https://nextjs.org/docs/messages/link-no-children");
        }
      } else
        le = a.default.Children.only(T);
    else if (process.env.NODE_ENV === "development" && (T == null ? void 0 : T.type) === "a")
      throw new Error(`Invalid <Link> with <a> child. Please remove <a> or use <Link legacyBehavior>.
Learn more: https://nextjs.org/docs/messages/invalid-new-link-with-extra-anchor`);
    const _e = ce ? le && typeof le == "object" && le.ref : R, [$e, ie, ye] = (0, f.useIntersection)({
      rootMargin: "200px"
    }), we = a.default.useCallback((J) => {
      (oe.current !== F || We.current !== I) && (ye(), oe.current = F, We.current = I), $e(J), _e && (typeof _e == "function" ? _e(J) : typeof _e == "object" && (_e.current = J));
    }, [
      F,
      _e,
      I,
      ye,
      $e
    ]);
    a.default.useEffect(() => {
      process.env.NODE_ENV === "production" && O && (!ie || !ge || v(O, I, F, {
        locale: W
      }, {
        kind: je
      }, ae));
    }, [
      F,
      I,
      ie,
      W,
      ge,
      se == null ? void 0 : se.locale,
      O,
      ae,
      je
    ]);
    const Ae = {
      ref: we,
      onClick(J) {
        if (process.env.NODE_ENV !== "production" && !J)
          throw new Error('Component rendered inside next/link has to pass click event to "onClick" prop.');
        !ce && typeof G == "function" && G(J), ce && le.props && typeof le.props.onClick == "function" && le.props.onClick(J), O && (J.defaultPrevented || x(J, O, I, F, $, q, U, W, ae));
      },
      onMouseEnter(J) {
        !ce && typeof ee == "function" && ee(J), ce && le.props && typeof le.props.onMouseEnter == "function" && le.props.onMouseEnter(J), O && ((!ge || process.env.NODE_ENV === "development") && ae || v(O, I, F, {
          locale: W,
          priority: !0,
          // @see {https://github.com/vercel/next.js/discussions/40268?sort=top#discussioncomment-3572642}
          bypassPrefetchedCheck: !0
        }, {
          kind: je
        }, ae));
      },
      onTouchStart: process.env.__NEXT_LINK_NO_TOUCH_START ? void 0 : function(Pe) {
        !ce && typeof ue == "function" && ue(Pe), ce && le.props && typeof le.props.onTouchStart == "function" && le.props.onTouchStart(Pe), O && (!ge && ae || v(O, I, F, {
          locale: W,
          priority: !0,
          // @see {https://github.com/vercel/next.js/discussions/40268?sort=top#discussioncomment-3572642}
          bypassPrefetchedCheck: !0
        }, {
          kind: je
        }, ae));
      }
    };
    if ((0, l.isAbsoluteUrl)(F))
      Ae.href = F;
    else if (!ce || _ || le.type === "a" && !("href" in le.props)) {
      const J = typeof W < "u" ? W : se == null ? void 0 : se.locale, Pe = (se == null ? void 0 : se.isLocaleDomain) && (0, p.getDomainLocale)(F, J, se == null ? void 0 : se.locales, se == null ? void 0 : se.domainLocales);
      Ae.href = Pe || (0, b.addBasePath)((0, d.addLocale)(F, J, se == null ? void 0 : se.defaultLocale));
    }
    return ce ? /* @__PURE__ */ a.default.cloneElement(le, Ae) : /* @__PURE__ */ (0, s.jsx)("a", {
      ...re,
      ...Ae,
      children: T
    });
  });
  (typeof n.default == "function" || typeof n.default == "object" && n.default !== null) && typeof n.default.__esModule > "u" && (Object.defineProperty(n.default, "__esModule", { value: !0 }), Object.assign(n.default, n), t.exports = n.default);
})(ca, ca.exports);
var Lm = ca.exports, Im = Lm;
const yn = /* @__PURE__ */ qn(Im), oi = ({ mode: t, pageType: n = "kmtoll" }) => {
  const r = n === "kmtoll";
  return /* @__PURE__ */ e.jsx(st, { className: "mt-6", colorMode: "information", children: /* @__PURE__ */ e.jsx(
    he,
    {
      i18nKey: t === "newBizz" && n == "kmtoll" ? "kmtoll.userFeedBack.information.newBizz" : "kmtoll.userFeedBack.information.emptyBizzList",
      ns: "account",
      components: r ? [
        /* @__PURE__ */ e.jsx(
          yn,
          {
            className: "font-semibold underline",
            href: "./bizz/order"
          }
        )
      ] : []
    }
  ) });
}, $m = (t, n, r, s) => t ? "loading" : (
  // We don't have any filters active but still 0 recognitions
  n === 0 && !r && s === "kmtoll" ? "newBizz" : (
    // We have 0 recognitions due to our filters
    n === 0 && r ? "emptyBizzList" : "displayBizzList"
  )
), Fm = (t) => t >= 12e3 ? "kmtoll.landing.bizzList.vehicle.weight.above12000" : t > 3500 ? "kmtoll.landing.bizzList.vehicle.weight.above3500" : "kmtoll.landing.bizzList.vehicle.weight.below3500", Bm = (t) => [pe.OresundPendler, pe.OresundBusinessPendler].includes(
  t
), da = (t) => t === "Storebelt", Vm = (t) => t === "OresundPAY" || t === "OresundPAYBusiness", qm = (t) => t === pe.OresundBusinessPendler, Ml = (t, n) => !!n && Bm(t.agreementType), Wm = (t, n) => (r, s) => Ml(r, s) ? t(r) : n(r), Hm = (t) => t ? {} : {
  borderTopColor: "colors.neutral.400",
  borderTopStyle: "solid",
  borderTopWidth: "1px"
}, Um = ({
  children: t,
  template: n = "two-column",
  gridTemplateColumns: r,
  noBorder: s
}) => /* @__PURE__ */ e.jsx(
  nn,
  {
    template: n,
    py: "spacing.400",
    sx: {
      gridTemplateColumns: r,
      ...Hm(s)
    },
    children: t
  }
), Gm = (t, n) => Dt(t, "yyyy-MM-dd, HH:mm", {
  locale: n
}), rr = (t, n) => `${t} ${n}`, Km = (t, n) => {
  const r = new Date(t);
  return isNaN(r.getTime()) ? "-" : Gm(r, n);
}, ua = (t) => (t ? new Date(t) : /* @__PURE__ */ new Date()).toLocaleDateString("sv-SE", {
  day: "2-digit",
  month: "2-digit",
  year: "numeric"
});
var Zn = /* @__PURE__ */ ((t) => (t.internal = "internal", t.external = "external", t))(Zn || {});
const Ym = ({
  props: t,
  condition: n,
  wrapper: r,
  children: s
}) => /* @__PURE__ */ e.jsx(e.Fragment, { children: n ? r(s, t) : s }), Qm = fn(function({ children: n, className: r, color: s, underline: a, href: o, full: i, ...c }, l) {
  return /* @__PURE__ */ e.jsx(
    M,
    {
      as: "a",
      ref: l,
      target: "_blank",
      href: o,
      ...c,
      className: ct(
        zl({ color: s, full: i, underline: a }),
        r,
        c.intent ? void 0 : "font-size-inherit"
      ),
      children: n
    }
  );
}), Xm = fn(function({ children: n, className: r, color: s, underline: a, href: o, full: i, active: c, ...l }, d) {
  return /* @__PURE__ */ e.jsx(yn, { href: o, passHref: !0, legacyBehavior: !0, children: /* @__PURE__ */ e.jsx(
    M,
    {
      as: "a",
      active: c ? "true" : void 0,
      "data-active": c,
      ref: d,
      ...l,
      className: ct(
        zl({ color: s, full: i, underline: a }),
        r,
        l.intent ? void 0 : "font-size-inherit"
      ),
      children: n
    }
  ) });
}), Jm = (t) => /* @__PURE__ */ e.jsx(Hu, { ...t, asChild: !0, children: t.children }), zl = Gt(["underline", "hover:underline", "cursor-pointer"], {
  variants: {
    color: {
      inherit: ["text-inherit"],
      default: [
        "text-primary-600",
        "active:text-primary-700",
        "focus:text-primary-700",
        "hover:text-primary-700"
      ],
      primaryHover: [
        "text-type-heading",
        "active:text-primary-600",
        "focus:text-primary-600",
        "hover:text-primary-600"
      ],
      white: [
        "text-white",
        "active:text-white",
        "focus:text-white",
        "hover:text-white"
      ],
      neutral: [
        "text-type-secondary",
        "active:text-type-secondary",
        "focus:text-type-secondary",
        "hover:text-type-secondary"
      ]
    },
    full: {
      true: [
        "after:z-[1]",
        'after:content-[" "]',
        "after:absolute",
        "after:inset-0"
      ],
      false: []
    },
    underline: {
      true: [],
      false: ["no-underline"]
    }
  },
  defaultVariants: {
    color: "default"
  }
}), jt = fn(function({
  navLinkWrapper: n,
  children: r,
  href: s,
  color: a,
  full: o,
  underline: i,
  className: c,
  ...l
}, d) {
  if (!s) return /* @__PURE__ */ e.jsx(e.Fragment, {});
  const m = ((b) => b[0] === "/" ? Zn.internal : Zn.external)(s), f = (b) => {
    switch (b) {
      case Zn.internal:
        return /* @__PURE__ */ e.jsx(
          Xm,
          {
            href: s,
            ref: d,
            color: a,
            className: ct(c),
            ...l,
            children: r
          }
        );
      case Zn.external:
        return /* @__PURE__ */ e.jsx(
          Qm,
          {
            href: s,
            ref: d,
            color: a,
            className: ct(c),
            ...l,
            children: r
          }
        );
    }
  }, p = {
    children: r,
    href: s,
    color: a,
    full: o,
    underline: i,
    className: c,
    ...l
  };
  return /* @__PURE__ */ e.jsx(
    Ym,
    {
      condition: !!n,
      wrapper: (b) => /* @__PURE__ */ e.jsx(Jm, { ...p, children: b }),
      children: f(m)
    }
  );
}), Zm = ({
  value: t,
  label: n,
  isMobile: r
}) => /* @__PURE__ */ e.jsxs("div", { className: "mb-4 flex flex-col", children: [
  /* @__PURE__ */ e.jsx(
    "label",
    {
      className: `text-sm ${r ? "text-neutral-800" : "text-neutral-600"}`,
      children: n
    }
  ),
  /* @__PURE__ */ e.jsx("span", { className: "text-base", children: t })
] }), ef = ({
  trip: t,
  showColumns: n,
  t: r,
  downloadTrip: s
}) => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
  (n == null ? void 0 : n.includes("tripPaymentStation")) && /* @__PURE__ */ e.jsxs("div", { className: "mb-4 flex flex-col", children: [
    /* @__PURE__ */ e.jsxs("span", { className: "text-neutral-800", children: [
      r("form.labels.station"),
      ":"
    ] }),
    /* @__PURE__ */ e.jsx("span", { className: "text-base", children: t.station })
  ] }),
  (n == null ? void 0 : n.includes("tripRoute")) && /* @__PURE__ */ e.jsxs("div", { className: "mb-4 flex flex-col ", children: [
    /* @__PURE__ */ e.jsx("span", { className: "text-neutral-800", children: r("trips.columns.tripRoute") }),
    t.route === "-" ? "-" : /* @__PURE__ */ e.jsx(
      jt,
      {
        href: t.route,
        className: "text-primary-600 py-2",
        as: "a",
        onClick: (a) => {
          a.stopPropagation();
        },
        children: r("trips.labels.viewTripRoute")
      }
    )
  ] }),
  /* @__PURE__ */ e.jsx(
    "button",
    {
      onClick: (a) => {
        a.stopPropagation(), s(
          t.dateTime,
          t.listId,
          t.id,
          t.type,
          on.PDF
        );
      },
      children: /* @__PURE__ */ e.jsx(Ln, { className: "text-neutral-800" })
    }
  )
] }), tf = ({
  trip: t,
  isMobile: n,
  showColumns: r,
  downloadTrip: s
}) => {
  const { t: a } = V(["account", "common"], {
    nsMode: "fallback"
  }), o = [
    {
      label: a("form.labels.licensePlate"),
      value: t.alpr,
      className: "col-span-2"
    },
    {
      label: a("form.labels.bizzNumber"),
      value: t.bizzNr,
      className: "col-span-2"
    },
    {
      label: a("form.labels.direction"),
      value: a(t.direction),
      className: "col-span-2"
    },
    {
      label: a("form.labels.priceExclVAT"),
      value: rr(t.price.amount, t.price.currencyCode),
      className: "col-span-2"
    },
    {
      label: a("form.labels.priceInclVAT"),
      value: rr(t.price.amountInclVAT, t.price.currencyCode),
      className: "col-span-2"
    },
    {
      label: a("form.labels.contract"),
      value: t.contract ? a(`agreementTypes.${t.contract}.label`) : "-",
      className: "col-span-2"
    },
    {
      label: a("form.labels.paymentProvider"),
      value: t.actor === "OresundPAY" ? a("agreementProviders.A40001.label") : t.actor,
      className: "col-span-2"
    },
    {
      label: a("form.labels.invoice"),
      value: t.invoiceNr,
      className: "col-span-2"
    }
  ];
  return /* @__PURE__ */ e.jsx("div", { className: "text-sm", children: /* @__PURE__ */ e.jsxs(
    Um,
    {
      gridTemplateColumns: {
        xs: "repeat(1, 1fr)",
        sm: "repeat(2, 1fr)",
        md: "repeat(4, 1fr)"
      },
      noBorder: !0,
      children: [
        o.map((i, c) => /* @__PURE__ */ e.jsx(
          Zm,
          {
            ...i,
            isMobile: n,
            t: a
          },
          `${c}${i.value}`
        )),
        n && /* @__PURE__ */ e.jsx(
          ef,
          {
            trip: t,
            showColumns: r,
            t: a,
            downloadTrip: s
          }
        )
      ]
    }
  ) });
};
function Ba() {
  var n;
  const { data: t } = bt();
  return (n = t == null ? void 0 : t.paymentAgreement) == null ? void 0 : n.contractNo;
}
function nf(t = !1, n) {
  const { customerInformation: r } = tt(), s = (r == null ? void 0 : r.customerType) === "business-commuter", {
    data: a,
    error: o,
    refetch: i
  } = De(
    xe.PaymentAgreementList,
    ({ Contract: c }) => c.paymentAgreementList,
    {
      suspense: t,
      onSuccess(c) {
      },
      enabled: !s
    }
  );
  return { contracts: a, error: o, refetch: i };
}
const rf = [
  pe.OresundBusinessPendler,
  pe.OresundPendler
], sf = [nr.ORESUNDPAY], af = (t, n) => t ? n ? t.filter((r) => !rf.includes(r.agreementType)) : t : [], of = (t, n) => t ? n ? t.filter(
  (r) => sf.includes(r.providerId)
) : t : [], lf = (t, n) => t || [], cf = ({
  paymentAgreement: {
    agreementType: t,
    contractNo: n,
    paymentType: r,
    provider: s,
    status: a
  }
}) => ({
  agreementType: t,
  contractNo: n,
  paymentType: r,
  providerId: s.id,
  providerName: s.name,
  status: a
}), Dl = (t) => (n) => ({
  label: `${t == null ? void 0 : t(`agreementProviders.${n == null ? void 0 : n.providerId}.label`)} - ${n.contractNo}`,
  value: n.contractNo
}), Ll = (t, n, r, s, a) => {
  let o = af(n, r);
  return o = of(o, s), o = lf(o), o.map(Dl(t));
}, df = ({
  onAgreementChange: t,
  hideCommuter: n
}) => {
  const { contracts: r } = nf(), {
    query: { contract: s }
  } = ve();
  Y(() => {
    t(s ? [s] : []);
  }, [s, t]);
  const { t: a } = V(["common"], {
    nsMode: "fallback"
  }), o = Ll(
    a,
    r,
    n
  );
  return s ? /* @__PURE__ */ e.jsxs("div", { className: "w-full  md:self-start ", children: [
    /* @__PURE__ */ e.jsx("label", { className: "block text-sm font-medium text-neutral-950", children: a("form.labels.contract") }),
    /* @__PURE__ */ e.jsx("div", { className: "md:pt-2", children: s })
  ] }) : !s && (o == null ? void 0 : o.length) > 1 ? /* @__PURE__ */ e.jsx(
    Ia,
    {
      className: "w-full ",
      label: a("form.labels.contract"),
      options: o,
      onChange: t,
      showAll: !0
    }
  ) : null;
}, Va = ({
  hits: t,
  labelKey: n,
  search: r,
  dates: s,
  setAgreements: a,
  otherFilters: o,
  hideCommuter: i
}) => {
  const { t: c } = V(["account", "common"], {
    nsMode: "fallback"
  }), [l, d] = L(!0);
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    n && /* @__PURE__ */ e.jsx(
      M,
      {
        as: "h3",
        style: {
          fontWeight: "fontWeights.medium",
          fontSize: "fontSizes.300"
        },
        children: /* @__PURE__ */ e.jsx(he, { ns: "account", i18nKey: n, values: { amount: t }, children: /* @__PURE__ */ e.jsx(
          M,
          {
            as: "span",
            style: { fontWeight: "fontWeights.light" }
          }
        ) })
      }
    ),
    /* @__PURE__ */ e.jsxs("div", { className: "mt-6 flex flex-col gap-4", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-3 sm:flex-row sm:items-end", children: [
        r && /* @__PURE__ */ e.jsx(
          wl,
          {
            className: "sm:w-1/2",
            label: c(r.labelKey),
            query: r.query,
            setQuery: r.setSearch,
            description: c(r.descriptionKey ?? ""),
            maxLength: 30
          }
        ),
        /* @__PURE__ */ e.jsx(
          "button",
          {
            onClick: () => d((u) => !u),
            className: `${l ? "border-2" : "border-1"} h-12 min-w-40 rounded border border-blue-950 px-4 py-3`,
            children: c(l ? "form.labels.hideFilter" : "form.labels.showFilter")
          }
        )
      ] }),
      l && /* @__PURE__ */ e.jsxs("div", { className: "grid  grid-cols-2 gap-6 sm:grid-cols-3", children: [
        s && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx(
            rt,
            {
              label: c("form.labels.dateFrom"),
              className: "w-full",
              type: "date",
              value: (s == null ? void 0 : s.startDate) || "",
              onChange: (u) => s.setStartDate(u.target.value)
            }
          ),
          /* @__PURE__ */ e.jsx(
            rt,
            {
              label: c("form.labels.dateTo"),
              className: "w-full",
              type: "date",
              value: s.endDate || "",
              onChange: (u) => s.setEndDate(u.target.value)
            }
          )
        ] }),
        o == null ? void 0 : o.map((u) => u.multiSelect ? /* @__PURE__ */ e.jsx(
          Ia,
          {
            className: "w-full",
            label: c(u.labelKey),
            onChange: u.setValue,
            showAll: !0,
            options: u.options
          },
          u.labelKey
        ) : /* @__PURE__ */ e.jsx(
          mt,
          {
            className: "sm:w-1/3",
            label: c(u.labelKey),
            onChange: (m) => u.setValue(m),
            options: u.options
          },
          u.labelKey
        )),
        a && /* @__PURE__ */ e.jsx(
          df,
          {
            onAgreementChange: a,
            hideCommuter: i
          }
        )
      ] })
    ] })
  ] });
}, Il = kt(
  void 0
), $l = kt(
  void 0
), Fl = kt(
  void 0
), Bl = kt(
  {}
), Vl = kt(void 0), ql = kt(void 0);
var un = /* @__PURE__ */ ((t) => (t.Oresundsbron = "oresundsbron.com", t.OresundPay = "oresundpay.com", t.InternalTools = "tools.oresundsbron.com", t))(un || {});
const eC = ({
  appData: t,
  i18n: n,
  router: r,
  api: s,
  contentful: a,
  children: o,
  queryClient: i,
  context: c,
  authStore: l,
  contractsStore: d,
  localeStore: { getDateLocale: u },
  flags: m,
  contentRequest: f
}) => /* @__PURE__ */ e.jsx($l.Provider, { value: { appData: t }, children: /* @__PURE__ */ e.jsx(za.Provider, { value: { i18n: n, lng: (n == null ? void 0 : n.language) || "en" }, children: /* @__PURE__ */ e.jsx(Qr.Provider, { value: r, children: /* @__PURE__ */ e.jsx(ku, { contentful: a, api: s, children: /* @__PURE__ */ e.jsx(zu, { client: i, children: /* @__PURE__ */ e.jsx(Du, { context: c, children: /* @__PURE__ */ e.jsx(Il.Provider, { value: l, children: /* @__PURE__ */ e.jsx(ql.Provider, { value: d, children: /* @__PURE__ */ e.jsx(Fl.Provider, { value: { getDateLocale: u }, children: /* @__PURE__ */ e.jsx(Bl.Provider, { value: m, children: /* @__PURE__ */ e.jsx(
  Vl.Provider,
  {
    value: { contentRequest: f },
    children: o
  }
) }) }) }) }) }) }) }) }) }) }), Ft = () => {
  const t = pt($l);
  if (!t)
    throw new Error("useAppCommon must be used within an AppCommonProvider");
  const {
    appData: { app: n, baseURL: r, apiUrl: s, apiSecret: a, oresundPayBase: o }
  } = t;
  return {
    app: n,
    baseURL: r || "",
    apiUrl: s || "",
    apiSecret: a || "",
    oresundPayBase: o || ""
  };
};
function uf(t = 20, {
  searchText: n,
  agreements: r,
  fromDate: s,
  toDate: a
} = {}) {
  const [o, i] = L(1), c = {
    agreements: r,
    page: o,
    pageSize: t,
    fromDate: s,
    toDate: a,
    searchText: n
  }, l = hn(), { data: d, isFetching: u } = De(
    xe.TripsV2({ ...c, contractNo: l }),
    ({ Trips: m }) => m.listV2(c),
    {
      keepPreviousData: !0,
      suspense: !0
    }
  );
  return !d || u ? {
    isFetching: u,
    trips: [],
    totalTrips: 0,
    page: o,
    pages: 1,
    setPage: i
  } : {
    isFetching: u,
    trips: d.trips,
    page: o,
    pages: d.pages,
    totalTrips: d.totalTrips,
    setPage: i
  };
}
const mf = () => {
  const t = pt(Fl);
  if (!t)
    throw new Error("useAuthStore must be used within an AuthStoreProvider");
  const { getDateLocale: n } = t;
  return { locale: n() };
}, ff = ({ onAddReceipt: t }) => {
  const n = (G) => {
    const ee = /* @__PURE__ */ new Date();
    return ee.setMonth(ee.getMonth() - G), Dt(ee, "yyyy-MM-dd");
  }, { locale: r } = ve(), { locale: s } = mf(), { data: a } = bt(), [o, i] = L(""), [c, l] = L(
    n(12)
  ), [d, u] = L(n(0)), [m, f] = L([]), [p, b] = L(), { isMobile: h } = yl(), { t: g } = V(["account", "common"], {
    nsMode: "fallback"
  }), v = Ba(), y = {
    agreements: m,
    fromDate: c || void 0,
    toDate: d || void 0,
    /* operators, */
    searchText: o || void 0
  }, { trips: x, page: j, pages: w, setPage: C, totalTrips: P, isFetching: N } = uf(20, y), R = K(
    () => ({
      startDate: g("trips.labels.startDate"),
      endDate: g("trips.labels.endDate"),
      apply: g("trips.action.apply"),
      filter: g("trips.action.filter")
    }),
    [g]
  ), T = K(() => h ? [{ key: "tripDatetime", label: g("trips.columns.tripDatetime") }] : [
    { key: "tripDatetime", label: g("trips.columns.tripDatetime") },
    {
      key: "tripPaymentStation",
      label: g("form.labels.station")
    },
    {
      key: "tripRoute",
      label: g("trips.columns.tripRoute")
    },
    { key: "tripCost", label: g("trips.columns.tripCost") }
  ], [g, h]), z = Q(
    (G) => b((ee) => ee === G ? null : G),
    [b]
  ), D = async () => await (await fetch("/api/auth/access-token")).json(), { apiUrl: A, apiSecret: S } = Ft(), _ = Q(
    async (G) => {
      const ee = `${A}/api/customer/v1/trips/${v}/download`, ue = {
        headers: {
          Accept: G,
          Authorization: "",
          "x-azure-api-secret": S
        }
      }, ce = new URLSearchParams({}), re = await D();
      ue.headers.Authorization = `Bearer ${re}`, r && ce.append("lang", r), c && ce.append("fromDate", c), d && ce.append("toDate", d);
      const se = `${ee}?${ce.toString()}`, O = await (await fetch(se, ue)).blob(), ae = window.URL.createObjectURL(O), ge = document.createElement("a");
      ge.href = ae, ge.download = "trips-" + ua(), ge.click();
    },
    [v, r, c, d]
  ), $ = Q(
    async (G, ee, ue, ce, re) => {
      let se;
      const H = {
        headers: {
          Accept: re,
          Authorization: "",
          "x-azure-api-secret": S
        }
      };
      if (ce === "Trip") {
        const [F] = ue.split("-");
        se = `${A}/api/customer/v1/trips/${v}/download/${ee}/${F}?lang=${r}`;
      } else
        se = `${A}/api/customer/v1/trips/${v}/download/annualFee?lang=${r}`;
      const O = await D();
      H.headers.Authorization = `Bearer ${O}`;
      const ge = await (await fetch(se, H)).blob(), je = window.URL.createObjectURL(ge), I = document.createElement("a");
      I.href = je, I.download = "trip-" + ua(G), I.click();
    },
    [r, v]
  ), q = K(() => a ? a.activeDiscountAgreements.filter(
    ({ agreementType: G }) => !da(G)
  ).length > 0 : !1, [a]), U = (G) => G.contract === "Oresund_Business_Pendler" || G.contract === "Oresund_Business" ? G.price.amount : G.price.amountInclVAT;
  Y(() => {
    C(1);
  }, [o, c, d, m]);
  const W = () => {
    if (x.length === 0)
      return /* @__PURE__ */ e.jsx(st, { colorMode: "information", className: "mt-6 text-blue-700", children: g("kmtoll.userFeedBack.information.noResults") });
  };
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      Va,
      {
        hideCommuter: !0,
        hits: P,
        labelKey: "trips.label",
        search: {
          setSearch: i,
          query: o,
          labelKey: "action.search",
          descriptionKey: "form.labels.searchDescription"
        },
        setAgreements: f,
        dates: { startDate: c, endDate: d, setStartDate: l, setEndDate: u },
        otherFilters: [
          // Operators filter is hidden until requirements for it are figured out
          // {
          //   labelKey: 'form.labels.operator',
          //   multiSelect: true,
          //   options: operatorOptions,
          //   setValue: setOperators,
          // },
        ]
      }
    ),
    /* @__PURE__ */ e.jsxs("div", { className: "mt-7 flex flex-row justify-end", children: [
      q && /* @__PURE__ */ e.jsx(
        be,
        {
          intent: "text",
          startIcon: /* @__PURE__ */ e.jsx(cn, {}),
          onClick: t,
          children: g("invoices.action.addReceipt")
        }
      ),
      x.length > 0 && /* @__PURE__ */ e.jsxs(it.Root, { children: [
        /* @__PURE__ */ e.jsx(it.Trigger, { asChild: !0, children: /* @__PURE__ */ e.jsx(be, { intent: "text", startIcon: /* @__PURE__ */ e.jsx(Ln, {}), children: g("invoices.action.exportAllTrips") }) }),
        /* @__PURE__ */ e.jsx(it.Portal, { children: /* @__PURE__ */ e.jsxs(
          it.Content,
          {
            className: "w-48 rounded-lg bg-white px-1.5 py-1 shadow-md md:w-56",
            sideOffset: 5,
            children: [
              /* @__PURE__ */ e.jsx(
                it.Item,
                {
                  className: "cursor-pointer select-none items-center rounded-md px-2 py-2 text-sm text-neutral-600 outline-none  hover:text-black data-[highlighted]:bg-neutral-50 md:hover:bg-neutral-50",
                  onClick: () => _(on.CSV),
                  children: g("invoices.action.exportAllTripsAsCsv")
                }
              ),
              /* @__PURE__ */ e.jsx(
                it.Item,
                {
                  className: "cursor-pointer select-none items-center rounded-md px-2 py-2 text-sm text-neutral-600 outline-none hover:text-black data-[highlighted]:bg-neutral-50 md:hover:bg-neutral-50",
                  onClick: () => _(on.XLSX),
                  children: g("invoices.action.exportAllTripsAsExcel")
                }
              ),
              /* @__PURE__ */ e.jsx(
                it.Item,
                {
                  className: "cursor-pointer select-none items-center rounded-md px-2 py-2 text-sm text-neutral-900 outline-none hover:text-black data-[highlighted]:bg-neutral-50 md:hover:bg-neutral-50",
                  onClick: () => _(on.PDF),
                  children: g("invoices.action.exportAllTripsAsPdf")
                }
              ),
              /* @__PURE__ */ e.jsx(it.Arrow, { className: "fill-white" })
            ]
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ e.jsx(_a, { columns: T, labels: R, children: N ? /* @__PURE__ */ e.jsx("tr", { children: /* @__PURE__ */ e.jsx("td", { colSpan: 4, className: "py-4 text-center", children: /* @__PURE__ */ e.jsx("div", { className: "flex items-center justify-center", children: /* @__PURE__ */ e.jsx(Wn, {}) }) }) }) : x.map((G) => /* @__PURE__ */ e.jsxs(Sa, { children: [
      /* @__PURE__ */ e.jsxs(
        "tr",
        {
          onClick: () => z(G.id),
          className: "cursor-pointer text-sm leading-5 text-neutral-800 md:hover:bg-neutral-50",
          children: [
            /* @__PURE__ */ e.jsx("td", { className: "py-4", children: /* @__PURE__ */ e.jsxs("div", { className: "flex", children: [
              /* @__PURE__ */ e.jsx(
                "div",
                {
                  className: `text-sm ${h ? "flex-grow" : ""} transition-colors duration-300`,
                  children: Km(G.dateTime, s)
                }
              ),
              h && /* @__PURE__ */ e.jsx(
                Mt,
                {
                  "aria-label": p === G.id ? "expand" : "collapse",
                  variant: "text",
                  icon: _r,
                  className: "mr-3",
                  rotate: p === G.id ? "180deg" : "0deg",
                  sx: {
                    "svg path": { fill: "none" },
                    "svg, i": { height: "10px", width: "10px" }
                  },
                  style: { paddingRight: 0 }
                }
              )
            ] }) }),
            !h && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
              /* @__PURE__ */ e.jsx(
                "td",
                {
                  className: `leading-tight transition-colors duration-300 ${N ? "text-neutral-400" : "inherit"}`,
                  children: G.type === "AnnualFee" ? `${g("form.labels.price")} ${G.contract ? g(`agreementTypes.${G.contract}.label`) : "-"}` : G.station
                }
              ),
              /* @__PURE__ */ e.jsx("td", { children: G.route === "-" ? "-" : /* @__PURE__ */ e.jsx(
                jt,
                {
                  href: G.route,
                  className: "text-primary-600 py-2",
                  as: "a",
                  onClick: (ee) => {
                    ee.stopPropagation();
                  },
                  children: g("trips.labels.viewTripRoute")
                }
              ) }),
              /* @__PURE__ */ e.jsx(
                "td",
                {
                  className: `leading-tight transition-colors duration-300 ${N ? "text-neutral-400" : ""}`,
                  children: /* @__PURE__ */ e.jsxs("div", { className: "flex items-center justify-between", children: [
                    rr(
                      U(G),
                      G.price.currencyCode
                    ),
                    /* @__PURE__ */ e.jsxs("div", { className: "flex", children: [
                      /* @__PURE__ */ e.jsx(
                        "button",
                        {
                          className: "mr-4 p-2",
                          onClick: (ee) => {
                            ee.stopPropagation(), $(
                              G.dateTime,
                              G.listId,
                              G.id,
                              G.type,
                              on.PDF
                            );
                          },
                          children: /* @__PURE__ */ e.jsx(Ln, { className: "text-neutral-800" })
                        }
                      ),
                      /* @__PURE__ */ e.jsx(
                        Mt,
                        {
                          "aria-label": p === G.id ? "expand" : "collapse",
                          variant: "text",
                          icon: _r,
                          className: "mr-3",
                          rotate: p === G.id ? "180deg" : "0deg",
                          sx: {
                            "svg path": {
                              fill: "none",
                              stroke: N ? "colors.neutral.400" : "colors.neutral.900",
                              transition: "stroke 0.3s ease-in-out"
                            },
                            "svg, i": { height: "10px", width: "10px" }
                          },
                          style: { paddingRight: 0 }
                        }
                      )
                    ] })
                  ] })
                }
              )
            ] })
          ]
        }
      ),
      /* @__PURE__ */ e.jsx("tr", { className: "border-b border-neutral-400 transition-colors duration-300", children: /* @__PURE__ */ e.jsx("td", { colSpan: 4, "aria-colspan": 4, className: "py-0", children: /* @__PURE__ */ e.jsx(Lu, { open: p === G.id, children: /* @__PURE__ */ e.jsx(
        tf,
        {
          trip: G,
          isMobile: h,
          showColumns: ["tripPaymentStation", "tripRoute"],
          downloadTrip: $
        }
      ) }) }) })
    ] }, G.id)) }),
    W(),
    /* @__PURE__ */ e.jsx("div", { className: "mt-3", children: /* @__PURE__ */ e.jsx(
      Kr,
      {
        currentPage: j,
        totalPages: w,
        onPageChange: C,
        labels: {
          next: g("pagination.next"),
          previous: g("pagination.previous")
        }
      }
    ) })
  ] });
}, Wl = ({
  loadingLabel: t,
  size: n = "35px"
}) => /* @__PURE__ */ e.jsx("div", { className: "flex items-center justify-center p-10", children: /* @__PURE__ */ e.jsx("div", { style: { width: n }, children: /* @__PURE__ */ e.jsx(Tt, { "aria-label": t }) }) }), pf = ({
  contracts: t,
  labels: n
}) => {
  const { registerField: r, getError: s } = Se({
    namespace: "add-receipt"
  });
  return /* @__PURE__ */ e.jsx("div", { className: "mt-3", children: /* @__PURE__ */ e.jsxs(nn, { template: "two-column", children: [
    /* @__PURE__ */ e.jsx(yt, { children: /* @__PURE__ */ e.jsx(
      Mr,
      {
        label: n.contractNo,
        variant: "secondary",
        error: s("contractNo"),
        ...r("contractNo"),
        children: t.map(({ label: a, value: o }) => /* @__PURE__ */ e.jsx(zr, { value: o, children: a }, o))
      }
    ) }),
    /* @__PURE__ */ e.jsx(yt, { odd: !0, children: /* @__PURE__ */ e.jsx(
      en,
      {
        label: n.receiptNo,
        error: s("receiptNo"),
        required: !0,
        ...r("receiptNo")
      }
    ) })
  ] }) });
}, hf = (t) => !!t && typeof t == "object" && t.success === !1, gf = (t) => t.path.join("."), xf = (t) => (n) => {
  const r = {};
  for (const s of n.issues) {
    const a = gf(s), o = t(s.message);
    if (!r[a])
      r[a] = o;
    else {
      const i = r[a];
      r[a] = Array.isArray(i) ? [...i, o] : [i, o];
    }
  }
  return r;
}, rn = (t, n = (r) => r) => async (r) => {
  try {
    const s = await t(r);
    if (hf(s)) {
      const a = xf(n)(s.error) || {};
      return Object.keys(a).length > 0 ? a : void 0;
    }
    return;
  } catch {
    return;
  }
}, Hn = (t, n = (r) => r) => (r) => rn(t, n)(r), bf = (t, n = "") => {
  var a, o;
  const r = {}, s = Object.entries(t.shape());
  for (const [i, c] of s) {
    const l = n ? `${n}.${i}` : i, d = (o = (a = c._def) == null ? void 0 : a.schema) == null ? void 0 : o._def;
    d != null && d.shape ? Object.assign(r, bf(d, i)) : r[l] = !c.isOptional();
  }
  return r;
}, vf = ({
  onShowReceiptExample: t,
  onError: n
}) => {
  const r = qe(null), { t: s } = V(["trips", "common"], {
    nsMode: "fallback"
  }), a = Ye(), { close: o, nextStep: i } = wn(), { mutateAsync: c, isLoading: l } = ke(
    ["trips", "add-receipt"],
    ({ Trips: b }) => b.addReceipt,
    {
      onError: (b) => {
        n(b.code === 429 ? "429" : "general");
      },
      onSuccess: () => a.invalidateQueries({
        queryKey: xe.AllTrips()
      }),
      onSettled: i
    }
  ), { data: d } = bt(!0), u = K(() => {
    if (!d)
      return [];
    const b = d.activeDiscountAgreements.filter(
      ({ agreementType: h }) => h !== "Storebelt"
    );
    return b || [d.paymentAgreement];
  }, [d]), {
    handleSubmit: m,
    resetData: f,
    validate: p
  } = Se({
    namespace: "add-receipt",
    onValidate: Hn(fu.spa, s),
    onSubmit: ({ receiptNo: b, contractNo: h }) => c({ receipt: b, contractNo: h })
  });
  return /* @__PURE__ */ e.jsxs(
    Yr,
    {
      onSubmit: Kt(p, m),
      onReset: () => f(),
      ref: r,
      children: [
        /* @__PURE__ */ e.jsxs(Yt, { children: [
          /* @__PURE__ */ e.jsxs("div", { className: "w-0 min-w-full", children: [
            /* @__PURE__ */ e.jsx(de, { variant: "small", children: s("addReceiptModal.description.partOne") }),
            /* @__PURE__ */ e.jsx(de, { variant: "small", children: /* @__PURE__ */ e.jsxs(he, { ns: "trips", i18nKey: "addReceiptModal.description.partTwo", children: [
              /* @__PURE__ */ e.jsx(
                de,
                {
                  variant: "small",
                  as: "span",
                  sx: { fontWeight: "fontWeights.medium" }
                }
              ),
              /* @__PURE__ */ e.jsx(
                de,
                {
                  variant: "small",
                  as: "span",
                  sx: { fontWeight: "fontWeights.medium" }
                }
              )
            ] }) }),
            /* @__PURE__ */ e.jsx(de, { variant: "small", children: s("addReceiptModal.description.partThree") })
          ] }),
          /* @__PURE__ */ e.jsx("div", { className: "pt-4", children: /* @__PURE__ */ e.jsx(
            Mt,
            {
              variant: "text",
              style: { paddingLeft: 0 },
              onClick: t,
              type: "button",
              icon: Ud,
              sx: {
                span: {
                  textTransform: "initial",
                  display: "flex",
                  alignItems: "center"
                },
                svg: { width: 16, height: 16 },
                "svg path": { fill: "none" }
              },
              children: s("addReceiptModal.receiptExample")
            }
          ) }),
          /* @__PURE__ */ e.jsx(
            pf,
            {
              labels: {
                contractNo: s("form.labels.discountAgreement"),
                receiptNo: s("form.labels.receiptNo")
              },
              contracts: u.map(({ agreementType: b, contractNo: h }) => ({
                label: s(`agreementTypes.${b}.label`),
                value: h
              }))
            }
          )
        ] }),
        /* @__PURE__ */ e.jsx(
          It,
          {
            cancelLabel: s("action.cancel"),
            actionLabel: s("action.add"),
            onClose: o,
            cancelButtonType: "reset",
            actionButtonType: "submit",
            isLoading: l,
            loadingLabel: s("action.loading"),
            loadingButton: !0
          }
        )
      ]
    }
  );
}, yf = ({ error: t }) => {
  const { t: n } = V(["trips", "common"], {
    nsMode: "fallback"
  }), { close: r } = wn(), s = K(
    () => t ? `errorCodes.${t}` : "success",
    [t]
  );
  return /* @__PURE__ */ e.jsxs(
    Yt,
    {
      sx: { display: "flex", flexDirection: "column", alignItems: "center" },
      children: [
        /* @__PURE__ */ e.jsx("div", { className: "pt-1", children: t ? /* @__PURE__ */ e.jsx(Ta, { width: "50px", height: "50px" }) : /* @__PURE__ */ e.jsx(Gd, { width: "50px", height: "50px" }) }),
        /* @__PURE__ */ e.jsx(
          de,
          {
            pt: "spacing.200",
            pb: "spacing.100",
            variant: "smallParagraph",
            sx: { maxWidth: "65ch", textAlign: "center" },
            children: n(`addReceiptModal.confirmation.${s}.description`)
          }
        ),
        /* @__PURE__ */ e.jsx(Mt, { variant: "text", onClick: r, children: n("action.complete") })
      ]
    }
  );
};
var Hl = {}, qa = {}, ns = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "warnOnce", {
    enumerable: !0,
    get: function() {
      return n;
    }
  });
  let n = (r) => {
  };
  if (process.env.NODE_ENV !== "production") {
    const r = /* @__PURE__ */ new Set();
    n = (s) => {
      r.has(s) || console.warn(s), r.add(s);
    };
  }
})(ns);
var Ul = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "getImageBlurSvg", {
    enumerable: !0,
    get: function() {
      return n;
    }
  });
  function n(r) {
    let { widthInt: s, heightInt: a, blurWidth: o, blurHeight: i, blurDataURL: c, objectFit: l } = r;
    const d = 20, u = o ? o * 40 : s, m = i ? i * 40 : a, f = u && m ? "viewBox='0 0 " + u + " " + m + "'" : "", p = f ? "none" : l === "contain" ? "xMidYMid" : l === "cover" ? "xMidYMid slice" : "none";
    return "%3Csvg xmlns='http://www.w3.org/2000/svg' " + f + "%3E%3Cfilter id='b' color-interpolation-filters='sRGB'%3E%3CfeGaussianBlur stdDeviation='" + d + "'/%3E%3CfeColorMatrix values='1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 100 -1' result='s'/%3E%3CfeFlood x='0' y='0' width='100%25' height='100%25'/%3E%3CfeComposite operator='out' in='s'/%3E%3CfeComposite in2='SourceGraphic'/%3E%3CfeGaussianBlur stdDeviation='" + d + "'/%3E%3C/filter%3E%3Cimage width='100%25' height='100%25' x='0' y='0' preserveAspectRatio='" + p + "' style='filter: url(%23b);' href='" + c + "'/%3E%3C/svg%3E";
  }
})(Ul);
var rs = {};
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function n(a, o) {
    for (var i in o) Object.defineProperty(a, i, {
      enumerable: !0,
      get: o[i]
    });
  }
  n(t, {
    VALID_LOADERS: function() {
      return r;
    },
    imageConfigDefault: function() {
      return s;
    }
  });
  const r = [
    "default",
    "imgix",
    "cloudinary",
    "akamai",
    "custom"
  ], s = {
    deviceSizes: [
      640,
      750,
      828,
      1080,
      1200,
      1920,
      2048,
      3840
    ],
    imageSizes: [
      16,
      32,
      48,
      64,
      96,
      128,
      256,
      384
    ],
    path: "/_next/image",
    loader: "default",
    loaderFile: "",
    domains: [],
    disableStaticImages: !1,
    minimumCacheTTL: 60,
    formats: [
      "image/webp"
    ],
    dangerouslyAllowSVG: !1,
    contentSecurityPolicy: "script-src 'none'; frame-src 'none'; sandbox;",
    contentDispositionType: "inline",
    localPatterns: void 0,
    remotePatterns: [],
    qualities: void 0,
    unoptimized: !1
  };
})(rs);
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), Object.defineProperty(t, "getImgProps", {
    enumerable: !0,
    get: function() {
      return p;
    }
  });
  const n = ns, r = Ul, s = rs, a = [
    "lazy",
    "eager",
    void 0
  ];
  function o(b) {
    return b.default !== void 0;
  }
  function i(b) {
    return b.src !== void 0;
  }
  function c(b) {
    return typeof b == "object" && (o(b) || i(b));
  }
  const l = /* @__PURE__ */ new Map();
  let d;
  function u(b) {
    return typeof b > "u" ? b : typeof b == "number" ? Number.isFinite(b) ? b : NaN : typeof b == "string" && /^[0-9]+$/.test(b) ? parseInt(b, 10) : NaN;
  }
  function m(b, h, g) {
    let { deviceSizes: v, allSizes: y } = b;
    if (g) {
      const j = /(^|\s)(1?\d?\d)vw/g, w = [];
      for (let C; C = j.exec(g); C)
        w.push(parseInt(C[2]));
      if (w.length) {
        const C = Math.min(...w) * 0.01;
        return {
          widths: y.filter((P) => P >= v[0] * C),
          kind: "w"
        };
      }
      return {
        widths: y,
        kind: "w"
      };
    }
    return typeof h != "number" ? {
      widths: v,
      kind: "w"
    } : {
      widths: [
        ...new Set(
          // > This means that most OLED screens that say they are 3x resolution,
          // > are actually 3x in the green color, but only 1.5x in the red and
          // > blue colors. Showing a 3x resolution image in the app vs a 2x
          // > resolution image will be visually the same, though the 3x image
          // > takes significantly more data. Even true 3x resolution screens are
          // > wasteful as the human eye cannot see that level of detail without
          // > something like a magnifying glass.
          // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
          [
            h,
            h * 2
            /*, width * 3*/
          ].map((j) => y.find((w) => w >= j) || y[y.length - 1])
        )
      ],
      kind: "x"
    };
  }
  function f(b) {
    let { config: h, src: g, unoptimized: v, width: y, quality: x, sizes: j, loader: w } = b;
    if (v)
      return {
        src: g,
        srcSet: void 0,
        sizes: void 0
      };
    const { widths: C, kind: P } = m(h, y, j), N = C.length - 1;
    return {
      sizes: !j && P === "w" ? "100vw" : j,
      srcSet: C.map((R, T) => w({
        config: h,
        src: g,
        quality: x,
        width: R
      }) + " " + (P === "w" ? R : T + 1) + P).join(", "),
      // It's intended to keep `src` the last attribute because React updates
      // attributes in order. If we keep `src` the first one, Safari will
      // immediately start to fetch `src`, before `sizes` and `srcSet` are even
      // updated by React. That causes multiple unnecessary requests if `srcSet`
      // and `sizes` are defined.
      // This bug cannot be reproduced in Chrome or Firefox.
      src: w({
        config: h,
        src: g,
        quality: x,
        width: C[N]
      })
    };
  }
  function p(b, h) {
    let { src: g, sizes: v, unoptimized: y = !1, priority: x = !1, loading: j, className: w, quality: C, width: P, height: N, fill: R = !1, style: T, overrideSrc: z, onLoad: D, onLoadingComplete: A, placeholder: S = "empty", blurDataURL: _, fetchPriority: $, decoding: q = "async", layout: U, objectFit: W, objectPosition: G, lazyBoundary: ee, lazyRoot: ue, ...ce } = b;
    const { imgConf: re, showAltText: se, blurComplete: H, defaultLoader: O } = h;
    let ae, ge = re || s.imageConfigDefault;
    if ("allSizes" in ge)
      ae = ge;
    else {
      var je;
      const B = [
        ...ge.deviceSizes,
        ...ge.imageSizes
      ].sort((Ce, Ee) => Ce - Ee), k = ge.deviceSizes.sort((Ce, Ee) => Ce - Ee), X = (je = ge.qualities) == null ? void 0 : je.sort((Ce, Ee) => Ce - Ee);
      ae = {
        ...ge,
        allSizes: B,
        deviceSizes: k,
        qualities: X
      };
    }
    if (typeof O > "u")
      throw new Error(`images.loaderFile detected but the file is missing default export.
Read more: https://nextjs.org/docs/messages/invalid-images-config`);
    let I = ce.loader || O;
    delete ce.loader, delete ce.srcSet;
    const F = "__next_img_default" in I;
    if (F) {
      if (ae.loader === "custom")
        throw new Error('Image with src "' + g + `" is missing "loader" prop.
Read more: https://nextjs.org/docs/messages/next-image-missing-loader`);
    } else {
      const B = I;
      I = (k) => {
        const { config: X, ...Ce } = k;
        return B(Ce);
      };
    }
    if (U) {
      U === "fill" && (R = !0);
      const B = {
        intrinsic: {
          maxWidth: "100%",
          height: "auto"
        },
        responsive: {
          width: "100%",
          height: "auto"
        }
      }, k = {
        responsive: "100vw",
        fill: "100vw"
      }, X = B[U];
      X && (T = {
        ...T,
        ...X
      });
      const Ce = k[U];
      Ce && !v && (v = Ce);
    }
    let We = "", oe = u(P), le = u(N), _e, $e;
    if (c(g)) {
      const B = o(g) ? g.default : g;
      if (!B.src)
        throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received " + JSON.stringify(B));
      if (!B.height || !B.width)
        throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received " + JSON.stringify(B));
      if (_e = B.blurWidth, $e = B.blurHeight, _ = _ || B.blurDataURL, We = B.src, !R) {
        if (!oe && !le)
          oe = B.width, le = B.height;
        else if (oe && !le) {
          const k = oe / B.width;
          le = Math.round(B.height * k);
        } else if (!oe && le) {
          const k = le / B.height;
          oe = Math.round(B.width * k);
        }
      }
    }
    g = typeof g == "string" ? g : We;
    let ie = !x && (j === "lazy" || typeof j > "u");
    (!g || g.startsWith("data:") || g.startsWith("blob:")) && (y = !0, ie = !1), ae.unoptimized && (y = !0), F && g.endsWith(".svg") && !ae.dangerouslyAllowSVG && (y = !0), x && ($ = "high");
    const ye = u(C);
    if (process.env.NODE_ENV !== "production") {
      if (ae.output === "export" && F && !y)
        throw new Error("Image Optimization using the default loader is not compatible with `{ output: 'export' }`.\n  Possible solutions:\n    - Remove `{ output: 'export' }` and run \"next start\" to run server mode including the Image Optimization API.\n    - Configure `{ images: { unoptimized: true } }` in `next.config.js` to disable the Image Optimization API.\n  Read more: https://nextjs.org/docs/messages/export-image-api");
      if (!g)
        y = !0;
      else if (R) {
        if (P)
          throw new Error('Image with src "' + g + '" has both "width" and "fill" properties. Only one should be used.');
        if (N)
          throw new Error('Image with src "' + g + '" has both "height" and "fill" properties. Only one should be used.');
        if (T != null && T.position && T.position !== "absolute")
          throw new Error('Image with src "' + g + '" has both "fill" and "style.position" properties. Images with "fill" always use position absolute - it cannot be modified.');
        if (T != null && T.width && T.width !== "100%")
          throw new Error('Image with src "' + g + '" has both "fill" and "style.width" properties. Images with "fill" always use width 100% - it cannot be modified.');
        if (T != null && T.height && T.height !== "100%")
          throw new Error('Image with src "' + g + '" has both "fill" and "style.height" properties. Images with "fill" always use height 100% - it cannot be modified.');
      } else {
        if (typeof oe > "u")
          throw new Error('Image with src "' + g + '" is missing required "width" property.');
        if (isNaN(oe))
          throw new Error('Image with src "' + g + '" has invalid "width" property. Expected a numeric value in pixels but received "' + P + '".');
        if (typeof le > "u")
          throw new Error('Image with src "' + g + '" is missing required "height" property.');
        if (isNaN(le))
          throw new Error('Image with src "' + g + '" has invalid "height" property. Expected a numeric value in pixels but received "' + N + '".');
      }
      if (!a.includes(j))
        throw new Error('Image with src "' + g + '" has invalid "loading" property. Provided "' + j + '" should be one of ' + a.map(String).join(",") + ".");
      if (x && j === "lazy")
        throw new Error('Image with src "' + g + `" has both "priority" and "loading='lazy'" properties. Only one should be used.`);
      if (S !== "empty" && S !== "blur" && !S.startsWith("data:image/"))
        throw new Error('Image with src "' + g + '" has invalid "placeholder" property "' + S + '".');
      if (S !== "empty" && oe && le && oe * le < 1600 && (0, n.warnOnce)('Image with src "' + g + '" is smaller than 40x40. Consider removing the "placeholder" property to improve performance.'), S === "blur" && !_) {
        const B = [
          "jpeg",
          "png",
          "webp",
          "avif"
        ];
        throw new Error('Image with src "' + g + `" has "placeholder='blur'" property but is missing the "blurDataURL" property.
        Possible solutions:
          - Add a "blurDataURL" property, the contents should be a small Data URL to represent the image
          - Change the "src" property to a static import with one of the supported file types: ` + B.join(",") + ` (animated images not supported)
          - Remove the "placeholder" property, effectively no blur effect
        Read more: https://nextjs.org/docs/messages/placeholder-blur-data-url`);
      }
      if ("ref" in ce && (0, n.warnOnce)('Image with src "' + g + '" is using unsupported "ref" property. Consider using the "onLoad" property instead.'), !y && !F) {
        const B = I({
          config: ae,
          src: g,
          width: oe || 400,
          quality: ye || 75
        });
        let k;
        try {
          k = new URL(B);
        } catch {
        }
        (B === g || k && k.pathname === g && !k.search) && (0, n.warnOnce)('Image with src "' + g + `" has a "loader" property that does not implement width. Please implement it or use the "unoptimized" property instead.
Read more: https://nextjs.org/docs/messages/next-image-missing-loader-width`);
      }
      A && (0, n.warnOnce)('Image with src "' + g + '" is using deprecated "onLoadingComplete" property. Please use the "onLoad" property instead.');
      for (const [B, k] of Object.entries({
        layout: U,
        objectFit: W,
        objectPosition: G,
        lazyBoundary: ee,
        lazyRoot: ue
      }))
        k && (0, n.warnOnce)('Image with src "' + g + '" has legacy prop "' + B + `". Did you forget to run the codemod?
Read more: https://nextjs.org/docs/messages/next-image-upgrade-to-13`);
      if (typeof window < "u" && !d && window.PerformanceObserver) {
        d = new PerformanceObserver((B) => {
          for (const X of B.getEntries()) {
            var k;
            const Ce = (X == null || (k = X.element) == null ? void 0 : k.src) || "", Ee = l.get(Ce);
            Ee && !Ee.priority && Ee.placeholder === "empty" && !Ee.src.startsWith("data:") && !Ee.src.startsWith("blob:") && (0, n.warnOnce)('Image with src "' + Ee.src + `" was detected as the Largest Contentful Paint (LCP). Please add the "priority" property if this image is above the fold.
Read more: https://nextjs.org/docs/api-reference/next/image#priority`);
          }
        });
        try {
          d.observe({
            type: "largest-contentful-paint",
            buffered: !0
          });
        } catch (B) {
          console.error(B);
        }
      }
    }
    const we = Object.assign(R ? {
      position: "absolute",
      height: "100%",
      width: "100%",
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      objectFit: W,
      objectPosition: G
    } : {}, se ? {} : {
      color: "transparent"
    }, T), Ae = !H && S !== "empty" ? S === "blur" ? 'url("data:image/svg+xml;charset=utf-8,' + (0, r.getImageBlurSvg)({
      widthInt: oe,
      heightInt: le,
      blurWidth: _e,
      blurHeight: $e,
      blurDataURL: _ || "",
      objectFit: we.objectFit
    }) + '")' : 'url("' + S + '")' : null;
    let J = Ae ? {
      backgroundSize: we.objectFit || "cover",
      backgroundPosition: we.objectPosition || "50% 50%",
      backgroundRepeat: "no-repeat",
      backgroundImage: Ae
    } : {};
    process.env.NODE_ENV === "development" && J.backgroundImage && S === "blur" && _ != null && _.startsWith("/") && (J.backgroundImage = 'url("' + _ + '")');
    const Pe = f({
      config: ae,
      src: g,
      unoptimized: y,
      width: oe,
      quality: ye,
      sizes: v,
      loader: I
    });
    if (process.env.NODE_ENV !== "production" && typeof window < "u") {
      let B;
      try {
        B = new URL(Pe.src);
      } catch {
        B = new URL(Pe.src, window.location.href);
      }
      l.set(B.href, {
        src: g,
        priority: x,
        placeholder: S
      });
    }
    return {
      props: {
        ...ce,
        loading: ie ? "lazy" : j,
        fetchPriority: $,
        width: oe,
        height: le,
        decoding: q,
        className: w,
        style: {
          ...we,
          ...J
        },
        sizes: Pe.sizes,
        srcSet: Pe.srcSet,
        src: z || Pe.src
      },
      meta: {
        unoptimized: y,
        priority: x,
        placeholder: S,
        fill: R
      }
    };
  }
})(qa);
var ma = { exports: {} }, Tr = { exports: {} }, Us = {}, ii;
function jf() {
  return ii || (ii = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function() {
        return o;
      }
    });
    const n = ot, r = typeof window > "u", s = r ? () => {
    } : n.useLayoutEffect, a = r ? () => {
    } : n.useEffect;
    function o(i) {
      const { headManager: c, reduceComponentsToState: l } = i;
      function d() {
        if (c && c.mountedInstances) {
          const m = n.Children.toArray(Array.from(c.mountedInstances).filter(Boolean));
          c.updateHead(l(m, i));
        }
      }
      if (r) {
        var u;
        c == null || (u = c.mountedInstances) == null || u.add(i.children), d();
      }
      return s(() => {
        var m;
        return c == null || (m = c.mountedInstances) == null || m.add(i.children), () => {
          var f;
          c == null || (f = c.mountedInstances) == null || f.delete(i.children);
        };
      }), s(() => (c && (c._pendingUpdate = d), () => {
        c && (c._pendingUpdate = d);
      })), a(() => (c && c._pendingUpdate && (c._pendingUpdate(), c._pendingUpdate = null), () => {
        c && c._pendingUpdate && (c._pendingUpdate(), c._pendingUpdate = null);
      })), null;
    }
  }(Us)), Us;
}
var Gs = {}, li;
function Cf() {
  return li || (li = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "AmpStateContext", {
      enumerable: !0,
      get: function() {
        return s;
      }
    });
    const s = (/* @__PURE__ */ Et._(ot)).default.createContext({});
    process.env.NODE_ENV !== "production" && (s.displayName = "AmpStateContext");
  }(Gs)), Gs;
}
var Ks = {}, ci;
function Gl() {
  return ci || (ci = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "HeadManagerContext", {
      enumerable: !0,
      get: function() {
        return s;
      }
    });
    const s = (/* @__PURE__ */ Et._(ot)).default.createContext({});
    process.env.NODE_ENV !== "production" && (s.displayName = "HeadManagerContext");
  }(Ks)), Ks;
}
var Ys = {}, di;
function wf() {
  return di || (di = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "isInAmpMode", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    function n(r) {
      let { ampFirst: s = !1, hybrid: a = !1, hasQuery: o = !1 } = r === void 0 ? {} : r;
      return s || a && o;
    }
  }(Ys)), Ys;
}
var ui;
function Nf() {
  return ui || (ui = 1, function(t, n) {
    "use client";
    Object.defineProperty(n, "__esModule", {
      value: !0
    });
    function r(x, j) {
      for (var w in j) Object.defineProperty(x, w, {
        enumerable: !0,
        get: j[w]
      });
    }
    r(n, {
      default: function() {
        return y;
      },
      defaultHead: function() {
        return f;
      }
    });
    const s = Et, a = $n, o = e, i = /* @__PURE__ */ a._(ot), c = /* @__PURE__ */ s._(jf()), l = Cf(), d = Gl(), u = wf(), m = ns;
    function f(x) {
      x === void 0 && (x = !1);
      const j = [
        /* @__PURE__ */ (0, o.jsx)("meta", {
          charSet: "utf-8"
        })
      ];
      return x || j.push(/* @__PURE__ */ (0, o.jsx)("meta", {
        name: "viewport",
        content: "width=device-width"
      })), j;
    }
    function p(x, j) {
      return typeof j == "string" || typeof j == "number" ? x : j.type === i.default.Fragment ? x.concat(
        // @ts-expect-error @types/react does not remove fragments but this could also return ReactPortal[]
        i.default.Children.toArray(j.props.children).reduce(
          // @ts-expect-error @types/react does not remove fragments but this could also return ReactPortal[]
          (w, C) => typeof C == "string" || typeof C == "number" ? w : w.concat(C),
          []
        )
      ) : x.concat(j);
    }
    const b = [
      "name",
      "httpEquiv",
      "charSet",
      "itemProp"
    ];
    function h() {
      const x = /* @__PURE__ */ new Set(), j = /* @__PURE__ */ new Set(), w = /* @__PURE__ */ new Set(), C = {};
      return (P) => {
        let N = !0, R = !1;
        if (P.key && typeof P.key != "number" && P.key.indexOf("$") > 0) {
          R = !0;
          const T = P.key.slice(P.key.indexOf("$") + 1);
          x.has(T) ? N = !1 : x.add(T);
        }
        switch (P.type) {
          case "title":
          case "base":
            j.has(P.type) ? N = !1 : j.add(P.type);
            break;
          case "meta":
            for (let T = 0, z = b.length; T < z; T++) {
              const D = b[T];
              if (P.props.hasOwnProperty(D))
                if (D === "charSet")
                  w.has(D) ? N = !1 : w.add(D);
                else {
                  const A = P.props[D], S = C[D] || /* @__PURE__ */ new Set();
                  (D !== "name" || !R) && S.has(A) ? N = !1 : (S.add(A), C[D] = S);
                }
            }
            break;
        }
        return N;
      };
    }
    function g(x, j) {
      const { inAmpMode: w } = j;
      return x.reduce(p, []).reverse().concat(f(w).reverse()).filter(h()).reverse().map((C, P) => {
        const N = C.key || P;
        if (process.env.NODE_ENV !== "development" && process.env.__NEXT_OPTIMIZE_FONTS && !w && C.type === "link" && C.props.href && // TODO(prateekbh@): Replace this with const from `constants` when the tree shaking works.
        [
          "https://fonts.googleapis.com/css",
          "https://use.typekit.net/"
        ].some((R) => C.props.href.startsWith(R))) {
          const R = {
            ...C.props || {}
          };
          return R["data-href"] = R.href, R.href = void 0, R["data-optimized-fonts"] = !0, /* @__PURE__ */ i.default.cloneElement(C, R);
        }
        if (process.env.NODE_ENV === "development")
          if (C.type === "script" && C.props.type !== "application/ld+json") {
            const R = C.props.src ? '<script> tag with src="' + C.props.src + '"' : "inline <script>";
            (0, m.warnOnce)("Do not add <script> tags using next/head (see " + R + `). Use next/script instead. 
See more info here: https://nextjs.org/docs/messages/no-script-tags-in-head-component`);
          } else C.type === "link" && C.props.rel === "stylesheet" && (0, m.warnOnce)('Do not add stylesheets using next/head (see <link rel="stylesheet"> tag with href="' + C.props.href + `"). Use Document instead. 
See more info here: https://nextjs.org/docs/messages/no-stylesheets-in-head-component`);
        return /* @__PURE__ */ i.default.cloneElement(C, {
          key: N
        });
      });
    }
    function v(x) {
      let { children: j } = x;
      const w = (0, i.useContext)(l.AmpStateContext), C = (0, i.useContext)(d.HeadManagerContext);
      return /* @__PURE__ */ (0, o.jsx)(c.default, {
        reduceComponentsToState: g,
        headManager: C,
        inAmpMode: (0, u.isInAmpMode)(w),
        children: j
      });
    }
    const y = v;
    (typeof n.default == "function" || typeof n.default == "object" && n.default !== null) && typeof n.default.__esModule > "u" && (Object.defineProperty(n.default, "__esModule", { value: !0 }), Object.assign(n.default, n), t.exports = n.default);
  }(Tr, Tr.exports)), Tr.exports;
}
var Qs = {}, mi;
function Pf() {
  return mi || (mi = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "ImageConfigContext", {
      enumerable: !0,
      get: function() {
        return a;
      }
    });
    const r = /* @__PURE__ */ Et._(ot), s = rs, a = r.default.createContext(s.imageConfigDefault);
    process.env.NODE_ENV !== "production" && (a.displayName = "ImageConfigContext");
  }(Qs)), Qs;
}
var Xs = {}, Js = {}, Zs = { exports: {} }, fi;
function Kl() {
  return fi || (fi = 1, (() => {
    var t = { 170: (a, o, i) => {
      const c = i(510), l = () => {
        if (typeof navigator < "u" && navigator.platform) {
          const u = navigator.platform.toLowerCase();
          return u === "win32" || u === "windows";
        }
        return typeof process < "u" && process.platform ? process.platform === "win32" : !1;
      };
      function d(u, m, f = !1) {
        return m && (m.windows === null || m.windows === void 0) && (m = { ...m, windows: l() }), c(u, m, f);
      }
      Object.assign(d, c), a.exports = d;
    }, 154: (a) => {
      const o = "\\\\/", i = `[^${o}]`, c = "\\.", l = "\\+", d = "\\?", u = "\\/", m = "(?=.)", f = "[^/]", p = `(?:${u}|$)`, b = `(?:^|${u})`, h = `${c}{1,2}${p}`, g = `(?!${c})`, v = `(?!${b}${h})`, y = `(?!${c}{0,1}${p})`, x = `(?!${h})`, j = `[^.${u}]`, w = `${f}*?`, P = { DOT_LITERAL: c, PLUS_LITERAL: l, QMARK_LITERAL: d, SLASH_LITERAL: u, ONE_CHAR: m, QMARK: f, END_ANCHOR: p, DOTS_SLASH: h, NO_DOT: g, NO_DOTS: v, NO_DOT_SLASH: y, NO_DOTS_SLASH: x, QMARK_NO_DOT: j, STAR: w, START_ANCHOR: b, SEP: "/" }, N = { ...P, SLASH_LITERAL: `[${o}]`, QMARK: i, STAR: `${i}*?`, DOTS_SLASH: `${c}{1,2}(?:[${o}]|$)`, NO_DOT: `(?!${c})`, NO_DOTS: `(?!(?:^|[${o}])${c}{1,2}(?:[${o}]|$))`, NO_DOT_SLASH: `(?!${c}{0,1}(?:[${o}]|$))`, NO_DOTS_SLASH: `(?!${c}{1,2}(?:[${o}]|$))`, QMARK_NO_DOT: `[^.${o}]`, START_ANCHOR: `(?:^|[${o}])`, END_ANCHOR: `(?:[${o}]|$)`, SEP: "\\" }, R = { alnum: "a-zA-Z0-9", alpha: "a-zA-Z", ascii: "\\x00-\\x7F", blank: " \\t", cntrl: "\\x00-\\x1F\\x7F", digit: "0-9", graph: "\\x21-\\x7E", lower: "a-z", print: "\\x20-\\x7E ", punct: "\\-!\"#$%&'()\\*+,./:;<=>?@[\\]^_`{|}~", space: " \\t\\r\\n\\v\\f", upper: "A-Z", word: "A-Za-z0-9_", xdigit: "A-Fa-f0-9" };
      a.exports = { MAX_LENGTH: 65536, POSIX_REGEX_SOURCE: R, REGEX_BACKSLASH: /\\(?![*+?^${}(|)[\]])/g, REGEX_NON_SPECIAL_CHARS: /^[^@![\].,$*+?^{}()|\\/]+/, REGEX_SPECIAL_CHARS: /[-*+?.^${}(|)[\]]/, REGEX_SPECIAL_CHARS_BACKREF: /(\\?)((\W)(\3*))/g, REGEX_SPECIAL_CHARS_GLOBAL: /([-*+?.^${}(|)[\]])/g, REGEX_REMOVE_BACKSLASH: /(?:\[.*?[^\\]\]|\\(?=.))/g, REPLACEMENTS: { "***": "*", "**/**": "**", "**/**/**": "**" }, CHAR_0: 48, CHAR_9: 57, CHAR_UPPERCASE_A: 65, CHAR_LOWERCASE_A: 97, CHAR_UPPERCASE_Z: 90, CHAR_LOWERCASE_Z: 122, CHAR_LEFT_PARENTHESES: 40, CHAR_RIGHT_PARENTHESES: 41, CHAR_ASTERISK: 42, CHAR_AMPERSAND: 38, CHAR_AT: 64, CHAR_BACKWARD_SLASH: 92, CHAR_CARRIAGE_RETURN: 13, CHAR_CIRCUMFLEX_ACCENT: 94, CHAR_COLON: 58, CHAR_COMMA: 44, CHAR_DOT: 46, CHAR_DOUBLE_QUOTE: 34, CHAR_EQUAL: 61, CHAR_EXCLAMATION_MARK: 33, CHAR_FORM_FEED: 12, CHAR_FORWARD_SLASH: 47, CHAR_GRAVE_ACCENT: 96, CHAR_HASH: 35, CHAR_HYPHEN_MINUS: 45, CHAR_LEFT_ANGLE_BRACKET: 60, CHAR_LEFT_CURLY_BRACE: 123, CHAR_LEFT_SQUARE_BRACKET: 91, CHAR_LINE_FEED: 10, CHAR_NO_BREAK_SPACE: 160, CHAR_PERCENT: 37, CHAR_PLUS: 43, CHAR_QUESTION_MARK: 63, CHAR_RIGHT_ANGLE_BRACKET: 62, CHAR_RIGHT_CURLY_BRACE: 125, CHAR_RIGHT_SQUARE_BRACKET: 93, CHAR_SEMICOLON: 59, CHAR_SINGLE_QUOTE: 39, CHAR_SPACE: 32, CHAR_TAB: 9, CHAR_UNDERSCORE: 95, CHAR_VERTICAL_LINE: 124, CHAR_ZERO_WIDTH_NOBREAK_SPACE: 65279, extglobChars(T) {
        return { "!": { type: "negate", open: "(?:(?!(?:", close: `))${T.STAR})` }, "?": { type: "qmark", open: "(?:", close: ")?" }, "+": { type: "plus", open: "(?:", close: ")+" }, "*": { type: "star", open: "(?:", close: ")*" }, "@": { type: "at", open: "(?:", close: ")" } };
      }, globChars(T) {
        return T === !0 ? N : P;
      } };
    }, 697: (a, o, i) => {
      const c = i(154), l = i(96), { MAX_LENGTH: d, POSIX_REGEX_SOURCE: u, REGEX_NON_SPECIAL_CHARS: m, REGEX_SPECIAL_CHARS_BACKREF: f, REPLACEMENTS: p } = c, b = (v, y) => {
        if (typeof y.expandRange == "function")
          return y.expandRange(...v, y);
        v.sort();
        const x = `[${v.join("-")}]`;
        try {
          new RegExp(x);
        } catch {
          return v.map((w) => l.escapeRegex(w)).join("..");
        }
        return x;
      }, h = (v, y) => `Missing ${v}: "${y}" - use "\\\\${y}" to match literal characters`, g = (v, y) => {
        if (typeof v != "string")
          throw new TypeError("Expected a string");
        v = p[v] || v;
        const x = { ...y }, j = typeof x.maxLength == "number" ? Math.min(d, x.maxLength) : d;
        let w = v.length;
        if (w > j)
          throw new SyntaxError(`Input length: ${w}, exceeds maximum allowed length: ${j}`);
        const C = { type: "bos", value: "", output: x.prepend || "" }, P = [C], N = x.capture ? "" : "?:", R = c.globChars(x.windows), T = c.extglobChars(R), { DOT_LITERAL: z, PLUS_LITERAL: D, SLASH_LITERAL: A, ONE_CHAR: S, DOTS_SLASH: _, NO_DOT: $, NO_DOT_SLASH: q, NO_DOTS_SLASH: U, QMARK: W, QMARK_NO_DOT: G, STAR: ee, START_ANCHOR: ue } = R, ce = (te) => `(${N}(?:(?!${ue}${te.dot ? _ : z}).)*?)`, re = x.dot ? "" : $, se = x.dot ? W : G;
        let H = x.bash === !0 ? ce(x) : ee;
        x.capture && (H = `(${H})`), typeof x.noext == "boolean" && (x.noextglob = x.noext);
        const O = { input: v, index: -1, start: 0, dot: x.dot === !0, consumed: "", output: "", prefix: "", backtrack: !1, negated: !1, brackets: 0, braces: 0, parens: 0, quotes: 0, globstar: !1, tokens: P };
        v = l.removePrefix(v, O), w = v.length;
        const ae = [], ge = [], je = [];
        let I = C, F;
        const We = () => O.index === w - 1, oe = O.peek = (te = 1) => v[O.index + te], le = O.advance = () => v[++O.index] || "", _e = () => v.slice(O.index + 1), $e = (te = "", B = 0) => {
          O.consumed += te, O.index += B;
        }, ie = (te) => {
          O.output += te.output != null ? te.output : te.value, $e(te.value);
        }, ye = () => {
          let te = 1;
          for (; oe() === "!" && (oe(2) !== "(" || oe(3) === "?"); )
            le(), O.start++, te++;
          return te % 2 === 0 ? !1 : (O.negated = !0, O.start++, !0);
        }, we = (te) => {
          O[te]++, je.push(te);
        }, Ae = (te) => {
          O[te]--, je.pop();
        }, J = (te) => {
          if (I.type === "globstar") {
            const B = O.braces > 0 && (te.type === "comma" || te.type === "brace"), k = te.extglob === !0 || ae.length && (te.type === "pipe" || te.type === "paren");
            te.type !== "slash" && te.type !== "paren" && !B && !k && (O.output = O.output.slice(0, -I.output.length), I.type = "star", I.value = "*", I.output = H, O.output += I.output);
          }
          if (ae.length && te.type !== "paren" && (ae[ae.length - 1].inner += te.value), (te.value || te.output) && ie(te), I && I.type === "text" && te.type === "text") {
            I.output = (I.output || I.value) + te.value, I.value += te.value;
            return;
          }
          te.prev = I, P.push(te), I = te;
        }, Pe = (te, B) => {
          const k = { ...T[B], conditions: 1, inner: "" };
          k.prev = I, k.parens = O.parens, k.output = O.output;
          const X = (x.capture ? "(" : "") + k.open;
          we("parens"), J({ type: te, value: B, output: O.output ? "" : S }), J({ type: "paren", extglob: !0, value: le(), output: X }), ae.push(k);
        }, Te = (te) => {
          let B = te.close + (x.capture ? ")" : ""), k;
          if (te.type === "negate") {
            let X = H;
            if (te.inner && te.inner.length > 1 && te.inner.includes("/") && (X = ce(x)), (X !== H || We() || /^\)+$/.test(_e())) && (B = te.close = `)$))${X}`), te.inner.includes("*") && (k = _e()) && /^\.[^\\/.]+$/.test(k)) {
              const Ce = g(k, { ...y, fastpaths: !1 }).output;
              B = te.close = `)${Ce})${X})`;
            }
            te.prev.type === "bos" && (O.negatedExtglob = !0);
          }
          J({ type: "paren", extglob: !0, value: F, output: B }), Ae("parens");
        };
        if (x.fastpaths !== !1 && !/(^[*!]|[/()[\]{}"])/.test(v)) {
          let te = !1, B = v.replace(f, (k, X, Ce, Ee, Fe, _t) => Ee === "\\" ? (te = !0, k) : Ee === "?" ? X ? X + Ee + (Fe ? W.repeat(Fe.length) : "") : _t === 0 ? se + (Fe ? W.repeat(Fe.length) : "") : W.repeat(Ce.length) : Ee === "." ? z.repeat(Ce.length) : Ee === "*" ? X ? X + Ee + (Fe ? H : "") : H : X ? k : `\\${k}`);
          return te === !0 && (x.unescape === !0 ? B = B.replace(/\\/g, "") : B = B.replace(/\\+/g, (k) => k.length % 2 === 0 ? "\\\\" : k ? "\\" : "")), B === v && x.contains === !0 ? (O.output = v, O) : (O.output = l.wrapOutput(B, O, y), O);
        }
        for (; !We(); ) {
          if (F = le(), F === "\0")
            continue;
          if (F === "\\") {
            const k = oe();
            if (k === "/" && x.bash !== !0 || k === "." || k === ";")
              continue;
            if (!k) {
              F += "\\", J({ type: "text", value: F });
              continue;
            }
            const X = /^\\+/.exec(_e());
            let Ce = 0;
            if (X && X[0].length > 2 && (Ce = X[0].length, O.index += Ce, Ce % 2 !== 0 && (F += "\\")), x.unescape === !0 ? F = le() : F += le(), O.brackets === 0) {
              J({ type: "text", value: F });
              continue;
            }
          }
          if (O.brackets > 0 && (F !== "]" || I.value === "[" || I.value === "[^")) {
            if (x.posix !== !1 && F === ":") {
              const k = I.value.slice(1);
              if (k.includes("[") && (I.posix = !0, k.includes(":"))) {
                const X = I.value.lastIndexOf("["), Ce = I.value.slice(0, X), Ee = I.value.slice(X + 2), Fe = u[Ee];
                if (Fe) {
                  I.value = Ce + Fe, O.backtrack = !0, le(), !C.output && P.indexOf(I) === 1 && (C.output = S);
                  continue;
                }
              }
            }
            (F === "[" && oe() !== ":" || F === "-" && oe() === "]") && (F = `\\${F}`), F === "]" && (I.value === "[" || I.value === "[^") && (F = `\\${F}`), x.posix === !0 && F === "!" && I.value === "[" && (F = "^"), I.value += F, ie({ value: F });
            continue;
          }
          if (O.quotes === 1 && F !== '"') {
            F = l.escapeRegex(F), I.value += F, ie({ value: F });
            continue;
          }
          if (F === '"') {
            O.quotes = O.quotes === 1 ? 0 : 1, x.keepQuotes === !0 && J({ type: "text", value: F });
            continue;
          }
          if (F === "(") {
            we("parens"), J({ type: "paren", value: F });
            continue;
          }
          if (F === ")") {
            if (O.parens === 0 && x.strictBrackets === !0)
              throw new SyntaxError(h("opening", "("));
            const k = ae[ae.length - 1];
            if (k && O.parens === k.parens + 1) {
              Te(ae.pop());
              continue;
            }
            J({ type: "paren", value: F, output: O.parens ? ")" : "\\)" }), Ae("parens");
            continue;
          }
          if (F === "[") {
            if (x.nobracket === !0 || !_e().includes("]")) {
              if (x.nobracket !== !0 && x.strictBrackets === !0)
                throw new SyntaxError(h("closing", "]"));
              F = `\\${F}`;
            } else
              we("brackets");
            J({ type: "bracket", value: F });
            continue;
          }
          if (F === "]") {
            if (x.nobracket === !0 || I && I.type === "bracket" && I.value.length === 1) {
              J({ type: "text", value: F, output: `\\${F}` });
              continue;
            }
            if (O.brackets === 0) {
              if (x.strictBrackets === !0)
                throw new SyntaxError(h("opening", "["));
              J({ type: "text", value: F, output: `\\${F}` });
              continue;
            }
            Ae("brackets");
            const k = I.value.slice(1);
            if (I.posix !== !0 && k[0] === "^" && !k.includes("/") && (F = `/${F}`), I.value += F, ie({ value: F }), x.literalBrackets === !1 || l.hasRegexChars(k))
              continue;
            const X = l.escapeRegex(I.value);
            if (O.output = O.output.slice(0, -I.value.length), x.literalBrackets === !0) {
              O.output += X, I.value = X;
              continue;
            }
            I.value = `(${N}${X}|${I.value})`, O.output += I.value;
            continue;
          }
          if (F === "{" && x.nobrace !== !0) {
            we("braces");
            const k = { type: "brace", value: F, output: "(", outputIndex: O.output.length, tokensIndex: O.tokens.length };
            ge.push(k), J(k);
            continue;
          }
          if (F === "}") {
            const k = ge[ge.length - 1];
            if (x.nobrace === !0 || !k) {
              J({ type: "text", value: F, output: F });
              continue;
            }
            let X = ")";
            if (k.dots === !0) {
              const Ce = P.slice(), Ee = [];
              for (let Fe = Ce.length - 1; Fe >= 0 && (P.pop(), Ce[Fe].type !== "brace"); Fe--)
                Ce[Fe].type !== "dots" && Ee.unshift(Ce[Fe].value);
              X = b(Ee, x), O.backtrack = !0;
            }
            if (k.comma !== !0 && k.dots !== !0) {
              const Ce = O.output.slice(0, k.outputIndex), Ee = O.tokens.slice(k.tokensIndex);
              k.value = k.output = "\\{", F = X = "\\}", O.output = Ce;
              for (const Fe of Ee)
                O.output += Fe.output || Fe.value;
            }
            J({ type: "brace", value: F, output: X }), Ae("braces"), ge.pop();
            continue;
          }
          if (F === "|") {
            ae.length > 0 && ae[ae.length - 1].conditions++, J({ type: "text", value: F });
            continue;
          }
          if (F === ",") {
            let k = F;
            const X = ge[ge.length - 1];
            X && je[je.length - 1] === "braces" && (X.comma = !0, k = "|"), J({ type: "comma", value: F, output: k });
            continue;
          }
          if (F === "/") {
            if (I.type === "dot" && O.index === O.start + 1) {
              O.start = O.index + 1, O.consumed = "", O.output = "", P.pop(), I = C;
              continue;
            }
            J({ type: "slash", value: F, output: A });
            continue;
          }
          if (F === ".") {
            if (O.braces > 0 && I.type === "dot") {
              I.value === "." && (I.output = z);
              const k = ge[ge.length - 1];
              I.type = "dots", I.output += F, I.value += F, k.dots = !0;
              continue;
            }
            if (O.braces + O.parens === 0 && I.type !== "bos" && I.type !== "slash") {
              J({ type: "text", value: F, output: z });
              continue;
            }
            J({ type: "dot", value: F, output: z });
            continue;
          }
          if (F === "?") {
            if (!(I && I.value === "(") && x.noextglob !== !0 && oe() === "(" && oe(2) !== "?") {
              Pe("qmark", F);
              continue;
            }
            if (I && I.type === "paren") {
              const X = oe();
              let Ce = F;
              (I.value === "(" && !/[!=<:]/.test(X) || X === "<" && !/<([!=]|\w+>)/.test(_e())) && (Ce = `\\${F}`), J({ type: "text", value: F, output: Ce });
              continue;
            }
            if (x.dot !== !0 && (I.type === "slash" || I.type === "bos")) {
              J({ type: "qmark", value: F, output: G });
              continue;
            }
            J({ type: "qmark", value: F, output: W });
            continue;
          }
          if (F === "!") {
            if (x.noextglob !== !0 && oe() === "(" && (oe(2) !== "?" || !/[!=<:]/.test(oe(3)))) {
              Pe("negate", F);
              continue;
            }
            if (x.nonegate !== !0 && O.index === 0) {
              ye();
              continue;
            }
          }
          if (F === "+") {
            if (x.noextglob !== !0 && oe() === "(" && oe(2) !== "?") {
              Pe("plus", F);
              continue;
            }
            if (I && I.value === "(" || x.regex === !1) {
              J({ type: "plus", value: F, output: D });
              continue;
            }
            if (I && (I.type === "bracket" || I.type === "paren" || I.type === "brace") || O.parens > 0) {
              J({ type: "plus", value: F });
              continue;
            }
            J({ type: "plus", value: D });
            continue;
          }
          if (F === "@") {
            if (x.noextglob !== !0 && oe() === "(" && oe(2) !== "?") {
              J({ type: "at", extglob: !0, value: F, output: "" });
              continue;
            }
            J({ type: "text", value: F });
            continue;
          }
          if (F !== "*") {
            (F === "$" || F === "^") && (F = `\\${F}`);
            const k = m.exec(_e());
            k && (F += k[0], O.index += k[0].length), J({ type: "text", value: F });
            continue;
          }
          if (I && (I.type === "globstar" || I.star === !0)) {
            I.type = "star", I.star = !0, I.value += F, I.output = H, O.backtrack = !0, O.globstar = !0, $e(F);
            continue;
          }
          let te = _e();
          if (x.noextglob !== !0 && /^\([^?]/.test(te)) {
            Pe("star", F);
            continue;
          }
          if (I.type === "star") {
            if (x.noglobstar === !0) {
              $e(F);
              continue;
            }
            const k = I.prev, X = k.prev, Ce = k.type === "slash" || k.type === "bos", Ee = X && (X.type === "star" || X.type === "globstar");
            if (x.bash === !0 && (!Ce || te[0] && te[0] !== "/")) {
              J({ type: "star", value: F, output: "" });
              continue;
            }
            const Fe = O.braces > 0 && (k.type === "comma" || k.type === "brace"), _t = ae.length && (k.type === "pipe" || k.type === "paren");
            if (!Ce && k.type !== "paren" && !Fe && !_t) {
              J({ type: "star", value: F, output: "" });
              continue;
            }
            for (; te.slice(0, 3) === "/**"; ) {
              const qt = v[O.index + 4];
              if (qt && qt !== "/")
                break;
              te = te.slice(3), $e("/**", 3);
            }
            if (k.type === "bos" && We()) {
              I.type = "globstar", I.value += F, I.output = ce(x), O.output = I.output, O.globstar = !0, $e(F);
              continue;
            }
            if (k.type === "slash" && k.prev.type !== "bos" && !Ee && We()) {
              O.output = O.output.slice(0, -(k.output + I.output).length), k.output = `(?:${k.output}`, I.type = "globstar", I.output = ce(x) + (x.strictSlashes ? ")" : "|$)"), I.value += F, O.globstar = !0, O.output += k.output + I.output, $e(F);
              continue;
            }
            if (k.type === "slash" && k.prev.type !== "bos" && te[0] === "/") {
              const qt = te[1] !== void 0 ? "|$" : "";
              O.output = O.output.slice(0, -(k.output + I.output).length), k.output = `(?:${k.output}`, I.type = "globstar", I.output = `${ce(x)}${A}|${A}${qt})`, I.value += F, O.output += k.output + I.output, O.globstar = !0, $e(F + le()), J({ type: "slash", value: "/", output: "" });
              continue;
            }
            if (k.type === "bos" && te[0] === "/") {
              I.type = "globstar", I.value += F, I.output = `(?:^|${A}|${ce(x)}${A})`, O.output = I.output, O.globstar = !0, $e(F + le()), J({ type: "slash", value: "/", output: "" });
              continue;
            }
            O.output = O.output.slice(0, -I.output.length), I.type = "globstar", I.output = ce(x), I.value += F, O.output += I.output, O.globstar = !0, $e(F);
            continue;
          }
          const B = { type: "star", value: F, output: H };
          if (x.bash === !0) {
            B.output = ".*?", (I.type === "bos" || I.type === "slash") && (B.output = re + B.output), J(B);
            continue;
          }
          if (I && (I.type === "bracket" || I.type === "paren") && x.regex === !0) {
            B.output = F, J(B);
            continue;
          }
          (O.index === O.start || I.type === "slash" || I.type === "dot") && (I.type === "dot" ? (O.output += q, I.output += q) : x.dot === !0 ? (O.output += U, I.output += U) : (O.output += re, I.output += re), oe() !== "*" && (O.output += S, I.output += S)), J(B);
        }
        for (; O.brackets > 0; ) {
          if (x.strictBrackets === !0) throw new SyntaxError(h("closing", "]"));
          O.output = l.escapeLast(O.output, "["), Ae("brackets");
        }
        for (; O.parens > 0; ) {
          if (x.strictBrackets === !0) throw new SyntaxError(h("closing", ")"));
          O.output = l.escapeLast(O.output, "("), Ae("parens");
        }
        for (; O.braces > 0; ) {
          if (x.strictBrackets === !0) throw new SyntaxError(h("closing", "}"));
          O.output = l.escapeLast(O.output, "{"), Ae("braces");
        }
        if (x.strictSlashes !== !0 && (I.type === "star" || I.type === "bracket") && J({ type: "maybe_slash", value: "", output: `${A}?` }), O.backtrack === !0) {
          O.output = "";
          for (const te of O.tokens)
            O.output += te.output != null ? te.output : te.value, te.suffix && (O.output += te.suffix);
        }
        return O;
      };
      g.fastpaths = (v, y) => {
        const x = { ...y }, j = typeof x.maxLength == "number" ? Math.min(d, x.maxLength) : d, w = v.length;
        if (w > j)
          throw new SyntaxError(`Input length: ${w}, exceeds maximum allowed length: ${j}`);
        v = p[v] || v;
        const { DOT_LITERAL: C, SLASH_LITERAL: P, ONE_CHAR: N, DOTS_SLASH: R, NO_DOT: T, NO_DOTS: z, NO_DOTS_SLASH: D, STAR: A, START_ANCHOR: S } = c.globChars(x.windows), _ = x.dot ? z : T, $ = x.dot ? D : T, q = x.capture ? "" : "?:", U = { negated: !1, prefix: "" };
        let W = x.bash === !0 ? ".*?" : A;
        x.capture && (W = `(${W})`);
        const G = (re) => re.noglobstar === !0 ? W : `(${q}(?:(?!${S}${re.dot ? R : C}).)*?)`, ee = (re) => {
          switch (re) {
            case "*":
              return `${_}${N}${W}`;
            case ".*":
              return `${C}${N}${W}`;
            case "*.*":
              return `${_}${W}${C}${N}${W}`;
            case "*/*":
              return `${_}${W}${P}${N}${$}${W}`;
            case "**":
              return _ + G(x);
            case "**/*":
              return `(?:${_}${G(x)}${P})?${$}${N}${W}`;
            case "**/*.*":
              return `(?:${_}${G(x)}${P})?${$}${W}${C}${N}${W}`;
            case "**/.*":
              return `(?:${_}${G(x)}${P})?${C}${N}${W}`;
            default: {
              const se = /^(.*?)\.(\w+)$/.exec(re);
              if (!se) return;
              const H = ee(se[1]);
              return H ? H + C + se[2] : void 0;
            }
          }
        }, ue = l.removePrefix(v, U);
        let ce = ee(ue);
        return ce && x.strictSlashes !== !0 && (ce += `${P}?`), ce;
      }, a.exports = g;
    }, 510: (a, o, i) => {
      const c = i(716), l = i(697), d = i(96), u = i(154), m = (p) => p && typeof p == "object" && !Array.isArray(p), f = (p, b, h = !1) => {
        if (Array.isArray(p)) {
          const P = p.map((R) => f(R, b, h));
          return (R) => {
            for (const T of P) {
              const z = T(R);
              if (z) return z;
            }
            return !1;
          };
        }
        const g = m(p) && p.tokens && p.input;
        if (p === "" || typeof p != "string" && !g)
          throw new TypeError("Expected pattern to be a non-empty string");
        const v = b || {}, y = v.windows, x = g ? f.compileRe(p, b) : f.makeRe(p, b, !1, !0), j = x.state;
        delete x.state;
        let w = () => !1;
        if (v.ignore) {
          const P = { ...b, ignore: null, onMatch: null, onResult: null };
          w = f(v.ignore, P, h);
        }
        const C = (P, N = !1) => {
          const { isMatch: R, match: T, output: z } = f.test(P, x, b, { glob: p, posix: y }), D = { glob: p, state: j, regex: x, posix: y, input: P, output: z, match: T, isMatch: R };
          return typeof v.onResult == "function" && v.onResult(D), R === !1 ? (D.isMatch = !1, N ? D : !1) : w(P) ? (typeof v.onIgnore == "function" && v.onIgnore(D), D.isMatch = !1, N ? D : !1) : (typeof v.onMatch == "function" && v.onMatch(D), N ? D : !0);
        };
        return h && (C.state = j), C;
      };
      f.test = (p, b, h, { glob: g, posix: v } = {}) => {
        if (typeof p != "string")
          throw new TypeError("Expected input to be a string");
        if (p === "")
          return { isMatch: !1, output: "" };
        const y = h || {}, x = y.format || (v ? d.toPosixSlashes : null);
        let j = p === g, w = j && x ? x(p) : p;
        return j === !1 && (w = x ? x(p) : p, j = w === g), (j === !1 || y.capture === !0) && (y.matchBase === !0 || y.basename === !0 ? j = f.matchBase(p, b, h, v) : j = b.exec(w)), { isMatch: !!j, match: j, output: w };
      }, f.matchBase = (p, b, h) => (b instanceof RegExp ? b : f.makeRe(b, h)).test(d.basename(p)), f.isMatch = (p, b, h) => f(b, h)(p), f.parse = (p, b) => Array.isArray(p) ? p.map((h) => f.parse(h, b)) : l(p, { ...b, fastpaths: !1 }), f.scan = (p, b) => c(p, b), f.compileRe = (p, b, h = !1, g = !1) => {
        if (h === !0)
          return p.output;
        const v = b || {}, y = v.contains ? "" : "^", x = v.contains ? "" : "$";
        let j = `${y}(?:${p.output})${x}`;
        p && p.negated === !0 && (j = `^(?!${j}).*$`);
        const w = f.toRegex(j, b);
        return g === !0 && (w.state = p), w;
      }, f.makeRe = (p, b = {}, h = !1, g = !1) => {
        if (!p || typeof p != "string")
          throw new TypeError("Expected a non-empty string");
        let v = { negated: !1, fastpaths: !0 };
        return b.fastpaths !== !1 && (p[0] === "." || p[0] === "*") && (v.output = l.fastpaths(p, b)), v.output || (v = l(p, b)), f.compileRe(v, b, h, g);
      }, f.toRegex = (p, b) => {
        try {
          const h = b || {};
          return new RegExp(p, h.flags || (h.nocase ? "i" : ""));
        } catch (h) {
          if (b && b.debug === !0) throw h;
          return /$^/;
        }
      }, f.constants = u, a.exports = f;
    }, 716: (a, o, i) => {
      const c = i(96), { CHAR_ASTERISK: l, CHAR_AT: d, CHAR_BACKWARD_SLASH: u, CHAR_COMMA: m, CHAR_DOT: f, CHAR_EXCLAMATION_MARK: p, CHAR_FORWARD_SLASH: b, CHAR_LEFT_CURLY_BRACE: h, CHAR_LEFT_PARENTHESES: g, CHAR_LEFT_SQUARE_BRACKET: v, CHAR_PLUS: y, CHAR_QUESTION_MARK: x, CHAR_RIGHT_CURLY_BRACE: j, CHAR_RIGHT_PARENTHESES: w, CHAR_RIGHT_SQUARE_BRACKET: C } = i(154), P = (T) => T === b || T === u, N = (T) => {
        T.isPrefix !== !0 && (T.depth = T.isGlobstar ? 1 / 0 : 1);
      }, R = (T, z) => {
        const D = z || {}, A = T.length - 1, S = D.parts === !0 || D.scanToEnd === !0, _ = [], $ = [], q = [];
        let U = T, W = -1, G = 0, ee = 0, ue = !1, ce = !1, re = !1, se = !1, H = !1, O = !1, ae = !1, ge = !1, je = !1, I = !1, F = 0, We, oe, le = { value: "", depth: 0, isGlob: !1 };
        const _e = () => W >= A, $e = () => U.charCodeAt(W + 1), ie = () => (We = oe, U.charCodeAt(++W));
        for (; W < A; ) {
          oe = ie();
          let Pe;
          if (oe === u) {
            ae = le.backslashes = !0, oe = ie(), oe === h && (O = !0);
            continue;
          }
          if (O === !0 || oe === h) {
            for (F++; _e() !== !0 && (oe = ie()); ) {
              if (oe === u) {
                ae = le.backslashes = !0, ie();
                continue;
              }
              if (oe === h) {
                F++;
                continue;
              }
              if (O !== !0 && oe === f && (oe = ie()) === f) {
                if (ue = le.isBrace = !0, re = le.isGlob = !0, I = !0, S === !0)
                  continue;
                break;
              }
              if (O !== !0 && oe === m) {
                if (ue = le.isBrace = !0, re = le.isGlob = !0, I = !0, S === !0)
                  continue;
                break;
              }
              if (oe === j && (F--, F === 0)) {
                O = !1, ue = le.isBrace = !0, I = !0;
                break;
              }
            }
            if (S === !0)
              continue;
            break;
          }
          if (oe === b) {
            if (_.push(W), $.push(le), le = { value: "", depth: 0, isGlob: !1 }, I === !0) continue;
            if (We === f && W === G + 1) {
              G += 2;
              continue;
            }
            ee = W + 1;
            continue;
          }
          if (D.noext !== !0 && (oe === y || oe === d || oe === l || oe === x || oe === p) === !0 && $e() === g) {
            if (re = le.isGlob = !0, se = le.isExtglob = !0, I = !0, oe === p && W === G && (je = !0), S === !0) {
              for (; _e() !== !0 && (oe = ie()); ) {
                if (oe === u) {
                  ae = le.backslashes = !0, oe = ie();
                  continue;
                }
                if (oe === w) {
                  re = le.isGlob = !0, I = !0;
                  break;
                }
              }
              continue;
            }
            break;
          }
          if (oe === l) {
            if (We === l && (H = le.isGlobstar = !0), re = le.isGlob = !0, I = !0, S === !0)
              continue;
            break;
          }
          if (oe === x) {
            if (re = le.isGlob = !0, I = !0, S === !0)
              continue;
            break;
          }
          if (oe === v) {
            for (; _e() !== !0 && (Pe = ie()); ) {
              if (Pe === u) {
                ae = le.backslashes = !0, ie();
                continue;
              }
              if (Pe === C) {
                ce = le.isBracket = !0, re = le.isGlob = !0, I = !0;
                break;
              }
            }
            if (S === !0)
              continue;
            break;
          }
          if (D.nonegate !== !0 && oe === p && W === G) {
            ge = le.negated = !0, G++;
            continue;
          }
          if (D.noparen !== !0 && oe === g) {
            if (re = le.isGlob = !0, S === !0) {
              for (; _e() !== !0 && (oe = ie()); ) {
                if (oe === g) {
                  ae = le.backslashes = !0, oe = ie();
                  continue;
                }
                if (oe === w) {
                  I = !0;
                  break;
                }
              }
              continue;
            }
            break;
          }
          if (re === !0) {
            if (I = !0, S === !0)
              continue;
            break;
          }
        }
        D.noext === !0 && (se = !1, re = !1);
        let ye = U, we = "", Ae = "";
        G > 0 && (we = U.slice(0, G), U = U.slice(G), ee -= G), ye && re === !0 && ee > 0 ? (ye = U.slice(0, ee), Ae = U.slice(ee)) : re === !0 ? (ye = "", Ae = U) : ye = U, ye && ye !== "" && ye !== "/" && ye !== U && P(ye.charCodeAt(ye.length - 1)) && (ye = ye.slice(0, -1)), D.unescape === !0 && (Ae && (Ae = c.removeBackslashes(Ae)), ye && ae === !0 && (ye = c.removeBackslashes(ye)));
        const J = { prefix: we, input: T, start: G, base: ye, glob: Ae, isBrace: ue, isBracket: ce, isGlob: re, isExtglob: se, isGlobstar: H, negated: ge, negatedExtglob: je };
        if (D.tokens === !0 && (J.maxDepth = 0, P(oe) || $.push(le), J.tokens = $), D.parts === !0 || D.tokens === !0) {
          let Pe;
          for (let Te = 0; Te < _.length; Te++) {
            const te = Pe ? Pe + 1 : G, B = _[Te], k = T.slice(te, B);
            D.tokens && (Te === 0 && G !== 0 ? ($[Te].isPrefix = !0, $[Te].value = we) : $[Te].value = k, N($[Te]), J.maxDepth += $[Te].depth), (Te !== 0 || k !== "") && q.push(k), Pe = B;
          }
          if (Pe && Pe + 1 < T.length) {
            const Te = T.slice(Pe + 1);
            q.push(Te), D.tokens && ($[$.length - 1].value = Te, N($[$.length - 1]), J.maxDepth += $[$.length - 1].depth);
          }
          J.slashes = _, J.parts = q;
        }
        return J;
      };
      a.exports = R;
    }, 96: (a, o, i) => {
      const { REGEX_BACKSLASH: c, REGEX_REMOVE_BACKSLASH: l, REGEX_SPECIAL_CHARS: d, REGEX_SPECIAL_CHARS_GLOBAL: u } = i(154);
      o.isObject = (m) => m !== null && typeof m == "object" && !Array.isArray(m), o.hasRegexChars = (m) => d.test(m), o.isRegexChar = (m) => m.length === 1 && o.hasRegexChars(m), o.escapeRegex = (m) => m.replace(u, "\\$1"), o.toPosixSlashes = (m) => m.replace(c, "/"), o.removeBackslashes = (m) => m.replace(l, (f) => f === "\\" ? "" : f), o.escapeLast = (m, f, p) => {
        const b = m.lastIndexOf(f, p);
        return b === -1 ? m : m[b - 1] === "\\" ? o.escapeLast(m, f, b - 1) : `${m.slice(0, b)}\\${m.slice(b)}`;
      }, o.removePrefix = (m, f = {}) => {
        let p = m;
        return p.startsWith("./") && (p = p.slice(2), f.prefix = "./"), p;
      }, o.wrapOutput = (m, f = {}, p = {}) => {
        const b = p.contains ? "" : "^", h = p.contains ? "" : "$";
        let g = `${b}(?:${m})${h}`;
        return f.negated === !0 && (g = `(?:^(?!${g}).*$)`), g;
      }, o.basename = (m, { windows: f } = {}) => {
        const p = m.split(f ? /[\\/]/ : "/"), b = p[p.length - 1];
        return b === "" ? p[p.length - 2] : b;
      };
    } }, n = {};
    function r(a) {
      var o = n[a];
      if (o !== void 0)
        return o.exports;
      var i = n[a] = { exports: {} }, c = !0;
      try {
        t[a](i, i.exports, r), c = !1;
      } finally {
        c && delete n[a];
      }
      return i.exports;
    }
    typeof r < "u" && (r.ab = __dirname + "/");
    var s = r(170);
    Zs.exports = s;
  })()), Zs.exports;
}
var pi;
function Sf() {
  return pi || (pi = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function n(o, i) {
      for (var c in i) Object.defineProperty(o, c, {
        enumerable: !0,
        get: i[c]
      });
    }
    n(t, {
      hasLocalMatch: function() {
        return a;
      },
      matchLocalPattern: function() {
        return s;
      }
    });
    const r = Kl();
    function s(o, i) {
      if (o.search !== void 0 && o.search !== i.search)
        return !1;
      var c;
      return !!(0, r.makeRe)((c = o.pathname) != null ? c : "**", {
        dot: !0
      }).test(i.pathname);
    }
    function a(o, i) {
      if (!o)
        return !0;
      const c = new URL(i, "http://n");
      return o.some((l) => s(l, c));
    }
  }(Js)), Js;
}
var ea = {}, hi;
function Tf() {
  return hi || (hi = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    function n(o, i) {
      for (var c in i) Object.defineProperty(o, c, {
        enumerable: !0,
        get: i[c]
      });
    }
    n(t, {
      hasRemoteMatch: function() {
        return a;
      },
      matchRemotePattern: function() {
        return s;
      }
    });
    const r = Kl();
    function s(o, i) {
      if (o.protocol !== void 0) {
        const l = i.protocol.slice(0, -1);
        if (o.protocol !== l)
          return !1;
      }
      if (o.port !== void 0 && o.port !== i.port)
        return !1;
      if (o.hostname === void 0)
        throw new Error(`Pattern should define hostname but found
` + JSON.stringify(o));
      if (!(0, r.makeRe)(o.hostname).test(i.hostname) || o.search !== void 0 && o.search !== i.search)
        return !1;
      var c;
      return !!(0, r.makeRe)((c = o.pathname) != null ? c : "**", {
        dot: !0
      }).test(i.pathname);
    }
    function a(o, i, c) {
      return o.some((l) => c.hostname === l) || i.some((l) => s(l, c));
    }
  }(ea)), ea;
}
var gi;
function Yl() {
  return gi || (gi = 1, function(t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    }), Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function() {
        return s;
      }
    });
    const n = 75;
    function r(a) {
      let { config: o, src: i, width: c, quality: l } = a;
      var d;
      if (process.env.NODE_ENV !== "production") {
        const m = [];
        if (i || m.push("src"), c || m.push("width"), m.length > 0)
          throw new Error("Next Image Optimization requires " + m.join(", ") + " to be provided. Make sure you pass them as props to the `next/image` component. Received: " + JSON.stringify({
            src: i,
            width: c,
            quality: l
          }));
        if (i.startsWith("//"))
          throw new Error('Failed to parse src "' + i + '" on `next/image`, protocol-relative URL (//) must be changed to an absolute URL (http:// or https://)');
        if (i.startsWith("/") && o.localPatterns && process.env.NODE_ENV !== "test" && // micromatch isn't compatible with edge runtime
        process.env.NEXT_RUNTIME !== "edge") {
          const { hasLocalMatch: f } = Sf();
          if (!f(o.localPatterns, i))
            throw new Error("Invalid src prop (" + i + ") on `next/image` does not match `images.localPatterns` configured in your `next.config.js`\nSee more info: https://nextjs.org/docs/messages/next-image-unconfigured-localpatterns");
        }
        if (!i.startsWith("/") && (o.domains || o.remotePatterns)) {
          let f;
          try {
            f = new URL(i);
          } catch (p) {
            throw console.error(p), new Error('Failed to parse src "' + i + '" on `next/image`, if using relative image it must start with a leading slash "/" or be an absolute URL (http:// or https://)');
          }
          if (process.env.NODE_ENV !== "test" && // micromatch isn't compatible with edge runtime
          process.env.NEXT_RUNTIME !== "edge") {
            const { hasRemoteMatch: p } = Tf();
            if (!p(o.domains, o.remotePatterns, f))
              throw new Error("Invalid src prop (" + i + ') on `next/image`, hostname "' + f.hostname + '" is not configured under images in your `next.config.js`\nSee more info: https://nextjs.org/docs/messages/next-image-unconfigured-host');
          }
        }
        if (l && o.qualities && !o.qualities.includes(l))
          throw new Error("Invalid quality prop (" + l + ") on `next/image` does not match `images.qualities` configured in your `next.config.js`\nSee more info: https://nextjs.org/docs/messages/next-image-unconfigured-qualities");
      }
      const u = l || ((d = o.qualities) == null ? void 0 : d.reduce((m, f) => Math.abs(f - n) < Math.abs(m - n) ? f : m)) || n;
      return o.path + "?url=" + encodeURIComponent(i) + "&w=" + c + "&q=" + u + (process.env.NEXT_DEPLOYMENT_ID ? "&dpl=" + process.env.NEXT_DEPLOYMENT_ID : "");
    }
    r.__next_img_default = !0;
    const s = r;
  }(Xs)), Xs;
}
(function(t, n) {
  "use client";
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), Object.defineProperty(n, "Image", {
    enumerable: !0,
    get: function() {
      return x;
    }
  });
  const r = Et, s = $n, a = e, o = /* @__PURE__ */ s._(ot), i = /* @__PURE__ */ r._(fl), c = /* @__PURE__ */ r._(Nf()), l = qa, d = rs, u = Pf(), m = ns, f = _l(), p = /* @__PURE__ */ r._(Yl()), b = process.env.__NEXT_IMAGE_OPTS;
  typeof window > "u" && (globalThis.__NEXT_IMAGE_IMPORTED = !0);
  function h(j, w, C, P, N, R, T) {
    const z = j == null ? void 0 : j.src;
    if (!j || j["data-loaded-src"] === z)
      return;
    j["data-loaded-src"] = z, ("decode" in j ? j.decode() : Promise.resolve()).catch(() => {
    }).then(() => {
      if (!(!j.parentElement || !j.isConnected)) {
        if (w !== "empty" && N(!0), C != null && C.current) {
          const A = new Event("load");
          Object.defineProperty(A, "target", {
            writable: !1,
            value: j
          });
          let S = !1, _ = !1;
          C.current({
            ...A,
            nativeEvent: A,
            currentTarget: j,
            target: j,
            isDefaultPrevented: () => S,
            isPropagationStopped: () => _,
            persist: () => {
            },
            preventDefault: () => {
              S = !0, A.preventDefault();
            },
            stopPropagation: () => {
              _ = !0, A.stopPropagation();
            }
          });
        }
        if (P != null && P.current && P.current(j), process.env.NODE_ENV !== "production") {
          const A = new URL(z, "http://n").searchParams.get("url") || z;
          if (j.getAttribute("data-nimg") === "fill") {
            if (!R && (!T || T === "100vw") && j.getBoundingClientRect().width / window.innerWidth < 0.6 && (T === "100vw" ? (0, m.warnOnce)('Image with src "' + A + '" has "fill" prop and "sizes" prop of "100vw", but image is not rendered at full viewport width. Please adjust "sizes" to improve page performance. Read more: https://nextjs.org/docs/api-reference/next/image#sizes') : (0, m.warnOnce)('Image with src "' + A + '" has "fill" but is missing "sizes" prop. Please add it to improve page performance. Read more: https://nextjs.org/docs/api-reference/next/image#sizes')), j.parentElement) {
              const { position: $ } = window.getComputedStyle(j.parentElement), q = [
                "absolute",
                "fixed",
                "relative"
              ];
              q.includes($) || (0, m.warnOnce)('Image with src "' + A + '" has "fill" and parent element with invalid "position". Provided "' + $ + '" should be one of ' + q.map(String).join(",") + ".");
            }
            j.height === 0 && (0, m.warnOnce)('Image with src "' + A + '" has "fill" and a height value of 0. This is likely because the parent element of the image has not been styled to have a set height.');
          }
          const S = j.height.toString() !== j.getAttribute("height"), _ = j.width.toString() !== j.getAttribute("width");
          (S && !_ || !S && _) && (0, m.warnOnce)('Image with src "' + A + `" has either width or height modified, but not the other. If you use CSS to change the size of your image, also include the styles 'width: "auto"' or 'height: "auto"' to maintain the aspect ratio.`);
        }
      }
    });
  }
  function g(j) {
    return o.use ? {
      fetchPriority: j
    } : {
      fetchpriority: j
    };
  }
  const v = /* @__PURE__ */ (0, o.forwardRef)((j, w) => {
    let { src: C, srcSet: P, sizes: N, height: R, width: T, decoding: z, className: D, style: A, fetchPriority: S, placeholder: _, loading: $, unoptimized: q, fill: U, onLoadRef: W, onLoadingCompleteRef: G, setBlurComplete: ee, setShowAltText: ue, sizesInput: ce, onLoad: re, onError: se, ...H } = j;
    return /* @__PURE__ */ (0, a.jsx)("img", {
      ...H,
      ...g(S),
      // It's intended to keep `loading` before `src` because React updates
      // props in order which causes Safari/Firefox to not lazy load properly.
      // See https://github.com/facebook/react/issues/25883
      loading: $,
      width: T,
      height: R,
      decoding: z,
      "data-nimg": U ? "fill" : "1",
      className: D,
      style: A,
      // It's intended to keep `src` the last attribute because React updates
      // attributes in order. If we keep `src` the first one, Safari will
      // immediately start to fetch `src`, before `sizes` and `srcSet` are even
      // updated by React. That causes multiple unnecessary requests if `srcSet`
      // and `sizes` are defined.
      // This bug cannot be reproduced in Chrome or Firefox.
      sizes: N,
      srcSet: P,
      src: C,
      ref: (0, o.useCallback)((O) => {
        w && (typeof w == "function" ? w(O) : typeof w == "object" && (w.current = O)), O && (se && (O.src = O.src), process.env.NODE_ENV !== "production" && (C || console.error('Image is missing required "src" property:', O), O.getAttribute("alt") === null && console.error('Image is missing required "alt" property. Please add Alternative Text to describe the image for screen readers and search engines.')), O.complete && h(O, _, W, G, ee, q, ce));
      }, [
        C,
        _,
        W,
        G,
        ee,
        se,
        q,
        ce,
        w
      ]),
      onLoad: (O) => {
        const ae = O.currentTarget;
        h(ae, _, W, G, ee, q, ce);
      },
      onError: (O) => {
        ue(!0), _ !== "empty" && ee(!0), se && se(O);
      }
    });
  });
  function y(j) {
    let { isAppRouter: w, imgAttributes: C } = j;
    const P = {
      as: "image",
      imageSrcSet: C.srcSet,
      imageSizes: C.sizes,
      crossOrigin: C.crossOrigin,
      referrerPolicy: C.referrerPolicy,
      ...g(C.fetchPriority)
    };
    return w && i.default.preload ? (i.default.preload(
      C.src,
      // @ts-expect-error TODO: upgrade to `@types/react-dom@18.3.x`
      P
    ), null) : /* @__PURE__ */ (0, a.jsx)(c.default, {
      children: /* @__PURE__ */ (0, a.jsx)("link", {
        rel: "preload",
        // Note how we omit the `href` attribute, as it would only be relevant
        // for browsers that do not support `imagesrcset`, and in those cases
        // it would cause the incorrect image to be preloaded.
        //
        // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
        href: C.srcSet ? void 0 : C.src,
        ...P
      }, "__nimg-" + C.src + C.srcSet + C.sizes)
    });
  }
  const x = /* @__PURE__ */ (0, o.forwardRef)((j, w) => {
    const P = !(0, o.useContext)(f.RouterContext), N = (0, o.useContext)(u.ImageConfigContext), R = (0, o.useMemo)(() => {
      var G;
      const ee = b || N || d.imageConfigDefault, ue = [
        ...ee.deviceSizes,
        ...ee.imageSizes
      ].sort((se, H) => se - H), ce = ee.deviceSizes.sort((se, H) => se - H), re = (G = ee.qualities) == null ? void 0 : G.sort((se, H) => se - H);
      return {
        ...ee,
        allSizes: ue,
        deviceSizes: ce,
        qualities: re
      };
    }, [
      N
    ]), { onLoad: T, onLoadingComplete: z } = j, D = (0, o.useRef)(T);
    (0, o.useEffect)(() => {
      D.current = T;
    }, [
      T
    ]);
    const A = (0, o.useRef)(z);
    (0, o.useEffect)(() => {
      A.current = z;
    }, [
      z
    ]);
    const [S, _] = (0, o.useState)(!1), [$, q] = (0, o.useState)(!1), { props: U, meta: W } = (0, l.getImgProps)(j, {
      defaultLoader: p.default,
      imgConf: R,
      blurComplete: S,
      showAltText: $
    });
    return /* @__PURE__ */ (0, a.jsxs)(a.Fragment, {
      children: [
        /* @__PURE__ */ (0, a.jsx)(v, {
          ...U,
          unoptimized: W.unoptimized,
          placeholder: W.placeholder,
          fill: W.fill,
          onLoadRef: D,
          onLoadingCompleteRef: A,
          setBlurComplete: _,
          setShowAltText: q,
          sizesInput: j.sizes,
          ref: w
        }),
        W.priority ? /* @__PURE__ */ (0, a.jsx)(y, {
          isAppRouter: P,
          imgAttributes: U
        }) : null
      ]
    });
  });
  (typeof n.default == "function" || typeof n.default == "object" && n.default !== null) && typeof n.default.__esModule > "u" && (Object.defineProperty(n.default, "__esModule", { value: !0 }), Object.assign(n.default, n), t.exports = n.default);
})(ma, ma.exports);
var Ef = ma.exports;
(function(t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  });
  function n(l, d) {
    for (var u in d) Object.defineProperty(l, u, {
      enumerable: !0,
      get: d[u]
    });
  }
  n(t, {
    default: function() {
      return c;
    },
    getImageProps: function() {
      return i;
    }
  });
  const r = Et, s = qa, a = Ef, o = /* @__PURE__ */ r._(Yl());
  function i(l) {
    const { props: d } = (0, s.getImgProps)(l, {
      defaultLoader: o.default,
      // This is replaced by webpack define plugin
      imgConf: process.env.__NEXT_IMAGE_OPTS
    });
    for (const [u, m] of Object.entries(d))
      m === void 0 && delete d[u];
    return {
      props: d
    };
  }
  const c = a.Image;
})(Hl);
var kf = Hl;
const Wa = /* @__PURE__ */ qn(kf), Af = ({ onBack: t }) => {
  const { t: n } = V("common");
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(Yt, { children: /* @__PURE__ */ e.jsx("div", { className: "flex items-center justify-center p-6", children: /* @__PURE__ */ e.jsx(
      Wa,
      {
        width: 310,
        height: 485,
        src: "/images/receipt-example.png",
        alt: "Receipt Example"
      }
    ) }) }),
    /* @__PURE__ */ e.jsx(
      It,
      {
        cancelLabel: n("action.cancel"),
        actionLabel: n("action.back"),
        action: t,
        removeCancelButton: !0
      }
    )
  ] });
}, Of = () => {
  const [t, n] = L(), { t: r } = V(["trips", "common"], {
    nsMode: "fallback"
  }), { close: s, isOnLastStep: a } = wn(), o = K(
    () => a ? `addReceiptModal.confirmation.${t ? `errorCodes.${t}` : "success"}.title` : "addReceiptModal.label",
    [a, t]
  ), [i, c] = L(!1);
  return /* @__PURE__ */ e.jsxs(lr, { open: !0, ariaLabelledBy: "title", children: [
    /* @__PURE__ */ e.jsx(cr, { closeLabel: r("action.close"), onClose: s, children: r(o) }),
    /* @__PURE__ */ e.jsxs(Iu, { children: [
      /* @__PURE__ */ e.jsx(
        Ut,
        {
          fallback: /* @__PURE__ */ e.jsx(Wl, { loadingLabel: r("action.loading") }),
          children: i ? /* @__PURE__ */ e.jsx(Af, { onBack: () => c(!1) }) : /* @__PURE__ */ e.jsx(
            vf,
            {
              onShowReceiptExample: () => c(!0),
              onError: n
            }
          )
        }
      ),
      /* @__PURE__ */ e.jsx(yf, { error: t })
    ] })
  ] });
};
class Ql extends Dd {
  constructor(n) {
    super(n), this.state = { error: void 0 };
  }
  static getDerivedStateFromError(n) {
    return { error: n };
  }
  componentDidCatch(n, r) {
    console.log({ error: n, errorInfo: r });
  }
  render() {
    if (this.state.error) {
      if (this.props.fallback)
        return this.props.fallback;
      if (this.props.fallbackCallback)
        return this.props.fallbackCallback(this.state.error);
    }
    return this.props.children;
  }
}
const tC = () => {
  const { t } = V("common"), [n, r] = L(!1);
  return /* @__PURE__ */ e.jsxs("div", { children: [
    /* @__PURE__ */ e.jsx(
      Ql,
      {
        fallback: /* @__PURE__ */ e.jsx(st, { colorMode: "error", className: "mt-4", children: /* @__PURE__ */ e.jsx(e.Fragment, { children: t("errors.generic") }) }),
        children: /* @__PURE__ */ e.jsx(
          Ut,
          {
            fallback: /* @__PURE__ */ e.jsx("div", { className: "flex items-center justify-center p-12", children: /* @__PURE__ */ e.jsx("div", { className: "w-11", children: /* @__PURE__ */ e.jsx(Tt, { "aria-label": t("action.loading") }) }) }),
            children: /* @__PURE__ */ e.jsx(ff, { onAddReceipt: () => r(!0) })
          }
        )
      }
    ),
    n ? /* @__PURE__ */ e.jsx($u, { onClose: () => r(!1), hideProgress: !0, children: /* @__PURE__ */ e.jsx(zt, { children: /* @__PURE__ */ e.jsx(Of, {}) }) }) : null
  ] });
}, _f = (t) => {
  if (!t) return;
  const n = t.split("-");
  if (n.length === 0) return;
  const r = n[0], s = Number(r);
  return isNaN(s) ? void 0 : s;
}, Rf = (t, n) => t.filter((r) => n.includes(r.registrationNo)).map(({ id: r, label: s }) => ({ value: r, label: s })), Mf = () => {
  const { apiSecret: t, apiUrl: n } = Ft(), { locale: r } = ve();
  return Q(
    async ({ contractLineNo: a, contractNo: o }) => {
      const i = `${n}/api/customer/v1/recognition/vehicle-declaration?no=${a}&contractNo=${o}&lang=${r || ""}`, c = {
        headers: {
          Authorization: "",
          "x-azure-api-secret": t
        }
      }, d = await (await fetch("/api/auth/access-token")).json();
      c.headers.Authorization = `Bearer ${d}`;
      const m = await (await fetch(i, c)).blob(), f = window.URL.createObjectURL(m), p = document.createElement("a");
      p.href = f, p.download = `vehicle-declaration-${a}`, p.click();
    },
    [r]
  );
}, zf = () => {
  const { apiSecret: t, apiUrl: n } = Ft(), { locale: r } = ve();
  return Q(
    async (a, o) => {
      const i = o.length > 0 ? o.map((h) => `contractNo=${h}`).join("&") : "", c = `${n}/api/customer/v1/recognition/download?${i}&lang=${r}`, l = {
        headers: {
          Accept: a,
          Authorization: "",
          "x-azure-api-secret": t
        }
      }, u = await (await fetch("/api/auth/access-token")).json();
      l.headers.Authorization = `Bearer ${u}`;
      const f = await (await fetch(c, l)).blob(), p = window.URL.createObjectURL(f), b = document.createElement("a");
      b.href = p, b.download = "vehicles-" + ua(), b.click();
    },
    [r]
  );
}, Df = ({
  activeAgreements: t
}) => {
  const n = zf(), { t: r } = V(["recognitions", "common"], {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsxs(it.Root, { children: [
    /* @__PURE__ */ e.jsx(it.Trigger, { asChild: !0, children: /* @__PURE__ */ e.jsx(be, { startIcon: /* @__PURE__ */ e.jsx(Ln, {}), className: "pl-0", intent: "text", children: r("action.exportVehicles") }) }),
    /* @__PURE__ */ e.jsx(it.Portal, { children: /* @__PURE__ */ e.jsxs(
      it.Content,
      {
        className: "w-48 rounded-lg bg-white px-1.5 py-1 shadow-md md:w-56",
        sideOffset: 5,
        children: [
          /* @__PURE__ */ e.jsx(
            it.Item,
            {
              className: "cursor-pointer select-none items-center rounded-md px-2 py-2 text-sm text-neutral-600 outline-none  hover:text-black data-[highlighted]:bg-neutral-50 md:hover:bg-neutral-50",
              onClick: () => n(on.CSV, t),
              children: r("action.exportVehiclesAsCsv")
            }
          ),
          /* @__PURE__ */ e.jsx(
            it.Item,
            {
              className: "cursor-pointer select-none items-center rounded-md px-2 py-2 text-sm text-neutral-600 outline-none hover:text-black data-[highlighted]:bg-neutral-50 md:hover:bg-neutral-50",
              onClick: () => n(on.XLSX, t),
              children: r("action.exportVehiclesAsExcel")
            }
          ),
          /* @__PURE__ */ e.jsx(
            it.Item,
            {
              className: "cursor-pointer select-none items-center rounded-md px-2 py-2 text-sm text-neutral-600 outline-none hover:text-black data-[highlighted]:bg-neutral-50 md:hover:bg-neutral-50",
              onClick: () => n(on.PDF, t),
              children: r("action.exportVehiclesAsPDF")
            }
          ),
          /* @__PURE__ */ e.jsx(it.Arrow, { className: "fill-white" })
        ]
      }
    ) })
  ] });
}, Xl = ({
  open: t,
  className: n,
  onOpenChange: r,
  trigger: s,
  title: a,
  content: o,
  cancelText: i,
  confirmText: c,
  onAction: l,
  confirmColor: d = "negative"
}) => /* @__PURE__ */ e.jsxs(Jt.Root, { open: t, onOpenChange: r, children: [
  s && /* @__PURE__ */ e.jsx(Jt.Trigger, { asChild: !0, children: s }),
  /* @__PURE__ */ e.jsxs(Jt.Portal, { children: [
    /* @__PURE__ */ e.jsx(
      Jt.Overlay,
      {
        className: "fixed inset-0 z-40 bg-black/75",
        forceMount: !0
      }
    ),
    /* @__PURE__ */ e.jsxs(
      Jt.Content,
      {
        className: ct(
          "fixed inset-1/2 z-40 h-screen w-[100vw] translate-x-[-50%] translate-y-[-50%] bg-white p-6 sm:h-min sm:max-w-lg sm:rounded-2xl",
          n
        ),
        children: [
          /* @__PURE__ */ e.jsx(Jt.Title, { asChild: !0, children: /* @__PURE__ */ e.jsx(M, { intent: "title", children: a }) }),
          /* @__PURE__ */ e.jsx(Jt.Description, { asChild: !0, children: o }),
          /* @__PURE__ */ e.jsx("hr", { className: "mb-3 mt-6" }),
          /* @__PURE__ */ e.jsxs("div", { className: "flex justify-end gap-4", children: [
            /* @__PURE__ */ e.jsx(Jt.Cancel, { asChild: !0, children: /* @__PURE__ */ e.jsx(
              be,
              {
                intent: "text",
                color: "neutral",
                onClick: () => l(!1),
                children: i
              }
            ) }),
            /* @__PURE__ */ e.jsx(Jt.Action, { asChild: !0, children: /* @__PURE__ */ e.jsx(be, { color: d, onClick: () => l(!0), children: c }) })
          ] })
        ]
      }
    )
  ] })
] }), Bt = fn(function({
  className: n,
  title: r,
  footer: s,
  children: a,
  trigger: o,
  open: i,
  defaultOpen: c,
  onOpenChange: l,
  preventClose: d,
  contentWrapper: u
}, m) {
  const f = qe(null), p = qe(!1), [b, h] = L(
    () => i || c || !1
  ), [g, v] = L(!1), y = Q(() => {
    f.current && f.current.click();
  }, []);
  return Pa(m, () => ({
    close: y
  })), Y(() => {
    i !== void 0 && h(i);
  }, [i]), Y(() => {
    d ? p.current = !0 : p.current = !1;
  }, [d]), /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs(
      vt.Root,
      {
        onOpenChange: (x) => {
          if (!x && p.current) {
            v(!0);
            return;
          }
          l && l(x), h(x);
        },
        open: b,
        children: [
          o ? /* @__PURE__ */ e.jsx(vt.Trigger, { asChild: !0, onClick: () => h(!0), children: o }) : /* @__PURE__ */ e.jsx(vt.Trigger, {}),
          /* @__PURE__ */ e.jsx(vt.Portal, { children: /* @__PURE__ */ e.jsx(vt.Overlay, { className: "fixed inset-0 z-40 grid place-content-center overflow-y-auto bg-black/75", children: /* @__PURE__ */ e.jsxs(
            nt.Root,
            {
              as: vt.Content,
              className: ct(
                "max-h-screen w-[100vw] max-w-3xl overflow-y-auto p-6 shadow-md sm:my-4 sm:h-min sm:rounded-2xl",
                n
              ),
              rounded: !1,
              children: [
                /* @__PURE__ */ e.jsxs("div", { className: "flex justify-between", children: [
                  /* @__PURE__ */ e.jsx(M, { as: "h2", intent: "title", className: "mb-4 text-xl", children: r }),
                  /* @__PURE__ */ e.jsx(vt.Close, { asChild: !0, children: /* @__PURE__ */ e.jsx(
                    be,
                    {
                      intent: "text",
                      startIcon: /* @__PURE__ */ e.jsx(or, {}),
                      color: "primary",
                      iconSize: "lg",
                      ref: f
                    }
                  ) })
                ] }),
                u ? /* @__PURE__ */ e.jsxs(u, { children: [
                  a,
                  s ? /* @__PURE__ */ e.jsx(nt.Footer, { children: s(y) }) : null
                ] }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                  a,
                  s ? /* @__PURE__ */ e.jsx(nt.Footer, { children: s(y) }) : null
                ] })
              ]
            }
          ) }) })
        ]
      }
    ),
    d ? /* @__PURE__ */ e.jsx(
      Xl,
      {
        open: g,
        onOpenChange: v,
        ...d,
        onAction: (x) => {
          x && f.current && (p.current = !1, setTimeout(() => {
            y();
          }, 100));
        }
      }
    ) : null
  ] });
}), Jl = ({
  isOpen: t,
  onClose: n,
  onContinue: r
}) => {
  const { t: s } = V(["account", "common", "recognitions"], {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsx(
    Bt,
    {
      open: t,
      title: s("kmtoll.order.orderBizzOInfoModal.title"),
      onOpenChange: n,
      children: /* @__PURE__ */ e.jsxs("div", { className: "mb-4 gap-8", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-2", children: [
          /* @__PURE__ */ e.jsx("p", { children: s("kmtoll.order.orderBizzOInfoModal.preamble") }),
          /* @__PURE__ */ e.jsxs("ul", { className: "ml-3 h-full list-inside list-disc", children: [
            /* @__PURE__ */ e.jsx("li", { className: "mb-2", children: s("kmtoll.order.orderBizzOInfoModal.ListItemOne") }),
            /* @__PURE__ */ e.jsx("li", { children: s("kmtoll.order.orderBizzOInfoModal.ListItemTwo") })
          ] })
        ] }),
        /* @__PURE__ */ e.jsx("hr", { className: "mb-3 mt-8" }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex justify-end gap-2", children: [
          /* @__PURE__ */ e.jsx(
            be,
            {
              intent: "text",
              type: "button",
              className: "font-semibold text-blue-700 underline",
              onClick: n,
              children: s("action.cancelOrder")
            }
          ),
          /* @__PURE__ */ e.jsx(
            be,
            {
              type: "button",
              intent: "solid",
              className: "bg-blue-700 font-semibold",
              onClick: r,
              children: s("action.continue")
            }
          )
        ] })
      ] })
    }
  );
}, Lf = ({
  isOpen: t,
  onClose: n,
  contractNo: r,
  contractLineNo: s
}) => {
  const { t: a } = V(["account", "common", "recognitions"], {
    nsMode: "fallback"
  }), [o, i] = L(""), [c, l] = L(
    void 0
  ), d = Ye(), { mutateAsync: u } = ke(
    ["recognitions", "update"],
    ({ Recognition: f }) => f.updateRecognition,
    {
      onSuccess: () => (d.invalidateQueries({
        queryKey: ["account", "recognitions"]
      }), l(void 0), n())
    }
  ), m = async () => {
    try {
      await u({
        contractNo: r,
        contractLineNo: s,
        changes: {
          reference: o
        }
      }), l(void 0);
    } catch {
      l(a("kmtoll.landing.bizzList.referenceFieldError"));
    }
  };
  return /* @__PURE__ */ e.jsx(
    Bt,
    {
      className: "max-w-prose",
      open: t,
      title: a("action.editReference"),
      onOpenChange: n,
      children: /* @__PURE__ */ e.jsxs("div", { className: "mb-4 gap-8", children: [
        /* @__PURE__ */ e.jsx("div", { className: "mt-8", children: /* @__PURE__ */ e.jsx(
          rt,
          {
            onChange: (f) => i(f.target.value),
            value: o,
            label: a("kmtoll.landing.bizzList.referenceFieldLabel"),
            error: c
          }
        ) }),
        /* @__PURE__ */ e.jsx("hr", { className: "mb-3 mt-8" }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex justify-end gap-2", children: [
          /* @__PURE__ */ e.jsx(
            be,
            {
              intent: "text",
              type: "button",
              className: "font-semibold text-blue-700 underline",
              onClick: n,
              children: a("action.cancel")
            }
          ),
          /* @__PURE__ */ e.jsx(
            be,
            {
              type: "button",
              intent: "solid",
              className: "bg-blue-700 font-semibold",
              onClick: m,
              children: a("action.save")
            }
          )
        ] })
      ] })
    }
  );
}, Ot = (t) => qu.dataLayer({ dataLayer: t }), nC = (t) => Ot({
  event: "PageView",
  action: t
}), rC = ({ name: t, label: n, value: r }, s, a) => Ot({
  event: t,
  eventCategory: n === "web-vital" ? "Web Vitals" : "Next.js custom metric",
  eventValue: Math.round(t === "CLS" ? r * 1e3 : r),
  eventLabel: `/${s}${a}`,
  nonInteraction: !0
}), Ha = (t, n) => {
  Ot({
    event: "purchase",
    ecommerce: t,
    userData: n
  });
}, Ua = () => Ot({
  ecommerce: null
}), sC = (t) => {
  Ot({
    event: "contactUs",
    pagePath: document.location.href,
    loginMethod: t || ""
  });
}, aC = (t) => {
  Ot({
    event: "corporateForm",
    pagePath: document.location.href,
    subject: t
  });
}, oC = (t, n) => {
  Ot({
    event: "voucherDownload",
    locale: n,
    discountPercent: t.discount,
    voucherName: t.voucherName
  });
}, If = (t) => {
  Ot({
    event: "newsletterSignup",
    pagePath: document.location.href.replace(location.hash, ""),
    // Exclude hash from url, else it will be http://www.oresundsbron.com/sv/pendlare/oresund-pendlare-business/registrera#termsOfAgreement
    serviceType: t
  });
}, ta = (t, n) => {
  Ot({
    event: "click_replace_bizz",
    button_text: t,
    country: n
  });
}, xi = (t, n) => {
  Ot({
    event: "locations_replace_bizz",
    button_text: t,
    country: n
  });
}, bi = (t, n) => {
  Ot({
    event: "numberplate_replace_bizz",
    choice: t,
    country: n
  });
}, $f = (t) => {
  Ot({
    event: "confirm_adress_replace_bizz",
    country: t
  });
};
var Zl = /* @__PURE__ */ ((t) => (t.oresundPeriodCard = "oresundPeriodCard", t))(Zl || {});
const Ff = ({
  isOpen: t,
  isBizz: n,
  isExternalCustomer: r,
  isReplacable: s,
  onEditRecognition: a,
  onRemoveRecognition: o,
  onReplaceRecognition: i,
  paymentAgreementType: c,
  contract: l,
  isGNSS: d,
  contractNo: u,
  contractLineNo: m,
  serialNo: f
}) => {
  const { t: p } = V(["recognitions", "common"], {
    nsMode: "fallback"
  }), [b, h] = L(!1), [g, v] = L(!1), { locale: y, push: x } = ve(), j = () => {
    h(!1);
  }, w = () => {
    v(!1);
  }, C = () => {
    x(`./vehicles/change-vehicle?bizz=${f}`), v(!1);
  }, P = K(() => !r && s ? /* @__PURE__ */ e.jsx(
    Mt,
    {
      variant: "text",
      px: 0,
      sx: {
        span: { fontSize: "fontSizes.300" }
      },
      className: "mr-5",
      onClick: () => {
        i(), ta("replace", y);
      },
      small: !0,
      children: p("action.replace")
    }
  ) : null, [i, p, s, c]);
  return d && n && t ? /* @__PURE__ */ e.jsxs("div", { className: "flex gap-4", children: [
    /* @__PURE__ */ e.jsx(
      be,
      {
        padding: !1,
        intent: "text",
        type: "button",
        onClick: () => h(!0),
        className: " h-0 bg-white font-normal",
        children: p("action.updateReference")
      }
    ),
    /* @__PURE__ */ e.jsx(
      Lf,
      {
        onSubmit: a,
        isOpen: b,
        onClose: j,
        contractLineNo: m,
        contractNo: u
      }
    ),
    /* @__PURE__ */ e.jsx(
      be,
      {
        padding: !1,
        intent: "text",
        type: "button",
        onClick: () => v(!0),
        className: " h-0 bg-white font-normal",
        children: p("action.changeVehicle")
      }
    ),
    /* @__PURE__ */ e.jsx(
      Jl,
      {
        isOpen: g,
        onClose: w,
        onContinue: C
      }
    )
  ] }) : !t || r && !n ? null : r ? /* @__PURE__ */ e.jsxs(
    lt,
    {
      display: "flex",
      sx: {
        justifyContent: "flex-end",
        pt: "spacing.200",
        pb: "spacing.100"
      },
      children: [
        P,
        /* @__PURE__ */ e.jsx(
          Mt,
          {
            variant: "text",
            px: 0,
            sx: {
              span: { fontSize: "fontSizes.300" }
            },
            onClick: () => {
              a(), ta("edit", y);
            },
            small: !0,
            children: p("action.edit")
          }
        )
      ]
    }
  ) : /* @__PURE__ */ e.jsxs(
    lt,
    {
      display: "flex",
      sx: {
        justifyContent: "space-between",
        pt: "spacing.200",
        pb: "spacing.100"
      },
      children: [
        Object.values(Zl).includes(l) ? /* @__PURE__ */ e.jsx("span", { className: "mb-4 w-full text-center text-red-300 md:mt-4 md:text-lg", children: p("removeRecognitionModal.removeCarWithActiveAgreement") }) : !d && /* @__PURE__ */ e.jsx(
          Mt,
          {
            variant: "text",
            style: { paddingLeft: 0 },
            sx: {
              color: "colors.negative.300",
              "&:hover": { color: "colors.negative.200" },
              span: { fontSize: "fontSizes.300" }
            },
            onClick: o,
            small: !0,
            children: p(n ? "action.block" : "action.remove")
          }
        ),
        /* @__PURE__ */ e.jsxs(lt, { display: "flex", children: [
          P,
          !d && /* @__PURE__ */ e.jsx(
            Mt,
            {
              variant: "text",
              px: 0,
              sx: {
                span: { fontSize: "fontSizes.300" }
              },
              onClick: () => {
                a(), ta("edit", y);
              },
              small: !0,
              children: p("action.edit")
            }
          )
        ] })
      ]
    }
  );
}, Wt = {
  OresundGO: "oresundGo",
  OresundPendler: "oresundCommuter",
  Oresund_Business_Pendler: "oresundBusinessCommuter",
  Oresund_Business: "oresundBusiness",
  OresundPAY: "oresundPay",
  OresundPAYBusiness: "oresundPayBusiness",
  Storebelt: "storebelt",
  OresundPeriodCard: "oresundPeriodCard"
}, Ga = (t) => Wt[t], Bf = (t) => {
  const { data: n } = bt(!0, t), { data: r } = Ra(t), s = K(
    () => n == null ? void 0 : n.activeDiscountAgreements.find(
      ({ agreementType: o }) => [
        pe.OresundBusinessPendler,
        pe.OresundPendler,
        pe.OresundGo
      ].includes(o)
    ),
    [n == null ? void 0 : n.activeDiscountAgreements]
  ), a = ec(
    s,
    r
  );
  return { discountAgreement: s, contractTypeTranslationKey: a };
}, ec = (t, n) => t ? n ? Wt.OresundPeriodCard : Wt[t == null ? void 0 : t.agreementType] : Wt.OresundPAY, jn = (t) => !(t && t.id === nr.ORESUNDPAY), Vf = (t) => [pe.OresundPendler, pe.OresundBusinessPendler].includes(
  t
), qf = (t) => (n) => {
  if (n.length)
    return n.find(
      (r) => "value" in r ? r.value === t : r.serialNo === t
    );
}, Wf = () => {
  const { data: t, isLoading: n, error: r } = De(
    ["useGetRegistrationCertificates"],
    ({ Recognitions: s }) => s.registrationCertificates()
  );
  return { data: t, isLoading: n, error: r };
}, Hf = ({
  contractNo: t,
  registrationNo: n
}) => {
  const [r, s] = L(!1), { t: a } = V(["account", "common"], {
    nsMode: "fallback"
  }), o = Q(async () => {
    s(!1);
    try {
      const i = `${process.env.NEXT_PUBLIC_API_URL}/api/customer/v1/recognition/registration-certificate?contractNo=${t}&registrationNo=${n}`, c = {
        headers: {
          "x-azure-api-secret": process.env.API_SECRET || "",
          Accept: "application/pdf",
          Authorization: ""
        }
      }, d = await (await fetch("/api/auth/access-token")).json();
      c.headers.Authorization = `Bearer ${d}`;
      const u = await fetch(i, c);
      if (!u.ok) {
        s(!0);
        return;
      }
      const m = await u.blob(), f = window.URL.createObjectURL(m);
      let p = "vehicle-declaration.pdf";
      const b = u.headers.get("content-disposition");
      if (b) {
        const g = b.match(/filename="?(.+)"?/);
        g != null && g[1] && (p = g[1]);
      }
      const h = document.createElement("a");
      h.href = f, h.download = p, document.body.appendChild(h), h.click(), document.body.removeChild(h), window.URL.revokeObjectURL(f);
    } catch {
      s(!0);
    }
  }, [t, n]);
  return /* @__PURE__ */ e.jsxs("div", { className: "flex max-w-fit flex-col", children: [
    /* @__PURE__ */ e.jsx(
      be,
      {
        padding: !1,
        intent: "text",
        type: "button",
        style: {
          fontWeight: 400,
          fontSize: "fontSizes.200"
        },
        onClick: o,
        children: a("kmtoll.landing.bizzList.downloadVehicleRegistration")
      }
    ),
    r && /* @__PURE__ */ e.jsx(st, { colorMode: "error", size: "small", children: a("errors.generic") })
  ] });
}, Uf = ({ recognition: t }) => {
  var z;
  const {
    contract: n,
    contractNo: r,
    contractLineNo: s,
    recognitionType: a,
    serialNo: o,
    registrationNo: i,
    fuelType: c,
    emissionClass: l,
    isHybrid: d,
    vehicleDeclarationAvailable: u,
    isGNSS: m,
    lineStatus: f,
    isReplaceable: p,
    isPeriodCardActive: b,
    reference: h,
    grossWeight: g,
    firstRegistation: v,
    endDate: y
  } = t, { t: x } = V(["account", "common"], {
    nsMode: "fallback"
  }), { data: j } = Ra(r), { data: w } = Wf(), { onEditRecognition: C, onReplaceRecognition: P, onRemoveRecognition: N } = v0(), R = jn(n.provider), T = Mf();
  return /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsxs("div", { className: "mt-4 flex flex-col gap-8 sm:gap-6 sm:px-2 ", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col ", children: [
      /* @__PURE__ */ e.jsx("h2", { className: "pb-2 text-base font-semibold sm:text-lg", children: x("kmtoll.landing.bizzList.agreementDetails") }),
      /* @__PURE__ */ e.jsxs("div", { className: "grid grid-cols-1 gap-4  sm:flex sm:gap-6 ", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col text-sm sm:text-base", children: [
          /* @__PURE__ */ e.jsxs("span", { className: "sm:text-sm", children: [
            x("kmtoll.landing.bizzList.operatorAgreement"),
            ":"
          ] }),
          /* @__PURE__ */ e.jsx("span", { className: "text-sm sm:text-base", children: n.agreementType })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col text-sm sm:text-base", children: [
          /* @__PURE__ */ e.jsxs("span", { className: "sm:text-sm", children: [
            x("kmtoll.landing.bizzList.activeDiscountAgreement"),
            ":"
          ] }),
          /* @__PURE__ */ e.jsx("span", { className: "text-sm sm:text-base", children: n.isDiscount ? x("hybrid.true") : x("hybrid.false") })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col text-sm sm:text-base", children: [
          /* @__PURE__ */ e.jsxs("span", { className: "sm:text-sm", children: [
            x("kmtoll.landing.bizzList.startDate"),
            ":"
          ] }),
          /* @__PURE__ */ e.jsx("span", { children: n.startDate })
        ] })
      ] })
    ] }),
    a === "bizz" && /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col ", children: [
      /* @__PURE__ */ e.jsx("h2", { className: "pb-2 text-base font-semibold sm:text-lg", children: x("kmtoll.landing.bizzList.bizzDetails") }),
      /* @__PURE__ */ e.jsxs("div", { className: "grid grid-cols-1 gap-4 sm:flex sm:gap-6", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col text-sm sm:text-base", children: [
          /* @__PURE__ */ e.jsxs("span", { className: "sm:text-sm", children: [
            x("kmtoll.landing.bizzList.bizzType"),
            ":"
          ] }),
          /* @__PURE__ */ e.jsx("span", { className: "", children: a })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col text-sm sm:text-base", children: [
          /* @__PURE__ */ e.jsxs("span", { className: "sm:text-sm", children: [
            x("kmtoll.landing.bizzList.bizzNumber"),
            ":"
          ] }),
          /* @__PURE__ */ e.jsx("span", { children: o || "-" })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col text-sm sm:text-base", children: [
          /* @__PURE__ */ e.jsxs("span", { className: "sm:text-sm", children: [
            x("kmtoll.landing.bizzList.reference"),
            ":"
          ] }),
          /* @__PURE__ */ e.jsx("span", { children: h || "-" })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col", children: [
      /* @__PURE__ */ e.jsx("h2", { className: "pb-2 text-base font-semibold sm:text-lg", children: x("kmtoll.landing.bizzList.vehicleInformation") }),
      /* @__PURE__ */ e.jsxs("div", { className: "grid grid-cols-1 flex-wrap gap-4 sm:flex sm:gap-6", children: [
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col text-sm sm:text-base", children: [
          /* @__PURE__ */ e.jsx("span", { className: "sm:text-sm", children: x("kmtoll.landing.bizzList.registrationNumber") }),
          /* @__PURE__ */ e.jsx("span", { className: "", children: i })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col text-sm sm:text-base", children: [
          /* @__PURE__ */ e.jsx("span", { className: "sm:text-sm", children: x("kmtoll.landing.bizzList.fuel") }),
          /* @__PURE__ */ e.jsx("span", { children: c == null ? void 0 : c.label })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col text-sm sm:text-base", children: [
          /* @__PURE__ */ e.jsx("span", { className: "sm:text-sm", children: x("kmtoll.landing.bizzList.emissionClass") }),
          /* @__PURE__ */ e.jsx("span", { children: l == null ? void 0 : l.label })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col text-sm sm:text-base", children: [
          /* @__PURE__ */ e.jsx("span", { className: "sm:text-sm", children: x("kmtoll.landing.bizzList.hybrid") }),
          /* @__PURE__ */ e.jsx("span", { children: x(d === !1 ? "hybrid.false" : "hybrid.true") })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col text-sm sm:text-base", children: [
          /* @__PURE__ */ e.jsx("span", { className: "sm:text-sm", children: x("kmtoll.landing.bizzList.exactWeight") }),
          /* @__PURE__ */ e.jsx("span", { children: g || "-" })
        ] }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col text-sm sm:text-base", children: [
          /* @__PURE__ */ e.jsx("span", { className: "sm:text-sm", children: x("kmtoll.landing.bizzList.registrationDate") }),
          /* @__PURE__ */ e.jsx("span", { children: v || "-" })
        ] }),
        y ? /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col text-sm sm:text-base", children: [
          /* @__PURE__ */ e.jsx("span", { className: "sm:text-sm", children: x("kmtoll.landing.bizzList.endDate") }),
          /* @__PURE__ */ e.jsx("span", { children: y })
        ] }) : null
      ] })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col items-start justify-between gap-4 md:flex-row md:items-center", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex items-center gap-4", children: [
        u && /* @__PURE__ */ e.jsx(
          be,
          {
            padding: !1,
            intent: "text",
            type: "button",
            style: {
              fontWeight: 400,
              fontSize: "fontSizes.200"
            },
            onClick: () => T(t),
            children: x("kmtoll.landing.bizzList.downLoadVehicleDeclaration")
          }
        ),
        ((z = w == null ? void 0 : w[r]) == null ? void 0 : z.map((D) => D.toLocaleLowerCase()).includes(i.toLocaleLowerCase())) && /* @__PURE__ */ e.jsx(
          Hf,
          {
            contractNo: r,
            registrationNo: i
          }
        )
      ] }),
      /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
        Ff,
        {
          isGNSS: m,
          serialNo: o,
          isBizz: a === "bizz",
          isExternalCustomer: R,
          isOpen: f === "open",
          isReplacable: p,
          paymentAgreementType: n.provider.id,
          onEditRecognition: () => C == null ? void 0 : C(t),
          onReplaceRecognition: () => P == null ? void 0 : P(t),
          contract: ec(
            n,
            b ? j : void 0
          ),
          contractNo: r,
          contractLineNo: s,
          onRemoveRecognition: () => N == null ? void 0 : N({
            contractLineNos: [s],
            contractNo: String(n.contractNo),
            recognitionType: a
          })
        }
      ) })
    ] })
  ] }) });
}, Gf = (t) => {
  const { t: n } = V(["account"], {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    n("singleOrderBizzFlow.order.summary.Obus.info.autopass"),
    t.isGNSS && `, ${n("singleOrderBizzFlow.order.summary.Obus.info.gnss")}`,
    // asFinag is only applicable and should only be displayed for vehicles that are not GNSS
    t.isAsfinag && !t.isGNSS && `, ${n("singleOrderBizzFlow.order.summary.Obus.info.asFinag")}`
  ] });
}, Kf = ({
  recognitions: t,
  currentPage: n,
  totalPages: r,
  setPage: s
}) => {
  const { t: a } = V(["account", "common", "recognitions"], {
    nsMode: "fallback"
  }), [o, i] = L(null), c = (d) => {
    i((u) => u === d ? null : d);
  }, l = [
    {
      key: "bizzNumber",
      label: a("kmtoll.landing.bizzList.bizzNumber"),
      classNames: "text-start pb-2 "
    },
    {
      key: "",
      label: "",
      classNames: "w-18 pb-2"
    },
    {
      key: "country",
      label: a("form.labels.country"),
      classNames: "text-start pb-2"
    },
    {
      key: "licencePlateShort",
      label: a("form.labels.licencePlateShort"),
      classNames: "text-start pb-2"
    },
    {
      key: "weightClass",
      label: a("form.labels.weightClass"),
      classNames: "text-start pb-2"
    },
    {
      key: "validFor",
      label: a("form.labels.validFor"),
      classNames: "text-start pb-2 lg:w-34"
    },
    {
      key: "",
      label: "",
      classNames: "text-start pb-2"
    }
  ];
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("table", { className: "mt-16 w-full table-auto ", children: [
      /* @__PURE__ */ e.jsx("thead", { className: "border-b-2 text-sm ", children: /* @__PURE__ */ e.jsx("tr", { className: "w-full", children: l.map((d, u) => /* @__PURE__ */ e.jsx(
        "th",
        {
          className: `${d.classNames} ${d.key === "contractNo" || d.key === "" ? "" : "hidden sm:table-cell"}`,
          children: d.label
        },
        u
      )) }) }),
      /* @__PURE__ */ e.jsx("tbody", { children: t.map((d, u) => /* @__PURE__ */ e.jsxs(Sa, { children: [
        /* @__PURE__ */ e.jsxs(
          "tr",
          {
            className: `cursor-pointer text-sm leading-5 text-neutral-950 ${o === u ? "border-b-0" : "border-b border-b-neutral-400"}`,
            onClick: () => c(u),
            children: [
              /* @__PURE__ */ e.jsxs("td", { className: "flex flex-row justify-start  gap-3 py-4", children: [
                /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col", children: [
                  /* @__PURE__ */ e.jsxs("div", { className: "flex flex-row items-center gap-1", children: [
                    d.recognitionType === "bizz" ? /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(Kd, { width: 15, height: 15 }) }) : /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(Hr, { width: 15, height: 15 }) }),
                    /* @__PURE__ */ e.jsx("div", { className: "font-semibold", children: d.serialNo ? d.serialNo : a("kmtoll.landing.bizzList.ordered") })
                  ] }),
                  /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsxs("span", { className: "text-xs", children: [
                    a("kmtoll.landing.bizzList.reference"),
                    ":",
                    " ",
                    d.reference ? d.reference : "-"
                  ] }) })
                ] }),
                d.recognitionType === "bizz" && /* @__PURE__ */ e.jsx("div", { className: " sm:hidden", children: /* @__PURE__ */ e.jsx(Lr, { status: d.lineStatus }) })
              ] }),
              /* @__PURE__ */ e.jsx("td", { className: "hidden sm:table-cell", children: d.recognitionType === "bizz" && /* @__PURE__ */ e.jsx("div", { className: "m-auto h-fit w-fit", children: /* @__PURE__ */ e.jsx(Lr, { status: d.lineStatus }) }) }),
              /* @__PURE__ */ e.jsx("td", { className: "m-auto hidden py-4 sm:table-cell", children: d.countryCode }),
              /* @__PURE__ */ e.jsx("td", { className: "hidden sm:table-cell", children: d.registrationNo }),
              /* @__PURE__ */ e.jsxs("td", { className: "hidden sm:table-cell", children: [
                d.grossWeight === 0 ? "-" : d.grossWeight !== void 0 ? a(Fm(d.grossWeight)) : a("kmtoll.landing.bizzList.vehicle.weight.unknown"),
                " "
              ] }),
              /* @__PURE__ */ e.jsx("td", { className: "hidden sm:table-cell", children: /* @__PURE__ */ e.jsx(
                Gf,
                {
                  isGNSS: d.isGNSS,
                  isAsfinag: d.isAsfinag
                }
              ) }),
              /* @__PURE__ */ e.jsx("td", { className: "", children: /* @__PURE__ */ e.jsx(
                _r,
                {
                  className: `transition-transform ${o === u ? "rotate-180" : ""} ml-auto text-black `,
                  onClick: (m) => {
                    m.stopPropagation(), c(u);
                  }
                }
              ) })
            ]
          }
        ),
        o === u && /* @__PURE__ */ e.jsx("tr", { className: "border-b border-neutral-400 pr-0 transition-colors duration-300 ease-in-out", children: /* @__PURE__ */ e.jsx("td", { colSpan: l.length, children: /* @__PURE__ */ e.jsx(Uf, { recognition: d }) }) })
      ] }, u)) })
    ] }),
    r > 1 && /* @__PURE__ */ e.jsx("div", { className: "mt-10 flex justify-between text-sm font-medium uppercase text-neutral-500", children: /* @__PURE__ */ e.jsx(
      Kr,
      {
        currentPage: n,
        totalPages: r,
        onPageChange: s,
        labels: {
          next: a("pagination.next"),
          previous: a("pagination.previous")
        }
      }
    ) })
  ] });
};
function Yf({
  searchText: t,
  contractNo: n,
  fromDate: r,
  toDate: s,
  status: a
} = {}) {
  const [o, i] = L(1), c = {
    searchText: t,
    fromDate: r,
    toDate: s,
    contractNo: n,
    status: a,
    page: o
  }, l = hn(), { data: d } = De(
    xe.ListCustomerInvoices({ params: c, currentContractNo: l }),
    ({ Customer: u }) => u.invoices(c),
    { suspense: !0, keepPreviousData: !0 }
  );
  return d ? {
    invoices: d.invoices,
    page: o,
    pages: d.pages,
    total: d.total,
    setPage: i
  } : {
    invoices: [],
    total: 0,
    page: o,
    pages: 1,
    setPage: i
  };
}
const iC = () => {
  const [t, n] = L(""), [r, s] = L([]), [a, o] = L(null), [i, c] = L(null), [l, d] = L([]), { locale: u } = ve(), { t: m } = V(["account", "common"], { nsMode: "fallback" }), f = K(
    () => ({
      startDate: m("invoices.labels.startDate"),
      endDate: m("invoices.labels.endDate"),
      apply: m("invoices.action.apply"),
      filter: m("invoices.action.filter")
    }),
    [m]
  ), { isMobile: p } = yl(), b = K(
    () => p ? { display: "flex", justifyContent: "space-between" } : {},
    [p]
  ), { data: h } = lm(), g = K(
    () => (h == null ? void 0 : h.map(({ label: A, value: S }) => ({
      value: S,
      label: m(`invoices.status.${A}`)
    }))) || [],
    [h, m]
  ), v = K(() => p ? [{ key: "invoiceNumber", label: m("invoices.columns.invoiceNumber") }] : [
    { key: "invoiceNumber", label: m("invoices.columns.invoiceNumber") },
    { key: "invoiceDate", label: m("invoices.columns.invoiceDate") },
    { key: "dueDate", label: m("invoices.columns.invoiceDueDate") },
    { key: "status", label: m("invoices.columns.invoiceStatus") },
    { key: "invoiceAmount", label: m("invoices.columns.invoiceAmount") }
  ], [m, p]), y = {
    searchText: t,
    fromDate: a || void 0,
    toDate: i || void 0,
    contractNo: l,
    status: r
  }, { invoices: x, page: j, pages: w, total: C, setPage: P } = Yf(y), { apiUrl: N, apiSecret: R } = Ft(), T = Q(
    async (A) => {
      const S = `${N}/api/customer/v1/account/invoices/${A}?lang=${u}`, _ = {
        headers: { Authorization: "", "x-azure-api-secret": R }
      }, q = await (await fetch("/api/auth/access-token")).json();
      _.headers.Authorization = `Bearer ${q}`;
      const W = await (await fetch(S, _)).blob(), G = window.URL.createObjectURL(W);
      setTimeout(() => {
        window.open(G, "_top");
      });
    },
    [u]
  ), z = () => {
    if (x.length === 0)
      return /* @__PURE__ */ e.jsx(st, { className: "mt-6", colorMode: "information", children: m("invoices.userFeedBack.information.emptyInvoicesList") });
  }, D = (A) => A.status === "-" ? "-" : m(`invoices.status.${A.status}`);
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      Va,
      {
        hideCommuter: !0,
        hits: C,
        labelKey: "invoices.label",
        search: {
          query: t,
          setSearch: n,
          labelKey: "action.search"
        },
        setAgreements: d,
        dates: { startDate: a, endDate: i, setStartDate: o, setEndDate: c },
        otherFilters: [
          {
            labelKey: "form.labels.filterInvoiceStatus",
            multiSelect: !0,
            options: g,
            setValue: s
          }
        ]
      }
    ),
    /* @__PURE__ */ e.jsx(_a, { columns: v, labels: f, children: x.map((A) => /* @__PURE__ */ e.jsxs(
      "tr",
      {
        style: {
          borderBottomWidth: "1px",
          borderBottomColor: "colors.neutral.200",
          borderBottomStyle: "solid"
        },
        children: [
          /* @__PURE__ */ e.jsxs(
            "td",
            {
              className: "py-3 text-sm",
              style: {
                fontWeight: "fontWeights.medium",
                ...b
              },
              children: [
                /* @__PURE__ */ e.jsx(
                  de,
                  {
                    variant: "body2",
                    as: "span",
                    className: "cursor-pointer font-semibold text-blue-700 underline md:pt-0",
                    onClick: () => T(A.no),
                    children: A.no
                  }
                ),
                p && /* @__PURE__ */ e.jsx(
                  Mt,
                  {
                    variant: "text",
                    onClick: () => T(A.no),
                    children: /* @__PURE__ */ e.jsx(Ln, {})
                  }
                )
              ]
            }
          ),
          !p && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
            /* @__PURE__ */ e.jsx("td", { children: /* @__PURE__ */ e.jsx(de, { variant: "body2", children: A.postingDate }) }),
            /* @__PURE__ */ e.jsx("td", { children: /* @__PURE__ */ e.jsx(de, { variant: "body2", children: A.dueDate || "-" }) }),
            /* @__PURE__ */ e.jsx("td", { children: /* @__PURE__ */ e.jsx(de, { variant: "body2", children: D(A) }) }),
            /* @__PURE__ */ e.jsx("td", { children: /* @__PURE__ */ e.jsxs("div", { className: "flex items-center justify-between", children: [
              /* @__PURE__ */ e.jsxs(de, { variant: "body2", children: [
                A.amount,
                " ",
                A.currency
              ] }),
              /* @__PURE__ */ e.jsx("button", { onClick: () => T(A.no), children: /* @__PURE__ */ e.jsx(Ln, { className: "text-neutral-800" }) })
            ] }) })
          ] })
        ]
      },
      A.no
    )) }),
    z(),
    /* @__PURE__ */ e.jsx("div", { className: "mt-8", children: /* @__PURE__ */ e.jsx(
      Kr,
      {
        currentPage: j,
        totalPages: w,
        onPageChange: P,
        labels: {
          next: m("pagination.next"),
          previous: m("pagination.previous")
        }
      }
    ) })
  ] });
}, Ka = ({ status: t }) => {
  const { t: n } = V("account");
  return t ? /* @__PURE__ */ e.jsxs(
    ne,
    {
      className: ct(
        "flex flex-col items-center gap-2 rounded px-3 py-2 text-center md:px-5 md:py-5",
        t.backgroundColor
      ),
      children: [
        /* @__PURE__ */ e.jsx(tl, { height: "30px", width: "30px" }),
        /* @__PURE__ */ e.jsx(M, { intent: "body", children: n(`${t.translationKey}.title`) }),
        /* @__PURE__ */ e.jsx(M, { intent: "body", children: n(`${t.translationKey}.description`) })
      ]
    }
  ) : null;
}, Qf = (t) => {
  if (t)
    switch (t.status) {
      case pe.customerStatus.inactive:
        return {
          backgroundColor: "bg-red-300",
          translationKey: "dashboard.inactive"
        };
      case pe.customerStatus.pending:
        return {
          backgroundColor: "bg-yellow-200",
          translationKey: "dashboard.pending"
        };
      case pe.customerStatus.pendingInvoice:
        return {
          backgroundColor: "bg-yellow-200",
          translationKey: "dashboard.pending_invoice"
        };
      case pe.customerStatus.cardExpired:
      case pe.customerStatus.blocked:
        return {
          backgroundColor: "bg-red-300",
          translationKey: "dashboard.blocked"
        };
      default:
        return;
    }
}, sn = () => {
  const t = pt(Il);
  if (!t)
    throw new Error("useAuthStore must be used within an AuthStoreProvider");
  const { getCustomerType: n, resetAuthentication: r } = t;
  return { customerType: n(), resetAuthentication: r };
}, Xf = (t) => t === "email", Jf = ({
  labels: t,
  namespace: n,
  defaultValues: r,
  helpTexts: s
}) => {
  const { registerField: a, getError: o } = Se({
    namespace: n,
    defaultValues: r
  }), [i] = He(n, "addressType");
  return /* @__PURE__ */ e.jsxs("div", { className: "xs:w-full md:65ch", children: [
    /* @__PURE__ */ e.jsx(
      Fu,
      {
        ...a("addressType"),
        choices: [
          {
            label: t.address,
            value: "address",
            helpText: s.address
          },
          {
            label: t.email,
            value: "email",
            helpText: s.email
          }
        ],
        error: o("addressType"),
        sx: {
          flexDirection: "column",
          maxWidth: "65ch",
          "label span": {
            fontWeight: "fontWeights.medium",
            lineHeight: "lineHeights.500"
          }
        },
        singleColumn: !0
      }
    ),
    Xf(i) ? /* @__PURE__ */ e.jsx(nn, { template: "two-column", children: /* @__PURE__ */ e.jsx(yt, { children: /* @__PURE__ */ e.jsx(
      en,
      {
        type: "email",
        label: t.email,
        error: o("email"),
        ...a("email")
      }
    ) }) }) : null
  ] });
}, Zf = (t, { addressType: n, email: r }) => n === "address" ? { contractNo: t } : { contractNo: t, email: r }, ep = ({
  contract: t,
  onClose: n
}) => {
  const r = Ye(), s = qe(null), { t: a } = V(["account", "common"], {
    nsMode: "fallback"
  }), [o, i] = L(!1), { mutateAsync: c, isLoading: l } = ke(
    ["change", "specification"],
    ({ Contract: h }) => h.changeSpecification,
    {
      onError: () => i(!0),
      onSuccess: () => {
        r.invalidateQueries(xe.Agreements()), n();
      }
    }
  ), { handleSubmit: d, resetData: u, validate: m, isDirty: f, isValid: p } = Se(
    {
      namespace: "editBillingAddress",
      onSubmit: async (h) => {
        const g = Zf(t.contractNo, h);
        await c(g);
      },
      onValidate: (h) => {
        if (h.addressType === "email" && !h.email)
          return { email: a("form.validations.email.required") };
      }
    }
  ), b = K(
    () => !f || !p || l,
    [f, p, l]
  );
  return Y(
    () => () => {
      i(!1), u();
    },
    [i, u]
  ), /* @__PURE__ */ e.jsxs(lr, { ariaLabelledBy: "title", ariaDescribedBy: "description", open: !0, children: [
    /* @__PURE__ */ e.jsx(cr, { closeLabel: a("action.close"), onClose: n, children: /* @__PURE__ */ e.jsx(
      de,
      {
        id: "title",
        variant: "paragraph",
        mt: "spacing.200",
        mb: "spacing.100",
        as: "h2",
        sx: { color: "colors.neutral.100" },
        children: a("agreement.action.editBillingAddress")
      }
    ) }),
    /* @__PURE__ */ e.jsx(
      Yr,
      {
        onSubmit: Kt(m, d),
        onReset: n,
        ref: s,
        children: /* @__PURE__ */ e.jsxs(Yt, { children: [
          o && /* @__PURE__ */ e.jsx(Lt, { variant: "error", children: a("errors.generic") }),
          /* @__PURE__ */ e.jsx(
            Jf,
            {
              namespace: "editBillingAddress",
              labels: {
                address: a("form.labels.postalAddress"),
                email: a("form.labels.email")
              },
              helpTexts: {
                address: a("agreement.invoice.helpTexts.postalAddress"),
                email: a("agreement.invoice.helpTexts.email")
              },
              defaultValues: {
                addressType: t.billingAddressType,
                email: t.billingAddressType === "email" ? t.contractEmail : void 0
              }
            }
          ),
          /* @__PURE__ */ e.jsx(
            It,
            {
              actionButtonType: "submit",
              cancelButtonType: "reset",
              actionLabel: a("action.update"),
              cancelLabel: a("action.cancel"),
              loadingLabel: a("action.loading"),
              isLoading: l,
              disabled: b,
              loadingButton: !0
            }
          )
        ] })
      }
    )
  ] });
}, tp = ({ text: t }) => /* @__PURE__ */ e.jsx(
  de,
  {
    id: "title",
    as: "h2",
    variant: "paragraph",
    sx: { color: "colors.white" },
    children: t
  }
);
function Sn() {
  const { t } = V("common"), { isOnLastStep: n, close: r } = wn();
  return {
    actionLabel: K(
      () => t(n ? "action.complete" : "action.continue"),
      [t, n]
    ),
    cancelLabel: t("action.cancel"),
    close: r
  };
}
const np = ({
  formattedPrice: t,
  agreementType: n
}) => {
  const { t: r } = V("common"), { actionLabel: s, cancelLabel: a, close: o } = Sn(), i = K(
    () => r(`agreementTypes.${n}.badge`),
    [r, n]
  );
  return /* @__PURE__ */ e.jsxs(dr, { children: [
    /* @__PURE__ */ e.jsx(de, { variant: "small", sx: { fontWeight: "fontWeights.medium" }, children: /* @__PURE__ */ e.jsx(he, { ns: "common", i18nKey: `agreementTypes.${n}.badge`, children: /* @__PURE__ */ e.jsx(
      de,
      {
        as: "span",
        variant: "small",
        sx: { fontWeight: "fontWeights.bold" }
      }
    ) }) }),
    /* @__PURE__ */ e.jsx(de, { variant: "small", children: /* @__PURE__ */ e.jsxs(
      he,
      {
        ns: "account",
        i18nKey: "agreement.addAgreementModal.introductionStep.description",
        values: {
          agreementType: i
        },
        children: [
          /* @__PURE__ */ e.jsx(
            de,
            {
              as: "span",
              variant: "small",
              sx: { fontWeight: "fontWeights.medium" }
            }
          ),
          /* @__PURE__ */ e.jsx(
            de,
            {
              as: "span",
              variant: "small",
              sx: { fontWeight: "fontWeights.medium" }
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ e.jsxs("div", { className: "my-3 flex flex-col", children: [
      /* @__PURE__ */ e.jsx(de, { as: "span", mt: 0, sx: { fontSize: "fontSizes.100" }, children: r("form.labels.price") }),
      /* @__PURE__ */ e.jsx(
        de,
        {
          variant: "h3",
          mt: 0,
          sx: { color: "colors.primary.600", fontSize: "fontSizes.300" },
          children: t
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx(
      pn,
      {
        actionLabel: s,
        cancelLabel: a,
        onClose: o
      }
    )
  ] });
}, rp = () => {
  const { t } = V(["account", "common"], {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(de, { variant: "small", sx: { fontWeight: "fontWeights.medium" }, children: t("agreement.addAgreementModal.recognitionStep.label") }),
    /* @__PURE__ */ e.jsx(de, { variant: "small", children: t("agreement.addAgreementModal.recognitionStep.recognitionsLoading") }),
    /* @__PURE__ */ e.jsx("div", { className: "flex items-center justify-center p-6", children: /* @__PURE__ */ e.jsx("div", { className: " w-6", children: /* @__PURE__ */ e.jsx(Tt, { "aria-label": t("action.loading") }) }) })
  ] });
}, sp = ({
  agreementTypeLabel: t
}) => {
  const { t: n } = V(["account", "common"], {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(de, { variant: "small", sx: { fontWeight: "fontWeights.medium" }, children: n("agreement.addAgreementModal.recognitionStep.noRecognitions") }),
    /* @__PURE__ */ e.jsx(Lt, { variant: "inform", children: /* @__PURE__ */ e.jsx(de, { variant: "small", children: /* @__PURE__ */ e.jsxs(
      he,
      {
        ns: "account",
        i18nKey: "agreement.addAgreementModal.recognitionStep.recognitionsRequired",
        values: {
          agreementType: t
        },
        children: [
          /* @__PURE__ */ e.jsx(
            de,
            {
              as: "span",
              variant: "small",
              sx: { fontWeight: "fontWeights.medium" }
            }
          ),
          /* @__PURE__ */ e.jsx(
            de,
            {
              as: "span",
              variant: "small",
              sx: { fontWeight: "fontWeights.medium" }
            }
          ),
          /* @__PURE__ */ e.jsx(
            de,
            {
              as: "span",
              variant: "small",
              sx: { fontWeight: "fontWeights.medium" }
            }
          )
        ]
      }
    ) }) })
  ] });
}, vi = ({
  contractLineNo: t,
  registrationNo: n,
  serialNo: r,
  reference: s,
  recognitionType: a
}) => a === "bizz" ? { key: t, value: s || r } : { key: t, value: s || n }, ap = ({
  agreementTypeLabel: t,
  oneRecognitionOnly: n,
  recognitions: r
}) => {
  const { t: s } = V(["account", "common"], {
    nsMode: "fallback"
  }), { registerField: a, getError: o, lookupFieldData: i } = Se({
    namespace: "add-contract"
  }), c = K(() => n ? s("form.labels.recognition") : s("form.labels.multipleRecognitions", { replace: { number: 1 } }), [n, s]);
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(de, { variant: "small", sx: { fontWeight: "fontWeights.medium" }, children: s("agreement.addAgreementModal.recognitionStep.label") }),
    /* @__PURE__ */ e.jsx(de, { variant: "small", children: /* @__PURE__ */ e.jsx(
      he,
      {
        ns: "account",
        i18nKey: "agreement.addAgreementModal.recognitionStep.description",
        values: {
          agreementType: t
        },
        children: /* @__PURE__ */ e.jsx(
          de,
          {
            as: "span",
            variant: "small",
            sx: { fontWeight: "fontWeights.medium" }
          }
        )
      }
    ) }),
    /* @__PURE__ */ e.jsxs(nn, { template: "two-column", children: [
      /* @__PURE__ */ e.jsx(Rn, { column: "1", children: /* @__PURE__ */ e.jsx(
        Mr,
        {
          ...a("recognitions.recognition1"),
          label: c,
          error: o("recognitions.recognition1"),
          children: r.filter(
            (l) => String(l.contractLineNo) !== i("recognitions.recognition2")
          ).map((l) => {
            const { key: d, value: u } = vi(l);
            return /* @__PURE__ */ e.jsx(zr, { value: d, children: u }, d);
          })
        }
      ) }),
      !n && /* @__PURE__ */ e.jsx(Rn, { column: { xs: "1", md: "3" }, children: /* @__PURE__ */ e.jsx(
        Mr,
        {
          ...a("recognitions.recognition2"),
          label: s("form.labels.multipleRecognitions", {
            replace: { number: 2 }
          }),
          error: o("recognitions.recognition2"),
          children: r.filter(
            (l) => String(l.contractLineNo) !== i("recognitions.recognition1")
          ).map((l) => {
            const { key: d, value: u } = vi(l);
            return /* @__PURE__ */ e.jsx(zr, { value: d, children: u }, d);
          })
        }
      ) })
    ] })
  ] });
}, tc = (t) => t === pe.OresundGo, op = (t) => t === pe.OresundBusiness, ip = (t) => !t || t.length < 2, yi = (t) => t === pe.OresundBusinessPendler, nc = (t) => t === pe.OresundPendler, fa = (t) => tc(t) || nc(t), lp = (t) => tc(t) || op(t), ji = ["open", "closed", "blocked", "pending"], cp = (t, n) => {
  const r = ji.indexOf(t), s = ji.indexOf(n);
  return r - s;
}, dp = (t, n) => Number(n.isOSB) - Number(t.isOSB);
function rc() {
  const { recognitions: t, loading: n } = $a(20);
  return !t || n ? {
    loading: n,
    recognitions: []
  } : {
    loading: !1,
    recognitions: [...t].sort((s, a) => {
      const o = cp(s.lineStatus, a.lineStatus);
      return o !== 0 ? o : dp(s, a);
    })
  };
}
const up = ({
  agreementTypeLabel: t,
  oneRecognitionOnly: n,
  recognitions: r,
  namespace: s
}) => !r || r.length === 0 ? /* @__PURE__ */ e.jsx(sp, { agreementTypeLabel: t }) : /* @__PURE__ */ e.jsx(
  ap,
  {
    recognitions: r,
    agreementTypeLabel: t,
    namespace: s,
    oneRecognitionOnly: n
  }
), mp = ({
  onValidate: t,
  agreementType: n,
  namespace: r
}) => {
  const { t: s } = V(["account", "common"], {
    nsMode: "fallback"
  }), { validate: a, isValid: o } = Se({
    namespace: "add-contract",
    onValidate: t
  }), i = K(
    () => s(`agreementTypes.${n}.label`),
    [n, s]
  ), { recognitions: c, loading: l } = rc(), d = K(() => {
    const p = nc(n), b = ip(c);
    return p || b;
  }, [c, n]), { actionLabel: u, cancelLabel: m, close: f } = Sn();
  return /* @__PURE__ */ e.jsxs(dr, { children: [
    l ? /* @__PURE__ */ e.jsx(rp, {}) : up({
      agreementTypeLabel: i,
      recognitions: c,
      oneRecognitionOnly: d,
      namespace: r
    }),
    /* @__PURE__ */ e.jsx(
      pn,
      {
        actionLabel: u,
        cancelLabel: m,
        action: a,
        disabled: !o,
        onClose: f
      }
    )
  ] });
}, fp = ({ onValidate: t }) => {
  const { t: n } = V("account"), { registerField: r, validate: s, getError: a, isValid: o } = Se({
    namespace: "add-contract",
    onValidate: t
  }), { actionLabel: i, cancelLabel: c, close: l } = Sn();
  return /* @__PURE__ */ e.jsxs(dr, { children: [
    /* @__PURE__ */ e.jsx(de, { variant: "small", sx: { fontWeight: "fontWeights.medium" }, children: /* @__PURE__ */ e.jsx(
      he,
      {
        ns: "account",
        i18nKey: "agreement.addAgreementModal.newsLetterStep.label",
        children: /* @__PURE__ */ e.jsx(
          de,
          {
            as: "span",
            variant: "small",
            sx: { fontWeight: "fontWeights.bold" }
          }
        )
      }
    ) }),
    /* @__PURE__ */ e.jsx(de, { variant: "small", children: /* @__PURE__ */ e.jsxs(
      he,
      {
        ns: "account",
        i18nKey: "agreement.addAgreementModal.newsLetterStep.description",
        children: [
          /* @__PURE__ */ e.jsx(
            de,
            {
              as: "span",
              variant: "small",
              sx: { fontWeight: "fontWeights.medium" }
            }
          ),
          /* @__PURE__ */ e.jsx(
            de,
            {
              as: "span",
              variant: "small",
              sx: { fontWeight: "fontWeights.medium" }
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ e.jsx("div", { className: "my-3", children: /* @__PURE__ */ e.jsx(
      en,
      {
        label: n("agreement.addAgreementModal.newsLetterStep.subscribe"),
        ...r("subscribe", { type: "checkbox", value: "true" }),
        error: a("subscribe")
      }
    ) }),
    /* @__PURE__ */ e.jsx(de, { variant: "small", children: n("agreement.addAgreementModal.newsLetterStep.unsubscribe") }),
    /* @__PURE__ */ e.jsx(
      pn,
      {
        actionLabel: i,
        cancelLabel: c,
        action: s,
        disabled: !o,
        onClose: l
      }
    )
  ] });
}, pp = {
  sv: "SEK",
  da: "DKK"
}, hp = {
  sv: "sv-SE",
  da: "da-DK",
  de: "de-DE",
  en: "en-UK"
}, tn = (t) => pp[t] || "DKK", ss = (t, n, r) => new Intl.NumberFormat(hp[n || ""] || "sv-SE", {
  style: "currency",
  currency: r || tn(n || ""),
  currencyDisplay: "code"
}).format(t), gp = {
  sv: {
    place: "stallen",
    order: "bestall",
    help: "hjalp",
    about: "om",
    guides: "hjalp/guide",
    licensPlate: "hjalp/guide/betaling-med-registreringsnummer",
    payWithBizz: "hjalp/guide/betalning-med-bizz",
    termsAndConditions: "om/villkor-och-regler",
    faq: "hjalp/faq",
    orderContract: "bestall",
    privacyPolicy: "om/villkor-och-regler/personuppgiftspolicy",
    cookiePolicy: "om/villkor-och-regler/cookie-policy",
    customerService: "hjalp/kontakt",
    whistleBlower: "hjalp/whistleblower",
    kmToll: "vagavgift",
    prePaid: "vagskatt-danmark/ruttbiljett",
    privatePayTerms: "https://assets.ctfassets.net/nvd3zqha2yv3/5Zlvr5TZAOyy8xxQNMcxSt/5057c90316f81b12dda650e1e22364cb/8573_OresundPay_Aftalevilkar_SE2.pdf",
    businessPayTerms: "https://assets.ctfassets.net/nvd3zqha2yv3/2XYUULaLgWBzd34QC3lLtt/92d542c9e227f26f05c48fad4902344c/8573_OresundPay_Business_SE2.pdf",
    installationGuide: "vagavgift/manualer5310"
  },
  en: {
    place: "places",
    order: "order",
    help: "help",
    about: "about",
    guides: "help/guide",
    licensPlate: "help/guide/payment-by-number-plate",
    payWithBizz: "help/guide/paying-with-bizz",
    termsAndConditions: "about/terms-and-conditions",
    faq: "help/faq",
    orderContract: "order",
    privacyPolicy: "about/terms-and-conditions/personal-data-policy",
    cookiePolicy: "about/terms-and-conditions/cookie-policy",
    customerService: "help/contact",
    whistleBlower: "help/whistleblower",
    kmToll: "roadtoll",
    prePaid: "roadtax-denmark/routeticket",
    privatePayTerms: "https://assets.ctfassets.net/nvd3zqha2yv3/5Zlvr5TZAOyy8xxQNMcxSt/3c7d44c95048dd501177cfb484979e27/8573_OresundPay_Aftalevilkar_UK2.pdf",
    businessPayTerms: "https://assets.ctfassets.net/nvd3zqha2yv3/2XYUULaLgWBzd34QC3lLtt/19ce0287810a50c05c43dffef069599e/8573_OresundPay_Business_UK2.pdf",
    installationGuide: "roadtoll/usermanuals5310"
  },
  da: {
    place: "steder",
    order: "bestil",
    help: "hjaelp",
    about: "om",
    guides: "hjaelp/guide",
    licensPlate: "hjaelp/guide/betaling-med-nummerplade",
    payWithBizz: "hjaelp/guide/betaling-med-bizz",
    termsAndConditions: "om/vilkaar-og-betingelser",
    faq: "hjaelp/faq",
    orderContract: "bestil",
    privacyPolicy: "om/vilkaar-og-betingelser/persondatapolitik",
    cookiePolicy: "om/vilkaar-og-betingelser/cookie-policy",
    customerService: "hjaelp/kontakt",
    whistleBlower: "hjaelp/whistleblower",
    kmToll: "vejafgift",
    prePaid: "vejskat-danmark/rutebillet",
    privatePayTerms: "https://assets.ctfassets.net/nvd3zqha2yv3/5Zlvr5TZAOyy8xxQNMcxSt/e8e3b52314424ecbc8ab46403694e1ee/8573_OresundPay_Aftalevilkar_DK2.pdf",
    businessPayTerms: "https://assets.ctfassets.net/nvd3zqha2yv3/2XYUULaLgWBzd34QC3lLtt/18d7353a09351f5b4c3f19bd0a04e789/8573_OresundPay_Business_DK2.pdf",
    installationGuide: "vejafgift/manualer5310"
  },
  no: {
    place: "steder",
    order: "bestill",
    help: "hjelp",
    about: "om",
    guides: "hjelp/guide",
    licensPlate: "hjelp/guide/betaling-med-registreringsnummer",
    payWithBizz: "hjelp/guide/betaling-med-bizz",
    termsAndConditions: "om/vilkar-og-betingelser",
    faq: "hjelp/faq",
    orderContract: "bestill",
    privacyPolicy: "om/vilkar-og-betingelser/personopplysningspolicy",
    cookiePolicy: "om/vilkar-og-betingelser/cookie-policy",
    customerService: "hjelp/kontakt",
    whistleBlower: "hjelp/whistleblowser",
    kmToll: "veiavgift",
    prePaid: "veiskatt-danmark/rutebillett",
    privatePayTerms: "https://assets.ctfassets.net/nvd3zqha2yv3/5Zlvr5TZAOyy8xxQNMcxSt/c9abce08d0b81605141084bcc798aca2/8573_OresundPay_Aftalevilkar_UK2.pdf",
    businessPayTerms: "https://assets.ctfassets.net/nvd3zqha2yv3/2XYUULaLgWBzd34QC3lLtt/7ac594a7f25dfe267960caa70d3f3827/8573_OresundPay_Business_UK2.pdf",
    installationGuide: "roadtoll/usermanuals5310"
  }
}, xp = {
  en: {
    goTerms: "terms-info/agreement-oresundgo-oresundcommuter",
    businessTerms: "terms-info/agreement-oresundbusiness-oresundcommuter-for-business",
    faq: "customerservice/faq"
  },
  sv: {
    goTerms: "avtalsvillkor-info/agreement-oresundgo-oresundcommuter",
    businessTerms: "avtalsvillkor-info/avtal-oresundbusiness-oresundpendlare-for-foretag",
    faq: "kundservice/faq"
  },
  da: {
    goTerms: "aftalevilkar-info/fftalevilkar-oresundgo-oresundpendler",
    businessTerms: "aftalevilkar-info/aftale-oresundbusiness-oresundpendler-for-virksomheder",
    faq: "kundeservice/faq"
  }
};
function pa(t, n, r) {
  const s = xp[t][n];
  return `${r}/${t}/${s}`;
}
function ln(t) {
  const { locale: n, key: r } = t, s = gp[n][r];
  return "url" in t ? `${t.url}/${n}/${s}` : s;
}
const bp = {
  sv: "https://storebaelt.dk/en/privacy-policy-for-storebaelt-dk/",
  da: "https://storebaelt.dk/privatlivspolitik-for-storebaelt-dk/",
  en: "https://storebaelt.dk/en/privacy-policy-for-storebaelt-dk/"
}, Ya = ({
  type: t,
  ...n
}) => {
  const { locale: r } = ve(), s = K(() => t === pe.Storebelt ? bp[r] : ln({
    locale: r,
    key: "privacyPolicy",
    skipBase: !0
  }), [r, t]);
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: s && /* @__PURE__ */ e.jsx(jt, { ...n, href: s, target: "_blank" }) });
}, vp = {
  sv: "https://storebaelt.dk/en/terms-and-conditions/",
  da: "https://storebaelt.dk/vilkar-og-betingelser/",
  en: "https://storebaelt.dk/en/terms-and-conditions/"
}, as = ({
  type: t,
  children: n,
  isOresundPay: r,
  ...s
}) => {
  const { locale: a } = ve(), { baseURL: o } = Ft(), i = K(() => {
    if (t === pe.Storebelt)
      return vp[a] || void 0;
    if (r)
      switch (t) {
        case pe.OresundGo:
        case pe.OresundPendler:
          return ln({
            locale: a,
            key: "privatePayTerms",
            skipBase: !0
          });
        case pe.OresundBusiness:
        case pe.OresundPAYBusiness:
          return ln({
            locale: a,
            key: "businessPayTerms",
            skipBase: !0
          });
      }
    switch (t) {
      case pe.OresundGo:
        return pa(a, "goTerms", o);
      case pe.OresundBusiness:
        return pa(a, "businessTerms", o);
      case pe.OresundPAY:
        return ln({
          locale: a,
          key: "privatePayTerms",
          skipBase: !0
        });
      case pe.OresundPAYBusiness:
        return ln({
          locale: a,
          key: "businessPayTerms",
          skipBase: !0
        });
    }
  }, [a, t, r]);
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: i && /* @__PURE__ */ e.jsx(jt, { ...s, href: i, target: "_blank", children: n }) });
}, sc = { status: "initial" }, mr = Vn(() => sc), yp = (t) => mr.setState({ status: "success", contractNo: t }), jp = (t) => mr.setState({ status: "error", error: t }), Cp = () => mr.setState(sc), wp = ({
  formattedPrice: t,
  updatePrice: n,
  onValidate: r,
  contract: s
}) => {
  const { t: a } = V(["account", "common"], {
    nsMode: "fallback"
  }), { status: o } = mr(), { locale: i } = ve(), c = K(() => tn(i || ""), [i]), l = Ye(), { mutateAsync: d } = ke(
    ["price", "signup", "validate"],
    ({ Price: T }) => T.signup,
    {
      onSuccess: (T, z) => {
        l.setQueryData(
          xe.PriceSignup(z),
          () => T
        );
      }
    }
  ), { mutateAsync: u, isLoading: m } = ke(
    ["contract", "convert"],
    ({ Contract: T }) => T.convert,
    {
      onError: () => {
        jp(a("errors.generic"));
      },
      onSuccess: (T) => {
        l.invalidateQueries(xe.CustomerInformation()), l.invalidateQueries({
          queryKey: xe.AllContracts()
        }), l.invalidateQueries(xe.AllAgreements), yp(T.contractNo);
      }
    }
  ), f = Q(
    async (T) => {
      const z = {
        locale: i || "",
        currency: c,
        contractType: s.agreementType,
        campaignCode: T
      };
      return await d(z);
    },
    [d, c, i, s.agreementType]
  ), {
    registerField: p,
    validate: b,
    getError: h,
    isValid: g,
    setFieldErrors: v,
    setFieldData: y,
    getData: x
  } = Se({
    namespace: "add-contract",
    onValidate: r
  }), [j] = He(
    "add-contract",
    "campaignCode"
  ), w = Q(
    async (T) => {
      try {
        const z = await f(T);
        if (!z) {
          v({
            campaignCode: a("form.validations.campaignCode.invalid")
          });
          return;
        }
        const [D] = z;
        n(
          rr(D.priceInclVAT, D.currency)
        ), y("campaignCode", T, "");
      } catch {
        v({
          campaignCode: a("form.validations.campaignCode.invalid")
        });
      }
    },
    [f, y, v, a, n]
  ), C = Q(async () => {
    try {
      if (!b())
        throw new Error("Validation failed");
      const {
        recognitions: z = {},
        subscribe: D = "",
        campaignCode: A = ""
      } = x(), S = {
        attachRecognitions: Object.values(z).map(Number),
        contractNo: s.contractNo,
        newAgreementType: s.agreementType,
        subscribe: D === "true",
        campaignCode: A,
        commuterName: "",
        commuterEmail: "",
        startDate: void 0
      };
      return await u(S), !0;
    } catch {
      return !1;
    }
  }, [
    b,
    s.contractNo,
    s.agreementType,
    u,
    x
  ]), { actionLabel: P, cancelLabel: N, close: R } = Sn();
  return /* @__PURE__ */ e.jsxs(dr, { children: [
    /* @__PURE__ */ e.jsx(de, { variant: "small", sx: { fontWeight: "fontWeights.medium" }, children: a("agreement.addAgreementModal.termsOfAgreementStep.label") }),
    /* @__PURE__ */ e.jsx(de, { variant: "small", children: /* @__PURE__ */ e.jsx(
      he,
      {
        ns: "account",
        i18nKey: "agreement.addAgreementModal.termsOfAgreementStep.billing",
        children: /* @__PURE__ */ e.jsx(
          de,
          {
            as: "span",
            variant: "small",
            sx: { fontWeight: "fontWeights.medium" }
          }
        )
      }
    ) }),
    fa(s.agreementType) ? /* @__PURE__ */ e.jsx(nn, { template: "two-column", children: /* @__PURE__ */ e.jsx(yt, { children: /* @__PURE__ */ e.jsx(
      en,
      {
        label: a("action.campaignCode"),
        error: h("campaignCode"),
        adornment: /* @__PURE__ */ e.jsx(Bu, { children: /* @__PURE__ */ e.jsx(
          Mt,
          {
            type: "button",
            icon: cn,
            variant: "text",
            onClick: () => w(j),
            disabled: !j || !g
          }
        ) }),
        ...p("campaignCode")
      }
    ) }) }) : null,
    /* @__PURE__ */ e.jsxs("div", { className: "my-3 flex flex-col", children: [
      /* @__PURE__ */ e.jsx(de, { as: "span", mt: 0, sx: { fontSize: "fontSizes.100" }, children: a("agreement.addAgreementModal.labels.price") }),
      /* @__PURE__ */ e.jsx(
        de,
        {
          variant: "h3",
          mt: 0,
          sx: { color: "colors.primary.400", fontSize: "fontSizes.300" },
          children: t
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "my-3", children: /* @__PURE__ */ e.jsx(
      en,
      {
        label: a(
          "agreement.addAgreementModal.termsOfAgreementStep.termsOfAgreement"
        ),
        ...p("termsOfAgreement", {
          type: "checkbox",
          value: "true"
        }),
        error: h("termsOfAgreement")
      }
    ) }),
    /* @__PURE__ */ e.jsx(de, { variant: "small", children: /* @__PURE__ */ e.jsxs(
      he,
      {
        ns: "account",
        i18nKey: "agreement.addAgreementModal.termsOfAgreementStep.readMore",
        children: [
          /* @__PURE__ */ e.jsx(
            as,
            {
              type: fa(s.agreementType) ? pe.OresundGo : pe.OresundBusiness
            }
          ),
          /* @__PURE__ */ e.jsx(Ya, {})
        ]
      }
    ) }),
    /* @__PURE__ */ e.jsx(
      pn,
      {
        actionLabel: P,
        cancelLabel: N,
        action: () => C,
        onClose: R,
        disabled: !g || m || o === "error",
        loadingLabel: a("action.loading"),
        isLoading: m,
        loadingButton: !0
      }
    )
  ] });
}, Tn = () => (...t) => (n) => Object.entries(n).filter(
  ([s]) => t.includes(s)
).reduce((s, [a, o]) => ({ ...s, [a]: o }), {}), Ci = Tn()("licensePlate", "country"), Np = ({ namespace: t }) => {
  const { t: n } = V(["account", "common"], {
    nsMode: "fallback"
  }), r = $t(), s = Pn(), a = Q(
    (p) => {
      const b = Ci(p);
      return s({
        licensePlate: n("form.validations.licensePlate.exist")
      })(b);
    },
    [n, s]
  ), o = Q(
    async (p) => {
      try {
        const b = await rn(
          pu.spa,
          n
        )(p), h = Ci(p);
        return await a(h), b;
      } catch {
        return;
      }
    },
    [n, a]
  ), { registerField: i, getError: c, isValid: l, validate: d } = Se({
    namespace: t,
    onValidate: o
  }), { actionLabel: u, cancelLabel: m, close: f } = Sn();
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(de, { variant: "small", sx: { fontWeight: "fontWeights.medium" }, children: n("agreement.addAgreementModal.commuterVehicleStep.label") }),
    /* @__PURE__ */ e.jsx(de, { variant: "small", sx: { maxWidth: "65ch" }, children: /* @__PURE__ */ e.jsx(
      he,
      {
        ns: "account",
        i18nKey: "agreement.addAgreementModal.commuterVehicleStep.description",
        children: /* @__PURE__ */ e.jsx(
          de,
          {
            as: "span",
            variant: "small",
            sx: { fontWeight: "fontWeights.medium" }
          }
        )
      }
    ) }),
    /* @__PURE__ */ e.jsxs(nn, { template: "two-column", children: [
      /* @__PURE__ */ e.jsx(yt, { children: /* @__PURE__ */ e.jsx(
        Mr,
        {
          label: n("form.labels.country"),
          error: c("country"),
          ...i("country"),
          children: r.map(({ key: p, value: b }) => /* @__PURE__ */ e.jsx(zr, { children: b }, p))
        }
      ) }),
      /* @__PURE__ */ e.jsx(yt, { odd: !0, children: /* @__PURE__ */ e.jsx(
        en,
        {
          label: n("form.labels.licensePlate"),
          error: c("licensePlate"),
          ...i("licensePlate")
        }
      ) })
    ] }),
    /* @__PURE__ */ e.jsx(
      pn,
      {
        actionLabel: u,
        cancelLabel: m,
        action: d,
        disabled: !l,
        onClose: f
      }
    )
  ] });
}, Pp = ({
  namespace: t
}) => {
  const { t: n } = V(["account", "common"], {
    nsMode: "fallback"
  }), { registerField: r, getError: s, isValid: a, validate: o } = Se({
    namespace: t,
    onValidate: (d) => rn(hu.spa, n)(d)
  }), { actionLabel: i, cancelLabel: c, close: l } = Sn();
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(de, { variant: "small", sx: { fontWeight: "fontWeights.medium" }, children: n("agreement.addAgreementModal.businessCommuterStep.label") }),
    /* @__PURE__ */ e.jsx(de, { variant: "small", children: /* @__PURE__ */ e.jsx(
      he,
      {
        ns: "account",
        i18nKey: "agreement.addAgreementModal.businessCommuterStep.description",
        children: /* @__PURE__ */ e.jsx(
          de,
          {
            as: "span",
            variant: "small",
            sx: { fontWeight: "fontWeights.medium" }
          }
        )
      }
    ) }),
    /* @__PURE__ */ e.jsxs(nn, { template: "two-column", children: [
      /* @__PURE__ */ e.jsx(yt, { children: /* @__PURE__ */ e.jsx(
        en,
        {
          label: n("form.labels.firstName"),
          error: s("firstName"),
          ...r("firstName")
        }
      ) }),
      /* @__PURE__ */ e.jsx(yt, { odd: !0, children: /* @__PURE__ */ e.jsx(
        en,
        {
          label: n("form.labels.lastName"),
          error: s("lastName"),
          ...r("lastName")
        }
      ) }),
      /* @__PURE__ */ e.jsx(yt, { full: !0, children: /* @__PURE__ */ e.jsx(
        en,
        {
          label: n("form.labels.email"),
          error: s("email"),
          ...r("email")
        }
      ) })
    ] }),
    /* @__PURE__ */ e.jsx(
      pn,
      {
        actionLabel: i,
        cancelLabel: c,
        action: o,
        disabled: !a,
        onClose: l
      }
    )
  ] });
}, Sp = ({
  agreementType: t
}) => {
  const { t: n } = V("common"), { actionLabel: r, cancelLabel: s } = Sn();
  return /* @__PURE__ */ e.jsxs(dr, { children: [
    /* @__PURE__ */ e.jsx(de, { variant: "small", sx: { fontWeight: "fontWeights.medium" }, children: /* @__PURE__ */ e.jsx(
      he,
      {
        ns: "account",
        i18nKey: "agreement.addAgreementModal.confirmationStep.label",
        values: {
          agreementType: n(`agreementTypes.${t}.label`)
        },
        children: /* @__PURE__ */ e.jsx(
          de,
          {
            as: "span",
            variant: "small",
            sx: { fontWeight: "fontWeights.bold" }
          }
        )
      }
    ) }),
    /* @__PURE__ */ e.jsx(de, { variant: "small", children: /* @__PURE__ */ e.jsxs(
      he,
      {
        ns: "account",
        i18nKey: "agreement.addAgreementModal.confirmationStep.description",
        values: {
          agreementType: n(`agreementTypes.${t}.label`)
        },
        children: [
          /* @__PURE__ */ e.jsx(
            de,
            {
              as: "span",
              variant: "small",
              sx: { fontWeight: "fontWeights.medium" }
            }
          ),
          /* @__PURE__ */ e.jsx(
            de,
            {
              as: "span",
              variant: "small",
              sx: { fontWeight: "fontWeights.medium" }
            }
          ),
          /* @__PURE__ */ e.jsx(
            de,
            {
              as: "span",
              variant: "small",
              sx: { fontWeight: "fontWeights.medium" }
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ e.jsx(
      pn,
      {
        actionLabel: r,
        cancelLabel: s,
        removeCancelButton: !0
      }
    )
  ] });
}, Tp = ({
  onClose: t,
  contract: n,
  onSuccess: r
}) => {
  const s = mr(), [a, o] = L(""), { t: i } = V(["account", "common"], { nsMode: "fallback" }), { locale: c } = ve(), { resetData: l } = Se({ namespace: "add-contract" }), { customerInformation: d } = tt(), u = K(
    () => ({
      close: i("action.close"),
      cancel: i("action.cancel"),
      continue: i("action.continue"),
      complete: i("action.complete")
    }),
    [i]
  ), { data: m } = De(
    xe.PriceSignup({ agreementType: n.agreementType }),
    ({ Price: p }) => {
      var b, h;
      return p.signup({
        campaignCode: "",
        contractType: n.agreementType,
        currency: ((b = n.price) == null ? void 0 : b.currency) ?? "",
        locale: c || "",
        contractNumber: ((h = n.contractNo) == null ? void 0 : h.slice(0, 10)) ?? "",
        customerNo: d.customerNo ?? ""
      });
    }
  ), f = Q(() => {
    s.status === "success" && r(), t();
  }, [s, t, r]);
  return Y(() => {
    if (!m)
      return;
    const p = Array.isArray(m) && m.length > 0 ? m[0] : void 0;
    if (!p)
      return o(i("agreement.labels.free"));
    o(rr(p.priceInclVAT, p.currency));
  }, [m, i]), Y(() => () => {
    l(), Cp();
  }, [l]), /* @__PURE__ */ e.jsxs(
    ml,
    {
      ariaLabelledBy: "title",
      open: !0,
      labels: u,
      onClose: f,
      title: /* @__PURE__ */ e.jsx(tp, { text: i("agreement.addAgreementModal.title") }),
      error: s.status === "error" ? s.error : void 0,
      hideProgress: s.status === "error" ? !0 : void 0,
      children: [
        /* @__PURE__ */ e.jsx(
          np,
          {
            formattedPrice: a,
            agreementType: n.agreementType
          }
        ),
        fa(n.agreementType) ? /* @__PURE__ */ e.jsx(
          mp,
          {
            namespace: "recognitions",
            agreementType: n.agreementType,
            onValidate: (p) => {
              var b;
              if (!((b = p.recognitions) != null && b.recognition1))
                return {
                  "recognitions.recognition1": i(
                    "form.validations.recognition.required"
                  )
                };
            }
          }
        ) : null,
        yi(n.agreementType) ? /* @__PURE__ */ e.jsx(Pp, { namespace: "commuter" }) : null,
        yi(n.agreementType) ? /* @__PURE__ */ e.jsx(Np, { namespace: "commuterVehicle" }) : null,
        lp(n.agreementType) ? /* @__PURE__ */ e.jsx(fp, { namespace: "newsletter" }) : null,
        /* @__PURE__ */ e.jsx(
          wp,
          {
            namespace: "termsOfAgreement",
            formattedPrice: a,
            updatePrice: o,
            contract: n,
            contractNo: n.contractNo,
            onValidate: (p) => {
              if (!p.termsOfAgreement)
                return {
                  termsOfAgreement: i("form.validations.termsOfAgreement.required")
                };
            }
          }
        ),
        /* @__PURE__ */ e.jsx(Sp, { agreementType: n.agreementType })
      ]
    }
  );
}, wi = ({
  translationKey: t,
  ns: n,
  ...r
}) => {
  const { t: s } = V([n, "common"], { nsMode: "fallback" });
  return /* @__PURE__ */ e.jsx(jt, { ...r, href: s(t), target: "_blank" });
}, ac = ({
  getError: t,
  registerField: n,
  manualInputChecked: r,
  customError: s
}) => {
  const { t: a } = V(["account", "common"], { nsMode: "fallback" });
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(M, { intent: "title", className: "mb-4", children: /* @__PURE__ */ e.jsx(
      he,
      {
        ns: "account",
        i18nKey: "agreement.addAgreementModal.storebeltIntroductionsStep.title"
      }
    ) }),
    /* @__PURE__ */ e.jsx(M, { intent: "body", as: "p", className: "mb-4", children: /* @__PURE__ */ e.jsxs(
      he,
      {
        ns: "account",
        i18nKey: "agreement.addAgreementModal.storebeltIntroductionsStep.description",
        children: [
          /* @__PURE__ */ e.jsx(
            wi,
            {
              ns: "account",
              translationKey: "agreement.addAgreementModal.storebeltIntroductionsStep.readMoreLink1"
            }
          ),
          /* @__PURE__ */ e.jsx(
            wi,
            {
              ns: "account",
              translationKey: "agreement.addAgreementModal.storebeltIntroductionsStep.readMoreLink2"
            }
          )
        ]
      }
    ) }),
    n ? /* @__PURE__ */ e.jsx(
      me,
      {
        type: "checkbox",
        label: a(
          "agreement.addAgreementModal.storebeltIntroductionsStep.termsOfAgreement"
        ),
        ...n("termsOfAgreement", {
          type: "checkbox",
          value: "true"
        }),
        error: t && t("termsOfAgreement"),
        className: "mb-4"
      }
    ) : /* @__PURE__ */ e.jsx(
      me,
      {
        onChange: r ? (o) => r(o.target.checked) : () => ({}),
        type: "checkbox",
        label: a(
          "agreement.addAgreementModal.storebeltIntroductionsStep.termsOfAgreement"
        ),
        name: "termsOfAgreement",
        value: "true",
        error: s && a(s),
        className: "mb-4"
      }
    ),
    /* @__PURE__ */ e.jsx(M, { size: "sm", className: "mb-4", children: /* @__PURE__ */ e.jsxs(he, { ns: "common", i18nKey: "termsOfAgreement", children: [
      /* @__PURE__ */ e.jsx(as, { type: pe.Storebelt }),
      /* @__PURE__ */ e.jsx(Ya, { type: pe.Storebelt })
    ] }) })
  ] });
}, Ep = () => {
  const { registerField: t, getError: n } = Se({
    namespace: "add-sbf"
  });
  return /* @__PURE__ */ e.jsx(ac, { getError: n, registerField: t });
}, kp = ({
  handleOpenChange: t,
  error: n,
  validate: r,
  handleSubmit: s,
  success: a,
  state: o,
  isLoading: i,
  customSubmit: c
}) => {
  const { t: l } = V(["account", "common"], { nsMode: "fallback" }), d = qe(null), [u, m] = L(!1), [f, p] = L(void 0), b = () => {
    c || p(u ? void 0 : "form.validations.termsOfAgreement.required");
  };
  return Y(() => p(void 0), [u]), /* @__PURE__ */ e.jsxs(
    Bt,
    {
      open: !0,
      title: l("agreement.addAgreementModal.title"),
      onOpenChange: t,
      children: [
        n && /* @__PURE__ */ e.jsx(Le, { color: "negative", className: "col-span-full", children: n.error ?? l("errors.generic") }),
        /* @__PURE__ */ e.jsxs(
          "form",
          {
            onSubmit: r && s ? Kt(r, s) : b,
            onReset: () => t(!1),
            ref: d,
            children: [
              o === "success" ? a : c ? /* @__PURE__ */ e.jsx(ac, { manualInputChecked: m, customError: f }) : /* @__PURE__ */ e.jsx(Ep, {}),
              /* @__PURE__ */ e.jsx("div", { className: "flex flex-row justify-end", children: o === "success" || o === "error" ? /* @__PURE__ */ e.jsx(be, { intent: "solid", onClick: () => t(!1), children: l("action.complete") }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
                /* @__PURE__ */ e.jsx(be, { intent: "text", type: "reset", children: l("action.cancel") }),
                /* @__PURE__ */ e.jsx(
                  et,
                  {
                    intent: "solid",
                    type: "submit",
                    isLoading: i,
                    loadingLabel: l("action.loading"),
                    children: l("action.save")
                  }
                )
              ] }) })
            ]
          }
        )
      ]
    }
  );
}, Ap = ({
  onClose: t,
  onSuccess: n,
  contract: r
}) => {
  const { t: s } = V(["account", "common"], { nsMode: "fallback" }), [a, o] = L(), [i, c] = L(
    void 0
  ), l = (x) => {
    c("error"), o(x);
  }, d = Ye(), u = Q(
    (x) => x.termsOfAgreement ? void 0 : { termsOfAgreement: s("form.validations.termsOfAgreement.required") },
    [s]
  ), { mutateAsync: m, isLoading: f } = ke(
    ["contract", "activateSbf"],
    (x) => x.Contract.toggleSbf(r.contractNo),
    {
      onError: (x) => {
        l({ ...x, error: s("errors.generic") });
      },
      onSuccess: () => {
        c("success"), d.refetchQueries(xe.Agreements()), d.invalidateQueries({
          queryKey: xe.AllContracts()
        });
      }
    }
  ), p = Q(async () => m({ sbfActive: !0 }), [m]), { validate: b, resetData: h, handleSubmit: g } = Se({
    namespace: "add-sbf",
    onValidate: u,
    onSubmit: p
  }), v = Q(
    (x) => {
      x || (i === "success" && n(), h(), t());
    },
    [t, n, h, i]
  ), y = K(
    () => /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col items-center py-6", children: [
      /* @__PURE__ */ e.jsx(Ea, { className: "mb-8 h-12 w-12 text-green-500" }),
      /* @__PURE__ */ e.jsx(M, { intent: "title", className: "text-primary-900 mb-6", children: /* @__PURE__ */ e.jsx(
        he,
        {
          ns: "account",
          i18nKey: "agreement.addAgreementModal.storebeltConfirmationStep.title"
        }
      ) }),
      /* @__PURE__ */ e.jsx(M, { intent: "body", children: /* @__PURE__ */ e.jsx(
        he,
        {
          ns: "account",
          i18nKey: "agreement.addAgreementModal.storebeltConfirmationStep.description"
        }
      ) })
    ] }),
    []
  );
  return /* @__PURE__ */ e.jsx(
    kp,
    {
      success: y,
      handleOpenChange: v,
      error: a,
      validate: b,
      handleSubmit: g,
      state: i,
      isLoading: f
    }
  );
}, Op = ({
  contract: t,
  ...n
}) => t.agreementType === "Storebelt" ? /* @__PURE__ */ e.jsx(Ap, { contract: t, ...n }) : /* @__PURE__ */ e.jsx(Tp, { contract: t, ...n }), oc = {
  showConfirmation: !1,
  success: !1,
  loading: !1,
  contractNo: void 0
}, En = Vn(
  () => oc
), _p = () => En.setState(oc), Ni = () => En.setState({ loading: !0 }), Pi = (t) => En.setState({
  success: !0,
  showConfirmation: !0,
  loading: !1,
  contractNo: t
}), Si = () => En.setState({ showConfirmation: !0, loading: !1 }), Rp = ({
  agreementType: t
}) => {
  const { t: n } = V(["account", "common"], {
    nsMode: "fallback"
  }), { success: r } = En(), s = K(() => r ? "success" : "error", [r]), a = K(() => n(t === "Storebelt" && s === "success" ? "agreement.modal.confirmation.storebelt_success" : `agreement.modal.confirmation.${s}.description`), [t, s, n]);
  return /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col items-center", children: [
    /* @__PURE__ */ e.jsx("div", { className: " my-4", children: r ? /* @__PURE__ */ e.jsx(Yd, { className: "text-green-600", width: "50px", height: "50px" }) : /* @__PURE__ */ e.jsx(Ta, { width: "50px", height: "50px" }) }),
    /* @__PURE__ */ e.jsx(M, { className: "max-w-[65ch] pb-1 pt-2 text-center", children: a })
  ] });
}, Mp = ({
  agreementType: t
}) => {
  const { t: n } = V(["account", "common"], {
    nsMode: "fallback"
  }), { data: r } = bt(!0);
  return /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-3", children: [
    /* @__PURE__ */ e.jsx(
      M,
      {
        size: "sm",
        className: ct(
          "flex",
          "flex-col",
          "gap-3",
          da(t) ? "text-center" : "text-left"
        ),
        children: /* @__PURE__ */ e.jsxs(
          he,
          {
            ns: "account",
            i18nKey: `agreement.modal.description.${t}`,
            values: {
              agreementType: r == null ? void 0 : r.paymentAgreement.provider.name
            },
            children: [
              /* @__PURE__ */ e.jsx(M, { as: "span" }),
              /* @__PURE__ */ e.jsx(M, { as: "span" }),
              /* @__PURE__ */ e.jsx(M, { weight: "medium", as: "span" }),
              /* @__PURE__ */ e.jsx(M, { as: "span" })
            ]
          }
        )
      }
    ),
    !da(t) && !qm(t) && Vm(t) ? /* @__PURE__ */ e.jsx(Le, { color: "inform", children: n("agreement.modal.disclaimer") }) : null
  ] });
}, zp = ({ close: t, onCancel: n }) => {
  const { t: r } = V(["account", "common"], {
    nsMode: "fallback"
  }), { loading: s } = En();
  return /* @__PURE__ */ e.jsxs("div", { className: "flex justify-end", children: [
    /* @__PURE__ */ e.jsx(be, { intent: "text", onClick: t, children: r("action.cancel") }),
    /* @__PURE__ */ e.jsx(
      et,
      {
        intent: "solid",
        onClick: n,
        isLoading: s,
        loadingLabel: r("actions.loading"),
        children: r("agreement.modal.action.save")
      }
    )
  ] });
}, Dp = ({ close: t }) => {
  const { t: n } = V(["account", "common"], {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsx("div", { className: "flex justify-center", children: /* @__PURE__ */ e.jsx(be, { intent: "text", onClick: t, children: n("action.complete") }) });
}, ic = ({
  contract: t,
  onSuccess: n,
  onClose: r,
  periodCard: s,
  paymentContract: a
}) => {
  const o = Ye(), { t: i } = V(["account", "common"], {
    nsMode: "fallback"
  }), { push: c } = ve(), { showConfirmation: l, success: d } = En(), { mutateAsync: u } = ke(
    ["contract", "cancel"],
    ({ Contract: x }) => x.cancel(t.contractNo),
    {
      onMutate: Ni,
      onError: Si,
      onSuccess: (x) => {
        o.invalidateQueries(xe.Agreements()), o.invalidateQueries(xe.CustomerInformation()), o.invalidateQueries({
          queryKey: xe.AllContracts()
        }), c("/account/agreement"), Pi(x.contractNo);
      }
    }
  ), { mutateAsync: m } = ke(
    ["contract", "cancel"],
    ({ Contract: x }) => x.toggleSbf((a == null ? void 0 : a.contractNo) ?? t.contractNo),
    {
      onMutate: Ni,
      onError: Si,
      onSuccess: () => {
        o.invalidateQueries(xe.Agreements()), o.invalidateQueries(xe.CustomerInformation()), o.invalidateQueries({
          queryKey: xe.AllContracts()
        }), Pi((a == null ? void 0 : a.contractNo) ?? t.contractNo);
      }
    }
  ), f = K(
    () => l ? `agreement.modal.confirmation.${d ? "success" : "error"}.title` : "agreement.modal.title",
    [l, d]
  ), p = Q(() => {
    _p(), d && n && n(), r();
  }, [n, d, r]), g = Wm(
    () => /* @__PURE__ */ e.jsx("div", { className: "flex flex-col gap-3", children: /* @__PURE__ */ e.jsx(
      M,
      {
        size: "md",
        className: ct("flex", "flex-col", "gap-3", "text-left"),
        children: /* @__PURE__ */ e.jsx(
          he,
          {
            ns: "account",
            i18nKey: "agreement.modal.preventCancel.description",
            children: /* @__PURE__ */ e.jsx(M, { as: "span" })
          }
        )
      }
    ) }),
    () => l ? /* @__PURE__ */ e.jsx(Rp, { agreementType: t.agreementType }) : /* @__PURE__ */ e.jsx(Mp, { agreementType: t.agreementType })
  ), v = Q(async () => {
    t.agreementType === "Storebelt" ? await m({ sbfActive: !1 }) : await u({ closeInFuture: !1 });
  }, [m, t.agreementType, u]), y = (x) => l ? /* @__PURE__ */ e.jsx(Dp, { close: x }) : Ml(t, s) ? null : /* @__PURE__ */ e.jsx(zp, { close: x, onCancel: v });
  return /* @__PURE__ */ e.jsx(
    Bt,
    {
      footer: y,
      title: /* @__PURE__ */ e.jsx(
        M,
        {
          as: "h1",
          intent: "title",
          size: "lg",
          className: "text-neutral-900",
          children: /* @__PURE__ */ e.jsx(
            he,
            {
              ns: "account",
              i18nKey: f,
              values: {
                agreementType: i(
                  `agreementTypes.${t.agreementType}.badge`
                )
              },
              children: /* @__PURE__ */ e.jsx(M, { as: "span", weight: "bold" })
            }
          )
        }
      ),
      onOpenChange: (x) => {
        x || p();
      },
      open: !0,
      children: g(t, s)
    }
  );
}, Lp = (t) => t.paymentType === "invoice", Ip = ({
  startDateTime: t,
  endDateTime: n,
  active: r
}) => {
  const s = new Date(t), a = new Date(n);
  return {
    status: r ? "active" : "cancelled",
    date: Dt(s, "yyyy-MM-dd"),
    endDate: Dt(a, "yyyy-MM-dd")
  };
}, $p = (t) => ({
  contractNo: t,
  agreementType: "Storebelt"
}), Fp = Gt(
  "flex flex-col sm:flex-row sm:justify-between gap-2 py-4 px-5 items-center",
  {
    variants: {
      status: {
        active: ["bg-white-200", "text-neutral-800"],
        cancelled: ["bg-red-300", "text-red-600"],
        pending: ["bg-blue-200", "text-blue-800"]
      }
    },
    defaultVariants: {
      status: "pending"
    }
  }
), Qa = ({
  status: t,
  endDate: n,
  children: r,
  disableCancel: s
}) => {
  const { t: a } = V("account");
  return /* @__PURE__ */ e.jsxs("div", { className: Fp({ status: t }), children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex-[2]", children: [
      /* @__PURE__ */ e.jsx(M, { size: "md", children: /* @__PURE__ */ e.jsx(
        he,
        {
          ns: "account",
          i18nKey: `agreement.periodCard.${t}.label`,
          values: { date: n },
          context: n ? void 0 : "with-date",
          children: /* @__PURE__ */ e.jsx(M, { size: "md", weight: "bold", as: "span" })
        }
      ) }),
      t !== "cancelled" && /* @__PURE__ */ e.jsx(M, { size: "md", weight: "light", className: "mt-2", children: a(`agreement.periodCard.${t}.description`, { endDate: n }) })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "flex flex-1 flex-col items-end justify-center", children: [
      r,
      s ? /* @__PURE__ */ e.jsx(M, { size: "sm", weight: "light", className: "text-right", children: a("agreement.periodCard.cancelDisabled") }) : null
    ] })
  ] });
}, at = ({ contract: t, ns: n = "common" }) => /* @__PURE__ */ e.jsx(he, { ns: n, i18nKey: t, children: /* @__PURE__ */ e.jsx(ne, { as: "span", className: "font-bold text-inherit" }) });
function Bp({ onError: t }) {
  const [n, r] = L(!1), { data: s } = bt(), { data: a, refetch: o } = ur(), { mutateAsync: i } = ke(
    ["periodcard", "cancel"],
    (l) => l.PeriodCard.cancel,
    {
      onError: t
    }
  );
  return {
    cancelPeriodCard: Q(async () => {
      if (a) {
        r(!0);
        try {
          await i({
            periodCardId: a.id,
            contractNo: a.contractNo
          }), await o();
        } catch {
          t();
        } finally {
          r(!1);
        }
      }
    }, [a, i, o, t]),
    isCancelling: n,
    agreements: s
  };
}
const lc = ({ className: t, disabled: n }) => {
  const [r, s] = L(!1), a = qe(null), { t: o } = V(["account", "common"], { nsMode: "fallback" }), { cancelPeriodCard: i, isCancelling: c, agreements: l } = Bp({
    onError: () => s(!0)
  }), d = () => {
    a.current && a.current.close();
  }, u = (l == null ? void 0 : l.paymentAgreement.agreementType) === "Oresund_Business" ? "oresundBusinessCommuter" : "oresundCommuter";
  return /* @__PURE__ */ e.jsx(
    Bt,
    {
      ref: a,
      title: /* @__PURE__ */ e.jsx(he, { ns: "account", i18nKey: "periodCard.modals.cancel.title", children: /* @__PURE__ */ e.jsx("span", { className: "font-bold" }) }),
      trigger: /* @__PURE__ */ e.jsx(
        be,
        {
          iconSize: "lg",
          className: t,
          intent: "text",
          color: "positive",
          disabled: n,
          children: o("periodCard.modals.cancel.action")
        }
      ),
      children: /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-8", children: [
        /* @__PURE__ */ e.jsx(M, { children: /* @__PURE__ */ e.jsx(he, { ns: "account", i18nKey: "periodCard.modals.cancel.description", children: /* @__PURE__ */ e.jsx(at, { contract: u }) }) }),
        r ? /* @__PURE__ */ e.jsx(Le, { color: "negative", children: /* @__PURE__ */ e.jsx(M, { size: "md", children: o("periodCard.modals.cancel.errors.generic") }) }) : null,
        /* @__PURE__ */ e.jsxs("div", { className: "flex justify-end gap-4", children: [
          /* @__PURE__ */ e.jsx(be, { as: "button", intent: "text", onClick: d, children: o("action.cancel") }),
          /* @__PURE__ */ e.jsx(
            et,
            {
              loadingLabel: o("action.loading"),
              isLoading: c,
              onClick: i,
              children: o("periodCard.modals.cancel.action")
            }
          )
        ] })
      ] })
    }
  );
}, kn = ({ onClick: t, namespace: n, loadingLabel: r, ...s }) => {
  const [a, o] = L(!1), { labels: i, isLast: c, nextStep: l } = Oa(), d = K(
    () => c(n) ? i.submitLabel : i.nextLabel,
    [c, i.submitLabel, i.nextLabel, n]
  ), u = Q(async () => {
    o(!0);
    try {
      await t() && l();
    } finally {
      o(!1);
    }
  }, [t, l]);
  return /* @__PURE__ */ e.jsx(ne, { className: "col-span-full mt-2 flex justify-end", children: /* @__PURE__ */ e.jsx(
    et,
    {
      ...s,
      onClick: u,
      isLoading: a,
      loadingLabel: r,
      type: c(n) ? "submit" : "button",
      intent: "solid",
      children: d
    }
  ) });
}, Vp = ({ namespace: t, ...n }) => {
  const { labels: r, isLast: s, enableStep: a } = Oa();
  return s(t) ? null : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      be,
      {
        ...n,
        onClick: () => a(t),
        intent: "text",
        color: "neutral",
        type: "button",
        startIcon: /* @__PURE__ */ e.jsx(xo, {}),
        className: "ml-auto sm:hidden",
        "aria-label": r.editLabel,
        iconSize: "lg"
      }
    ),
    /* @__PURE__ */ e.jsx(
      be,
      {
        ...n,
        onClick: () => a(t),
        intent: "text",
        type: "button",
        color: "neutral",
        startIcon: /* @__PURE__ */ e.jsx(xo, {}),
        className: "ml-auto hidden sm:flex",
        children: r.editLabel
      }
    )
  ] });
}, Vt = ({
  nr: t,
  title: n,
  children: r,
  id: s,
  editButton: a = !0,
  full: o = !0,
  className: i,
  titleIntent: c = "headline",
  titleSize: l = "sm"
}) => /* @__PURE__ */ e.jsxs(
  ne,
  {
    as: "fieldset",
    className: ct(o ? "min-h-screen" : void 0, "pb-8", i),
    children: [
      /* @__PURE__ */ e.jsxs("div", { className: "mb-4 flex flex-row items-center", children: [
        t ? /* @__PURE__ */ e.jsx(cu, { className: "mr-4", children: t }) : null,
        /* @__PURE__ */ e.jsx(
          M,
          {
            as: "legend",
            intent: c,
            size: l,
            id: s,
            className: "scroll-mt-[10vh]",
            children: n
          }
        ),
        a ? /* @__PURE__ */ e.jsx(Vp, { namespace: s }) : null
      ] }),
      /* @__PURE__ */ e.jsx(ht, { className: "gap-4", children: r })
    ]
  }
), os = ({ type: t, isOresundPay: n }) => /* @__PURE__ */ e.jsxs(he, { i18nKey: "termsOfAgreement", ns: "common", children: [
  /* @__PURE__ */ e.jsx(as, { type: t, isOresundPay: n }),
  /* @__PURE__ */ e.jsx(Ya, { type: t })
] });
var ha = { exports: {} }, ga = { exports: {} };
(function(t, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = r;
  function r(s, a) {
    if (s == null)
      throw new TypeError("assign requires that input parameter not be null or undefined");
    for (var o in a)
      Object.prototype.hasOwnProperty.call(a, o) && (s[o] = a[o]);
    return s;
  }
  t.exports = n.default;
})(ga, ga.exports);
var qp = ga.exports;
(function(t, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = a;
  var r = s(qp);
  function s(o) {
    return o && o.__esModule ? o : { default: o };
  }
  function a(o) {
    return (0, r.default)({}, o);
  }
  t.exports = n.default;
})(ha, ha.exports);
var Wp = ha.exports;
const Hp = /* @__PURE__ */ qn(Wp);
var xa = { exports: {} };
(function(t, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = r;
  function r(s) {
    if (s === null || s === !0 || s === !1)
      return NaN;
    var a = Number(s);
    return isNaN(a) ? a : a < 0 ? Math.ceil(a) : Math.floor(a);
  }
  t.exports = n.default;
})(xa, xa.exports);
var Up = xa.exports;
const Gp = /* @__PURE__ */ qn(Up);
var ba = { exports: {} };
(function(t, n) {
  Object.defineProperty(n, "__esModule", {
    value: !0
  }), n.default = r;
  function r(s) {
    var a = new Date(Date.UTC(s.getFullYear(), s.getMonth(), s.getDate(), s.getHours(), s.getMinutes(), s.getSeconds(), s.getMilliseconds()));
    return a.setUTCFullYear(s.getFullYear()), s.getTime() - a.getTime();
  }
  t.exports = n.default;
})(ba, ba.exports);
var Kp = ba.exports;
const Ti = /* @__PURE__ */ qn(Kp);
function Yp(t, n) {
  var r = Zp(n);
  return r.formatToParts ? Xp(r, t) : Jp(r, t);
}
var Qp = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};
function Xp(t, n) {
  try {
    for (var r = t.formatToParts(n), s = [], a = 0; a < r.length; a++) {
      var o = Qp[r[a].type];
      o >= 0 && (s[o] = parseInt(r[a].value, 10));
    }
    return s;
  } catch (i) {
    if (i instanceof RangeError)
      return [NaN];
    throw i;
  }
}
function Jp(t, n) {
  var r = t.format(n).replace(/\u200E/g, ""), s = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(r);
  return [s[3], s[1], s[2], s[4], s[5], s[6]];
}
var na = {};
function Zp(t) {
  if (!na[t]) {
    var n = new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: "America/New_York",
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }).format(/* @__PURE__ */ new Date("2014-06-25T04:00:00.123Z")), r = n === "06/25/2014, 00:00:00" || n === "‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00";
    na[t] = r ? new Intl.DateTimeFormat("en-US", {
      hour12: !1,
      timeZone: t,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    }) : new Intl.DateTimeFormat("en-US", {
      hourCycle: "h23",
      timeZone: t,
      year: "numeric",
      month: "numeric",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit"
    });
  }
  return na[t];
}
function Xa(t, n, r, s, a, o, i) {
  var c = /* @__PURE__ */ new Date(0);
  return c.setUTCFullYear(t, n, r), c.setUTCHours(s, a, o, i), c;
}
var Ei = 36e5, eh = 6e4, ra = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
};
function cc(t, n, r) {
  var s, a;
  if (!t || (s = ra.timezoneZ.exec(t), s))
    return 0;
  var o;
  if (s = ra.timezoneHH.exec(t), s)
    return o = parseInt(s[1], 10), ki(o) ? -(o * Ei) : NaN;
  if (s = ra.timezoneHHMM.exec(t), s) {
    o = parseInt(s[1], 10);
    var i = parseInt(s[2], 10);
    return ki(o, i) ? (a = Math.abs(o) * Ei + i * eh, o > 0 ? -a : a) : NaN;
  }
  if (rh(t)) {
    n = new Date(n || Date.now());
    var c = th(n), l = va(c, t), d = nh(n, l, t);
    return -d;
  }
  return NaN;
}
function th(t) {
  return Xa(
    t.getFullYear(),
    t.getMonth(),
    t.getDate(),
    t.getHours(),
    t.getMinutes(),
    t.getSeconds(),
    t.getMilliseconds()
  );
}
function va(t, n) {
  var r = Yp(t, n), s = Xa(
    r[0],
    r[1] - 1,
    r[2],
    r[3] % 24,
    r[4],
    r[5],
    0
  ).getTime(), a = t.getTime(), o = a % 1e3;
  return a -= o >= 0 ? o : 1e3 + o, s - a;
}
function nh(t, n, r) {
  var s = t.getTime(), a = s - n, o = va(new Date(a), r);
  if (n === o)
    return n;
  a -= o - n;
  var i = va(new Date(a), r);
  return o === i ? o : Math.max(o, i);
}
function ki(t, n) {
  return -23 <= t && t <= 23 && (n == null || 0 <= n && n <= 59);
}
var Ai = {};
function rh(t) {
  if (Ai[t]) return !0;
  try {
    return new Intl.DateTimeFormat(void 0, { timeZone: t }), Ai[t] = !0, !0;
  } catch {
    return !1;
  }
}
var dc = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/, sa = 36e5, Oi = 6e4, sh = 2, ut = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [
    /^([+-]\d{2})$/,
    // 0 additional digits
    /^([+-]\d{3})$/,
    // 1 additional digit
    /^([+-]\d{4})$/
    // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [
    /^([+-]\d{4})/,
    // 0 additional digits
    /^([+-]\d{5})/,
    // 1 additional digit
    /^([+-]\d{6})/
    // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: dc
};
function _i(t, n) {
  if (arguments.length < 1)
    throw new TypeError("1 argument required, but only " + arguments.length + " present");
  if (t === null)
    return /* @__PURE__ */ new Date(NaN);
  var r = n || {}, s = r.additionalDigits == null ? sh : Gp(r.additionalDigits);
  if (s !== 2 && s !== 1 && s !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]")
    return new Date(t.getTime());
  if (typeof t == "number" || Object.prototype.toString.call(t) === "[object Number]")
    return new Date(t);
  if (!(typeof t == "string" || Object.prototype.toString.call(t) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var a = ah(t), o = oh(a.date, s), i = o.year, c = o.restDateString, l = ih(c, i);
  if (isNaN(l))
    return /* @__PURE__ */ new Date(NaN);
  if (l) {
    var d = l.getTime(), u = 0, m;
    if (a.time && (u = lh(a.time), isNaN(u)))
      return /* @__PURE__ */ new Date(NaN);
    if (a.timeZone || r.timeZone) {
      if (m = cc(a.timeZone || r.timeZone, new Date(d + u)), isNaN(m))
        return /* @__PURE__ */ new Date(NaN);
    } else
      m = Ti(new Date(d + u)), m = Ti(new Date(d + u + m));
    return new Date(d + u + m);
  } else
    return /* @__PURE__ */ new Date(NaN);
}
function ah(t) {
  var n = {}, r = ut.dateTimePattern.exec(t), s;
  if (r ? (n.date = r[1], s = r[3]) : (r = ut.datePattern.exec(t), r ? (n.date = r[1], s = r[2]) : (n.date = null, s = t)), s) {
    var a = ut.timeZone.exec(s);
    a ? (n.time = s.replace(a[1], ""), n.timeZone = a[1].trim()) : n.time = s;
  }
  return n;
}
function oh(t, n) {
  var r = ut.YYY[n], s = ut.YYYYY[n], a;
  if (a = ut.YYYY.exec(t) || s.exec(t), a) {
    var o = a[1];
    return {
      year: parseInt(o, 10),
      restDateString: t.slice(o.length)
    };
  }
  if (a = ut.YY.exec(t) || r.exec(t), a) {
    var i = a[1];
    return {
      year: parseInt(i, 10) * 100,
      restDateString: t.slice(i.length)
    };
  }
  return {
    year: null
  };
}
function ih(t, n) {
  if (n === null)
    return null;
  var r, s, a, o;
  if (t.length === 0)
    return s = /* @__PURE__ */ new Date(0), s.setUTCFullYear(n), s;
  if (r = ut.MM.exec(t), r)
    return s = /* @__PURE__ */ new Date(0), a = parseInt(r[1], 10) - 1, Mi(n, a) ? (s.setUTCFullYear(n, a), s) : /* @__PURE__ */ new Date(NaN);
  if (r = ut.DDD.exec(t), r) {
    s = /* @__PURE__ */ new Date(0);
    var i = parseInt(r[1], 10);
    return uh(n, i) ? (s.setUTCFullYear(n, 0, i), s) : /* @__PURE__ */ new Date(NaN);
  }
  if (r = ut.MMDD.exec(t), r) {
    s = /* @__PURE__ */ new Date(0), a = parseInt(r[1], 10) - 1;
    var c = parseInt(r[2], 10);
    return Mi(n, a, c) ? (s.setUTCFullYear(n, a, c), s) : /* @__PURE__ */ new Date(NaN);
  }
  if (r = ut.Www.exec(t), r)
    return o = parseInt(r[1], 10) - 1, zi(n, o) ? Ri(n, o) : /* @__PURE__ */ new Date(NaN);
  if (r = ut.WwwD.exec(t), r) {
    o = parseInt(r[1], 10) - 1;
    var l = parseInt(r[2], 10) - 1;
    return zi(n, o, l) ? Ri(n, o, l) : /* @__PURE__ */ new Date(NaN);
  }
  return null;
}
function lh(t) {
  var n, r, s;
  if (n = ut.HH.exec(t), n)
    return r = parseFloat(n[1].replace(",", ".")), aa(r) ? r % 24 * sa : NaN;
  if (n = ut.HHMM.exec(t), n)
    return r = parseInt(n[1], 10), s = parseFloat(n[2].replace(",", ".")), aa(r, s) ? r % 24 * sa + s * Oi : NaN;
  if (n = ut.HHMMSS.exec(t), n) {
    r = parseInt(n[1], 10), s = parseInt(n[2], 10);
    var a = parseFloat(n[3].replace(",", "."));
    return aa(r, s, a) ? r % 24 * sa + s * Oi + a * 1e3 : NaN;
  }
  return null;
}
function Ri(t, n, r) {
  n = n || 0, r = r || 0;
  var s = /* @__PURE__ */ new Date(0);
  s.setUTCFullYear(t, 0, 4);
  var a = s.getUTCDay() || 7, o = n * 7 + r + 1 - a;
  return s.setUTCDate(s.getUTCDate() + o), s;
}
var ch = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], dh = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function uc(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function Mi(t, n, r) {
  if (n < 0 || n > 11)
    return !1;
  if (r != null) {
    if (r < 1)
      return !1;
    var s = uc(t);
    if (s && r > dh[n] || !s && r > ch[n])
      return !1;
  }
  return !0;
}
function uh(t, n) {
  if (n < 1)
    return !1;
  var r = uc(t);
  return !(r && n > 366 || !r && n > 365);
}
function zi(t, n, r) {
  return !(n < 0 || n > 52 || r != null && (r < 0 || r > 6));
}
function aa(t, n, r) {
  return !(t != null && (t < 0 || t >= 25) || n != null && (n < 0 || n >= 60) || r != null && (r < 0 || r >= 60));
}
function mh(t, n, r) {
  if (typeof t == "string" && !t.match(dc)) {
    var s = Hp(r);
    return s.timeZone = n, _i(t, s);
  }
  var a = _i(t, r), o = Xa(
    a.getFullYear(),
    a.getMonth(),
    a.getDate(),
    a.getHours(),
    a.getMinutes(),
    a.getSeconds(),
    a.getMilliseconds()
  ).getTime(), i = cc(n, new Date(o));
  return new Date(o + i);
}
const fh = "OresundGO", ph = "OresundPendler", hh = "OresundPAY", gh = "BroBizz_Private";
var fr = /* @__PURE__ */ ((t) => (t.blockCommercialVehicle = "commercialVehicle", t))(fr || {});
function xh() {
  const t = Ye(), [n, r] = L(!1), { locale: s, query: a } = ve(), { customerType: o } = sn(), i = a.contract, c = hn(), l = i || c, { customerInformation: d } = tt(), { data: u, isLoading: m } = De(
    xe.Recognitions({
      contractNo: l
    }),
    (C) => C.Recognitions.getByContractNo({
      contractNo: l
    }),
    {
      enabled: !!l,
      retry: 1
    }
  ), { data: f } = De(
    xe.PeriodCardPrice(),
    (C) => C.Price.periodCard,
    {
      retry: 1
    }
  ), p = (C) => {
    var A;
    const { id: P, contractNo: N, currencyCode: R } = C, T = (A = f == null ? void 0 : f.find(
      (S) => S.currencyCode === R
    )) == null ? void 0 : A.fee, D = {
      private: "Private",
      business: "Business",
      iticket: "Private",
      "business-commuter": "Business"
    }[o];
    Ua(), Ha(
      {
        transaction_id: P,
        value: `${T}`,
        currency: R,
        coupon: void 0,
        items: [
          {
            item_name: "OresundCommuterPlus",
            item_id: P,
            item_category: D,
            item_variant: "OperatorMyAccount",
            quantity: "1",
            price: `${T}`
          }
        ]
      },
      {
        email: d == null ? void 0 : d.email,
        firstName: d == null ? void 0 : d.firstName,
        lastName: d == null ? void 0 : d.lastName,
        phone: `+${d == null ? void 0 : d.phoneCode}${d == null ? void 0 : d.phone}`,
        city: d == null ? void 0 : d.city,
        address1: d == null ? void 0 : d.address,
        zipCode: d == null ? void 0 : d.zipCode,
        company: d.companyName ?? "",
        country: d == null ? void 0 : d.country
      }
    ), t.setQueryData(
      xe.PeriodCard({ contractNo: N }),
      C
    ), t.invalidateQueries(
      xe.RecognitionsUsageHistory(N)
    ), t.invalidateQueries(
      xe.Recognitions({ contractNo: N })
    );
  }, [b, h] = L(!1), { mutateAsync: g, error: v } = ke(
    ["periodcard"],
    (C) => C.PeriodCard.add,
    {
      onSuccess: p,
      onError: (C) => {
        h(
          C && C.code === 400 && C.error === fr.blockCommercialVehicle
        );
      },
      onSettled: () => {
        r(!1);
      }
    }
  ), y = K(() => !u || !u.recognitions ? [] : u.recognitions.filter(
    (C) => C.recognitionType === "licensePlate"
  ), [u]), x = Q(
    async (C) => {
      const P = {
        ...C,
        startDateTime: mh(
          /* @__PURE__ */ new Date(),
          "Europe/Stockholm"
        ).toISOString(),
        contractNo: l || ""
      };
      r(!0);
      try {
        await g(P);
      } finally {
        r(!1);
      }
    },
    [l, g]
  ), j = tn(s || ""), w = K(() => (f == null ? void 0 : f.find((C) => C.currencyCode === j)) ?? void 0, [j, f]);
  return {
    loading: n,
    loadingRecoginitions: m,
    onSubmit: x,
    validRecognitions: y,
    price: w,
    error: v,
    attemptToAddCommercialVehicle: b
  };
}
const bh = ({ onClose: t }) => {
  const { locale: n } = ve(), {
    loading: r,
    loadingRecoginitions: s,
    onSubmit: a,
    validRecognitions: o,
    price: i,
    error: c,
    attemptToAddCommercialVehicle: l
  } = xh(), d = l, { t: u } = V(["account", "common", "recognitions"], {
    nsMode: "fallback"
  }), { customerType: m } = sn(), f = K(() => ({ serialNo: o.length ? `${o[0].serialNo}` : void 0 }), [o]), p = K(() => {
    if (i) {
      const { fee: C, currencyCode: P } = i;
      return ss(C, n, P);
    }
    return "";
  }, [i, n]), { registerField: b, handleSubmit: h, isValid: g } = Se({
    namespace: "periodcard",
    defaultValues: f,
    onSubmit: a
  }), [v, y] = He("periodcard", "agreement", "serialNo"), x = K(() => qf(y)(
    o
  ), [y, o]), j = K(
    () => !!(x != null && x.isCommercialVehicle),
    [x]
  ), w = K(() => v === "true", [v]);
  return /* @__PURE__ */ e.jsxs("form", { className: "flex flex-col gap-8", onSubmit: h, children: [
    /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-4", children: [
      /* @__PURE__ */ e.jsx(M, { intent: "title", size: "sm", children: u("form.labels.startDate") }),
      /* @__PURE__ */ e.jsx(M, { className: "col-span-full", weight: "light", children: u("periodCard.modals.add.startDate") })
    ] }),
    /* @__PURE__ */ e.jsxs(
      Vt,
      {
        title: u("form.labels.connectedAlpr"),
        id: "vehicle",
        full: !1,
        titleIntent: "title",
        titleSize: "sm",
        className: "pb-0",
        editButton: !1,
        children: [
          (j || d) && /* @__PURE__ */ e.jsx(
            Le,
            {
              color: "warn",
              className: "col-span-full flex items-center justify-between",
              children: /* @__PURE__ */ e.jsx(M, { size: "md", children: u("form.validations.periodCard.isCommercialVehicle") })
            }
          ),
          /* @__PURE__ */ e.jsx(
            Oe,
            {
              ...b("serialNo"),
              label: u("form.labels.alpr"),
              className: "col-span-2 sm:col-span-4 md:col-span-6",
              options: o.length ? o.map((C) => ({
                label: C.registrationNo,
                value: `${C.serialNo}`
              })) : [
                {
                  label: u("periodCard.modals.add.errors.noAvailableAlpr"),
                  value: "",
                  disabled: !0
                }
              ],
              helpText: u("form.helpTexts.periodCard"),
              required: !0
            }
          ),
          !s && o.length === 0 ? /* @__PURE__ */ e.jsx(
            Le,
            {
              color: "negative",
              className: "col-span-full flex items-center justify-between",
              children: /* @__PURE__ */ e.jsx(M, { size: "md", children: u("periodCard.modals.add.errors.noAlpr") })
            }
          ) : null,
          /* @__PURE__ */ e.jsx(M, { className: "col-span-full", weight: "light", children: u("periodCard.modals.add.disclaimers.alpr") })
        ]
      }
    ),
    /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-2", children: [
      /* @__PURE__ */ e.jsx("hr", { className: "col-span-full mb-4" }),
      /* @__PURE__ */ e.jsx(Pt, { label: u("periodCard.modals.add.price"), children: /* @__PURE__ */ e.jsx("span", { className: "text-2xl", children: p }) }),
      /* @__PURE__ */ e.jsx(M, { intent: "label", size: "lg", children: u("form.helpTexts.periodCardSpan") })
    ] }),
    /* @__PURE__ */ e.jsx(Le, { children: /* @__PURE__ */ e.jsx(M, { size: "md", children: u("periodCard.modals.add.disclaimers.product") }) }),
    /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-4", children: [
      /* @__PURE__ */ e.jsx(
        me,
        {
          ...b("agreement", { type: "checkbox", value: "true" }),
          className: "col-span-full",
          label: u("form.labels.termsOfAgreement"),
          required: !0
        }
      ),
      /* @__PURE__ */ e.jsx(M, { size: "sm", className: "col-span-full", children: /* @__PURE__ */ e.jsx(
        os,
        {
          type: m === "private" ? pe.OresundGo : pe.OresundBusiness
        }
      ) })
    ] }),
    c && !l ? /* @__PURE__ */ e.jsx(Le, { color: "negative", children: /* @__PURE__ */ e.jsx(M, { size: "md", children: u("periodCard.modals.add.errors.generic") }) }) : null,
    /* @__PURE__ */ e.jsxs("div", { className: "flex justify-end gap-4", children: [
      /* @__PURE__ */ e.jsx(be, { as: "button", intent: "text", onClick: t, children: u("action.cancel") }),
      /* @__PURE__ */ e.jsx(
        et,
        {
          loadingLabel: u("action.loading"),
          disabled: !w || !o.length || !g || j || d,
          type: "submit",
          isLoading: r,
          children: u("periodCard.modals.add.action")
        }
      )
    ] })
  ] });
}, mc = uu(({ className: t, buttonProps: n = {} }) => {
  const { t: r } = V(["account", "common"], { nsMode: "fallback" }), s = qe(null), a = hn(), o = jo(
    xe.PeriodCardPrice(),
    (c) => c.Price.periodCard
  ), i = jo(
    xe.Recognitions({
      contractNo: a
    }),
    (c) => c.Recognitions.getByContractNo({
      contractNo: a
    })
  );
  return Y(() => {
    a && (o(), i());
  }, [a, o, i]), /* @__PURE__ */ e.jsx(
    Bt,
    {
      title: /* @__PURE__ */ e.jsx(he, { ns: "account", i18nKey: "periodCard.modals.add.title", children: /* @__PURE__ */ e.jsx(ne, { as: "span", className: "font-bold" }) }),
      trigger: /* @__PURE__ */ e.jsx(be, { className: t, ...n, children: r("periodCard.modals.add.action") }),
      ref: s,
      children: /* @__PURE__ */ e.jsx(bh, { onClose: () => {
        var c;
        return (c = s.current) == null ? void 0 : c.close();
      } })
    }
  );
}), Ja = ({
  translationKey: t
}) => /* @__PURE__ */ e.jsx(he, { ns: "common", i18nKey: t, children: /* @__PURE__ */ e.jsx(M, { as: "span", intent: "title", size: "md", weight: "bold" }) }), vh = (t) => [
  fh,
  ph,
  hh,
  gh
].includes(t), yh = (t, n) => (r) => r ? `${r.amount} ${r.currency} / ${t}` : n, ya = ({
  onCancel: t,
  onEditBillingAddress: n,
  contract: r,
  actionsDisabled: s,
  periodCard: a,
  hideBillingInfo: o = !1
}) => {
  const { t: i } = V(["account", "common"], {
    nsMode: "fallback"
  }), { customerInformation: c } = tt(), l = c && c.contracts.length > 1, d = r.paymentType === "invoice", u = (c == null ? void 0 : c.customerType) === In.affiliatePartner, m = K(
    () => [
      pe.OresundGo,
      pe.OresundBusiness,
      pe.OresundPendler,
      pe.OresundBusinessPendler
    ].includes(r.agreementType),
    [r.agreementType]
  ), f = (g) => {
    var v;
    return (v = g.split("-")) == null ? void 0 : v[0];
  }, p = `/account/vehicles${l ? `?contract=${f(r.contractNo)}` : ""}`, b = `/account/debit-card${l ? `?contract=${f(r.contractNo)}` : ""}`, { app: h } = Ft();
  return /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsxs(ht, { className: "pt-2", children: [
    /* @__PURE__ */ e.jsx(
      Pt,
      {
        label: i("form.labels.contractType"),
        className: "col-span-full sm:col-span-4 md:col-span-6",
        children: i(`agreement.type.${r.contractType}`)
      }
    ),
    /* @__PURE__ */ e.jsx(
      Pt,
      {
        label: i("form.labels.contractNumber"),
        className: "col-span-full sm:col-span-4 md:col-span-6",
        children: f(r.contractNo)
      }
    ),
    r.agreementType !== pe.Storebelt && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(
        Pt,
        {
          label: i("form.labels.startDate"),
          className: "col-span-full sm:col-span-4 md:col-span-6",
          children: r.startDate
        }
      ),
      /* @__PURE__ */ e.jsx(
        Pt,
        {
          label: i("form.labels.nextPeriodDate"),
          className: "col-span-full sm:col-span-4 md:col-span-6",
          children: r.nextPeriod || "-"
        }
      ),
      /* @__PURE__ */ e.jsx(
        Pt,
        {
          label: i("form.labels.price"),
          className: "col-span-full sm:col-span-4 md:col-span-6",
          children: yh(
            i("agreement.labels.year"),
            "-"
          )(m ? r.price : void 0)
        }
      ),
      d && !o ? /* @__PURE__ */ e.jsx(
        Pt,
        {
          label: i("form.labels.paymentType"),
          className: "col-span-full sm:col-span-4 md:col-span-6",
          children: i(`paymentType.${r.paymentType}`)
        }
      ) : !o && /* @__PURE__ */ e.jsx(
        Pt,
        {
          label: i("form.labels.connectedCard"),
          className: "col-span-full sm:col-span-4 md:col-span-6",
          children: r.cardNumber ?? "-"
        }
      )
    ] }),
    s ? null : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      r.agreementType !== pe.Storebelt ? /* @__PURE__ */ e.jsxs("div", { className: "col-span-full flex flex-col gap-2 border-t border-t-neutral-400 pt-4 md:pt-6", children: [
        /* @__PURE__ */ e.jsx(jt, { href: p, className: "font-normal", children: i("agreement.action.updateRecognition") }),
        !d && !u && !o ? /* @__PURE__ */ e.jsx(jt, { className: "font-normal", href: b, children: i("agreement.action.updateCard") }) : null,
        /* @__PURE__ */ e.jsx(
          as,
          {
            isOresundPay: h === un.OresundPay,
            type: vh(r.agreementType) ? pe.OresundGo : pe.OresundBusiness,
            children: i("agreement.action.termsOfAgreement")
          }
        )
      ] }) : null,
      /* @__PURE__ */ e.jsx("div", { className: "col-span-full flex justify-end border-t border-t-neutral-400 py-2", children: r.cancelDate ? /* @__PURE__ */ e.jsx(M, { children: i("agreement.label.cancelled", {
        replace: { cancelDate: r.cancelDate }
      }) }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        n ? /* @__PURE__ */ e.jsx(
          be,
          {
            intent: "text",
            onClick: () => n(r),
            children: i("agreement.action.editBillingAddress")
          }
        ) : null,
        t ? /* @__PURE__ */ e.jsx(
          be,
          {
            intent: "text",
            onClick: () => t(r, a),
            children: i("agreement.action.cancelAgreement")
          }
        ) : null
      ] }) })
    ] })
  ] }) });
}, jh = Gt("px-5", {
  variants: {
    intent: {
      primary: ["py-5"],
      secondary: ["first-of-type:pt-5", "pt-3", "last-of-type:pb-6", "pb-3"]
    },
    color: {
      primary: ["bg-blue-600"],
      secondary: ["bg-green-600"],
      tertiary: ["bg-white"],
      dim: ["bg-neutral-50"]
    }
  },
  defaultVariants: {
    color: "primary",
    intent: "primary"
  }
}), Ch = Gt("", {
  variants: {
    intent: {
      primary: ["text-base", "font-semibold", "uppercase", "tracking-widest"],
      secondary: ["text-sm", "font-normal"]
    },
    color: {
      primary: ["text-white"],
      secondary: ["text-white"],
      tertiary: ["text-neutral-700"],
      dim: ["text-neutral-700"]
    }
  },
  defaultVariants: {
    color: "primary",
    intent: "primary"
  }
}), wh = Gt(
  "text-lg sm:text-2xl font-semibold leading-tight",
  {
    variants: {
      color: {
        primary: ["text-white"],
        secondary: ["text-white"],
        tertiary: ["text-neutral-700"],
        dim: ["text-neutral-800"]
      }
    },
    defaultVariants: {
      color: "primary"
    }
  }
), fc = ({
  preTitle: t,
  color: n = "primary",
  intent: r = "primary",
  title: s,
  brandLogo: a,
  cancelled: o,
  bannerCancelledText: i
}) => /* @__PURE__ */ e.jsx("div", { className: jh({ intent: r, color: n }), children: /* @__PURE__ */ e.jsxs("div", { className: "flex items-center gap-7", children: [
  /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-1", children: [
    /* @__PURE__ */ e.jsx("p", { className: Ch({ intent: r, color: n }), children: t }),
    /* @__PURE__ */ e.jsx("p", { className: wh({ color: n }), children: s })
  ] }),
  a ? /* @__PURE__ */ e.jsx("div", { className: "ml-auto h-full", children: /* @__PURE__ */ e.jsx(
    Wa,
    {
      src: a.src,
      alt: a.alt,
      width: 0,
      height: 0,
      loader: ({ src: c }) => c,
      className: "h-full w-auto max-w-[120px]"
    }
  ) }) : null,
  o ? /* @__PURE__ */ e.jsx("div", { className: "my-auto ml-auto max-w-[20ch] overflow-y-hidden rounded-lg bg-red-700 p-1", children: /* @__PURE__ */ e.jsx(
    M,
    {
      intent: "title",
      size: "sm",
      className: "truncate text-ellipsis text-white",
      children: i
    }
  ) }) : null
] }) }), Nh = Gt(
  "flex flex-col border-2 rounded-xl overflow-hidden",
  {
    variants: {
      intent: {
        primary: [],
        secondary: []
      },
      color: {
        primary: ["border-blue-600"],
        secondary: ["border-green-600"],
        tertiary: ["border-white"],
        dim: ["border-neutral-50"]
      }
    },
    defaultVariants: {
      color: "primary",
      intent: "primary"
    }
  }
), Ph = [pe.OresundGo], Sh = ({
  agreements: t
}) => {
  const { t: n } = V(["account", "common"], {
    nsMode: "fallback"
  }), r = [
    {
      condition: t == null ? void 0 : t.tollingAgreementSigned,
      preTitle: n("agreement.gnss.description"),
      title: n("agreement.gnss.label"),
      logoSrc: "/images/kmtoll.svg",
      logoAlt: "kmToll"
    },
    {
      condition: t == null ? void 0 : t.tollCollectAgreementSigned,
      preTitle: n("agreement.tollcollect.description"),
      title: n("agreement.tollcollect.label"),
      logoSrc: "/images/tollcollect.svg",
      logoAlt: "Toll Collect"
    }
  ];
  return /* @__PURE__ */ e.jsx("div", { className: "border-t border-neutral-300", children: /* @__PURE__ */ e.jsx("div", { className: "> * + * divide-y-[1px] border-neutral-200", children: r.map(
    ({ condition: s, preTitle: a, title: o, logoSrc: i, logoAlt: c }, l) => s && /* @__PURE__ */ e.jsx(
      fc,
      {
        preTitle: a,
        title: o,
        color: "dim",
        intent: "secondary",
        brandLogo: {
          src: i,
          alt: c
        }
      },
      l
    )
  ) }) });
}, sr = ({
  color: t,
  intent: n,
  title: r,
  preTitle: s,
  description: a,
  disabled: o,
  actionBanner: i,
  footNote: c,
  children: l,
  signedAgreements: d,
  cancelled: u,
  cancelledDescription: m,
  bannerCancelledText: f,
  onReactiveateClick: p,
  reactiveateButtonText: b,
  customerType: h
}) => {
  var j, w;
  const { customerInformation: g } = tt(), v = (j = g == null ? void 0 : g.contracts[0]) == null ? void 0 : j.contractNo, { data: y } = bt(!1, v), x = (w = y == null ? void 0 : y.paymentAgreement) == null ? void 0 : w.agreementType;
  return /* @__PURE__ */ e.jsxs("div", { className: Nh({ color: t, intent: n }), children: [
    /* @__PURE__ */ e.jsx(
      fc,
      {
        preTitle: s,
        title: r,
        color: t,
        intent: n,
        cancelled: u,
        bannerCancelledText: f
      }
    ),
    /* @__PURE__ */ e.jsx(zn.Root, { type: "single", collapsible: !0, children: u ? /* @__PURE__ */ e.jsxs("div", { className: "flex py-4", children: [
      /* @__PURE__ */ e.jsx("div", { className: "my-auto max-w-56 truncate text-ellipsis px-5", children: m }),
      x && Ph.includes(x) ? /* @__PURE__ */ e.jsx(
        be,
        {
          className: "lg-bg ml-auto mr-2 max-w-56 truncate text-ellipsis",
          intent: "solid",
          color: "primary",
          "aria-label": "Re-activate agreement",
          onClick: () => {
            p && p(!0);
          },
          children: b
        }
      ) : null
    ] }) : /* @__PURE__ */ e.jsxs(zn.Item, { value: "content", disabled: o, children: [
      /* @__PURE__ */ e.jsx(zn.Header, { children: /* @__PURE__ */ e.jsx(pc, { disabled: o, children: a }) }),
      /* @__PURE__ */ e.jsx(hc, { children: l })
    ] }) }),
    d && Object.keys(d).length > 0 && /* @__PURE__ */ e.jsx(Sh, { agreements: d }),
    c && /* @__PURE__ */ e.jsx(
      M,
      {
        intent: "body",
        size: "sm",
        className: "border-1-neutral-400 mt-2 border-t px-5 py-4 text-neutral-800",
        children: c
      }
    ),
    i
  ] });
}, pc = ot.forwardRef(
  ({
    children: t,
    disabled: n,
    className: r,
    ...s
  }, a) => /* @__PURE__ */ e.jsx(zn.Header, { className: "flex", children: /* @__PURE__ */ e.jsxs(
    zn.Trigger,
    {
      disabled: n,
      className: "group/trigger flex flex-1 items-center justify-between gap-2 px-5 py-4 text-left text-sm leading-normal",
      ...s,
      ref: a,
      children: [
        t,
        !n && /* @__PURE__ */ e.jsx(
          _r,
          {
            className: "h-auto w-3 flex-none rotate-180 transition-transform duration-150 ease-in-out group-data-[state=open]/trigger:rotate-0",
            "aria-hidden": !0
          }
        )
      ]
    }
  ) })
);
pc.displayName = "AccordionTrigger";
const hc = ot.forwardRef(
  ({
    children: t,
    className: n,
    ...r
  }, s) => /* @__PURE__ */ e.jsx(zn.Content, { ...r, ref: s, className: "px-5", children: /* @__PURE__ */ e.jsx("div", { children: t }) })
);
hc.displayName = "AccordionContent";
sr.displayName = "AgreementCard";
const Th = (t) => t === "business" ? pe.OresundPAYBusiness : pe.OresundPAY, Za = (t, n) => (r) => r === t ? n() : null, Eh = (t) => Za("pending", () => /* @__PURE__ */ e.jsx(Qa, { ...t, children: /* @__PURE__ */ e.jsx(lc, {}) }))(t.status), kh = (t) => Za("active", () => {
  const n = _u(/* @__PURE__ */ new Date(), Ru(new Date(t.date), 1));
  return /* @__PURE__ */ e.jsx(Qa, { ...t, disableCancel: n, children: /* @__PURE__ */ e.jsx(lc, { disabled: n }) });
})(t.status), Ah = (t) => Za("cancelled", () => /* @__PURE__ */ e.jsx(Qa, { ...t }))(t.status), Oh = () => /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-2 border-t border-t-neutral-300 px-5 py-4 sm:flex-row sm:items-center sm:justify-between", children: [
  /* @__PURE__ */ e.jsx(M, { size: "md", className: "max-w-[55ch] leading-relaxed", children: /* @__PURE__ */ e.jsx(he, { ns: "account", i18nKey: "agreement.periodCard.upgrade", children: /* @__PURE__ */ e.jsx(
    M,
    {
      as: "span",
      size: "md",
      weight: "medium",
      className: "bg-primary-400 rounded-sm px-1 py-1 text-white"
    }
  ) }) }),
  /* @__PURE__ */ e.jsx("div", { className: "flex items-center", children: /* @__PURE__ */ e.jsx(mc, {}) })
] }), _h = (t) => {
  const n = Ip(t);
  return Eh(n) || kh(n) || Ah(n);
}, gc = (t) => t ? _h(t) : Oh(), Rh = ({
  agreements: t,
  onEditAgreement: n,
  onCancelAgreement: r,
  onReactiveateClick: s
}) => {
  const { t: a } = V(["account", "common"], {
    nsMode: "fallback"
  }), { customerType: o } = sn();
  tt();
  const { data: i } = ur();
  if (!t)
    return null;
  const { tollingAgreementSigned: c, tollCollectAgreementSigned: l } = t || {};
  return /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-12", children: [
    t.paymentAgreement ? /* @__PURE__ */ e.jsxs("div", { children: [
      /* @__PURE__ */ e.jsx(
        M,
        {
          as: "h3",
          size: "lg",
          intent: "title",
          weight: "medium",
          className: "mb-1",
          children: a("agreement.exhibition.label")
        }
      ),
      /* @__PURE__ */ e.jsx("p", { className: "mb-6 leading-relaxed text-neutral-600", children: a("agreement.exhibition.description") }),
      /* @__PURE__ */ e.jsx("div", { className: "flex flex-col gap-4", children: /* @__PURE__ */ e.jsx(
        sr,
        {
          preTitle: a("agreement.label.paymentAgreement"),
          description: a(
            `agreementProviders.${t.paymentAgreement.provider.id}.description`
          ),
          title: /* @__PURE__ */ e.jsx(
            Ja,
            {
              translationKey: `agreementProviders.${t.paymentAgreement.provider.id}.badge`
            }
          ),
          color: "secondary",
          signedAgreements: {
            tollingAgreementSigned: c,
            tollCollectAgreementSigned: l
          },
          cancelled: t.paymentAgreement.status === "closed",
          cancelledDescription: a(
            "reactivateContract.agreementCard.description"
          ),
          bannerCancelledText: a(
            "reactivateContract.agreementCard.header.cancelled"
          ),
          onReactiveateClick: s,
          reactiveateButtonText: a(
            "reactivateContract.agreementCard.content.reactivateButton"
          ),
          customerType: o,
          children: t.paymentAgreement.status !== "closed" ? /* @__PURE__ */ e.jsx(
            ya,
            {
              onEditBillingAddress: Lp(t.paymentAgreement) ? n : void 0,
              onCancel: !i || !(i != null && i.active) ? r : void 0,
              contract: {
                ...t.paymentAgreement,
                contractType: "payment",
                agreementType: Th(o)
              },
              actionsDisabled: jn(
                t.paymentAgreement.provider
              )
            }
          ) : null
        }
      ) })
    ] }) : null,
    t.activeDiscountAgreements.length ? /* @__PURE__ */ e.jsxs("div", { className: "pt-4", children: [
      /* @__PURE__ */ e.jsx(
        M,
        {
          as: "h3",
          size: "lg",
          intent: "title",
          weight: "medium",
          className: "mb-1",
          children: a("agreement.discount.label")
        }
      ),
      /* @__PURE__ */ e.jsx("p", { className: "mb-2 leading-relaxed text-neutral-600", children: a("agreement.discount.activeDescription") }),
      /* @__PURE__ */ e.jsx("div", { className: "my-4 flex flex-col gap-4", children: t.activeDiscountAgreements.map((d, u) => /* @__PURE__ */ e.jsx(
        sr,
        {
          preTitle: a("agreement.label.discountAgreement"),
          description: a(
            `agreementTypes.${d.agreementType}.description`
          ),
          title: /* @__PURE__ */ e.jsx(
            at,
            {
              contract: Ga(
                d.agreementType
              ) ?? Wt.OresundGO
            }
          ),
          actionBanner: Vf(d.agreementType) ? gc(i) : void 0,
          customerType: o,
          children: /* @__PURE__ */ e.jsx(
            ya,
            {
              onCancel: r,
              contract: d,
              actionsDisabled: !1,
              periodCard: i,
              hideBillingInfo: !0
            }
          )
        },
        `agreement-active-${u}`
      )) })
    ] }) : null
  ] });
}, Mh = ({
  agreements: t,
  onAddAgreement: n
}) => {
  const { t: r } = V(["account", "common"], {
    nsMode: "fallback"
  }), s = qe(), a = ve();
  Ld(() => {
    var c;
    a.query.showSbf && ((c = s == null ? void 0 : s.current) == null || c.scrollIntoView({ behavior: "smooth" }));
  }, [a.query.showSbf]);
  const { customerType: o } = sn(), i = K(() => {
    var f, p, b;
    const c = (f = t == null ? void 0 : t.paymentAgreement) == null ? void 0 : f.provider.id, l = (c === nr.ORESUNDPAY || c === nr.ORESUNDSBRON) && ((p = t == null ? void 0 : t.paymentAgreement) == null ? void 0 : p.status) === "active", d = !(t != null && t.activeDiscountAgreements.some(
      (h) => h.agreementType === "Storebelt"
    )), u = o === "private" && l && d, m = (t == null ? void 0 : t.availableDiscountAgreements) ?? [];
    return u ? [
      ...m,
      $p(((b = t == null ? void 0 : t.paymentAgreement) == null ? void 0 : b.contractNo) ?? "")
    ] : m;
  }, [t, o]);
  return i.length === 0 ? null : /* @__PURE__ */ e.jsxs("div", { id: "available-agreements", children: [
    /* @__PURE__ */ e.jsx(
      M,
      {
        as: "h3",
        size: "lg",
        intent: "title",
        weight: "medium",
        className: "mb-1",
        children: r("agreement.discount.availableDiscountAgreements")
      }
    ),
    /* @__PURE__ */ e.jsx("p", { className: "mb-2 leading-relaxed text-neutral-600", children: r("agreement.discount.description") }),
    /* @__PURE__ */ e.jsx("div", { className: "my-4 flex flex-col gap-4", children: i.map((c) => /* @__PURE__ */ e.jsx(
      sr,
      {
        color: "primary",
        preTitle: r("agreement.label.discountAgreement"),
        title: /* @__PURE__ */ e.jsx(
          Ja,
          {
            translationKey: `agreementTypes.${c == null ? void 0 : c.agreementType}.badge`
          }
        ),
        description: r(
          `agreementTypes.${c == null ? void 0 : c.agreementType}.description`
        ),
        footNote: (c == null ? void 0 : c.agreementType) === "Storebelt" && r(`agreementTypes.${c == null ? void 0 : c.agreementType}.footNote`),
        actionBanner: /* @__PURE__ */ e.jsxs("div", { className: "border-1-neutral-400 mt-2 flex justify-end border-t px-5 py-4", children: [
          c.agreementType === "Storebelt" && /* @__PURE__ */ e.jsxs(
            jt,
            {
              href: r(
                `agreementTypes.${c == null ? void 0 : c.agreementType}.readMoreLink`
              ),
              target: "_blank",
              className: "mr-4 flex flex-row items-center p-2",
              children: [
                r("action.readMore"),
                /* @__PURE__ */ e.jsx(Qd, { className: "ml-2" })
              ]
            }
          ),
          /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col items-end", children: [
            /* @__PURE__ */ e.jsx(
              be,
              {
                intent: "solid",
                disabled: !(t != null && t.hasActiveRecognitions),
                onClick: () => n(c),
                children: r("agreement.action.add")
              }
            ),
            !(t != null && t.hasActiveRecognitions) && /* @__PURE__ */ e.jsx(M, { weight: "light", className: "mt-2", children: r("agreement.discount.noActiveRecognitionWarning") })
          ] })
        ] }),
        disabled: !0
      },
      c.agreementType
    )) })
  ] });
}, xc = {
  showConfirmation: !1,
  success: !1,
  loading: !1,
  contractNo: void 0,
  agreedToPoliciesClicked: !1,
  error: !1,
  errorMessage: void 0
}, mn = Vn(
  () => xc
), zh = () => mn.setState(xc), Dh = () => mn.setState({ loading: !0 }), Lh = (t) => mn.setState({
  success: !0,
  showConfirmation: !0,
  loading: !1,
  contractNo: t
}), Ih = (t) => mn.setState({
  error: !0,
  loading: !1,
  errorMessage: t
}), $h = () => {
  const t = mn.getState();
  mn.setState({
    agreedToPoliciesClicked: !t.agreedToPoliciesClicked
  });
}, Fh = ({ close: t, onReactivate: n, agreedToPolicies: r }) => {
  const { t: s } = V(["account", "common"], {
    nsMode: "fallback"
  }), { loading: a } = mn();
  return /* @__PURE__ */ e.jsxs("div", { className: "flex justify-end", children: [
    /* @__PURE__ */ e.jsx(
      be,
      {
        intent: "text",
        onClick: t,
        className: "max-w-[65ch] truncate text-ellipsis",
        children: s("action.cancel")
      }
    ),
    /* @__PURE__ */ e.jsx(
      et,
      {
        intent: "solid",
        onClick: n,
        isLoading: a,
        disabled: !r,
        loadingLabel: s("actions.loading"),
        className: "max-w-[65ch] truncate text-ellipsis",
        children: s("reactivateContract.modal.action.reactivate")
      }
    )
  ] });
}, Bh = ({ close: t }) => {
  const { t: n } = V(["account", "common"], {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsx("div", { className: "flex justify-center", children: /* @__PURE__ */ e.jsx(be, { intent: "text", onClick: t, children: n("action.complete") }) });
}, Vh = ({ onToggleAgreeToPolicies: t, paymentContract: n }) => {
  const { t: r } = V(["account", "common"], {
    nsMode: "fallback"
  }), { customerType: s } = sn(), { app: a } = Ft();
  return un.OresundPay, /* @__PURE__ */ e.jsxs("div", { children: [
    /* @__PURE__ */ e.jsx(
      Ja,
      {
        translationKey: `agreementProviders.${n == null ? void 0 : n.provider.id}.badge`
      }
    ),
    /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-3", children: [
      /* @__PURE__ */ e.jsx(
        M,
        {
          size: "md",
          className: ct("flex", "flex-col", "gap-3", "text-left, pt-2"),
          children: r("reactivateContract.modal.confirm.description")
        }
      ),
      /* @__PURE__ */ e.jsx(
        vn,
        {
          label: r("reactivateContract.agreeToPoliciesLabel"),
          onChange: () => t()
        }
      ),
      /* @__PURE__ */ e.jsx("div", { className: "flex space-x-1", children: /* @__PURE__ */ e.jsx(
        os,
        {
          isOresundPay: !0,
          type: s === "private" ? pe.OresundGo : pe.OresundBusiness
        }
      ) })
    ] })
  ] });
}, qh = ({ errorMessage: t }) => {
  const { t: n } = V(["account", "common"], {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    n("reactivateContract.backendError"),
    " ",
    null
  ] });
}, Wh = () => {
  const { t } = V(["account", "common"], {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsx("div", { className: "mb-0", children: /* @__PURE__ */ e.jsx(M, { children: t("reactivateContract.modal.success") }) });
}, Hh = ({
  onSuccess: t,
  onClose: n,
  paymentContract: r
}) => {
  const s = Ye(), { t: a } = V(["account", "common"], {
    nsMode: "fallback"
  }), {
    success: o,
    agreedToPoliciesClicked: i,
    error: c,
    errorMessage: l
  } = mn(), { mutateAsync: d } = ke(
    ["contract", "reactivate"],
    ({ Contract: f }) => f.reactivate,
    {
      onMutate: Dh,
      onError: (f) => {
        Ih(f.error);
      },
      onSuccess: (f) => {
        s.invalidateQueries(xe.Agreements()), s.invalidateQueries(xe.CustomerInformation()), s.invalidateQueries({
          queryKey: xe.AllContracts()
        }), Lh(f.success);
      }
    }
  ), u = Q(() => {
    zh(), o && t && t(), n();
  }, [t, o, n]), m = () => o ? /* @__PURE__ */ e.jsx(Wh, {}) : c ? /* @__PURE__ */ e.jsx(qh, { errorMessage: l }) : /* @__PURE__ */ e.jsx(
    Vh,
    {
      onToggleAgreeToPolicies: $h,
      paymentContract: r
    }
  );
  return /* @__PURE__ */ e.jsx(
    Bt,
    {
      footer: () => o ? /* @__PURE__ */ e.jsx(Bh, { close: u }) : /* @__PURE__ */ e.jsx(
        Fh,
        {
          close: u,
          onReactivate: async () => {
            r && d({ contractNo: r.contractNo });
          },
          agreedToPolicies: i
        }
      ),
      title: /* @__PURE__ */ e.jsx(M, { as: "span", className: "text-neutral-900", weight: "bold", children: a("reactivateContract.modal.title") }),
      onOpenChange: (f) => {
        f || u();
      },
      open: !0,
      children: m()
    }
  );
}, Uh = ({
  contractNumber: t
}) => {
  const [n, r] = L(), [s, a] = L(), [o, i] = L(), [c, l] = L(), [d, u] = L(!1), { data: m, refetch: f } = bt(!0, t), { customerType: p } = sn();
  return /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-12", children: [
    /* @__PURE__ */ e.jsx(
      Rh,
      {
        agreements: m,
        onEditAgreement: i,
        onCancelAgreement: (b, h) => {
          r(b), a(h);
        },
        onReactiveateClick: u
      }
    ),
    /* @__PURE__ */ e.jsx(
      Mh,
      {
        agreements: m,
        onAddAgreement: l
      }
    ),
    d === !0 ? /* @__PURE__ */ e.jsx(
      Hh,
      {
        paymentContract: m == null ? void 0 : m.paymentAgreement,
        onClose: () => {
          u(!1);
        },
        onSuccess: () => f()
      }
    ) : null,
    n && /* @__PURE__ */ e.jsx(
      ic,
      {
        contract: n,
        paymentContract: m == null ? void 0 : m.paymentAgreement,
        periodCard: s,
        customerType: p,
        onClose: () => r(void 0),
        onSuccess: () => f()
      }
    ),
    o && /* @__PURE__ */ e.jsx(zt, { children: /* @__PURE__ */ e.jsx(
      ep,
      {
        contract: o,
        onClose: () => i(void 0)
      }
    ) }),
    /* @__PURE__ */ e.jsx(zt, { children: c && /* @__PURE__ */ e.jsx(
      Op,
      {
        contract: c,
        onClose: () => l(void 0),
        onSuccess: () => f()
      }
    ) })
  ] });
}, Gh = (t) => {
  if (t.length === 0) return !0;
  const { provider: n } = t[0].paymentAgreement;
  return t.every(
    ({ paymentAgreement: r }) => r.provider.id === n.id
  );
}, Kh = ({
  contracts: t
}) => {
  const { t: n } = V(["account", "common"], { nsMode: "fallback" }), r = !Gh(t), { locale: s } = ve(), a = [
    {
      key: "contractNo",
      label: n("agreement.agreementTableColumns.labels.contractNo")
    },
    {
      key: "details",
      label: n("agreement.agreementTableColumns.labels.carsOrBizzes")
    },
    {
      key: "paymentType",
      label: n("agreement.agreementTableColumns.labels.paymentMethod")
    },
    {
      key: "activeAgreements",
      label: n("agreement.agreementTableColumns.labels.activeAgreements")
    }
  ];
  r && a.push({
    key: "paymentProvider",
    label: n("agreement.agreementTableColumns.labels.paymentProvider")
  });
  const o = {
    contractNo: "",
    paymentType: "",
    activeAgreements: "",
    filter: "",
    startDate: "",
    endDate: "",
    apply: ""
  }, i = (d) => {
    const m = ((d == null ? void 0 : d.activeDiscountAgreements) || []).map(
      (f) => f.agreementType
    );
    return d.tollingAgreementSigned && m.push("KmToll"), m.map((f, p) => /* @__PURE__ */ e.jsxs(Sa, { children: [
      n(`agreementTypes.${f}.label`),
      p < m.length - 1 ? ", " : ""
    ] }, f));
  }, c = (d) => {
    let u = "";
    switch (d) {
      case "invoice":
        u = "form.labels.invoice";
        break;
      case "card":
        u = "";
        break;
    }
    return n(u);
  }, l = (d) => {
    var p;
    if (!d) return "";
    const u = d.validDate || "", m = ((p = d.cardNumber) == null ? void 0 : p.replace(/\*/g, "")) || "", f = c(d.paymentType) || "";
    return d.paymentType === "card" ? /* @__PURE__ */ e.jsxs("div", { className: "flex items-center gap-1 overflow-hidden truncate text-ellipsis", children: [
      /* @__PURE__ */ e.jsx(Xd, {}),
      " ",
      "...",
      m,
      " ",
      /* @__PURE__ */ e.jsxs("span", { className: "hidden sm:inline", children: [
        "•",
        " ",
        f,
        u
      ] })
    ] }) : d.paymentType === "invoice" ? /* @__PURE__ */ e.jsx(e.Fragment, { children: f }) : f;
  };
  return /* @__PURE__ */ e.jsx(_a, { columns: a, labels: o, children: t.map((d) => {
    var u, m;
    return /* @__PURE__ */ e.jsxs(
      "tr",
      {
        className: "border-b-2 text-xs leading-4 text-neutral-800 sm:text-sm",
        children: [
          /* @__PURE__ */ e.jsx("td", { className: "pr-14 sm:py-2 sm:pr-0 ", children: /* @__PURE__ */ e.jsx(
            jt,
            {
              className: "font-bold text-blue-700",
              as: "a",
              href: `/${s}/account/agreement/${d.paymentAgreement.contractNo}`,
              children: d.paymentAgreement.contractNo
            }
          ) }),
          /* @__PURE__ */ e.jsx("td", { className: "py-2 pr-14 sm:py-2", children: /* @__PURE__ */ e.jsxs("div", { className: "flex gap-1 ", children: [
            /* @__PURE__ */ e.jsxs("div", { className: "flex  items-center gap-1 rounded bg-neutral-100 px-1 py-1 sm:px-2 sm:py-1", children: [
              /* @__PURE__ */ e.jsx("span", { children: ((u = d.recognitions) == null ? void 0 : u.alpr) ?? "0" }),
              /* @__PURE__ */ e.jsx(Hr, {})
            ] }),
            /* @__PURE__ */ e.jsxs("div", { className: "flex  items-center gap-1 rounded bg-neutral-100 px-1 py-1 sm:px-2 sm:py-1", children: [
              /* @__PURE__ */ e.jsx("span", { children: ((m = d.recognitions) == null ? void 0 : m.bizz) ?? "0" }),
              /* @__PURE__ */ e.jsx(ka, {})
            ] })
          ] }) }),
          /* @__PURE__ */ e.jsx("td", { className: "gap-1 py-2 pr-14 sm:pr-2", children: l(d.paymentAgreement) || "-" }),
          /* @__PURE__ */ e.jsx("td", { className: "py-2", children: /* @__PURE__ */ e.jsx("span", { children: i(d) || "-" }) }),
          r && /* @__PURE__ */ e.jsx("td", { className: "py-2", children: /* @__PURE__ */ e.jsx("span", { children: n(
            `agreementProviders.${d.paymentAgreement.provider.id}.label`
          ) }) })
        ]
      },
      d.paymentAgreement.contractNo
    );
  }) });
}, Yh = ({ error: t, namespace: n, i18nKey: r }) => {
  const { t: s } = V(n);
  if (t.code !== 404)
    throw t;
  return /* @__PURE__ */ e.jsx(Lt, { variant: "notice", children: s(r) });
}, Qh = ({
  namespace: t,
  i18nKey: n,
  children: r
}) => /* @__PURE__ */ e.jsx(
  Ql,
  {
    fallbackCallback: (s) => /* @__PURE__ */ e.jsx(Yh, { error: s, namespace: t, i18nKey: n }),
    children: r
  }
), lC = () => {
  var d, u;
  const { t } = V(["account", "common"], { nsMode: "fallback" }), { data: n, error: r } = Ma(
    !0,
    void 0,
    !0
  ), { customerType: s } = sn(), { customerInformation: a } = tt(), o = K(
    () => Qf(a),
    [a]
  );
  if (r)
    return /* @__PURE__ */ e.jsx(Lt, { variant: "error", children: t("agreement.error.notFound") });
  const i = ["Oresund_Business_Pendler", "OresundPendler"], c = (d = a == null ? void 0 : a.contracts) == null ? void 0 : d.filter(
    (m) => !i.includes(m.contractType)
  ), l = n == null ? void 0 : n.filter(
    (m) => m.paymentAgreement.agreementType !== pe.OresundBusinessPendler
  );
  return l ? s === "business-commuter" ? (
    //This is to not show agreements to business-commuter if they enter the URL manually as they should not have access (currently backend does not stop them from activating pendler+)
    /* @__PURE__ */ e.jsx(Lt, { variant: "notice", children: t("agreement.unauthorized") })
  ) : /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsxs(
    Ut,
    {
      fallback: /* @__PURE__ */ e.jsx("div", { className: "flex content-center justify-center p-6", children: /* @__PURE__ */ e.jsx("div", { className: "w-11", children: /* @__PURE__ */ e.jsx(Tt, { "aria-label": t("action.loading") }) }) }),
      children: [
        /* @__PURE__ */ e.jsx("div", { className: "mb-12", children: /* @__PURE__ */ e.jsx(Ka, { status: o }) }),
        /* @__PURE__ */ e.jsx(
          Qh,
          {
            namespace: "account",
            i18nKey: "agreement.error.notFound",
            children: c && c.length > 1 ? /* @__PURE__ */ e.jsx("div", { className: "overflow-x-auto", children: /* @__PURE__ */ e.jsx(Kh, { contracts: l }) }) : /* @__PURE__ */ e.jsx(
              Uh,
              {
                contractNumber: (u = a == null ? void 0 : a.contracts[0]) == null ? void 0 : u.contractNo
              }
            )
          }
        )
      ]
    }
  ) }) : /* @__PURE__ */ e.jsx("div", { className: "flex justify-center p-6", children: /* @__PURE__ */ e.jsx("div", { className: "w-11", children: /* @__PURE__ */ e.jsx(Tt, { "aria-label": t("action.loading") }) }) });
}, Xh = [
  pe.OresundBusinessPendler,
  pe.OresundPendler
], Jh = [nr.ORESUNDPAY], Zh = (t, n) => t ? n ? t.filter((r) => !Xh.includes(r.agreementType)) : t : [], eg = (t, n) => t ? n ? t.filter(
  (r) => Jh.includes(r.providerId)
) : t : [], tg = (t, n) => t ? n ? t.filter((r) => r.paymentType === n) : t : [], cC = ({
  paymentAgreement: {
    agreementType: t,
    contractNo: n,
    paymentType: r,
    provider: s,
    status: a
  }
}) => ({
  agreementType: t,
  contractNo: n,
  paymentType: r,
  providerId: s.id,
  providerName: s.name,
  status: a
}), ng = (t) => (n) => ({
  label: `${t == null ? void 0 : t(`agreementProviders.${n == null ? void 0 : n.providerId}.label`)} - ${n.contractNo}`,
  value: n.contractNo
}), rg = (t, n, r, s, a) => {
  let o = Zh(n, r);
  return o = eg(o, s), o = tg(o, a), o.map(ng(t));
}, sg = ({
  className: t,
  hideCustomerNo: n
}) => {
  const { customerInformation: r } = tt();
  return r ? /* @__PURE__ */ e.jsxs("div", { className: t, children: [
    /* @__PURE__ */ e.jsxs("span", { children: [
      r == null ? void 0 : r.firstName,
      " ",
      r == null ? void 0 : r.lastName
    ] }),
    (r == null ? void 0 : r.customerType) === "business" && !n && ` ${r == null ? void 0 : r.customerNo}`
  ] }) : /* @__PURE__ */ e.jsx(e.Fragment, {});
}, bc = () => {
  const { t } = V(["common", "account"], { nsMode: "fallback" });
  return /* @__PURE__ */ e.jsx("div", { className: "bg-primary-600 mr-2 rounded-md px-2 py-1 text-white", children: t("corporateGroup.selectedCompany") });
}, ag = ({
  corporate: t,
  index: n,
  handleUpdateSessionCustomer: r,
  errorIndex: s,
  isLoading: a,
  activeCustomerNo: o
}) => {
  const { t: i } = V(["common", "account"], { nsMode: "fallback" });
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: "flex max-h-min items-center border-[0.5px] border-neutral-300 p-4 text-sm font-semibold hover:cursor-pointer hover:bg-neutral-50",
      onClick: () => r(t.customerNo, n),
      children: [
        a ? /* @__PURE__ */ e.jsx("div", { className: "flex flex-grow font-thin", children: i("action.loading") }) : /* @__PURE__ */ e.jsxs("div", { className: "flex flex-grow flex-col", children: [
          /* @__PURE__ */ e.jsx("div", { className: "flex items-center justify-between ", children: /* @__PURE__ */ e.jsxs("div", { className: "flex items-center", children: [
            o === t.customerNo && /* @__PURE__ */ e.jsx(bc, {}),
            t.name,
            ", ",
            t.customerNo
          ] }) }),
          s === n && /* @__PURE__ */ e.jsx("div", { className: "mt-2 w-full rounded bg-red-50 p-2 text-red-700", children: i("corporateGroup.missingContract") })
        ] }),
        /* @__PURE__ */ e.jsx(Aa, { className: "text-primary-700 ml-2 rotate-90" })
      ]
    },
    t.customerNo
  );
};
function og() {
  const { customerInformation: t } = tt(), n = (t == null ? void 0 : t.customerType) === "business", r = n ? t == null ? void 0 : t.customerNo : "", { data: s, isLoading: a } = De(
    xe.CorporateGroupMembers(),
    (o) => o.CorporateGroup.getMembers(),
    {
      suspense: !0,
      enabled: n
    }
  );
  return K(() => {
    if (!s) return { isLoading: a, corporateGroup: [] };
    const { corporateGroup: o, corporateHead: i } = s;
    return { corporateGroup: o.filter(({ customerNo: l }) => l !== i.customerNo).sort((l, d) => l.customerNo === r ? -1 : d.customerNo === r ? 1 : `${l.name}${l.companyNo}`.localeCompare(
      `${d.name}${d.companyNo}`
    )), corporateHead: i, isLoading: a };
  }, [s, a]);
}
function ig() {
  const { updateCustomer: t } = tt(), { mutateAsync: n } = ke(
    ["useUpdateSessionCustomer"],
    ({ Customer: s }) => s.updateSessionCustomer
  );
  return Q(
    async (s) => {
      try {
        const a = await n({ customerNo: s });
        await t(a);
      } catch (a) {
        return { error: a.message };
      }
    },
    [n, t]
  );
}
const oa = 10, lg = ["name", "customerNo"], Di = 1234566789, cg = ({ onSuccess: t }) => {
  const [n, r] = L(1), [s, a] = L(""), [o, i] = L([]), [c, l] = L(), [d, u] = L(), [m, f] = L(""), { t: p } = V(["common", "account"], { nsMode: "fallback" }), { corporateGroup: b, corporateHead: h, isLoading: g } = og(), { customerInformation: v } = tt(), y = ig(), x = qe(null), j = (v == null ? void 0 : v.customerType) === "business" ? v.customerNo : "", w = K(
    () => Uu((D) => a(D), 300),
    []
  );
  Y(() => (w(m), () => w.cancel()), [m]);
  const C = K(() => b.filter(
    (D) => (s.length < 3 || lg.some(
      (A) => {
        var S;
        return (S = D[A]) == null ? void 0 : S.toString().toLowerCase().includes(s.toLowerCase());
      }
    )) && (o.length === 0 || o.includes(D.languageCode))
  ), [b, s, o]), P = K(
    () => Math.ceil(C.length / oa),
    [C]
  ), N = K(() => {
    const D = (n - 1) * oa;
    return C.slice(D, D + oa);
  }, [C, n]), R = K(() => Array.from(
    new Set(b.map((A) => A.languageCode))
  ).map((A) => ({ value: A, label: A })), [b]);
  Y(() => r(1), [s, o]);
  const T = Q(
    async (D, A) => {
      u(A), l(void 0);
      const S = await y(D);
      S && "error" in S ? (u(void 0), l(A), setTimeout(() => l(void 0), 4e3)) : t == null || t();
    },
    [y, t]
  ), z = Q(() => {
    var D;
    (D = x.current) == null || D.resetSelection(), a("");
  }, []);
  return g ? /* @__PURE__ */ e.jsx(Wn, {}) : /* @__PURE__ */ e.jsxs("div", { className: "relative", children: [
    b.length > 0 && /* @__PURE__ */ e.jsxs("div", { className: "mx-auto max-w-2xl", children: [
      /* @__PURE__ */ e.jsx("div", { className: "flex items-center justify-between", children: /* @__PURE__ */ e.jsx("h1", { className: "text-2xl font-semibold", children: `${p("corporateGroup.header")} (${C.length})` }) }),
      /* @__PURE__ */ e.jsxs("div", { className: "my-8 flex flex-col items-end gap-5 rounded-lg bg-neutral-50 p-4 md:flex-row", children: [
        /* @__PURE__ */ e.jsx(
          wl,
          {
            label: p("corporateGroup.filter.search"),
            query: m,
            setQuery: f,
            className: "flex-grow"
          }
        ),
        /* @__PURE__ */ e.jsx(
          Ia,
          {
            className: "flex-grow",
            options: R,
            label: p("corporateGroup.filter.country"),
            onChange: i,
            ref: x
          }
        ),
        /* @__PURE__ */ e.jsx(be, { onClick: z, children: p("corporateGroup.filter.clear") })
      ] }),
      h && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx("div", { className: "font-bold", children: p("corporateGroup.mainCompany") }),
        /* @__PURE__ */ e.jsx(
          "div",
          {
            className: "mt-2 flex cursor-pointer items-center border border-neutral-300 p-4 text-sm font-semibold hover:bg-neutral-50",
            onClick: async () => {
              u(Di), await y(h.customerNo), t == null || t();
            },
            children: d === Di ? /* @__PURE__ */ e.jsx("div", { children: p("action.loading") }) : /* @__PURE__ */ e.jsxs("div", { className: "flex w-full items-center justify-between", children: [
              /* @__PURE__ */ e.jsxs("div", { className: "flex items-center", children: [
                j === h.customerNo && /* @__PURE__ */ e.jsx(bc, {}),
                " ",
                h.name,
                ", ",
                h.customerNo
              ] }),
              /* @__PURE__ */ e.jsx(Aa, { className: "text-primary-700 rotate-90" })
            ] })
          }
        )
      ] }),
      /* @__PURE__ */ e.jsxs("div", { className: "mt-8 flex flex-col gap-2", children: [
        /* @__PURE__ */ e.jsx("div", { className: "font-bold", children: p("corporateGroup.corporateGroupCompanies") }),
        N.length === 0 ? /* @__PURE__ */ e.jsx(st, { colorMode: "information", children: p("corporateGroup.emptySearch") }) : N.map((D, A) => /* @__PURE__ */ e.jsx(
          ag,
          {
            corporate: D,
            activeCustomerNo: j,
            handleUpdateSessionCustomer: T,
            index: A,
            errorIndex: c,
            isLoading: A === d
          },
          D.customerNo
        ))
      ] }),
      P > 1 && /* @__PURE__ */ e.jsx(
        Kr,
        {
          className: "mt-8",
          currentPage: n,
          totalPages: P,
          labels: {
            next: p("action.next"),
            previous: p("action.previous")
          },
          onPageChange: r
        }
      )
    ] }),
    d !== void 0 && /* @__PURE__ */ e.jsx(La, {})
  ] });
}, dC = () => {
  const { t } = V(["account"]), [n, r] = L(!1);
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs("div", { className: " flex flex-col pt-8 text-white md:mb-8 md:pt-0 md:text-neutral-950", children: [
      /* @__PURE__ */ e.jsxs(
        "div",
        {
          className: "mb-1 flex cursor-pointer items-center font-semibold ",
          onClick: () => r(!0),
          children: [
            /* @__PURE__ */ e.jsx(Jd, { className: "mr-2" }),
            t("corporateGroup.changeActiveCorporate")
          ]
        }
      ),
      /* @__PURE__ */ e.jsx(sg, { className: "flex flex-col", hideCustomerNo: !0 })
    ] }),
    /* @__PURE__ */ e.jsx(Bt, { open: n, title: "", onOpenChange: () => r(!1), children: /* @__PURE__ */ e.jsx(cg, { onSuccess: () => r(!1) }) })
  ] });
};
var ja = { exports: {} }, Er = { exports: {} }, Li;
function dg() {
  return Li || (Li = 1, function(t, n) {
    Object.defineProperty(n, "__esModule", {
      value: !0
    });
    function r(l, d) {
      for (var u in d) Object.defineProperty(l, u, {
        enumerable: !0,
        get: d[u]
      });
    }
    r(n, {
      DOMAttributeNames: function() {
        return s;
      },
      default: function() {
        return c;
      },
      isEqualNode: function() {
        return o;
      }
    });
    const s = {
      acceptCharset: "accept-charset",
      className: "class",
      htmlFor: "for",
      httpEquiv: "http-equiv",
      noModule: "noModule"
    };
    function a(l) {
      let { type: d, props: u } = l;
      const m = document.createElement(d);
      for (const b in u) {
        if (!u.hasOwnProperty(b) || b === "children" || b === "dangerouslySetInnerHTML" || u[b] === void 0) continue;
        const h = s[b] || b.toLowerCase();
        d === "script" && (h === "async" || h === "defer" || h === "noModule") ? m[h] = !!u[b] : m.setAttribute(h, u[b]);
      }
      const { children: f, dangerouslySetInnerHTML: p } = u;
      return p ? m.innerHTML = p.__html || "" : f && (m.textContent = typeof f == "string" ? f : Array.isArray(f) ? f.join("") : ""), m;
    }
    function o(l, d) {
      if (l instanceof HTMLElement && d instanceof HTMLElement) {
        const u = d.getAttribute("nonce");
        if (u && !l.getAttribute("nonce")) {
          const m = d.cloneNode(!0);
          return m.setAttribute("nonce", ""), m.nonce = u, u === l.nonce && l.isEqualNode(m);
        }
      }
      return l.isEqualNode(d);
    }
    let i;
    process.env.__NEXT_STRICT_NEXT_HEAD ? i = (l, d) => {
      const u = document.querySelector("head");
      if (!u) return;
      const m = u.querySelectorAll('meta[name="next-head"]') || [], f = [];
      if (l === "meta") {
        const h = u.querySelector("meta[charset]");
        h && f.push(h);
      }
      for (let h = 0; h < m.length; h++) {
        var p;
        const v = m[h].nextSibling;
        (v == null || (p = v.tagName) == null ? void 0 : p.toLowerCase()) === l && f.push(v);
      }
      const b = d.map(a).filter((h) => {
        for (let g = 0, v = f.length; g < v; g++) {
          const y = f[g];
          if (o(y, h))
            return f.splice(g, 1), !1;
        }
        return !0;
      });
      f.forEach((h) => {
        var g;
        const v = h.previousSibling;
        if (v && v.getAttribute("name") === "next-head") {
          var y;
          (y = h.parentNode) == null || y.removeChild(v);
        }
        (g = h.parentNode) == null || g.removeChild(h);
      }), b.forEach((h) => {
        var g;
        const v = document.createElement("meta");
        v.name = "next-head", v.content = "1", ((g = h.tagName) == null ? void 0 : g.toLowerCase()) === "meta" && h.getAttribute("charset") || u.appendChild(v), u.appendChild(h);
      });
    } : i = (l, d) => {
      const u = document.getElementsByTagName("head")[0], m = u.querySelector("meta[name=next-head-count]");
      if (process.env.NODE_ENV !== "production" && !m) {
        console.error("Warning: next-head-count is missing. https://nextjs.org/docs/messages/next-head-count-missing");
        return;
      }
      const f = Number(m.content), p = [];
      for (let g = 0, v = m.previousElementSibling; g < f; g++, v = (v == null ? void 0 : v.previousElementSibling) || null) {
        var b;
        (v == null || (b = v.tagName) == null ? void 0 : b.toLowerCase()) === l && p.push(v);
      }
      const h = d.map(a).filter((g) => {
        for (let v = 0, y = p.length; v < y; v++) {
          const x = p[v];
          if (o(x, g))
            return p.splice(v, 1), !1;
        }
        return !0;
      });
      p.forEach((g) => {
        var v;
        return (v = g.parentNode) == null ? void 0 : v.removeChild(g);
      }), h.forEach((g) => u.insertBefore(g, m)), m.content = (f - p.length + h.length).toString();
    };
    function c() {
      return {
        mountedInstances: /* @__PURE__ */ new Set(),
        updateHead: (l) => {
          const d = {};
          l.forEach((f) => {
            if (
              // If the font tag is loaded only on client navigation
              // it won't be inlined. In this case revert to the original behavior
              f.type === "link" && f.props["data-optimized-fonts"]
            ) {
              if (document.querySelector('style[data-href="' + f.props["data-href"] + '"]'))
                return;
              f.props.href = f.props["data-href"], f.props["data-href"] = void 0;
            }
            const p = d[f.type] || [];
            p.push(f), d[f.type] = p;
          });
          const u = d.title ? d.title[0] : null;
          let m = "";
          if (u) {
            const { children: f } = u.props;
            m = typeof f == "string" ? f : Array.isArray(f) ? f.join("") : "";
          }
          m !== document.title && (document.title = m), [
            "meta",
            "base",
            "link",
            "style",
            "script"
          ].forEach((f) => {
            i(f, d[f] || []);
          });
        }
      };
    }
    (typeof n.default == "function" || typeof n.default == "object" && n.default !== null) && typeof n.default.__esModule > "u" && (Object.defineProperty(n.default, "__esModule", { value: !0 }), Object.assign(n.default, n), t.exports = n.default);
  }(Er, Er.exports)), Er.exports;
}
(function(t, n) {
  "use client";
  Object.defineProperty(n, "__esModule", {
    value: !0
  });
  function r(C, P) {
    for (var N in P) Object.defineProperty(C, N, {
      enumerable: !0,
      get: P[N]
    });
  }
  r(n, {
    default: function() {
      return w;
    },
    handleClientScriptLoad: function() {
      return g;
    },
    initScriptLoader: function() {
      return x;
    }
  });
  const s = Et, a = $n, o = e, i = /* @__PURE__ */ s._(fl), c = /* @__PURE__ */ a._(ot), l = Gl(), d = dg(), u = Rl(), m = /* @__PURE__ */ new Map(), f = /* @__PURE__ */ new Set(), p = [
    "onLoad",
    "onReady",
    "dangerouslySetInnerHTML",
    "children",
    "onError",
    "strategy",
    "stylesheets"
  ], b = (C) => {
    if (i.default.preinit) {
      C.forEach((P) => {
        i.default.preinit(P, {
          as: "style"
        });
      });
      return;
    }
    if (typeof window < "u") {
      let P = document.head;
      C.forEach((N) => {
        let R = document.createElement("link");
        R.type = "text/css", R.rel = "stylesheet", R.href = N, P.appendChild(R);
      });
    }
  }, h = (C) => {
    const { src: P, id: N, onLoad: R = () => {
    }, onReady: T = null, dangerouslySetInnerHTML: z, children: D = "", strategy: A = "afterInteractive", onError: S, stylesheets: _ } = C, $ = N || P;
    if ($ && f.has($))
      return;
    if (m.has(P)) {
      f.add($), m.get(P).then(R, S);
      return;
    }
    const q = () => {
      T && T(), f.add($);
    }, U = document.createElement("script"), W = new Promise((G, ee) => {
      U.addEventListener("load", function(ue) {
        G(), R && R.call(this, ue), q();
      }), U.addEventListener("error", function(ue) {
        ee(ue);
      });
    }).catch(function(G) {
      S && S(G);
    });
    z ? (U.innerHTML = z.__html || "", q()) : D ? (U.textContent = typeof D == "string" ? D : Array.isArray(D) ? D.join("") : "", q()) : P && (U.src = P, m.set(P, W));
    for (const [G, ee] of Object.entries(C)) {
      if (ee === void 0 || p.includes(G))
        continue;
      const ue = d.DOMAttributeNames[G] || G.toLowerCase();
      U.setAttribute(ue, ee);
    }
    A === "worker" && U.setAttribute("type", "text/partytown"), U.setAttribute("data-nscript", A), _ && b(_), document.body.appendChild(U);
  };
  function g(C) {
    const { strategy: P = "afterInteractive" } = C;
    P === "lazyOnload" ? window.addEventListener("load", () => {
      (0, u.requestIdleCallback)(() => h(C));
    }) : h(C);
  }
  function v(C) {
    document.readyState === "complete" ? (0, u.requestIdleCallback)(() => h(C)) : window.addEventListener("load", () => {
      (0, u.requestIdleCallback)(() => h(C));
    });
  }
  function y() {
    [
      ...document.querySelectorAll('[data-nscript="beforeInteractive"]'),
      ...document.querySelectorAll('[data-nscript="beforePageRender"]')
    ].forEach((P) => {
      const N = P.id || P.getAttribute("src");
      f.add(N);
    });
  }
  function x(C) {
    C.forEach(g), y();
  }
  function j(C) {
    const { id: P, src: N = "", onLoad: R = () => {
    }, onReady: T = null, strategy: z = "afterInteractive", onError: D, stylesheets: A, ...S } = C, { updateScripts: _, scripts: $, getIsSsr: q, appDir: U, nonce: W } = (0, c.useContext)(l.HeadManagerContext), G = (0, c.useRef)(!1);
    (0, c.useEffect)(() => {
      const ue = P || N;
      G.current || (T && ue && f.has(ue) && T(), G.current = !0);
    }, [
      T,
      P,
      N
    ]);
    const ee = (0, c.useRef)(!1);
    if ((0, c.useEffect)(() => {
      ee.current || (z === "afterInteractive" ? h(C) : z === "lazyOnload" && v(C), ee.current = !0);
    }, [
      C,
      z
    ]), (z === "beforeInteractive" || z === "worker") && (_ ? ($[z] = ($[z] || []).concat([
      {
        id: P,
        src: N,
        onLoad: R,
        onReady: T,
        onError: D,
        ...S
      }
    ]), _($)) : q && q() ? f.add(P || N) : q && !q() && h(C)), U) {
      if (A && A.forEach((ue) => {
        i.default.preinit(ue, {
          as: "style"
        });
      }), z === "beforeInteractive")
        return N ? (i.default.preload(N, S.integrity ? {
          as: "script",
          integrity: S.integrity,
          nonce: W,
          crossOrigin: S.crossOrigin
        } : {
          as: "script",
          nonce: W,
          crossOrigin: S.crossOrigin
        }), /* @__PURE__ */ (0, o.jsx)("script", {
          nonce: W,
          dangerouslySetInnerHTML: {
            __html: "(self.__next_s=self.__next_s||[]).push(" + JSON.stringify([
              N,
              {
                ...S,
                id: P
              }
            ]) + ")"
          }
        })) : (S.dangerouslySetInnerHTML && (S.children = S.dangerouslySetInnerHTML.__html, delete S.dangerouslySetInnerHTML), /* @__PURE__ */ (0, o.jsx)("script", {
          nonce: W,
          dangerouslySetInnerHTML: {
            __html: "(self.__next_s=self.__next_s||[]).push(" + JSON.stringify([
              0,
              {
                ...S,
                id: P
              }
            ]) + ")"
          }
        }));
      z === "afterInteractive" && N && i.default.preload(N, S.integrity ? {
        as: "script",
        integrity: S.integrity,
        nonce: W,
        crossOrigin: S.crossOrigin
      } : {
        as: "script",
        nonce: W,
        crossOrigin: S.crossOrigin
      });
    }
    return null;
  }
  Object.defineProperty(j, "__nextScript", {
    value: !0
  });
  const w = j;
  (typeof n.default == "function" || typeof n.default == "object" && n.default !== null) && typeof n.default.__esModule > "u" && (Object.defineProperty(n.default, "__esModule", { value: !0 }), Object.assign(n.default, n), t.exports = n.default);
})(ja, ja.exports);
var ug = ja.exports, mg = ug;
const eo = /* @__PURE__ */ qn(mg), fg = [
  pe.OresundBusinessPendler,
  pe.OresundPendler
], is = fn(
  ({
    onAgreementChange: t,
    hideCommuter: n,
    hideProviders: r,
    initialContractNo: s,
    showPaymentType: a,
    selectFirstContract: o,
    ...i
  }, c) => {
    const { t: l } = V(["common"], { nsMode: "fallback" }), { contracts: d } = Xr(!0), u = qe(null), m = (h) => {
      var g;
      return (g = d == null ? void 0 : d.find((v) => v.contractNo === h)) == null ? void 0 : g.providerId;
    }, f = d == null ? void 0 : d.every(
      ({ agreementType: h }) => fg.includes(h)
    ), p = rg(
      l,
      d,
      f ? !1 : n,
      r,
      a
    );
    let b = s;
    return d && d.length > 0 && !b && (o ? b = d[0].contractNo : p.length === 1 && (b = p[0].value)), b && u.current !== b && (u.current = b, t(b, m(b))), p.length < 1 ? null : p.length !== 1 ? /* @__PURE__ */ e.jsx(
      mt,
      {
        ref: c,
        label: l("form.labels.contract"),
        placeholder: l("form.labels.contract"),
        options: p,
        onChange: (h) => {
          u.current !== h && (u.current = h, t(h, m(h)));
        },
        required: !0,
        initialValue: b,
        ...i
      }
    ) : /* @__PURE__ */ e.jsxs(M, { ref: c, className: "pt-3", children: [
      l("form.labels.contract"),
      ": ",
      p[0].label
    ] });
  }
);
is.displayName = "AgreementSelector";
const vc = ({ onSuccess: t, token: n }) => {
  const r = qe(), s = qe(), a = Q(() => {
    if (!window.Reepay || !n || s.current)
      return;
    clearInterval(r.current);
    const { EmbeddedCheckout: o } = window.Reepay;
    s.current = new o(n, {
      html_element: "rp-container",
      showReceipt: !1
    }), s.current.addEventHandler(Reepay.Event.Accept, (i) => {
      var c;
      t(i), (c = s.current) == null || c.destroy();
    });
  }, [n, t]);
  return Y(() => () => {
    if (s.current) {
      s.current.removeEventHandler(Reepay.Event.Accept);
      try {
        s.current.destroy();
      } catch {
      }
    }
  }, []), Y(() => (r.current = setInterval(a), () => {
    r.current && clearInterval(r.current);
  })), /* @__PURE__ */ e.jsx("div", { className: "col-span-full flex items-center justify-center md:col-span-6 md:col-start-4", children: /* @__PURE__ */ e.jsx(nt.Root, { id: "rp-container", className: "h-[600px] w-full sm:w-[500px]" }) });
}, pg = () => {
  const { t } = V("common", {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsx("div", { className: "flex items-center justify-center", children: /* @__PURE__ */ e.jsx(
    Ur,
    {
      label: t("action.loading"),
      className: "mx-auto block",
      width: "2em",
      height: "2em"
    }
  ) });
}, hg = ({ onClose: t }) => {
  const { t: n } = V(["account", "common"], {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col items-center py-6", children: [
    /* @__PURE__ */ e.jsx(Ea, { className: "mb-8 h-12 w-12 text-green-500" }),
    /* @__PURE__ */ e.jsx(M, { intent: "body", className: "mb-8", children: /* @__PURE__ */ e.jsx(he, { ns: "account", i18nKey: "debitCard.modal.success.description" }) }),
    /* @__PURE__ */ e.jsx(be, { intent: "solid", onClick: t, children: n("action.complete") })
  ] });
}, gg = ({
  token: t,
  onSuccess: n,
  errorMessage: r
}) => t ? /* @__PURE__ */ e.jsx(vc, { token: t, onSuccess: n }) : /* @__PURE__ */ e.jsx(M, { children: r }), xg = ({
  onClose: t,
  currency: n
}) => {
  const r = Ye(), s = qe(""), { t: a } = V(["account", "common"], {
    nsMode: "fallback"
  }), o = Ba(), [i, c] = L(!1), { mutateAsync: l, isLoading: d, isIdle: u } = ke(
    ["reepay", "update", "token"],
    ({ Reepay: b }) => b.createUpdateToken,
    {
      onSuccess: (b) => s.current = b.token
    }
  ), { mutateAsync: m } = ke(
    ["reepay", "update", "card"],
    ({ Reepay: b }) => b.updateCard,
    {
      onSuccess: () => {
        r.invalidateQueries(xe.Agreements()), c(!0);
      }
    }
  );
  Y(() => {
    o && !s.current && l({
      contractNo: o,
      currency: n || "DKK"
    });
  }, [o, n, l]);
  const f = Q(
    (b) => {
      if (!(!o || !s.current))
        return m({
          contractNo: o,
          card: { data: { ...b, invoice: "" }, session: s.current },
          method: "card",
          currency: n || "DKK"
        });
    },
    [o, n, m]
  ), p = Q(
    (b) => {
      b || t(i);
    },
    [i, t]
  );
  return /* @__PURE__ */ e.jsx(Bt, { open: !0, title: a("debitCard.modal.title"), onOpenChange: p, children: /* @__PURE__ */ e.jsx("div", { children: i ? /* @__PURE__ */ e.jsx(hg, { onClose: () => p(!1) }) : u || d ? /* @__PURE__ */ e.jsx(pg, {}) : /* @__PURE__ */ e.jsx(
    gg,
    {
      token: s.current,
      onSuccess: f,
      errorMessage: a("errors.reepay")
    }
  ) }) });
}, uC = () => {
  var y;
  const {
    query: { contract: t, updateCreditCard: n }
  } = ve(), [r, s] = L(n !== void 0), { customerInformation: a } = tt(), o = t || ((a == null ? void 0 : a.contracts.length) === 1 ? a.contracts[0].contractNo : void 0), { t: i } = V(["account", "common"], {
    nsMode: "fallback"
  }), { data: c, refetch: l } = bt(!0, o, !0), d = K(
    () => ({
      inactive: i("debitCard.labels.inactive"),
      active: i("debitCard.labels.active"),
      type: i("debitCard.labels.debitCard")
    }),
    [i]
  ), { query: u, push: m } = ve(), f = (x) => {
    m({ query: { ...u, contract: x } });
  }, [p, b] = L(
    (y = c == null ? void 0 : c.paymentAgreement.price) == null ? void 0 : y.currency
  ), h = Q(
    (x) => {
      x && l(), s(!1);
    },
    [l]
  ), g = c && !jn(c.paymentAgreement.provider) && c.paymentAgreement.paymentType === "card", v = a && a.contracts.length > 1;
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    v && /* @__PURE__ */ e.jsx("div", { className: "mb-4", children: /* @__PURE__ */ e.jsx(
      Ut,
      {
        fallback: /* @__PURE__ */ e.jsx("div", { className: "w-9", children: /* @__PURE__ */ e.jsx(Wn, { "aria-label": i("action.loading") }) }),
        children: /* @__PURE__ */ e.jsx(
          is,
          {
            hideCommuter: !0,
            onAgreementChange: f,
            initialContractNo: u.contract
          }
        )
      }
    ) }),
    o ? g ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(
        de,
        {
          variant: "h3",
          sx: {
            fontWeight: "fontWeights.medium",
            fontSize: "fontSizes.300"
          },
          children: i("debitCard.label", {
            amount: 1,
            maxAmount: 1
          })
        }
      ),
      /* @__PURE__ */ e.jsx(
        Vu,
        {
          labels: d,
          variant: "primary",
          cardTitle: /* @__PURE__ */ e.jsx(
            de,
            {
              variant: "h4",
              pt: "spacing.0",
              pb: "spacing.0",
              sx: { color: "inherit", fontWeight: "fontWeights.regular" },
              children: c == null ? void 0 : c.paymentAgreement.cardType
            }
          ),
          icon: Zd,
          active: !0,
          children: /* @__PURE__ */ e.jsxs("div", { className: "bg-neutral-100 px-8 pb-8 pt-6 md:px-10", children: [
            /* @__PURE__ */ e.jsxs(nn, { template: "two-column", children: [
              /* @__PURE__ */ e.jsx(Rn, { column: "1", children: /* @__PURE__ */ e.jsx(xn, { label: i("form.labels.cardNo"), children: c == null ? void 0 : c.paymentAgreement.cardNumber }) }),
              /* @__PURE__ */ e.jsx(Rn, { column: { xs: "1", md: "3" }, children: /* @__PURE__ */ e.jsx(xn, { label: i("form.labels.expiryDate"), children: c == null ? void 0 : c.paymentAgreement.validDate }) }),
              /* @__PURE__ */ e.jsx(Rn, { column: "1", children: /* @__PURE__ */ e.jsx(xn, { label: i("form.labels.connectedAgreement"), children: i(
                `agreementProviders.${c == null ? void 0 : c.paymentAgreement.provider.id}.label`
              ) }) }),
              /* @__PURE__ */ e.jsx(Rn, { column: { xs: "1", md: "3" }, children: /* @__PURE__ */ e.jsx(
                mt,
                {
                  onChange: b,
                  className: "mt-5",
                  label: i("form.labels.currency"),
                  placeholder: i("form.placeholders.currency"),
                  options: [
                    { label: "SEK", value: "SEK" },
                    { label: "DKK", value: "DKK" }
                  ]
                }
              ) })
            ] }),
            /* @__PURE__ */ e.jsx("div", { className: "mb-2 mt-4 flex justify-end", children: /* @__PURE__ */ e.jsx(
              Mt,
              {
                variant: "text",
                sx: { color: "colors.primary.400" },
                style: { paddingRight: 0 },
                onClick: () => s(!0),
                children: i("debitCard.action.update")
              }
            ) })
          ] })
        }
      )
    ] }) : /* @__PURE__ */ e.jsx(st, { colorMode: "warning", children: i("debitCard.unauthorized") }) : /* @__PURE__ */ e.jsx(st, { className: "my-4", colorMode: "warning", children: i("debitCard.pickContract") }),
    r ? /* @__PURE__ */ e.jsx(
      xg,
      {
        currency: p,
        onClose: h
      }
    ) : null,
    /* @__PURE__ */ e.jsx(
      eo,
      {
        strategy: "lazyOnload",
        src: "https://checkout.reepay.com/checkout.js"
      }
    )
  ] });
}, yc = (t, n) => {
  const { locale: r } = ve(), { data: s } = De(
    xe.ContractTypeList({ type: t, locale: r }),
    (o) => o.Contract.contractTypeList({ type: t, locale: r || "" })
  );
  return K(
    () => (s == null ? void 0 : s.filter((o) => o.value === n).map(({ currency: o, price: i, priceInclVat: c }) => ({
      currency: o,
      price: i,
      priceInclVat: c
    }))) ?? [],
    [n, s]
  );
}, bg = Gu.object({
  agreement: gu
}), vg = xu.and(
  bg
), jc = { startDate: /* @__PURE__ */ new Date() }, Ht = Vn(() => ({
  action: () => Promise.resolve(),
  disableNext: !1,
  body: jc
})), yg = (t) => Ht.setState(() => ({ contractNo: t })), ls = (t) => {
  const { action: n } = Ht.getState();
  n !== t && Ht.setState(() => ({ action: t }));
}, ar = (t) => Ht.setState(() => ({ disableNext: t })), to = (t) => Ht.setState((n) => ({
  body: { ...n.body, ...t }
})), jg = () => Ht.setState(() => ({ body: jc })), Cg = async () => {
  const { action: t } = Ht.getState();
  t && await t();
}, Cc = kt({
  currentStep: 0,
  isOnLastStep: !0,
  nextStep: () => {
  },
  close: () => {
  },
  steps: 0,
  setSteps: () => {
  },
  prevStep: () => {
  }
});
function Un() {
  return pt(Cc);
}
const wg = ({ onClose: t, children: n }) => {
  const [r, s] = L(() => 0), [a, o] = L(() => 0), i = Q(() => {
    t && t(), s(0);
  }, [t, s]), c = K(
    () => r === a - 1,
    [r, a]
  ), l = Q(() => c ? i() : s((u) => u + 1), [c, s, i]), d = Q(() => s((u) => u - 1), [s]);
  return /* @__PURE__ */ e.jsx(
    Cc.Provider,
    {
      value: {
        currentStep: r,
        isOnLastStep: c,
        steps: a,
        setSteps: o,
        close: i,
        nextStep: l,
        prevStep: d
      },
      children: n
    }
  );
}, Ng = () => {
  const { locale: t } = ve(), { t: n } = V(["account", "common"], { nsMode: "fallback" }), r = yc(
    "business",
    pe.OresundBusinessPendler
  ), { nextStep: s } = Un();
  Y(() => {
    s && ls(async () => s());
  }, [s]);
  const a = K(
    () => tn(t || ""),
    [t]
  ), o = r.find((c) => c.currency === a), i = o ? ss(o.price || 0, t, a) : "";
  return /* @__PURE__ */ e.jsxs(ht, { children: [
    /* @__PURE__ */ e.jsx(M, { className: "col-span-full", as: "h3", intent: "title", children: /* @__PURE__ */ e.jsx(
      he,
      {
        ns: "account",
        i18nKey: "businessCommuters.modals.add.disclaimer.title",
        children: /* @__PURE__ */ e.jsx(at, { contract: "oresundBusinessCommuter" })
      }
    ) }),
    /* @__PURE__ */ e.jsx(
      he,
      {
        ns: "account",
        i18nKey: "businessCommuters.modals.add.disclaimer.description",
        children: /* @__PURE__ */ e.jsx(M, { className: "col-span-full", gutter: !0, children: /* @__PURE__ */ e.jsx(at, { contract: "oresundBusinessCommuter" }) })
      }
    ),
    /* @__PURE__ */ e.jsx("div", { className: "col-span-full mb-4 sm:w-2/3", children: /* @__PURE__ */ e.jsx(
      is,
      {
        hideCommuter: !0,
        showPaymentType: "invoice",
        onAgreementChange: yg,
        selectFirstContract: !0
      }
    ) }),
    /* @__PURE__ */ e.jsxs(M, { className: "col-span-full mb-4", children: [
      /* @__PURE__ */ e.jsx(M, { as: "span", className: "block", intent: "label", children: n("form.labels.priceExclVAT") }),
      /* @__PURE__ */ e.jsx(
        M,
        {
          as: "span",
          intent: "title",
          className: "text-primary-400 block pt-2",
          children: i
        }
      )
    ] })
  ] });
};
var Pg = function(t, n) {
  for (var r = {}; t.length; ) {
    var s = t[0], a = s.code, o = s.message, i = s.path.join(".");
    if (!r[i]) if ("unionErrors" in s) {
      var c = s.unionErrors[0].errors[0];
      r[i] = { message: c.message, type: c.code };
    } else r[i] = { message: o, type: a };
    if ("unionErrors" in s && s.unionErrors.forEach(function(u) {
      return u.errors.forEach(function(m) {
        return t.push(m);
      });
    }), n) {
      var l = r[i].types, d = l && l[s.code];
      r[i] = Ku(i, n, r, a, d ? [].concat(d, s.message) : s.message);
    }
    t.shift();
  }
  return r;
}, Gn = function(t, n, r) {
  return r === void 0 && (r = {}), function(s, a, o) {
    try {
      return Promise.resolve(function(i, c) {
        try {
          var l = Promise.resolve(t[r.mode === "sync" ? "parse" : "parseAsync"](s, n)).then(function(d) {
            return o.shouldUseNativeValidation && Yu({}, o), { errors: {}, values: r.raw ? s : d };
          });
        } catch (d) {
          return c(d);
        }
        return l && l.then ? l.then(void 0, c) : l;
      }(0, function(i) {
        if (function(c) {
          return c.errors != null;
        }(i)) return { values: {}, errors: Qu(Pg(i.errors, !o.shouldUseNativeValidation && o.criteriaMode === "all"), o) };
        throw i;
      }));
    } catch (i) {
      return Promise.reject(i);
    }
  };
};
const Sg = () => {
  var u, m, f;
  const t = Ht((p) => p.body), { t: n } = V(["account", "common"], { nsMode: "fallback" }), { nextStep: r } = Un(), {
    register: s,
    handleSubmit: a,
    formState: { errors: o, isValid: i },
    reset: c
  } = Nn({
    resolver: Gn(bu),
    mode: "onChange",
    defaultValues: { ...t }
  }), l = Q(
    (p) => {
      to(p), r();
    },
    [r]
  );
  Y(() => {
    ar(!i);
  }, [i]);
  const d = Q(async () => {
    await a(l)();
  }, [a, l]);
  return Y(() => {
    ls(d);
  }, [d]), Y(() => () => {
    c();
  }, [c]), /* @__PURE__ */ e.jsxs(
    Vt,
    {
      title: n("businessCommuters.modals.add.contactInformation.title"),
      id: "commuter-contact-information",
      full: !1,
      titleIntent: "title",
      titleSize: "md",
      className: "pb-0",
      editButton: !1,
      children: [
        /* @__PURE__ */ e.jsx(M, { className: "col-span-full", weight: "light", children: n("businessCommuters.modals.add.contactInformation.description") }),
        /* @__PURE__ */ e.jsx(
          rt,
          {
            className: "col-span-full sm:col-span-4 md:col-span-6",
            ...s("firstName"),
            label: n("form.labels.firstName"),
            error: n(((u = o.firstName) == null ? void 0 : u.message) || ""),
            required: !0
          }
        ),
        /* @__PURE__ */ e.jsx(
          rt,
          {
            className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7",
            ...s("lastName"),
            label: n("form.labels.lastName"),
            error: n(((m = o.lastName) == null ? void 0 : m.message) || ""),
            required: !0
          }
        ),
        /* @__PURE__ */ e.jsx(
          rt,
          {
            className: "col-span-full",
            ...s("email"),
            label: n("form.labels.email"),
            error: n(((f = o.email) == null ? void 0 : f.message) || ""),
            required: !0
          }
        )
      ]
    }
  );
}, Tg = [
  "black",
  "blue",
  "brown",
  "green",
  "grey",
  "orange",
  "purple",
  "red",
  "white",
  "yellow",
  "other"
];
function Eg(t) {
  const { country: n, licensePlate: r } = t || {};
  return De(
    xe.VehicleInfo(t),
    ({ VehicleInfo: s }) => s.getBilvVehicleInfo(n, r),
    {
      enabled: !!t && !!n && !!r,
      retry: 0
    }
  );
}
const Ii = (t) => !t || t.trim() === "", no = (t) => t.reduce((n, { value: r }) => (n[r] = r, n), {}), wc = (t, n, r, s) => {
  if (!t) {
    r();
    return;
  }
  const a = s.reduce((o, { value: i }) => (o[i] = i, o), {});
  n({
    ...t,
    weightClass: t.isHGV ? "true" : "false",
    hybrid: t.isHybrid.toString(),
    fuelType: t.fuelTypeId.toString(),
    emissionClass: t.euroEmissionNorm ? a[t.euroEmissionNorm] : void 0
  });
}, kr = "CREDIT_EVAL_YELLOW", Nc = "CREDIT_EVAL_RED", ro = (t) => (!!t && typeof t.error == "string" || Array.isArray(t.validationError)) && typeof t.code == "number", kg = (t) => t === Nc || t === kr, Ag = (t) => (n) => n ? t ? { ...n, ...t } : n : t, Og = (t) => async (n) => {
  let r = n;
  for (const s of t) {
    const a = await s(r), o = a ? _g(a) : void 0;
    o && (r = Ag(r)(o));
  }
  return r;
}, cs = (...t) => async (n) => {
  try {
    return await Og(t)(n) ?? n;
  } catch {
    return n;
  }
}, St = (t) => (n) => {
  if (!n || !(t in n))
    return !0;
  const r = n[t];
  return r != null;
}, _g = (t) => {
  if (!t)
    return;
  const n = Object.entries(t).filter(([r, s]) => s !== void 0).reduce((r, [s, a]) => ({ ...r, [s]: a }), {});
  return Object.keys(n).length > 0 ? n : void 0;
};
function pr(t) {
  return t.toUpperCase().slice(0, 10).replace(/[^0-9a-zäöæøåü]/gi, "").replace(/[\s-]+/g, "");
}
function hr(t, n) {
  if (t.length === 0 || n.length === 0)
    return !1;
  switch (n.toUpperCase()) {
    case "DA":
    case "DK":
    case "NO":
      return /^[A-ZÆØÅ]{2}[0-9]{4,5}$/i.test(t);
    case "SV":
    case "SE":
      return /^[A-ZÄÜÖ]{3}[0-9]{2}[A-ZÄÜÖ0-9]{1}$/i.test(t);
    default:
      return !1;
  }
}
const Rg = () => {
  const { locale: t } = ve(), { t: n } = V(["account", "common"], { nsMode: "fallback" }), [r, s] = L(), a = $t(), { nextStep: o } = Un(), i = Pn(), c = At(), [l, d] = L(), [u, m] = L(), f = Q(
    async (re, se) => {
      if (se && St("licensePlate")(se))
        return { licensePlate: se.licensePlate };
      const H = await i({
        licensePlate: n("form.validations.licensePlate.exist")
      })({ licensePlate: re.licensePlate, country: re.country });
      return H ? {
        ...se,
        ...H
      } : se;
    },
    [n, i]
  ), p = Q(
    async (re) => {
      const se = await rn(vu.spa, n)(re);
      return se ? await f(re, se) : void 0;
    },
    [f, n]
  ), b = Q(() => {
    o();
  }, [o]), {
    registerField: h,
    getError: g,
    handleSubmit: v,
    resetFieldErrors: y,
    validate: x,
    isValid: j,
    getData: w,
    setFieldErrors: C,
    resetSelectedData: P,
    setPartialData: N
  } = Se({
    onValidate: p,
    onSubmit: b,
    namespace: "alpr",
    defaultValues: {
      country: dn(t || ""),
      paymentOptions: "licensePlate"
    }
  }), [R, T, z, D] = He(
    "alpr",
    "country",
    "licensePlate",
    "fuelType",
    "emissionClass"
  ), {
    data: A,
    error: S,
    isFetching: _
  } = Eg(l);
  Y(() => s(S), [S]), Y(() => s(null), [T]), Y(() => m(A), [A]), Y(() => m(void 0), [T, R]), Y(() => d(void 0), [R]), Y(() => {
    z === "5" && D && N({
      emissionClass: void 0
    });
  }, [z, N, D]), Y(() => (ar(!j), () => ar(!1)), [j]);
  const $ = w(), q = Q(v, []), U = Q(x, [$.licensePlate]);
  Y(() => {
    ls(Kt(U, q));
  }, [q, U]), Y(() => () => {
    y();
  }, []);
  const W = Q(() => {
    P([
      "make",
      "model",
      "color",
      "weightClass",
      "hybrid",
      "fuelType",
      "emissionClass"
    ]);
  }, [P]);
  Y(() => {
    if (u || W(), !R && !T)
      return;
    const se = no(
      c.emissionClasses
    )[u == null ? void 0 : u.euroEmissionNorm] ?? void 0, H = {
      ...u,
      paymentOptions: "licensePlate",
      country: R || "",
      licensePlate: T || "",
      weightClass: (!!(u != null && u.isHGV)).toString(),
      hybrid: (!!(u != null && u.isHybrid)).toString(),
      fuelType: u == null ? void 0 : u.fuelTypeId.toString(),
      emissionClass: se
    };
    (u || R && T) && to({ alpr: { ...H } }), N(H);
  }, [
    u,
    N,
    W,
    R,
    T,
    c
  ]);
  const G = Q(() => {
    d({
      licensePlate: T,
      country: R
    });
  }, [R, T]), ee = Tg.map((re) => ({
    label: n(`vehicleColors.${re}`),
    value: re
  })), ue = (re) => !!re.trim(), ce = Q(async () => {
    const re = w();
    if (!ue(re.country)) return;
    const se = f ? await f(re) : void 0;
    if (!se) {
      G();
      return;
    }
    C(se), W(), d(void 0);
  }, [
    w,
    f,
    C,
    W,
    G
  ]);
  return Y(() => {
    hr(
      pr(T),
      R
    ) && ce();
  }, [T, R, ce]), /* @__PURE__ */ e.jsxs(
    Vt,
    {
      title: n("businessCommuters.modals.add.alpr.title"),
      id: "commuter-contact-information",
      full: !1,
      titleIntent: "title",
      titleSize: "md",
      className: "pb-0",
      editButton: !1,
      children: [
        /* @__PURE__ */ e.jsx(M, { className: "col-span-full", weight: "light", children: n("businessCommuters.modals.add.alpr.description") }),
        /* @__PURE__ */ e.jsx(
          Oe,
          {
            className: "col-span-full sm:col-span-4 md:col-span-6",
            ...h("country"),
            label: n("form.labels.country"),
            options: a.map((re) => ({ ...re, label: re.key })),
            placeholder: n("form.placeholders.country"),
            error: g("country"),
            required: !0
          }
        ),
        /* @__PURE__ */ e.jsx(
          me,
          {
            className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7",
            ...h("licensePlate"),
            label: n("form.labels.licensePlate"),
            error: g("licensePlate"),
            required: !0
          }
        ),
        r ? /* @__PURE__ */ e.jsx(Le, { className: "col-span-full sm:col-span-12 md:col-span-12", children: n("form.validations.licensePlate.notfound") }) : null,
        /* @__PURE__ */ e.jsx(
          M,
          {
            as: "h6",
            size: "lg",
            className: "col-span-full sm:col-span-12 md:col-span-12",
            children: n("form.labels.vlinfo")
          }
        ),
        /* @__PURE__ */ e.jsx(
          me,
          {
            className: "col-span-full sm:col-span-4 md:col-span-6",
            ...h("make"),
            label: n("form.labels.make"),
            error: g("make"),
            disabled: !!(u != null && u.make)
          }
        ),
        /* @__PURE__ */ e.jsx(
          me,
          {
            className: "col-span-full sm:col-span-4 md:col-span-6",
            ...h("model"),
            label: n("form.labels.model"),
            error: g("model"),
            disabled: !!(u != null && u.model)
          }
        ),
        /* @__PURE__ */ e.jsx(
          Oe,
          {
            className: "col-span-full sm:col-span-4 md:col-span-6",
            ...h("color"),
            placeholder: n("form.placeholders.color"),
            label: n("form.labels.color"),
            options: ee,
            placeholderDisabled: !1,
            error: g("color"),
            disabled: !!(u != null && u.color)
          }
        ),
        /* @__PURE__ */ e.jsx(
          Oe,
          {
            className: "col-span-full sm:col-span-4 md:col-span-6",
            ...h("weightClass"),
            label: n("form.labels.weightClass"),
            options: [
              { label: n("weightClasses.heavy"), value: "true" },
              { label: n("weightClasses.light"), value: "false" }
            ],
            placeholder: n("form.placeholders.weightClass"),
            error: g("weightClass"),
            required: !0,
            disabled: (u == null ? void 0 : u.isHGV) !== void 0
          }
        ),
        /* @__PURE__ */ e.jsx(
          Oe,
          {
            className: "col-span-full sm:col-start-5 md:col-span-6",
            ...h("fuelType"),
            label: n("form.labels.fuelType"),
            options: c.fuelTypes,
            placeholder: n("form.placeholders.fuelType"),
            error: g("fuelType"),
            disabled: !!(u != null && u.fuelType)
          }
        ),
        /* @__PURE__ */ e.jsx(
          Oe,
          {
            className: "col-span-full sm:col-span-4 md:col-span-6 md:col-start-7",
            ...h("emissionClass"),
            label: n("form.labels.emissionClass"),
            options: c.emissionClasses,
            placeholder: n("form.placeholders.emissionClass"),
            error: g("emissionClass"),
            disabled: z === "5" || !!(u != null && u.euroEmissionNorm)
          }
        ),
        /* @__PURE__ */ e.jsx(
          me,
          {
            ...h("hybrid", {
              type: "checkbox",
              value: "true"
            }),
            label: n("form.labels.hybrid"),
            className: "col-span-full sm:col-start-5 md:col-span-6",
            error: g("hybrid"),
            disabled: (u == null ? void 0 : u.isHybrid) !== void 0
          }
        )
      ]
    }
  );
}, Mg = () => {
  const { t } = V(["account", "common"], { nsMode: "fallback" }), n = Q((c) => {
    to(c);
  }, []), {
    registerField: r,
    handleSubmit: s,
    validate: a
  } = Se({
    onSubmit: n,
    namespace: "termsOfAgreement"
  }), [o] = He(
    "termsOfAgreement",
    "agreement"
  ), i = K(() => o === "true", [o]);
  return Y(() => (ar(!i), () => ar(!1)), [i]), Y(() => {
    ls(Kt(a, s));
  }, [s, a]), /* @__PURE__ */ e.jsxs(
    Vt,
    {
      title: t("businessCommuters.modals.add.termsOfAgreement.title"),
      id: "commuter-contact-information",
      full: !1,
      titleIntent: "title",
      titleSize: "md",
      className: "pb-0",
      editButton: !1,
      children: [
        /* @__PURE__ */ e.jsx(M, { className: "col-span-full", weight: "light", children: /* @__PURE__ */ e.jsxs(
          he,
          {
            ns: "account",
            i18nKey: "businessCommuters.modals.add.termsOfAgreement.description",
            children: [
              /* @__PURE__ */ e.jsx(at, { contract: "oresundBusinessCommuter" }),
              /* @__PURE__ */ e.jsx(at, { contract: "oresundPayBusiness" })
            ]
          }
        ) }),
        /* @__PURE__ */ e.jsx(
          me,
          {
            ...r("agreement", { type: "checkbox", value: "true" }),
            className: "col-span-full",
            label: t("form.labels.termsOfAgreement"),
            required: !0
          }
        ),
        /* @__PURE__ */ e.jsx(M, { size: "sm", className: "col-span-full", children: /* @__PURE__ */ e.jsx(os, { type: pe.OresundBusiness }) })
      ]
    }
  );
}, zg = (t) => Id.toArray(t).filter(Boolean), Dg = ({
  hideProgress: t,
  children: n
}) => {
  const { currentStep: r, setSteps: s } = Un(), a = K(() => zg(n), [n]);
  Y(() => {
    s(a.length);
  }, [a, s]);
  const o = K(
    () => a[r] ?? a[0],
    [a, r]
  ), i = K(
    () => a.map((c, l) => /* @__PURE__ */ e.jsx(
      Rr.Item,
      {
        nr: l + 1,
        active: r >= l,
        completed: r > l
      },
      l
    )),
    [a, r]
  );
  return /* @__PURE__ */ e.jsx(zt, { children: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    t ? null : /* @__PURE__ */ e.jsx(Rr.Root, { direction: "horizontal", className: "mb-8", children: i }),
    o
  ] }) });
}, Lg = ({
  hideProgress: t,
  children: n,
  ...r
}) => {
  const { close: s } = Un();
  return /* @__PURE__ */ e.jsx(
    Bt,
    {
      ...r,
      onOpenChange: (a) => {
        a || s();
      },
      children: /* @__PURE__ */ e.jsx(Dg, { hideProgress: t, children: n })
    }
  );
}, Ig = ({ onClose: t, ...n }) => /* @__PURE__ */ e.jsx(wg, { onClose: t, children: /* @__PURE__ */ e.jsx(Lg, { ...n }) }), $g = () => {
  const [t, n] = L(!1), { t: r } = V(["account", "common"], { nsMode: "fallback" }), { prevStep: s, currentStep: a, isOnLastStep: o } = Un(), { disableNext: i } = Ht(), c = async () => {
    n(!0), await Cg(), n(!1);
  };
  return /* @__PURE__ */ e.jsxs(ne, { className: "flex justify-end gap-4", children: [
    a > 0 && /* @__PURE__ */ e.jsx(be, { as: "button", onClick: s, intent: "text", children: r("action.back") }),
    /* @__PURE__ */ e.jsx(
      et,
      {
        loadingLabel: r("action.loading"),
        onClick: c,
        isLoading: t,
        disabled: i,
        children: r(o ? "action.add" : "action.continue")
      }
    )
  ] });
}, Pc = ({ state: t, close: n }) => {
  const { t: r } = V(["account", "common"], { nsMode: "fallback" });
  return t === "loading" ? /* @__PURE__ */ e.jsx(ne, {}) : t === "success" ? /* @__PURE__ */ e.jsx(ne, { className: "flex justify-end gap-4", children: /* @__PURE__ */ e.jsx(be, { as: "button", onClick: n, children: r("action.complete") }) }) : t === "error" ? /* @__PURE__ */ e.jsx(ne, { className: "flex justify-end gap-4", children: /* @__PURE__ */ e.jsx(be, { as: "button", onClick: n, children: r("action.close") }) }) : /* @__PURE__ */ e.jsx($g, {});
};
Pc.displayName = "ModalFooter";
const Fg = async (t) => (await vg.spa(t)).success, Bg = ({
  className: t
}) => {
  const [n, r] = L(), { t: s } = V(["account", "common"], { nsMode: "fallback" }), { body: a, contractNo: o } = Ht(), i = Ye(), { mutateAsync: c } = ke(
    ["add", "business", "commuter"],
    (f) => f.Contract.addBusinessCommuter,
    {
      onError: () => {
        r("error");
      },
      onSuccess: () => {
        r("success"), i.invalidateQueries(xe.BusinessCommutersList);
      }
    }
  );
  Y(() => {
    if (!a || !o || n === "loading" || n === "success")
      return;
    let f = !1;
    return (async () => {
      if (await Fg(
        a
      ) && !f) {
        r("loading");
        try {
          await c({
            ...a,
            contractNo: o
          }), f || r("success");
        } catch {
          f || r("error");
        }
      }
    })(), () => {
      f = !0;
    };
  }, [a, o, c, n]);
  const l = K(() => n === "loading" ? /* @__PURE__ */ e.jsxs(ne, { className: "flex h-64 flex-col items-center justify-center", children: [
    /* @__PURE__ */ e.jsx(
      Ur,
      {
        label: s("action.loading"),
        className: "text-primary-400 text-4xl"
      }
    ),
    /* @__PURE__ */ e.jsx(M, { className: "mt-8", children: /* @__PURE__ */ e.jsx(
      he,
      {
        ns: "account",
        i18nKey: "businessCommuters.modals.add.loading.description",
        children: /* @__PURE__ */ e.jsx(at, { contract: "oresundBusinessCommuter" })
      }
    ) })
  ] }) : n === "success" ? /* @__PURE__ */ e.jsxs(ne, { className: "flex h-64 flex-col items-center justify-center", children: [
    /* @__PURE__ */ e.jsx(eu, { className: "text-[3.25rem]", "aria-hidden": "true" }),
    /* @__PURE__ */ e.jsx(M, { intent: "title", className: "mt-8", gutter: !0, children: /* @__PURE__ */ e.jsx(
      he,
      {
        ns: "account",
        i18nKey: "businessCommuters.modals.add.success.title",
        children: /* @__PURE__ */ e.jsx(at, { contract: "oresundBusinessCommuter" })
      }
    ) }),
    /* @__PURE__ */ e.jsx(M, { children: s("businessCommuters.modals.add.success.description") })
  ] }) : n === "error" ? /* @__PURE__ */ e.jsxs(ne, { className: "flex h-64 flex-col items-center justify-center", children: [
    /* @__PURE__ */ e.jsx(nl, { className: "text-[3.25rem]", "aria-hidden": "true" }),
    /* @__PURE__ */ e.jsx(M, { intent: "title", className: "mt-8", gutter: !0, children: s("businessCommuters.modals.add.error.title") }),
    /* @__PURE__ */ e.jsx(M, { children: /* @__PURE__ */ e.jsx(
      he,
      {
        ns: "account",
        i18nKey: "businessCommuters.modals.add.error.description",
        children: /* @__PURE__ */ e.jsx(at, { contract: "oresundBusinessCommuter" })
      }
    ) })
  ] }) : [
    /* @__PURE__ */ e.jsx(Ng, {}, 0),
    /* @__PURE__ */ e.jsx(Sg, {}, 1),
    /* @__PURE__ */ e.jsx(Rg, {}, 2),
    /* @__PURE__ */ e.jsx(Mg, {}, 3)
  ], [n, s]), d = K(() => {
    const f = (p) => /* @__PURE__ */ e.jsx(Pc, { state: n, close: p });
    return f.displayName = "MultiStepModalFooter", f;
  }, [n]), u = K(
    () => n === void 0 ? {
      title: s("businessCommuters.modals.add.preventClose.title"),
      content: s("businessCommuters.modals.add.preventClose.description"),
      cancelText: s("businessCommuters.modals.add.preventClose.cancel"),
      confirmText: s("businessCommuters.modals.add.preventClose.confirm")
    } : void 0,
    [n, s]
  ), m = Q(() => {
    r(void 0), jg();
  }, []);
  return /* @__PURE__ */ e.jsx(
    Ig,
    {
      contentWrapper: "form",
      title: /* @__PURE__ */ e.jsx(he, { ns: "account", i18nKey: "businessCommuters.modals.add.title", children: /* @__PURE__ */ e.jsx(at, { contract: "oresundBusinessCommuter" }) }),
      trigger: /* @__PURE__ */ e.jsx(be, { startIcon: /* @__PURE__ */ e.jsx(cn, {}), iconSize: "lg", className: t, children: s("businessCommuters.action.addCommuter") }),
      footer: d,
      hideProgress: n !== void 0 ? !0 : void 0,
      onClose: m,
      preventClose: u,
      children: l
    }
  );
}, Vg = (t, n) => [t, n].join(" "), qg = (t) => `/account/vehicles?contract=${t}`, Wg = () => {
  const { data: t } = De(
    xe.BusinessCommutersList,
    ({ Contract: r }) => r.businessCommuters,
    { suspense: !0 }
  );
  if (!t)
    return null;
  const n = t.filter(
    (r) => r.paymentAgreement.agreementType === "Oresund_Business_Pendler"
  );
  return n.length < 1 ? /* @__PURE__ */ e.jsx(e.Fragment, {}) : /* @__PURE__ */ e.jsx(ne, { as: "ul", className: "flex flex-col gap-4", children: n.map(({ paymentAgreement: r }) => /* @__PURE__ */ e.jsxs(
    ne,
    {
      as: "li",
      className: "hover:text-primary-400 hover:ring-primary-400 relative flex cursor-pointer items-center justify-between rounded px-4 py-4 shadow-md hover:ring-2",
      children: [
        /* @__PURE__ */ e.jsxs(ne, { as: "span", className: "mr-4 flex items-center gap-2", children: [
          /* @__PURE__ */ e.jsx(tu, { fontSize: "15px" }),
          /* @__PURE__ */ e.jsx(M, { intent: "label", size: "lg", as: "p", children: /* @__PURE__ */ e.jsx(
            jt,
            {
              href: qg(r.contractNo),
              className: "hover:text-primary-400 text-neutral-800",
              full: !0,
              children: Vg(
                r.firstName,
                r.lastName
              )
            }
          ) })
        ] }),
        /* @__PURE__ */ e.jsx(Aa, { fontSize: "12px", className: "rotate-90" })
      ]
    },
    r.contractNo
  )) });
}, mC = () => {
  const { t } = V(["account"]);
  yc("business", pe.OresundBusinessPendler);
  const { contracts: n } = Xr(), r = n == null ? void 0 : n.some(
    (s) => s.paymentType === "invoice"
  );
  return /* @__PURE__ */ e.jsxs(ne, { children: [
    /* @__PURE__ */ e.jsx(ne, { className: "mb-12 mt-4 sm:mb-16 sm:mt-2", children: r ? /* @__PURE__ */ e.jsx(Bg, {}) : /* @__PURE__ */ e.jsx(M, { children: t("businessCommuters.creditCardCustomer") }) }),
    /* @__PURE__ */ e.jsx(Wg, {})
  ] });
}, Hg = (t = "information") => {
  switch (t) {
    case "information":
      return " border-blue-600";
    case "success":
      return " border-green-600";
    case "error":
      return " border-red-600";
    case "warning":
      return "border-yellow-600";
  }
}, Ug = (t = "information") => {
  switch (t) {
    case "information":
      return /* @__PURE__ */ e.jsx(nu, { width: 24, height: 24, className: "text-blue-600" });
    case "success":
      return /* @__PURE__ */ e.jsx(Ea, { width: 24, height: 24, className: "text-green-600" });
    case "error":
      return /* @__PURE__ */ e.jsx(nl, { width: 24, height: 24, className: "text-red-600" });
    case "warning":
      return /* @__PURE__ */ e.jsx(rl, { width: 24, height: 24, className: "text-yellow-600" });
  }
}, Sc = ({
  registrationNumber: t,
  duration: n = 5e3,
  colorMode: r = "success",
  onClose: s
}) => {
  const [a, o] = L(!0), { t: i } = V(["account"], {
    nsMode: "fallback"
  }), c = qe(null);
  Y(() => ((() => {
    c.current = setTimeout(() => {
      o(!1), s == null || s();
    }, n);
  })(), () => {
    c.current && clearTimeout(c.current);
  }), [n, s]);
  const l = () => {
    o(!1), s == null || s();
  }, d = () => {
    o(!0), c.current && clearTimeout(c.current);
  }, u = () => {
    c.current && clearTimeout(c.current), c.current = setTimeout(() => {
      o(!1), s == null || s();
    }, n);
  };
  if (!a)
    return null;
  const m = Hg(r), f = Ug(r);
  return /* @__PURE__ */ e.jsxs(
    "div",
    {
      "aria-live": "assertive",
      onMouseEnter: d,
      onMouseLeave: u,
      className: `shadow-toast absolute right-6 top-7 z-50 flex max-w-[417px] cursor-pointer justify-between rounded-lg border-l-[3px] bg-white p-4 ${m}`,
      children: [
        /* @__PURE__ */ e.jsx("div", { className: " flex justify-between  ", children: /* @__PURE__ */ e.jsxs("div", { className: "flex gap-6 ", children: [
          /* @__PURE__ */ e.jsx("div", { children: f }),
          /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-1", children: [
            /* @__PURE__ */ e.jsx("div", { className: "font-semibold text-neutral-950", children: i("kmtoll.order.toast.title") }),
            /* @__PURE__ */ e.jsx(
              he,
              {
                as: "span",
                ns: "account",
                i18nKey: "kmtoll.order.toast.orderSuccess",
                children: t
              }
            )
          ] })
        ] }) }),
        /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
          or,
          {
            width: 16,
            height: 16,
            onClick: l,
            className: "cursor-pointer  text-neutral-700 "
          }
        ) })
      ]
    }
  );
}, Tc = Vn(
  () => ({})
), Ec = (t) => Tc.setState(t), kc = () => Tc.getState(), Gg = () => {
  const { customerInformation: t } = tt();
  return t ? /* @__PURE__ */ e.jsxs(lt, { pt: "spacing.200", pb: "spacing.100", display: "block", children: [
    /* @__PURE__ */ e.jsxs(de, { variant: "smallParagraph", my: "spacing.100", mt: 0, children: [
      t.firstName,
      " ",
      t.lastName
    ] }),
    /* @__PURE__ */ e.jsx(de, { variant: "smallParagraph", my: "spacing.100", mt: 0, children: t.address }),
    /* @__PURE__ */ e.jsxs(de, { variant: "smallParagraph", my: "spacing.100", mt: 0, children: [
      t.zipCode,
      " ",
      t.city
    ] })
  ] }) : null;
}, Kg = () => {
  const t = Ye(), [n, r] = L(), { t: s } = V(["recognitions", "common"], {
    nsMode: "fallback"
  }), { locale: a } = ve(), { nextStep: o, close: i } = wn(), { mutateAsync: c, isLoading: l } = ke(
    ["recognitions", "add", "bizz"],
    ({ Recognition: u }) => u.addRecognition,
    {
      onSuccess: () => {
        t.invalidateQueries(xe.Recognitions());
      },
      onError: (u) => u && u.code === 400 && u.error === fr.blockCommercialVehicle ? r(s("form.validations.commercial.notAllowed")) : r(s("errors.generic"))
    }
  ), d = Q(async () => {
    try {
      const u = kc();
      await c(u), o();
    } catch {
    }
  }, [c, o]);
  return Y(() => () => r(void 0), [r]), /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    n ? /* @__PURE__ */ e.jsx(Lt, { variant: "error", children: n }) : null,
    /* @__PURE__ */ e.jsxs(lt, { mt: "spacing.300", children: [
      /* @__PURE__ */ e.jsxs(lt, { sx: { maxWidth: "65ch" }, children: [
        /* @__PURE__ */ e.jsx(
          de,
          {
            variant: "smallParagraph",
            mt: 0,
            mb: 0,
            pt: "spacing.200",
            pb: "spacing.100",
            children: s("replaceRecognitionModal.descriptions.verifyAddress")
          }
        ),
        /* @__PURE__ */ e.jsx(
          de,
          {
            variant: "smallParagraph",
            mt: 0,
            mb: 0,
            pt: "spacing.200",
            pb: "spacing.100",
            children: s("replaceRecognitionModal.descriptions.order")
          }
        )
      ] }),
      /* @__PURE__ */ e.jsxs(
        Ut,
        {
          fallback: /* @__PURE__ */ e.jsx(
            lt,
            {
              display: "flex",
              p: "spacing.500",
              sx: { justifyContent: "center", alignItems: "center" },
              children: /* @__PURE__ */ e.jsx(lt, { sx: { width: "35px" }, children: /* @__PURE__ */ e.jsx(Tt, { "aria-label": s("action.loading") }) })
            }
          ),
          children: [
            /* @__PURE__ */ e.jsx(Gg, {}),
            /* @__PURE__ */ e.jsx(
              jt,
              {
                as: "a",
                href: `/${a}/account/customerInformation`,
                className: "mb-2 mt-3 font-normal",
                children: s("action.updateAddress")
              }
            )
          ]
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx(
      It,
      {
        px: 0,
        actionLabel: s("action.order"),
        cancelLabel: s("action.cancel"),
        loadingLabel: s("action.loading"),
        disabled: l || !!n,
        action: d,
        onClose: i,
        isLoading: l,
        loadingButton: !0
      }
    )
  ] });
}, Yg = () => {
  const { t } = V(["recognitions", "common"], {
    nsMode: "fallback"
  }), { close: n } = wn(), { type: r = "alpr" } = K(
    () => kc(),
    []
  );
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsxs(lt, { py: "spacing.300", sx: { textAlign: "center" }, children: [
      /* @__PURE__ */ e.jsx(de, { variant: "small", sx: { fontWeight: "fontWeights.medium" }, children: /* @__PURE__ */ e.jsx(
        he,
        {
          ns: "recognitions",
          i18nKey: `addRecognitionModal.confirmation.${r}.title`,
          children: /* @__PURE__ */ e.jsx(
            de,
            {
              as: "span",
              variant: "small",
              sx: { fontWeight: "fontWeights.bold" }
            }
          )
        }
      ) }),
      /* @__PURE__ */ e.jsx(de, { variant: "small", children: /* @__PURE__ */ e.jsxs(
        he,
        {
          ns: "recognitions",
          i18nKey: `addRecognitionModal.confirmation.${r}.description`,
          children: [
            /* @__PURE__ */ e.jsx(
              de,
              {
                as: "span",
                variant: "small",
                sx: { fontWeight: "fontWeights.medium" }
              }
            ),
            /* @__PURE__ */ e.jsx(
              de,
              {
                as: "span",
                variant: "small",
                sx: { fontWeight: "fontWeights.medium" }
              }
            ),
            /* @__PURE__ */ e.jsx(
              de,
              {
                as: "span",
                variant: "small",
                sx: { fontWeight: "fontWeights.medium" }
              }
            )
          ]
        }
      ) })
    ] }),
    /* @__PURE__ */ e.jsx(
      pn,
      {
        actionLabel: t("action.close"),
        cancelLabel: t("action.cancel"),
        action: () => () => Promise.resolve(n()).then(() => !0),
        removeCancelButton: !0
      }
    )
  ] });
}, Qg = (t) => (n) => n && t[n] ? t[n] : "", $i = ({
  weightClass: t,
  hybrid: n,
  asfinag: r,
  country: s,
  licensePlate: a,
  fuelType: o,
  emissionClass: i,
  reference: c,
  recognitionType: l,
  contractNo: d,
  isCommercialVehicle: u,
  endDate: m
}) => ({
  type: l,
  isHGV: t === "heavy",
  isHybrid: n === "true",
  isAsfinag: r === "true",
  countryCode: s,
  regNo: a,
  fuelType: o ? Number(o) : void 0,
  reference: c || "",
  emissionClass: i ? Number(i) : void 0,
  contractNo: d,
  isCommercialVehicle: u === "true",
  endDate: m || ""
}), Xg = {
  isHybrid: "hybrid",
  isAsfinag: "asfinag",
  isHGV: "weightClass",
  regNo: "licensePlate",
  countryCode: "country"
}, Jg = (t) => t && Object.entries(t).reduce((n, [r, s]) => {
  if (!s)
    return n;
  const a = Xg[r] || r;
  return a ? { ...n, [a]: s } : n;
}, {}), Zg = (t) => !!t && t.trim() !== "", ex = ({
  namespace: t,
  bvSupportCountries: n,
  countries: r,
  fuelTypes: s,
  emissionClasses: a,
  weightClasses: o,
  contracts: i,
  recognitionTypes: c,
  labels: l,
  placeholders: d,
  descriptions: u,
  validateLicensePlate: m,
  defaultValues: f,
  vehicleColors: p
}) => {
  const {
    registerField: b,
    getError: h,
    setFieldErrors: g,
    setPartialData: v,
    resetSelectedData: y,
    resetFieldError: x
  } = Se({
    namespace: t,
    defaultValues: f
  }), [
    j,
    w,
    C,
    P,
    N,
    R,
    T
  ] = He(
    t,
    "country",
    "licensePlate",
    "recognitionType",
    "contractNo",
    "weightClass",
    "fuelType",
    "emissionClass"
  );
  Y(() => {
    R === "5" && T && v({
      emissionClass: void 0
    });
  }, [R, v, T]);
  const [z, D] = L(), [A, S] = L(), [_, $] = L(), q = K(() => C === "alpr", [C]), U = K(() => N === "heavy", [N]), W = K(() => C === "bizz", [C]);
  Y(() => {
    W && v({
      endDate: void 0
    });
  }, [W, v]);
  const {
    data: G,
    error: ee,
    isFetching: ue
  } = Jr(z);
  Y(() => S(ee), [ee]), Y(() => S(null), [w]), Y(() => $(G), [G]), Y(() => $(void 0), [w, j]), Y(() => D(void 0), [j]), Y(() => {
    R === "5" && T && v({
      emissionClass: void 0
    });
  }, [R, v, T]);
  const ce = Q(() => {
    D({
      licensePlate: w,
      country: j
    });
  }, [j, w]), re = Q(() => {
    y([
      "make",
      "model",
      "color",
      "weightClass",
      "hybrid",
      "asfinag",
      "fuelType",
      "emissionClass"
    ]);
  }, [y]);
  Y(() => {
    if (_) {
      const ge = _;
      v({
        ...ge,
        weightClass: ge.isHGV ? "heavy" : "light",
        hybrid: ge.isHybrid ? "true" : "false",
        fuelType: ge.fuelTypeId.toString(),
        isCommercialVehicle: ge.isCommercialVehicle ? "true" : "false",
        emissionClass: ge.euroEmissionNorm !== void 0 ? no(a)[ge.euroEmissionNorm] : void 0
      });
    } else
      re();
  }, [
    _,
    v,
    re,
    a
  ]), Y(() => {
    re(), x("licensePlate");
  }, [j, re, x]);
  const se = Q(async () => {
    if (!Zg(j)) return;
    let je = !0;
    if (q) {
      const F = await m({
        country: j,
        licensePlate: w
      })(void 0);
      F && (je = !1, g(F), re(), D(void 0));
    }
    (!q || je) && ce();
  }, [
    j,
    q,
    m,
    w,
    g,
    re,
    ce
  ]);
  Y(() => {
    hr(pr(w), j) && se();
  }, [j, se, w]);
  const H = K(() => C != "", [C]), O = K(() => P != "", [P]), ae = Qg(u)(C);
  return /* @__PURE__ */ e.jsxs(ht, { className: ct("mb-4 gap-4"), children: [
    /* @__PURE__ */ e.jsxs(ne, { className: "col-span-full sm:col-span-12 md:col-span-12 md:col-start-1", children: [
      /* @__PURE__ */ e.jsx(M, { children: u.recognitionType }),
      /* @__PURE__ */ e.jsx(
        Oe,
        {
          label: l.recognitionType,
          error: h("recognitionType"),
          ...b("recognitionType"),
          options: c,
          required: !0
        }
      )
    ] }),
    /* @__PURE__ */ e.jsxs(ne, { className: "col-span-full mb-8 sm:col-span-12 md:col-span-12 md:col-start-1", children: [
      /* @__PURE__ */ e.jsx(M, { children: u.contract }),
      /* @__PURE__ */ e.jsx(
        Oe,
        {
          placeholder: d.contractNo,
          label: l.contractNo,
          disabled: !H,
          error: h("contractNo"),
          ...b("contractNo"),
          options: i,
          required: !0
        }
      )
    ] }),
    ae && ae.trim() !== "" ? /* @__PURE__ */ e.jsx(ne, { className: "col-span-full w-0 min-w-full sm:col-span-12 md:col-span-12", children: /* @__PURE__ */ e.jsx(Le, { children: ae }) }) : null,
    /* @__PURE__ */ e.jsx(ne, { className: "col-span-full sm:col-span-12 md:col-span-12", children: /* @__PURE__ */ e.jsx(
      me,
      {
        ...b("reference"),
        label: W ? l.reference : l.alprName,
        error: h("reference"),
        disabled: !H || !O
      }
    ) }),
    /* @__PURE__ */ e.jsx(ne, { className: "col-span-full sm:col-span-12 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      Oe,
      {
        label: l.country,
        placeholder: d.country,
        error: h("country"),
        disabled: !H || !O,
        ...b("country"),
        options: r,
        required: !0
      }
    ) }),
    /* @__PURE__ */ e.jsxs(ne, { className: "col-span-full w-0 min-w-full sm:col-span-12 md:col-span-6", children: [
      /* @__PURE__ */ e.jsx(
        me,
        {
          ...b("licensePlate"),
          label: l.licensePlate,
          error: h("licensePlate"),
          disabled: !H || !O,
          required: !0
        }
      ),
      A ? /* @__PURE__ */ e.jsx(Le, { children: l.noVehicleInfo }) : null
    ] }),
    /* @__PURE__ */ e.jsx(ne, { className: "col-span-full mb-0 sm:col-span-12 md:col-span-12", children: /* @__PURE__ */ e.jsx(M, { as: "h6", size: "lg", className: "mb-0", children: l.volVehicleInfo }) }),
    /* @__PURE__ */ e.jsx(ne, { className: "col-span-full sm:col-span-12 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      me,
      {
        ...b("make"),
        label: l.make,
        error: h("make"),
        disabled: !H || !O || !!(_ != null && _.make)
      }
    ) }),
    /* @__PURE__ */ e.jsx(ne, { className: "col-span-full sm:col-span-12 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      me,
      {
        ...b("model"),
        label: l.model,
        error: h("model"),
        disabled: !H || !O || !!(_ != null && _.model)
      }
    ) }),
    /* @__PURE__ */ e.jsx(ne, { className: "col-span-full sm:col-span-12 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      Oe,
      {
        ...b("color"),
        placeholder: d.color,
        label: l.color,
        options: p,
        placeholderDisabled: !1,
        error: h("color"),
        disabled: !H || !O || !!(_ != null && _.color)
      }
    ) }),
    /* @__PURE__ */ e.jsx(ne, { className: "col-span-full sm:col-span-12 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      Oe,
      {
        label: l.weightClass,
        placeholder: d.weightClass,
        error: h("weightClass"),
        placeholderDisabled: !1,
        disabled: !H || !O || (_ == null ? void 0 : _.isHGV) !== void 0,
        ...b("weightClass"),
        options: o
      }
    ) }),
    /* @__PURE__ */ e.jsx(ne, { className: "col-span-full sm:col-span-12 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      Oe,
      {
        label: l.fuelType,
        placeholder: d.fuelType,
        placeholderDisabled: !1,
        error: h("fuelType"),
        disabled: !H || !O || !!(_ != null && _.fuelType),
        ...b("fuelType"),
        options: s
      }
    ) }),
    /* @__PURE__ */ e.jsx(ne, { className: "col-span-full sm:col-span-12 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      Oe,
      {
        label: l.emissionClass,
        placeholder: d.emissionClass,
        placeholderDisabled: !1,
        error: h("emissionClass"),
        disabled: !H || !O || R === "5" || !!(_ != null && _.euroEmissionNorm),
        ...b("emissionClass"),
        options: a
      }
    ) }),
    /* @__PURE__ */ e.jsx(ne, { className: "col-span-full sm:col-span-12 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      me,
      {
        error: h("hybrid"),
        label: l.hybrid,
        disabled: !H || !O || (_ == null ? void 0 : _.isHybrid) !== void 0,
        ...b("hybrid", {
          type: "checkbox",
          value: "true"
        })
      }
    ) }),
    W && U && /* @__PURE__ */ e.jsx(ne, { className: "col-span-full sm:col-span-12 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      me,
      {
        error: h("asfinag"),
        label: l.asfinag,
        disabled: !H || !O,
        ...b("asfinag", {
          type: "checkbox",
          value: "true"
        })
      }
    ) }),
    /* @__PURE__ */ e.jsx(ne, { className: "col-span-full hidden sm:col-span-12 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      me,
      {
        error: h("isCommercialVehicle"),
        label: l.isCommercialVehicle,
        ...b("isCommercialVehicle", {
          type: "checkbox",
          value: "true"
        }),
        disabled: (_ == null ? void 0 : _.isCommercialVehicle) !== void 0
      }
    ) }),
    W ? null : /* @__PURE__ */ e.jsxs(ne, { className: "col-span-full text-neutral-500 sm:col-span-12 md:col-span-12", children: [
      /* @__PURE__ */ e.jsx(
        me,
        {
          error: h("endDate"),
          label: /* @__PURE__ */ e.jsx("span", { className: "text-neutral-900", children: l.endDate }),
          ...b("endDate", {
            type: "date"
          }),
          onClick: (ge) => ge.currentTarget.showPicker()
        }
      ),
      /* @__PURE__ */ e.jsx(M, { className: "max-w-[672px] text-wrap pt-4 text-neutral-500", children: u.endDate })
    ] })
  ] });
};
function Ac(t) {
  const n = hn();
  let r = t;
  t || (r = n);
  const { data: s, isLoading: a } = De(
    xe.ContractByNo(r),
    ({ Contract: o }) => o.byContractNo(r),
    { enabled: !!t, suspense: !0 }
  );
  return { data: s, isLoading: a };
}
const fC = (t) => {
  switch (t) {
    case "oresundsPay":
      return "Som kund hos ÖresundsPay måste du registrera ditt Bropass-avtal via Mitt konto.";
    case "brobizz":
      return "Som kund hos Brobizz måste du registrera ditt Bropass-avtal via Brobizz hemsida.";
    default:
      return `Om du har en aktiv bizz med ${t} kan du lägga till den här. Ditt Bropass-avtal knyts då till din bizz och konto hos ${t}.`;
  }
}, ds = [
  "black",
  "blue",
  "brown",
  "green",
  "grey",
  "orange",
  "purple",
  "red",
  "white",
  "yellow",
  "other"
], pC = (t, n) => {
  const r = n == null ? void 0 : n.supportedCountries;
  return Array.isArray(r) && r.includes(t);
}, tx = {
  sv: "/sv/account",
  da: "/da/account",
  en: "/account"
  // en is the default locale so we do not need the locale prefix here
}, nx = (t) => t != null && t.includes("sv") ? "sv" : t != null && t.includes("da") ? "da" : "en", hC = (t) => {
  const n = nx(t);
  return tx[n];
}, Oc = (t, n) => {
  const { query: r, replace: s, pathname: a } = n;
  delete r[t], s({ pathname: a, query: r }, void 0, { shallow: !0 });
}, rx = Tn()("licensePlate", "country"), sx = ({
  contractNo: t,
  preSelectedRecognitionType: n
}) => {
  const r = qe(null), s = Ye(), [a, o] = L(), { t: i } = V(["recognitions", "common"], {
    nsMode: "fallback"
  }), { mutateAsync: c, isLoading: l } = ke(
    ["recognitions", "add", "alpr"],
    ({ Recognition: S }) => S.addRecognition,
    {
      onSuccess: () => {
        s.invalidateQueries({
          queryKey: ["account", "recognitions"]
        });
      },
      onError: (S) => S && S.code === 400 && S.error === fr.blockCommercialVehicle ? o(i("form.validations.commercial.notAllowed")) : o(i("errors.generic"))
    }
  ), [d] = He(
    "add-recognition",
    "recognitionType"
  ), u = K(() => d === "alpr", [d]), { nextStep: m, close: f } = wn(), p = Pn(), b = Q(
    (S) => async (_) => {
      const $ = _ || {};
      if ($ && !St("licensePlate")($) || $ && !St("country")($))
        return;
      const q = rx(S);
      try {
        return await p({
          licensePlate: i("form.validations.licensePlate.exist")
        })(q);
      } catch {
        return;
      }
    },
    [i, p]
  ), h = Q(
    async (S) => {
      try {
        const _ = $i(S), $ = await rn(
          yu.spa,
          i
        )(_), q = Jg($);
        let U = q;
        return u && (U = await b(S)(q), !U) ? void 0 : U;
      } catch {
        return;
      }
    },
    [i, b, u]
  ), g = Q(
    async (S) => {
      const _ = $i(S);
      if (Ec(_), u)
        try {
          await c(_), m();
        } catch {
        }
      else
        m();
    },
    [u, c, m]
  ), v = "add-recognition", { handleSubmit: y, resetData: x, validate: j, isValid: w } = Se({
    namespace: v,
    onValidate: h,
    onSubmit: g
  }), { emissionClasses: C, fuelTypes: P } = At(), N = Zr(), R = $t(), { contracts: T } = Xr(!1), { data: z } = Ac(t);
  Y(
    () => () => {
      x(), o(void 0);
    },
    [x, o]
  );
  const D = K(
    () => ds.map((S) => ({
      label: i(`vehicleColors.${S}`),
      value: S
    })),
    [i]
  ), A = K(
    () => ({
      namespace: v,
      fuelTypes: P,
      emissionClasses: C,
      countries: R.map(({ key: S, value: _ }) => ({
        label: S,
        value: _
      })),
      vehicleColors: D,
      bvSupportCountries: N,
      weightClasses: [
        { label: i("weightClasses.heavy"), value: "heavy" },
        { label: i("weightClasses.light"), value: "light" }
      ],
      contracts: z ? [
        Dl(i)(
          cf(z)
        )
      ] : Ll(i, T, !1, !0),
      recognitionTypes: [
        { label: i("form.labels.bizz.order"), value: "bizz" },
        {
          label: i("form.labels.regNo.add"),
          value: "alpr"
        }
      ],
      labels: {
        contractNo: i("form.labels.contract"),
        country: i("form.labels.country"),
        emissionClass: i("form.labels.emissionClass"),
        fuelType: i("form.labels.fuelType"),
        licensePlate: i("form.labels.licensePlate"),
        weightClass: i("form.labels.weightClass"),
        hybrid: i("form.labels.hybrid"),
        asfinag: i("form.labels.asfinag"),
        reference: i("form.labels.reference"),
        recognitionType: i("form.labels.recognitionType"),
        lookup: i("form.labels.lookupLicensePlate"),
        vehicleSearch: i("action.search"),
        make: i("form.labels.make"),
        model: i("form.labels.model"),
        color: i("form.labels.color"),
        alprName: i("form.labels.alprName"),
        volVehicleInfo: i("form.labels.vlinfo"),
        noVehicleInfo: i("form.validations.licensePlate.notfound"),
        loadingSearch: i("action.loading"),
        isCommercialVehicle: i("form.labels.commercialVehicle"),
        endDate: i("form.labels.lastUseDate")
      },
      placeholders: {
        weightClass: i("form.placeholders.weightClass"),
        country: i("form.placeholders.country"),
        emissionClass: i("form.placeholders.emissionClass"),
        fuelType: i("form.placeholders.fuelType"),
        color: i("form.placeholders.color"),
        contractNo: i("form.placeholders.contractNo")
      },
      descriptions: {
        bizz: i("form.descriptions.bizz"),
        licensePlate: i("form.descriptions.licensePlate"),
        contract: i("form.descriptions.contract"),
        recognitionType: i("form.descriptions.recognitionType"),
        contractBizzSelected: i("form.descriptions.contractBizzSelected"),
        contractAlprSelected: i("form.descriptions.contractAlprSelected"),
        endDate: i("form.descriptions.endDate")
      },
      validateLicensePlate: b,
      defaultValues: {
        recognitionType: n === "bizz" || n === "alpr" ? n : "alpr",
        contractNo: t
      }
    }),
    [
      z,
      N,
      t,
      T,
      R,
      C,
      P,
      n,
      i,
      b,
      D
    ]
  );
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    a ? /* @__PURE__ */ e.jsx(Lt, { variant: "error", children: a }) : null,
    /* @__PURE__ */ e.jsxs(
      Yr,
      {
        onSubmit: Kt(j, y),
        onReset: f,
        ref: r,
        children: [
          /* @__PURE__ */ e.jsx(
            ex,
            {
              preSelectedRecognitionType: n,
              ...A
            }
          ),
          /* @__PURE__ */ e.jsx(
            It,
            {
              px: 0,
              actionLabel: i(u ? "action.add" : "action.next"),
              cancelLabel: i("action.cancel"),
              loadingLabel: i("action.loading"),
              disabled: !w,
              actionButtonType: "submit",
              cancelButtonType: "reset",
              isLoading: l,
              loadingButton: !0
            }
          )
        ]
      }
    )
  ] });
}, _c = () => {
  const t = ve(), { query: n } = t, { contracts: r } = Xr();
  return (r ?? []).length === 1 ? r == null ? void 0 : r[0].contractNo : n.contract;
}, ax = ({
  preSelectedRecognitionType: t,
  onClose: n
}) => {
  const { t: r } = V(["recognitions", "common"], {
    nsMode: "fallback"
  }), s = _c(), [a] = He(
    "add-recognition",
    "recognitionType"
  ), o = K(() => a === "bizz", [a]), i = t === "bizz" ? "action.bizz" : "action.alpr";
  return /* @__PURE__ */ e.jsxs(
    ml,
    {
      open: !0,
      ariaLabelledBy: "title",
      title: /* @__PURE__ */ e.jsx(
        de,
        {
          id: "title",
          variant: "paragraph",
          mt: 0,
          mb: 0,
          sx: { color: "colors.neutral.100" },
          children: r(i)
        }
      ),
      labels: {
        close: r("action.close"),
        cancel: r("action.cancel"),
        complete: r("action.complete"),
        continue: r("action.continue")
      },
      onClose: () => {
        n(), Ec({});
      },
      hideProgress: !0,
      children: [
        /* @__PURE__ */ e.jsx(
          sx,
          {
            preSelectedRecognitionType: t,
            contractNo: s
          }
        ),
        o ? /* @__PURE__ */ e.jsx(Kg, {}) : null,
        /* @__PURE__ */ e.jsx(Yg, {})
      ]
    }
  );
}, ox = (t) => t == null ? "" : String(t), ix = ({
  namespace: t,
  defaultValues: n,
  labels: r,
  placeholders: s,
  countries: a,
  fuelTypes: o,
  emissionClasses: i,
  weightClasses: c,
  isExternalCustomer: l,
  isLicensePlate: d,
  bvSupportCountries: u,
  vehicleColors: m
}) => {
  const {
    registerField: f,
    getError: p,
    setPartialData: b,
    resetSelectedData: h,
    resetFieldError: g
  } = Se({
    namespace: t,
    defaultValues: n
  }), [v, y, x, j, w] = He(
    t,
    "reference",
    "countryCode",
    "licensePlate",
    "fuelType",
    "emissionClass"
  ), [C, P] = L(), [N, R] = L();
  Y(() => {
    x === "5" && j && b({
      emissionClass: void 0
    });
  }, [x, b, j]);
  const {
    data: T,
    error: z,
    isFetching: D
  } = Jr(C), A = Q(() => {
    h([
      "make",
      "model",
      "color",
      "weightClass",
      "hybrid",
      "fuelType",
      "emissionClass"
    ]);
  }, [h]);
  Y(() => R(T), [T]), Y(
    () => R(void 0),
    [y, v]
  ), Y(() => P(void 0), [v]), Y(() => {
    if (!N)
      A();
    else {
      const $ = N, q = no(i)[$.euroEmissionNorm] || void 0;
      b({
        ...$,
        weightClass: (!!$.isHGV).toString(),
        hybrid: (!!$.isHybrid).toString(),
        fuelType: $.fuelTypeId.toString(),
        emissionClass: q,
        reference: w
      });
    }
  }, [N, b, A, w]), Y(() => {
    A(), g("licensePlate");
  }, [v, A, g]);
  const S = Q(
    ($) => P({
      licensePlate: $,
      country: v
    }),
    [P, v]
  );
  Y(() => {
    hr(
      pr(y),
      v
    ) && S(y);
  }, [y, v, S]);
  const { t: _ } = V(["recognitions", "common"], {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsxs(ht, { className: ct("mb-4 gap-4"), children: [
    /* @__PURE__ */ e.jsx(ne, { className: "col-span-full sm:col-span-4 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      Oe,
      {
        label: r.countryCode,
        ...f("countryCode"),
        error: p("countryCode"),
        options: a,
        disabled: d,
        placeholder: s.countryCode,
        required: !0
      }
    ) }),
    /* @__PURE__ */ e.jsxs(ne, { className: "col-span-full w-0 min-w-full sm:col-span-4 md:col-span-6", children: [
      /* @__PURE__ */ e.jsx(
        me,
        {
          label: r.licensePlate,
          ...f("licensePlate"),
          error: p("licensePlate"),
          required: !0,
          disabled: d,
          helpText: p("licensePlate") == null ? _("modal.form.licensePlateHelp") : void 0
        }
      ),
      z ? /* @__PURE__ */ e.jsx(Le, { children: r.noVehicleInfo }) : null
    ] }),
    /* @__PURE__ */ e.jsx(ne, { className: "col-span-full sm:col-span-4 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      me,
      {
        ...f("make"),
        label: r.make,
        className: "col-span-full sm:col-span-12 md:col-span-6",
        error: p("make"),
        disabled: l || !!(N != null && N.make)
      }
    ) }),
    /* @__PURE__ */ e.jsx(ne, { className: "col-span-full sm:col-span-4 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      me,
      {
        ...f("model"),
        label: r.model,
        className: "col-span-full sm:col-span-12 md:col-span-6",
        error: p("model"),
        disabled: l || !!(N != null && N.model)
      }
    ) }),
    /* @__PURE__ */ e.jsx(ne, { className: "col-span-full sm:col-span-4 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      Oe,
      {
        className: "col-span-full sm:col-span-12 md:col-span-6",
        ...f("color"),
        placeholder: s.color,
        label: r.color,
        options: m,
        error: p("color"),
        disabled: l || !!(N != null && N.color),
        placeholderDisabled: !1
      }
    ) }),
    /* @__PURE__ */ e.jsx(ne, { className: "col-span-full sm:col-span-4 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      Oe,
      {
        label: r.weightClass,
        ...f("weightClass"),
        error: p("weightClass"),
        disabled: l || (N == null ? void 0 : N.isHGV) !== void 0,
        options: c,
        placeholder: s.weightClass,
        placeholderDisabled: !1
      }
    ) }),
    /* @__PURE__ */ e.jsx(ne, { className: "col-span-full sm:col-span-4 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      Oe,
      {
        label: r.fuelType,
        ...f("fuelType"),
        error: p("fuelType"),
        disabled: l || !!(N != null && N.fuelType),
        options: o,
        placeholder: s.fuelType,
        placeholderDisabled: !1
      }
    ) }),
    /* @__PURE__ */ e.jsx(ne, { className: "col-span-full sm:col-span-4 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      Oe,
      {
        label: r.emissionClass,
        ...f("emissionClass"),
        error: p("emissionClass"),
        disabled: l || x === "5" || !!(N != null && N.euroEmissionNorm),
        options: i,
        placeholder: s.emissionClass,
        placeholderDisabled: !1
      }
    ) }),
    /* @__PURE__ */ e.jsx(ne, { className: "col-span-full sm:col-span-4 md:col-span-6", children: /* @__PURE__ */ e.jsx(
      me,
      {
        label: r.hybrid,
        ...f("hybrid", { type: "checkbox", value: "true" }),
        disabled: l || (N == null ? void 0 : N.isHybrid) !== void 0
      }
    ) }),
    /* @__PURE__ */ e.jsx(ne, { className: "border-black-400 col-span-full border-t pt-4", children: /* @__PURE__ */ e.jsx(
      me,
      {
        label: r.reference,
        ...f("reference"),
        disabled: l
      }
    ) })
  ] });
}, lx = ({ white: t, contract: n }) => /* @__PURE__ */ e.jsx(ne, { className: "text-primary-400", children: /* @__PURE__ */ e.jsxs(
  M,
  {
    size: "sm",
    color: t ? "white" : "default",
    className: "flex items-center",
    children: [
      /* @__PURE__ */ e.jsx(ru, { width: "15px", height: "10px", className: "mr-2" }),
      /* @__PURE__ */ e.jsx(at, { contract: n })
    ]
  }
) }), cx = ({
  bizzName: t,
  bizzNumber: n,
  licensePlate: r,
  type: s,
  contract: a,
  isOSB: o
}) => {
  const { t: i } = V("common"), c = K(
    () => t ? "modal.title.withReference" : "modal.title.withoutReference",
    [t]
  ), l = K(
    () => s === "licensePlate" ? "form.labels.licensePlate" : "form.labels.bizz",
    [s]
  );
  return /* @__PURE__ */ e.jsxs(lt, { display: "flex", sx: { flexDirection: "column" }, children: [
    /* @__PURE__ */ e.jsxs(
      de,
      {
        as: "span",
        mt: 0,
        mb: 0,
        sx: {
          color: "colors.neutral.100",
          display: "flex",
          alignItems: "center"
        },
        children: [
          /* @__PURE__ */ e.jsx("span", { className: "mr-4 size-5", children: i(l) }),
          o ? /* @__PURE__ */ e.jsx(lx, { contract: a, white: !0 }) : null
        ]
      }
    ),
    /* @__PURE__ */ e.jsx(
      de,
      {
        id: "description",
        variant: "paragraph",
        mt: 0,
        mb: 0,
        sx: { color: "colors.neutral.100" },
        children: /* @__PURE__ */ e.jsx(
          he,
          {
            ns: "recognitions",
            i18nKey: c,
            values: { bizzName: t, bizzNumber: n, licensePlate: r },
            children: /* @__PURE__ */ e.jsx(
              de,
              {
                id: "title",
                as: "span",
                mt: 0,
                mb: 0,
                sx: {
                  color: "inherit",
                  fontWeight: "fontWeights.medium"
                }
              }
            )
          }
        )
      }
    )
  ] });
}, Fi = ({
  activeRecognition: t,
  onClose: n,
  isExternalCustomer: r,
  contract: s,
  replaceSerialNumber: a,
  onSuccessReplaceBizz: o
}) => {
  var N, R;
  const i = qe(null), c = Ye(), { t: l } = V(["recognitions", "common"], {
    nsMode: "fallback"
  }), [d, u] = L(!1), { mutateAsync: m, isLoading: f } = ke(
    ["recognitions", "update"],
    ({ Recognition: T }) => T.updateRecognition,
    {
      onSuccess: () => (c.invalidateQueries({
        queryKey: ["account", "recognitions"]
      }), o ? o() : n()),
      onError: () => {
        u(!0);
      }
    }
  ), p = Q(
    (T) => (async () => {
      if (!t) {
        console.error("Invalid recognition, recognition is null");
        return;
      }
      const z = {
        contractLineNo: t.contractLineNo,
        contractNo: t.contract.contractNo,
        changes: {
          isHybrid: T.hybrid === "true",
          isHGV: T.weightClass === "heavy",
          reference: T.reference || void 0,
          emissionClass: Number(T.emissionClass) || void 0,
          fuelType: Number(T.fuelType) || void 0
        }
      };
      try {
        await m(z);
      } catch {
      }
    })(),
    [t, m]
  ), b = "edit-recognition-modal", {
    resetData: h,
    handleSubmit: g,
    validate: v,
    isDirty: y,
    isValid: x
  } = Se({
    namespace: b,
    onSubmit: p,
    onValidate: Hn(ju.spa, l)
  });
  Y(() => () => {
    h(), u(!1);
  }, [h, u]);
  const { fuelTypes: j, emissionClasses: w } = At(), C = Zr(), P = $t();
  return /* @__PURE__ */ e.jsxs(lr, { open: !0, ariaLabelledBy: "title", ariaDescribedBy: "description", children: [
    /* @__PURE__ */ e.jsx(cr, { closeLabel: l("action.close"), onClose: n, children: a ? /* @__PURE__ */ e.jsx(M, { as: "h2", children: l("replaceBizz.title") }) : /* @__PURE__ */ e.jsx(
      cx,
      {
        bizzName: t.reference,
        bizzNumber: t.serialNo,
        licensePlate: t.registrationNo,
        type: t.recognitionType,
        contract: s,
        isOSB: t.isOSB
      }
    ) }),
    /* @__PURE__ */ e.jsxs(
      ne,
      {
        ref: i,
        as: "form",
        noValidate: !0,
        onSubmit: Kt(v, g),
        onReset: n,
        className: "flex flex-col gap-12",
        children: [
          /* @__PURE__ */ e.jsx(Yt, { children: /* @__PURE__ */ e.jsxs(ne, { className: "flex flex-col gap-12", children: [
            /* @__PURE__ */ e.jsx(M, { intent: "label", size: "lg", children: l("form.requiredFields") }),
            /* @__PURE__ */ e.jsx(ne, { className: "col-span-full", children: /* @__PURE__ */ e.jsx(M, { intent: "title", children: l("modal.form.title") }) }),
            /* @__PURE__ */ e.jsx(Le, { color: "inform", children: /* @__PURE__ */ e.jsxs(ne, { as: "div", className: "flex flex-1 flex-row items-center	", children: [
              /* @__PURE__ */ e.jsx(tl, { height: "20", width: "20", className: "mr-2" }),
              /* @__PURE__ */ e.jsx(M, { intent: "body", size: "md", children: l("modal.form.infoBanner") })
            ] }) }),
            d && /* @__PURE__ */ e.jsx(Lt, { variant: "error", children: l("errors.generic") }),
            t && /* @__PURE__ */ e.jsx(
              ix,
              {
                namespace: b,
                countries: P.map(({ key: T, value: z }) => ({
                  label: T,
                  value: z
                })),
                bvSupportCountries: C,
                fuelTypes: j,
                emissionClasses: w,
                weightClasses: [
                  { label: l("weightClasses.heavy"), value: "heavy" },
                  { label: l("weightClasses.light"), value: "light" }
                ],
                vehicleColors: ds.map((T) => ({
                  label: l(`vehicleColors.${T}`),
                  value: T
                })),
                labels: {
                  reference: l("form.labels.reference"),
                  emissionClass: l("form.labels.emissionClass"),
                  fuelType: l("form.labels.fuelType"),
                  weightClass: l("form.labels.weightClass"),
                  hybrid: l("form.labels.hybrid"),
                  licensePlate: l("form.labels.licensePlate"),
                  countryCode: l("form.labels.country"),
                  vehicleSearch: l("action.search"),
                  make: l("form.labels.make"),
                  model: l("form.labels.model"),
                  color: l("form.labels.color"),
                  alprName: l("form.labels.alprName"),
                  volVehicleInfo: l("form.labels.vlinfo"),
                  noVehicleInfo: l("form.validations.licensePlate.notfound"),
                  loadingSearch: l("action.loading"),
                  licensePlateExist: l("form.validations.licensePlate.exist")
                },
                placeholders: {
                  weightClass: l("form.placeholders.weightClass"),
                  countryCode: l("form.placeholders.country"),
                  emissionClass: l("form.placeholders.emissionClass"),
                  fuelType: l("form.placeholders.fuelType"),
                  color: l("form.placeholders.color")
                },
                defaultValues: {
                  reference: t.reference,
                  licensePlate: t.registrationNo,
                  fuelType: (N = t.fuelType) == null ? void 0 : N.value,
                  emissionClass: (R = t.emissionClass) == null ? void 0 : R.value,
                  hybrid: ox(t.isHybrid),
                  weightClass: t.isHGV ? "heavy" : "light",
                  countryCode: t.countryCode
                },
                isExternalCustomer: r,
                isLicensePlate: t.recognitionType === "licensePlate"
              }
            )
          ] }) }),
          /* @__PURE__ */ e.jsx(
            It,
            {
              actionLabel: l(
                a ? "action.continue" : "action.save"
              ),
              cancelLabel: l("action.cancel"),
              loadingLabel: l("action.loading"),
              cancelButtonType: "reset",
              actionButtonType: "submit",
              onClose: n,
              isLoading: f,
              disabled: f || d || !y || !x,
              loadingButton: !0
            }
          )
        ]
      }
    )
  ] });
}, dx = ({
  recognition: t,
  onClose: n
}) => {
  const { t: r } = V(["recognitions", "common"], {
    nsMode: "fallback"
  }), [s, a] = L(), o = K(
    () => t.recognitionType == "bizz",
    [t.recognitionType]
  ), i = Ye(), { mutateAsync: c } = ke(
    ["recognitions", "remove"],
    ({ Recognition: d }) => d.closeRecognition,
    {
      onSuccess: () => (i.invalidateQueries({
        queryKey: ["account", "recognitions"]
      }), n()),
      onError: () => {
        a(r("errors.generic"));
      }
    }
  ), l = Q(async () => {
    const { ...d } = t;
    try {
      await c(d);
    } catch {
    }
  }, [t, c]);
  return Y(() => () => {
    a(void 0);
  }, [a]), /* @__PURE__ */ e.jsxs(lr, { open: !0, ariaLabelledBy: "title", children: [
    /* @__PURE__ */ e.jsx(cr, { closeLabel: r("action.close"), onClose: n, children: /* @__PURE__ */ e.jsx(
      de,
      {
        id: "title",
        variant: "paragraph",
        mt: 0,
        mb: 0,
        sx: { color: "colors.neutral.100" },
        children: r(o ? "removeRecognitionModal.title.bizz" : "removeRecognitionModal.title.licensePlate")
      }
    ) }),
    /* @__PURE__ */ e.jsxs(Yt, { children: [
      s && /* @__PURE__ */ e.jsx(Lt, { variant: "error", children: s }),
      /* @__PURE__ */ e.jsxs("div", { className: "max-w-[65ch]", children: [
        /* @__PURE__ */ e.jsx(
          de,
          {
            variant: "smallParagraph",
            mt: 0,
            mb: 0,
            pt: "spacing.200",
            pb: "spacing.100",
            sx: { textAlign: "center" },
            children: r(o ? "removeRecognitionModal.confirmation.bizz" : "removeRecognitionModal.confirmation.licensePlate")
          }
        ),
        /* @__PURE__ */ e.jsx(
          de,
          {
            variant: "smallParagraph",
            mt: 0,
            mb: 0,
            pt: "spacing.200",
            pb: "spacing.100",
            sx: { textAlign: "center" },
            children: r(o ? "removeRecognitionModal.description.bizz" : "removeRecognitionModal.description.licensePlate")
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ e.jsx(
      It,
      {
        onClose: n,
        cancelLabel: r("action.cancel"),
        actionLabel: r(o ? "action.block" : "action.remove"),
        action: l
      }
    )
  ] });
}, ux = ({
  preambleKey: t
}) => {
  const { t: n } = V(["recognitions"], {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsx(M, { as: "span", className: "max-w-3xl", children: n(t) });
}, Bi = ({ isOSB: t, isPeriodCardActive: n }) => t || n, mx = ({ lineStatus: t }) => t == "open", fx = (t) => t === "bizz", px = (t) => fx(t.recognitionType) ? t.registrationNo : [
  t.reference,
  t.registrationNo,
  t.serialNo
].filter(Boolean).join(" - "), hx = (t) => ({
  status: t.lineStatus,
  id: `${t.contractLineNo}-${t.contractNo}`,
  label: px(t),
  isEditable: t.isEditable,
  isOSB: t.isOSB,
  isInvalid: t.country === "-" || !t.country || !t.registrationNo,
  isPeriodCardActive: t.isPeriodCardActive,
  serialNo: t.serialNo,
  contractLineNo: t.contractLineNo,
  recognitionType: t.recognitionType,
  registrationNo: t.registrationNo
}), gx = (t) => mx(t) ? [hx(t)] : [];
function Rc() {
  const { query: t } = ve(), n = t.contract, r = n ? [n] : void 0, { recognitions: s, loading: a } = $a(20, {
    agreements: r
  }), { data: o } = ur();
  return K(() => {
    if (!s || s.length === 0 || a)
      return {
        activeRecognitions: [],
        recognitionChoices: [],
        loading: a
      };
    const i = s.flatMap(gx), c = i.filter(Bi), l = i.filter(
      (m) => !Bi(m)
    ), d = c.concat(l), u = s.length > 0 ? s[0].contract : void 0;
    return {
      activeRecognitions: c,
      recognitionChoices: o ? d.filter((m) => m.recognitionType === "licensePlate") : d,
      loading: !1,
      contract: u
    };
  }, [a, s, o]);
}
const xx = ({ rowNumber: t, alpr: n }) => {
  const { t: r } = V("recognitions");
  return /* @__PURE__ */ e.jsxs("div", { className: "flex gap-4 py-2", children: [
    /* @__PURE__ */ e.jsx("div", { className: "w-[30px]", children: /* @__PURE__ */ e.jsx(M, { intent: "headline", size: "sm", className: "text-center", children: t }) }),
    n ? /* @__PURE__ */ e.jsx(Pt, { label: r("form.labels.regNo.short"), children: n }) : /* @__PURE__ */ e.jsx("div", { className: "flex items-center", children: /* @__PURE__ */ e.jsx(
      M,
      {
        intent: "body",
        size: "lg",
        weight: "light",
        className: "text-neutral-700",
        children: r("form.labels.notInUse")
      }
    ) })
  ] });
}, bx = ({
  usedLicensePlates: t,
  maxCount: n,
  description: r
}) => {
  const { t: s } = V("recognitions"), [a, o] = L(!1), i = K(
    () => new Array(n).fill(void 0).map((c, l) => t[l]),
    [t, n]
  );
  return /* @__PURE__ */ e.jsxs(vt.Root, { open: a, onOpenChange: o, children: [
    /* @__PURE__ */ e.jsx(vt.Trigger, { asChild: !0, children: /* @__PURE__ */ e.jsx(be, { intent: "text", className: "mt-4 sm:mt-2 md:mt-0", children: s("usageHistory.labels.readMore") }) }),
    /* @__PURE__ */ e.jsx(vt.Portal, { children: /* @__PURE__ */ e.jsx(vt.Overlay, { className: "fixed inset-0 flex bg-black/75 sm:items-center sm:justify-center", children: /* @__PURE__ */ e.jsx(
      vt.Content,
      {
        className: ct(
          "relative",
          "z-30",
          "sm:rounded-xl",
          "overflow-hidden"
        ),
        children: /* @__PURE__ */ e.jsxs("div", { className: "flex h-full flex-col bg-white sm:max-h-fit", children: [
          /* @__PURE__ */ e.jsxs("div", { className: "bg-primary-800 flex justify-between px-4 py-4", children: [
            /* @__PURE__ */ e.jsx(M, { intent: "headline", color: "white", size: "sm", children: s("usageHistory.title") }),
            /* @__PURE__ */ e.jsx(vt.Close, { asChild: !0, children: /* @__PURE__ */ e.jsx(
              be,
              {
                intent: "text",
                "aria-label": s("action.close"),
                startIcon: /* @__PURE__ */ e.jsx(or, { fontSize: "25px" }),
                color: "white",
                iconSize: "lg"
              }
            ) })
          ] }),
          /* @__PURE__ */ e.jsx("div", { className: "px-4 py-4", children: i.map((c, l) => /* @__PURE__ */ e.jsx(xx, { alpr: c, rowNumber: l + 1 }, l)) }),
          /* @__PURE__ */ e.jsx("div", { className: "px-5 pb-4", children: r })
        ] })
      }
    ) }) })
  ] });
}, vx = ({
  usedLicensePlates: t,
  usedCount: n,
  maxCount: r,
  nextPeriod: s,
  description: a,
  longDescription: o,
  isPeriodCard: i
}) => /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col justify-between sm:flex-row", children: [
  /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col", children: [
    /* @__PURE__ */ e.jsx(M, { children: /* @__PURE__ */ e.jsx(
      he,
      {
        i18nKey: i ? "periodCard.form.labels.usage" : "form.labels.usage",
        ns: "recognitions",
        values: { count: n, maxCount: r },
        children: /* @__PURE__ */ e.jsx(M, { intent: "title", size: "md", as: "span" })
      }
    ) }),
    a ? /* @__PURE__ */ e.jsx(M, { weight: "light", size: "sm", children: a }) : null
  ] }),
  /* @__PURE__ */ e.jsx("div", { className: "flex justify-end", children: /* @__PURE__ */ e.jsx(
    bx,
    {
      usedLicensePlates: t,
      nextPeriod: s,
      maxCount: r,
      description: o
    }
  ) })
] }), yx = Gt("flex gap-5 p-5", {
  variants: {
    intent: {
      primary: ["bg-primary-400", "text-white"],
      secondary: ["bg-white"]
    }
  },
  defaultVariants: {
    intent: "primary"
  }
}), jx = Gt("rounded-full p-2", {
  variants: {
    intent: {
      primary: ["bg-white", "text-primary-400"],
      secondary: ["bg-primary-400", "text-white"]
    }
  },
  defaultVariants: {
    intent: "primary"
  }
});
function Cx({
  onError: t,
  queryParam: n
}) {
  const r = Ye(), { t: s } = V(["recognitions", "common"], {
    nsMode: "fallback"
  });
  let a = Ba();
  const { query: o } = ve();
  if (n) {
    const y = o[n];
    y && (a = y);
  }
  const { data: i } = ur(), { recognitionChoices: c, contract: l } = Rc(), { mutateAsync: d, isLoading: u } = ke(
    ["recognitions", "swap"],
    ({ Recognition: y }) => y.swapRecognitions,
    {
      onMutate: () => {
        t(void 0);
      },
      onSuccess: () => r.invalidateQueries({
        queryKey: ["account", "recognitions"]
      }),
      onError: (y) => (y.error || "") === pe.SWAP_LIMIT_EXCEEDED ? t(s("errors.swapLimitExceeded")) : t(s("errors.generic"))
    }
  ), [m, f] = L(!1), { mutateAsync: p, isLoading: b } = ke(
    ["periodCard", "swap"],
    ({ PeriodCard: y }) => y.swap,
    {
      onMutate: () => {
        t(void 0);
      },
      onSuccess: (y) => {
        r.invalidateQueries({
          queryKey: ["account", "recognitions"]
        }), r.setQueryData(
          xe.PeriodCard({
            contractNo: a
          }),
          y
        );
      },
      onError: (y) => {
        const x = (y == null ? void 0 : y.code) === 400 && y.error === fr.blockCommercialVehicle;
        return f(x), x ? t(
          s("form.validations.periodCard.isCommercialVehicle")
        ) : (y.error || "") === pe.SWAP_LIMIT_EXCEEDED ? t(s("errors.swapLimitExceeded")) : t(s("errors.generic"));
      }
    }
  ), h = Q(() => l && l.contractNo.split("-")[0] || null, [l]), g = Q(
    async (y) => {
      if (!i)
        return d(y);
      const x = y.attach[0], j = c.find(
        (w) => w.contractLineNo === x
      );
      return j ? p({
        serialNo: j.serialNo,
        periodCardId: i.id,
        contractNo: i.contractNo
      }) : d(y);
    },
    [i, c, d, p]
  );
  return {
    swap: Q(
      async ({
        recognition1: y = "",
        recognition2: x = ""
      }) => {
        if (c.some(
          ({ id: P, isInvalid: N }) => (P === y || P === x) && N
        ))
          return t(s("errors.invalidRecognition")), Promise.resolve();
        const w = h();
        if (!w) return Promise.resolve();
        const C = [y, x].map(_f).filter(Boolean);
        await g({ contractNo: w, attach: C });
      },
      [c, g, t, s]
    ),
    isMutating: u || b,
    periodCard: i,
    attemptSwapToCommercialVehicle: m
  };
}
function xt(t, n) {
  if (n.length < t)
    throw new TypeError(t + " argument" + (t > 1 ? "s" : "") + " required, but only " + n.length + " present");
}
function Ar(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Ar = function(r) {
    return typeof r;
  } : Ar = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Ar(t);
}
function wx(t) {
  return xt(1, arguments), t instanceof Date || Ar(t) === "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function Or(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Or = function(r) {
    return typeof r;
  } : Or = function(r) {
    return r && typeof Symbol == "function" && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
  }, Or(t);
}
function Qt(t) {
  xt(1, arguments);
  var n = Object.prototype.toString.call(t);
  return t instanceof Date || Or(t) === "object" && n === "[object Date]" ? new Date(t.getTime()) : typeof t == "number" || n === "[object Number]" ? new Date(t) : ((typeof t == "string" || n === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function Nx(t) {
  if (xt(1, arguments), !wx(t) && typeof t != "number")
    return !1;
  var n = Qt(t);
  return !isNaN(Number(n));
}
function Cn(t) {
  if (t === null || t === !0 || t === !1)
    return NaN;
  var n = Number(t);
  return isNaN(n) ? n : n < 0 ? Math.ceil(n) : Math.floor(n);
}
function Px(t, n) {
  xt(2, arguments);
  var r = Qt(t).getTime(), s = Cn(n);
  return new Date(r + s);
}
function Sx(t, n) {
  xt(2, arguments);
  var r = Cn(n);
  return Px(t, -r);
}
var Tx = 864e5;
function Ex(t) {
  xt(1, arguments);
  var n = Qt(t), r = n.getTime();
  n.setUTCMonth(0, 1), n.setUTCHours(0, 0, 0, 0);
  var s = n.getTime(), a = r - s;
  return Math.floor(a / Tx) + 1;
}
function Ir(t) {
  xt(1, arguments);
  var n = 1, r = Qt(t), s = r.getUTCDay(), a = (s < n ? 7 : 0) + s - n;
  return r.setUTCDate(r.getUTCDate() - a), r.setUTCHours(0, 0, 0, 0), r;
}
function Mc(t) {
  xt(1, arguments);
  var n = Qt(t), r = n.getUTCFullYear(), s = /* @__PURE__ */ new Date(0);
  s.setUTCFullYear(r + 1, 0, 4), s.setUTCHours(0, 0, 0, 0);
  var a = Ir(s), o = /* @__PURE__ */ new Date(0);
  o.setUTCFullYear(r, 0, 4), o.setUTCHours(0, 0, 0, 0);
  var i = Ir(o);
  return n.getTime() >= a.getTime() ? r + 1 : n.getTime() >= i.getTime() ? r : r - 1;
}
function kx(t) {
  xt(1, arguments);
  var n = Mc(t), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var s = Ir(r);
  return s;
}
var Ax = 6048e5;
function Ox(t) {
  xt(1, arguments);
  var n = Qt(t), r = Ir(n).getTime() - kx(n).getTime();
  return Math.round(r / Ax) + 1;
}
var _x = {};
function us() {
  return _x;
}
function $r(t, n) {
  var r, s, a, o, i, c, l, d;
  xt(1, arguments);
  var u = us(), m = Cn((r = (s = (a = (o = n == null ? void 0 : n.weekStartsOn) !== null && o !== void 0 ? o : n == null || (i = n.locale) === null || i === void 0 || (c = i.options) === null || c === void 0 ? void 0 : c.weekStartsOn) !== null && a !== void 0 ? a : u.weekStartsOn) !== null && s !== void 0 ? s : (l = u.locale) === null || l === void 0 || (d = l.options) === null || d === void 0 ? void 0 : d.weekStartsOn) !== null && r !== void 0 ? r : 0);
  if (!(m >= 0 && m <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var f = Qt(t), p = f.getUTCDay(), b = (p < m ? 7 : 0) + p - m;
  return f.setUTCDate(f.getUTCDate() - b), f.setUTCHours(0, 0, 0, 0), f;
}
function zc(t, n) {
  var r, s, a, o, i, c, l, d;
  xt(1, arguments);
  var u = Qt(t), m = u.getUTCFullYear(), f = us(), p = Cn((r = (s = (a = (o = n == null ? void 0 : n.firstWeekContainsDate) !== null && o !== void 0 ? o : n == null || (i = n.locale) === null || i === void 0 || (c = i.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && a !== void 0 ? a : f.firstWeekContainsDate) !== null && s !== void 0 ? s : (l = f.locale) === null || l === void 0 || (d = l.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && r !== void 0 ? r : 1);
  if (!(p >= 1 && p <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var b = /* @__PURE__ */ new Date(0);
  b.setUTCFullYear(m + 1, 0, p), b.setUTCHours(0, 0, 0, 0);
  var h = $r(b, n), g = /* @__PURE__ */ new Date(0);
  g.setUTCFullYear(m, 0, p), g.setUTCHours(0, 0, 0, 0);
  var v = $r(g, n);
  return u.getTime() >= h.getTime() ? m + 1 : u.getTime() >= v.getTime() ? m : m - 1;
}
function Rx(t, n) {
  var r, s, a, o, i, c, l, d;
  xt(1, arguments);
  var u = us(), m = Cn((r = (s = (a = (o = n == null ? void 0 : n.firstWeekContainsDate) !== null && o !== void 0 ? o : n == null || (i = n.locale) === null || i === void 0 || (c = i.options) === null || c === void 0 ? void 0 : c.firstWeekContainsDate) !== null && a !== void 0 ? a : u.firstWeekContainsDate) !== null && s !== void 0 ? s : (l = u.locale) === null || l === void 0 || (d = l.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && r !== void 0 ? r : 1), f = zc(t, n), p = /* @__PURE__ */ new Date(0);
  p.setUTCFullYear(f, 0, m), p.setUTCHours(0, 0, 0, 0);
  var b = $r(p, n);
  return b;
}
var Mx = 6048e5;
function zx(t, n) {
  xt(1, arguments);
  var r = Qt(t), s = $r(r, n).getTime() - Rx(r, n).getTime();
  return Math.round(s / Mx) + 1;
}
function Be(t, n) {
  for (var r = t < 0 ? "-" : "", s = Math.abs(t).toString(); s.length < n; )
    s = "0" + s;
  return r + s;
}
var an = {
  // Year
  y: function(n, r) {
    var s = n.getUTCFullYear(), a = s > 0 ? s : 1 - s;
    return Be(r === "yy" ? a % 100 : a, r.length);
  },
  // Month
  M: function(n, r) {
    var s = n.getUTCMonth();
    return r === "M" ? String(s + 1) : Be(s + 1, 2);
  },
  // Day of the month
  d: function(n, r) {
    return Be(n.getUTCDate(), r.length);
  },
  // AM or PM
  a: function(n, r) {
    var s = n.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return s.toUpperCase();
      case "aaa":
        return s;
      case "aaaaa":
        return s[0];
      case "aaaa":
      default:
        return s === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(n, r) {
    return Be(n.getUTCHours() % 12 || 12, r.length);
  },
  // Hour [0-23]
  H: function(n, r) {
    return Be(n.getUTCHours(), r.length);
  },
  // Minute
  m: function(n, r) {
    return Be(n.getUTCMinutes(), r.length);
  },
  // Second
  s: function(n, r) {
    return Be(n.getUTCSeconds(), r.length);
  },
  // Fraction of second
  S: function(n, r) {
    var s = r.length, a = n.getUTCMilliseconds(), o = Math.floor(a * Math.pow(10, s - 3));
    return Be(o, r.length);
  }
}, _n = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Dx = {
  // Era
  G: function(n, r, s) {
    var a = n.getUTCFullYear() > 0 ? 1 : 0;
    switch (r) {
      case "G":
      case "GG":
      case "GGG":
        return s.era(a, {
          width: "abbreviated"
        });
      case "GGGGG":
        return s.era(a, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return s.era(a, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(n, r, s) {
    if (r === "yo") {
      var a = n.getUTCFullYear(), o = a > 0 ? a : 1 - a;
      return s.ordinalNumber(o, {
        unit: "year"
      });
    }
    return an.y(n, r);
  },
  // Local week-numbering year
  Y: function(n, r, s, a) {
    var o = zc(n, a), i = o > 0 ? o : 1 - o;
    if (r === "YY") {
      var c = i % 100;
      return Be(c, 2);
    }
    return r === "Yo" ? s.ordinalNumber(i, {
      unit: "year"
    }) : Be(i, r.length);
  },
  // ISO week-numbering year
  R: function(n, r) {
    var s = Mc(n);
    return Be(s, r.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(n, r) {
    var s = n.getUTCFullYear();
    return Be(s, r.length);
  },
  // Quarter
  Q: function(n, r, s) {
    var a = Math.ceil((n.getUTCMonth() + 1) / 3);
    switch (r) {
      case "Q":
        return String(a);
      case "QQ":
        return Be(a, 2);
      case "Qo":
        return s.ordinalNumber(a, {
          unit: "quarter"
        });
      case "QQQ":
        return s.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return s.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return s.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(n, r, s) {
    var a = Math.ceil((n.getUTCMonth() + 1) / 3);
    switch (r) {
      case "q":
        return String(a);
      case "qq":
        return Be(a, 2);
      case "qo":
        return s.ordinalNumber(a, {
          unit: "quarter"
        });
      case "qqq":
        return s.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return s.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return s.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(n, r, s) {
    var a = n.getUTCMonth();
    switch (r) {
      case "M":
      case "MM":
        return an.M(n, r);
      case "Mo":
        return s.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "MMM":
        return s.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return s.month(a, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return s.month(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(n, r, s) {
    var a = n.getUTCMonth();
    switch (r) {
      case "L":
        return String(a + 1);
      case "LL":
        return Be(a + 1, 2);
      case "Lo":
        return s.ordinalNumber(a + 1, {
          unit: "month"
        });
      case "LLL":
        return s.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return s.month(a, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return s.month(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(n, r, s, a) {
    var o = zx(n, a);
    return r === "wo" ? s.ordinalNumber(o, {
      unit: "week"
    }) : Be(o, r.length);
  },
  // ISO week of year
  I: function(n, r, s) {
    var a = Ox(n);
    return r === "Io" ? s.ordinalNumber(a, {
      unit: "week"
    }) : Be(a, r.length);
  },
  // Day of the month
  d: function(n, r, s) {
    return r === "do" ? s.ordinalNumber(n.getUTCDate(), {
      unit: "date"
    }) : an.d(n, r);
  },
  // Day of year
  D: function(n, r, s) {
    var a = Ex(n);
    return r === "Do" ? s.ordinalNumber(a, {
      unit: "dayOfYear"
    }) : Be(a, r.length);
  },
  // Day of week
  E: function(n, r, s) {
    var a = n.getUTCDay();
    switch (r) {
      case "E":
      case "EE":
      case "EEE":
        return s.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return s.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return s.day(a, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return s.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(n, r, s, a) {
    var o = n.getUTCDay(), i = (o - a.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "e":
        return String(i);
      case "ee":
        return Be(i, 2);
      case "eo":
        return s.ordinalNumber(i, {
          unit: "day"
        });
      case "eee":
        return s.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return s.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return s.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return s.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(n, r, s, a) {
    var o = n.getUTCDay(), i = (o - a.weekStartsOn + 8) % 7 || 7;
    switch (r) {
      case "c":
        return String(i);
      case "cc":
        return Be(i, r.length);
      case "co":
        return s.ordinalNumber(i, {
          unit: "day"
        });
      case "ccc":
        return s.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return s.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return s.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return s.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(n, r, s) {
    var a = n.getUTCDay(), o = a === 0 ? 7 : a;
    switch (r) {
      case "i":
        return String(o);
      case "ii":
        return Be(o, r.length);
      case "io":
        return s.ordinalNumber(o, {
          unit: "day"
        });
      case "iii":
        return s.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return s.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return s.day(a, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return s.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(n, r, s) {
    var a = n.getUTCHours(), o = a / 12 >= 1 ? "pm" : "am";
    switch (r) {
      case "a":
      case "aa":
        return s.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return s.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return s.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return s.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(n, r, s) {
    var a = n.getUTCHours(), o;
    switch (a === 12 ? o = _n.noon : a === 0 ? o = _n.midnight : o = a / 12 >= 1 ? "pm" : "am", r) {
      case "b":
      case "bb":
        return s.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return s.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return s.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return s.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(n, r, s) {
    var a = n.getUTCHours(), o;
    switch (a >= 17 ? o = _n.evening : a >= 12 ? o = _n.afternoon : a >= 4 ? o = _n.morning : o = _n.night, r) {
      case "B":
      case "BB":
      case "BBB":
        return s.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return s.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return s.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(n, r, s) {
    if (r === "ho") {
      var a = n.getUTCHours() % 12;
      return a === 0 && (a = 12), s.ordinalNumber(a, {
        unit: "hour"
      });
    }
    return an.h(n, r);
  },
  // Hour [0-23]
  H: function(n, r, s) {
    return r === "Ho" ? s.ordinalNumber(n.getUTCHours(), {
      unit: "hour"
    }) : an.H(n, r);
  },
  // Hour [0-11]
  K: function(n, r, s) {
    var a = n.getUTCHours() % 12;
    return r === "Ko" ? s.ordinalNumber(a, {
      unit: "hour"
    }) : Be(a, r.length);
  },
  // Hour [1-24]
  k: function(n, r, s) {
    var a = n.getUTCHours();
    return a === 0 && (a = 24), r === "ko" ? s.ordinalNumber(a, {
      unit: "hour"
    }) : Be(a, r.length);
  },
  // Minute
  m: function(n, r, s) {
    return r === "mo" ? s.ordinalNumber(n.getUTCMinutes(), {
      unit: "minute"
    }) : an.m(n, r);
  },
  // Second
  s: function(n, r, s) {
    return r === "so" ? s.ordinalNumber(n.getUTCSeconds(), {
      unit: "second"
    }) : an.s(n, r);
  },
  // Fraction of second
  S: function(n, r) {
    return an.S(n, r);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(n, r, s, a) {
    var o = a._originalDate || n, i = o.getTimezoneOffset();
    if (i === 0)
      return "Z";
    switch (r) {
      case "X":
        return qi(i);
      case "XXXX":
      case "XX":
        return gn(i);
      case "XXXXX":
      case "XXX":
      default:
        return gn(i, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(n, r, s, a) {
    var o = a._originalDate || n, i = o.getTimezoneOffset();
    switch (r) {
      case "x":
        return qi(i);
      case "xxxx":
      case "xx":
        return gn(i);
      case "xxxxx":
      case "xxx":
      default:
        return gn(i, ":");
    }
  },
  // Timezone (GMT)
  O: function(n, r, s, a) {
    var o = a._originalDate || n, i = o.getTimezoneOffset();
    switch (r) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Vi(i, ":");
      case "OOOO":
      default:
        return "GMT" + gn(i, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(n, r, s, a) {
    var o = a._originalDate || n, i = o.getTimezoneOffset();
    switch (r) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Vi(i, ":");
      case "zzzz":
      default:
        return "GMT" + gn(i, ":");
    }
  },
  // Seconds timestamp
  t: function(n, r, s, a) {
    var o = a._originalDate || n, i = Math.floor(o.getTime() / 1e3);
    return Be(i, r.length);
  },
  // Milliseconds timestamp
  T: function(n, r, s, a) {
    var o = a._originalDate || n, i = o.getTime();
    return Be(i, r.length);
  }
};
function Vi(t, n) {
  var r = t > 0 ? "-" : "+", s = Math.abs(t), a = Math.floor(s / 60), o = s % 60;
  if (o === 0)
    return r + String(a);
  var i = n;
  return r + String(a) + i + Be(o, 2);
}
function qi(t, n) {
  if (t % 60 === 0) {
    var r = t > 0 ? "-" : "+";
    return r + Be(Math.abs(t) / 60, 2);
  }
  return gn(t, n);
}
function gn(t, n) {
  var r = n || "", s = t > 0 ? "-" : "+", a = Math.abs(t), o = Be(Math.floor(a / 60), 2), i = Be(a % 60, 2);
  return s + o + r + i;
}
var Wi = function(n, r) {
  switch (n) {
    case "P":
      return r.date({
        width: "short"
      });
    case "PP":
      return r.date({
        width: "medium"
      });
    case "PPP":
      return r.date({
        width: "long"
      });
    case "PPPP":
    default:
      return r.date({
        width: "full"
      });
  }
}, Dc = function(n, r) {
  switch (n) {
    case "p":
      return r.time({
        width: "short"
      });
    case "pp":
      return r.time({
        width: "medium"
      });
    case "ppp":
      return r.time({
        width: "long"
      });
    case "pppp":
    default:
      return r.time({
        width: "full"
      });
  }
}, Lx = function(n, r) {
  var s = n.match(/(P+)(p+)?/) || [], a = s[1], o = s[2];
  if (!o)
    return Wi(n, r);
  var i;
  switch (a) {
    case "P":
      i = r.dateTime({
        width: "short"
      });
      break;
    case "PP":
      i = r.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      i = r.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      i = r.dateTime({
        width: "full"
      });
      break;
  }
  return i.replace("{{date}}", Wi(a, r)).replace("{{time}}", Dc(o, r));
}, Ix = {
  p: Dc,
  P: Lx
};
function $x(t) {
  var n = new Date(Date.UTC(t.getFullYear(), t.getMonth(), t.getDate(), t.getHours(), t.getMinutes(), t.getSeconds(), t.getMilliseconds()));
  return n.setUTCFullYear(t.getFullYear()), t.getTime() - n.getTime();
}
var Fx = ["D", "DD"], Bx = ["YY", "YYYY"];
function Vx(t) {
  return Fx.indexOf(t) !== -1;
}
function qx(t) {
  return Bx.indexOf(t) !== -1;
}
function Hi(t, n, r) {
  if (t === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(n, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(n, "`) for formatting years to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(n, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (t === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(n, "`) for formatting days of the month to the input `").concat(r, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var Wx = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Lc = function(n, r, s) {
  var a, o = Wx[n];
  return typeof o == "string" ? a = o : r === 1 ? a = o.one : a = o.other.replace("{{count}}", r.toString()), s != null && s.addSuffix ? s.comparison && s.comparison > 0 ? "in " + a : a + " ago" : a;
};
function ft(t) {
  return function() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, r = n.width ? String(n.width) : t.defaultWidth, s = t.formats[r] || t.formats[t.defaultWidth];
    return s;
  };
}
var Hx = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Ux = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Gx = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Kx = {
  date: ft({
    formats: Hx,
    defaultWidth: "full"
  }),
  time: ft({
    formats: Ux,
    defaultWidth: "full"
  }),
  dateTime: ft({
    formats: Gx,
    defaultWidth: "full"
  })
}, Yx = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Ic = function(n, r, s, a) {
  return Yx[n];
};
function Je(t) {
  return function(n, r) {
    var s = r != null && r.context ? String(r.context) : "standalone", a;
    if (s === "formatting" && t.formattingValues) {
      var o = t.defaultFormattingWidth || t.defaultWidth, i = r != null && r.width ? String(r.width) : o;
      a = t.formattingValues[i] || t.formattingValues[o];
    } else {
      var c = t.defaultWidth, l = r != null && r.width ? String(r.width) : t.defaultWidth;
      a = t.values[l] || t.values[c];
    }
    var d = t.argumentCallback ? t.argumentCallback(n) : n;
    return a[d];
  };
}
var Qx = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Xx = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Jx = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, Zx = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, eb = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, tb = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, nb = function(n, r) {
  var s = Number(n), a = s % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return s + "st";
      case 2:
        return s + "nd";
      case 3:
        return s + "rd";
    }
  return s + "th";
}, $c = {
  ordinalNumber: nb,
  era: Je({
    values: Qx,
    defaultWidth: "wide"
  }),
  quarter: Je({
    values: Xx,
    defaultWidth: "wide",
    argumentCallback: function(n) {
      return n - 1;
    }
  }),
  month: Je({
    values: Jx,
    defaultWidth: "wide"
  }),
  day: Je({
    values: Zx,
    defaultWidth: "wide"
  }),
  dayPeriod: Je({
    values: eb,
    defaultWidth: "wide",
    formattingValues: tb,
    defaultFormattingWidth: "wide"
  })
};
function Ze(t) {
  return function(n) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = r.width, a = s && t.matchPatterns[s] || t.matchPatterns[t.defaultMatchWidth], o = n.match(a);
    if (!o)
      return null;
    var i = o[0], c = s && t.parsePatterns[s] || t.parsePatterns[t.defaultParseWidth], l = Array.isArray(c) ? sb(c, function(m) {
      return m.test(i);
    }) : rb(c, function(m) {
      return m.test(i);
    }), d;
    d = t.valueCallback ? t.valueCallback(l) : l, d = r.valueCallback ? r.valueCallback(d) : d;
    var u = n.slice(i.length);
    return {
      value: d,
      rest: u
    };
  };
}
function rb(t, n) {
  for (var r in t)
    if (t.hasOwnProperty(r) && n(t[r]))
      return r;
}
function sb(t, n) {
  for (var r = 0; r < t.length; r++)
    if (n(t[r]))
      return r;
}
function ms(t) {
  return function(n) {
    var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = n.match(t.matchPattern);
    if (!s) return null;
    var a = s[0], o = n.match(t.parsePattern);
    if (!o) return null;
    var i = t.valueCallback ? t.valueCallback(o[0]) : o[0];
    i = r.valueCallback ? r.valueCallback(i) : i;
    var c = n.slice(a.length);
    return {
      value: i,
      rest: c
    };
  };
}
var ab = /^(\d+)(th|st|nd|rd)?/i, ob = /\d+/i, ib = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, lb = {
  any: [/^b/i, /^(a|c)/i]
}, cb = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, db = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ub = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, mb = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, fb = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, pb = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, hb = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, gb = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Fc = {
  ordinalNumber: ms({
    matchPattern: ab,
    parsePattern: ob,
    valueCallback: function(n) {
      return parseInt(n, 10);
    }
  }),
  era: Ze({
    matchPatterns: ib,
    defaultMatchWidth: "wide",
    parsePatterns: lb,
    defaultParseWidth: "any"
  }),
  quarter: Ze({
    matchPatterns: cb,
    defaultMatchWidth: "wide",
    parsePatterns: db,
    defaultParseWidth: "any",
    valueCallback: function(n) {
      return n + 1;
    }
  }),
  month: Ze({
    matchPatterns: ub,
    defaultMatchWidth: "wide",
    parsePatterns: mb,
    defaultParseWidth: "any"
  }),
  day: Ze({
    matchPatterns: fb,
    defaultMatchWidth: "wide",
    parsePatterns: pb,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ze({
    matchPatterns: hb,
    defaultMatchWidth: "any",
    parsePatterns: gb,
    defaultParseWidth: "any"
  })
}, xb = {
  code: "en-US",
  formatDistance: Lc,
  formatLong: Kx,
  formatRelative: Ic,
  localize: $c,
  match: Fc,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, bb = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, vb = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, yb = /^'([^]*?)'?$/, jb = /''/g, Cb = /[a-zA-Z]/;
function wb(t, n, r) {
  var s, a, o, i, c, l, d, u, m, f, p, b, h, g;
  xt(2, arguments);
  var v = String(n), y = us(), x = (s = (a = void 0) !== null && a !== void 0 ? a : y.locale) !== null && s !== void 0 ? s : xb, j = Cn((o = (i = (c = (l = void 0) !== null && l !== void 0 ? l : void 0) !== null && c !== void 0 ? c : y.firstWeekContainsDate) !== null && i !== void 0 ? i : (d = y.locale) === null || d === void 0 || (u = d.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(j >= 1 && j <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var w = Cn((m = (f = (p = (b = void 0) !== null && b !== void 0 ? b : void 0) !== null && p !== void 0 ? p : y.weekStartsOn) !== null && f !== void 0 ? f : (h = y.locale) === null || h === void 0 || (g = h.options) === null || g === void 0 ? void 0 : g.weekStartsOn) !== null && m !== void 0 ? m : 0);
  if (!(w >= 0 && w <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!x.localize)
    throw new RangeError("locale must contain localize property");
  if (!x.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var C = Qt(t);
  if (!Nx(C))
    throw new RangeError("Invalid time value");
  var P = $x(C), N = Sx(C, P), R = {
    firstWeekContainsDate: j,
    weekStartsOn: w,
    locale: x,
    _originalDate: C
  }, T = v.match(vb).map(function(z) {
    var D = z[0];
    if (D === "p" || D === "P") {
      var A = Ix[D];
      return A(z, x.formatLong);
    }
    return z;
  }).join("").match(bb).map(function(z) {
    if (z === "''")
      return "'";
    var D = z[0];
    if (D === "'")
      return Nb(z);
    var A = Dx[D];
    if (A)
      return qx(z) && Hi(z, n, String(t)), Vx(z) && Hi(z, n, String(t)), A(N, z, x.localize, R);
    if (D.match(Cb))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + D + "`");
    return z;
  }).join("");
  return T;
}
function Nb(t) {
  var n = t.match(yb);
  return n ? n[1].replace(jb, "'") : t;
}
const Pb = ({
  namespace: t,
  defaultValues: n,
  recognitions: r,
  isPendler: s,
  onValidate: a,
  onSubmit: o,
  className: i,
  isLoading: c,
  maxNoOfConnections: l,
  hasPeriodCard: d,
  usedRecognitions: u,
  onInfo: m
}) => {
  const { t: f } = V(["recognitions", "common"], {
    nsMode: "fallback"
  }), {
    registerField: p,
    getError: b,
    setFieldData: h,
    validate: g,
    handleSubmit: v,
    isValid: y,
    setPartialData: x,
    isDirty: j
  } = Se({
    namespace: t,
    defaultValues: n,
    onValidate: a,
    onSubmit: o
  }), [w, C] = L(n), [P, N] = He(
    t,
    "recognition1",
    "recognition2"
  ), R = () => C({
    recognition1: P,
    recognition2: N
  }), T = K(
    () => !P || P === (w == null ? void 0 : w.recognition1),
    [P, w == null ? void 0 : w.recognition1]
  ), z = K(
    () => !N || N === (w == null ? void 0 : w.recognition2),
    [N, w == null ? void 0 : w.recognition2]
  );
  Y(() => {
    (n == null ? void 0 : n.recognition1) !== P && (h(
      "recognition1",
      (n == null ? void 0 : n.recognition1) || "",
      "select",
      !1
    ), C((W) => ({
      ...W,
      recognition1: (n == null ? void 0 : n.recognition1) || ""
    }))), (n == null ? void 0 : n.recognition2) !== N && (h(
      "recognition2",
      (n == null ? void 0 : n.recognition2) || "",
      "select",
      !1
    ), C((W) => ({
      ...W,
      recognition2: (n == null ? void 0 : n.recognition2) || ""
    })));
  }, [n == null ? void 0 : n.recognition1, n == null ? void 0 : n.recognition2]);
  const D = K(
    () => (W) => String(W).trim() !== "" && !u.some((G) => G.value === W),
    [u]
  ), A = K(
    () => !s && l && (D(N) || D(P)),
    [
      P,
      N,
      s,
      D,
      l
    ]
  ), S = K(
    () => s ? !y || T || c : !y || A || T && z || c,
    [
      T,
      z,
      s,
      A,
      y,
      c
    ]
  ), _ = K(
    () => s && l,
    [l, s]
  );
  Y(() => {
    m(
      A || _ ? f(
        d ? "periodCard.errors.swapLimitExceeded" : "errors.swapLimitExceeded"
      ) : void 0
    );
  }, [A, _, m, f, d]);
  const $ = Q(
    (W) => {
      (w == null ? void 0 : w.recognition1) === N && (w == null ? void 0 : w.recognition2) === P ? h(W, (w == null ? void 0 : w[W]) ?? "", "select") : x(
        w
      );
    },
    [w, N, P, h, x]
  ), { label: q, placeholder: U } = K(() => d ? {
    label: f("periodCard.paymentOption.label"),
    placeholder: f("periodCard.paymentOption.placeholder")
  } : s ? {
    label: f("commuter.paymentOption.label"),
    placeholder: f("commuter.paymentOption.placeholder")
  } : {
    label: f("paymentOption.label", { amount: 1 }),
    placeholder: f("paymentOption.placeholder", { amount: 1 })
  }, [d, s, f]);
  return /* @__PURE__ */ e.jsxs(
    ht,
    {
      as: "form",
      onSubmit: (W) => {
        Kt(g, v)(W), R();
      },
      className: i,
      children: [
        /* @__PURE__ */ e.jsx("div", { className: "col-span-full md:col-span-6", children: d ? /* @__PURE__ */ e.jsx(
          Oe,
          {
            label: q,
            error: b("recognition1"),
            placeholder: U,
            disabled: l,
            options: r.filter(({ value: W }) => W !== N),
            ...p("recognition1")
          }
        ) : /* @__PURE__ */ e.jsx(
          Oe,
          {
            label: q,
            error: b("recognition1"),
            placeholder: U,
            options: r,
            ...p("recognition1")
          }
        ) }),
        /* @__PURE__ */ e.jsx("div", { className: "col-span-full md:col-span-6 md:flex md:items-end", children: /* @__PURE__ */ e.jsx(
          be,
          {
            intent: "text",
            onClick: () => $("recognition1"),
            startIcon: /* @__PURE__ */ e.jsx(bo, {}),
            iconSize: "lg",
            disabled: T,
            children: f("action.reset")
          }
        ) }),
        s ? null : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx("div", { className: "col-span-full md:col-span-6", children: /* @__PURE__ */ e.jsx(
            Oe,
            {
              label: f("paymentOption.label", { amount: 2 }),
              placeholder: f("paymentOption.placeholder", { amount: 2 }),
              error: b("recognition2"),
              options: r,
              ...p("recognition2")
            }
          ) }),
          /* @__PURE__ */ e.jsx("div", { className: "col-span-full md:col-span-6 md:flex md:items-end", children: /* @__PURE__ */ e.jsx(
            be,
            {
              intent: "text",
              onClick: () => $("recognition2"),
              startIcon: /* @__PURE__ */ e.jsx(bo, {}),
              iconSize: "lg",
              disabled: z,
              children: f("action.reset")
            }
          ) })
        ] }),
        /* @__PURE__ */ e.jsx("div", { className: "col-span-full flex justify-end", children: /* @__PURE__ */ e.jsx(
          et,
          {
            type: "submit",
            disabled: S || !j,
            loadingLabel: f("action.loading"),
            isLoading: c,
            children: f("action.save")
          }
        ) })
      ]
    }
  );
}, Sb = ({
  contract: t,
  isPendler: n,
  className: r,
  intent: s = "primary",
  onError: a,
  onInfo: o
}) => {
  var w, C;
  const { t: i } = V(["recognitions", "common"], {
    nsMode: "fallback"
  }), { swap: c, isMutating: l, periodCard: d } = Cx({
    onError: a,
    queryParam: "contract"
  }), {
    activeRecognitions: u,
    recognitionChoices: m,
    loading: f,
    contract: p
  } = Rc(), b = K(() => {
    if (p)
      return p.contractNo.split("-")[0];
  }, [p]), { data: h, isLoading: g } = De(
    xe.RecognitionsUsageHistory(b),
    ({ Recognitions: P }) => P.usageHistory(b),
    { enabled: !!b }
  ), v = b ? g : !1, y = K(
    () => ((h == null ? void 0 : h.usedLicensePlates.length) ?? 0) >= ((h == null ? void 0 : h.maxNoOfChanges) ?? 5),
    [h == null ? void 0 : h.usedLicensePlates, h == null ? void 0 : h.maxNoOfChanges]
  ), x = K(
    () => Rf(m, (h == null ? void 0 : h.usedLicensePlates) ?? []),
    [m, h == null ? void 0 : h.usedLicensePlates]
  );
  return K(
    () => f || v,
    [f, v]
  ) ? /* @__PURE__ */ e.jsx("div", { className: "flex items-center justify-center p-5", children: /* @__PURE__ */ e.jsx(Ur, { label: i("action.loading") }) }) : /* @__PURE__ */ e.jsxs("div", { className: r, children: [
    /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: yx({
          intent: s
        }),
        children: [
          /* @__PURE__ */ e.jsx(
            "div",
            {
              className: jx({
                intent: s
              }),
              children: /* @__PURE__ */ e.jsx(sl, { fontSize: "35px" })
            }
          ),
          /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col justify-center", children: [
            s === "primary" ? /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
              at,
              {
                contract: d ? Wt.OresundPeriodCard : t
              }
            ) }) : null,
            /* @__PURE__ */ e.jsx(M, { intent: "title", size: "md", children: i("form.labels.activeRecognitions", {
              count: n ? 1 : 2
            }) })
          ] })
        ]
      }
    ),
    /* @__PURE__ */ e.jsxs("div", { className: "border-b-[1px] border-b-neutral-300 bg-white px-6 pb-4 pt-6", children: [
      !d && t === Wt.OresundPendler ? /* @__PURE__ */ e.jsxs(
        Le,
        {
          color: "inform",
          className: "mb-4 flex items-center justify-between",
          children: [
            /* @__PURE__ */ e.jsx(M, { size: "md", children: /* @__PURE__ */ e.jsx(he, { ns: "account", i18nKey: "agreement.periodCard.upgrade", children: /* @__PURE__ */ e.jsx(M, { as: "span", size: "md", weight: "bold" }) }) }),
            /* @__PURE__ */ e.jsx(
              mc,
              {
                buttonProps: { intent: "text", color: "primary" }
              }
            )
          ]
        }
      ) : null,
      /* @__PURE__ */ e.jsx(
        Pb,
        {
          namespace: "activeRecognitions",
          defaultValues: {
            recognition1: ((w = u[0]) == null ? void 0 : w.id) ?? "",
            recognition2: d || t === Wt.OresundPendler ? "" : ((C = u[1]) == null ? void 0 : C.id) ?? ""
          },
          recognitions: m.map(({ id: P, label: N }) => ({
            value: P,
            label: N
          })),
          usedRecognitions: x,
          onValidate: ({ recognition1: P }) => {
            if (!P)
              return {
                recognition1: i("form.validations.recognition.required")
              };
          },
          onSubmit: c,
          isPendler: n,
          isLoading: l,
          maxNoOfConnections: y,
          onInfo: o,
          hasPeriodCard: !!d
        }
      )
    ] }),
    /* @__PURE__ */ e.jsx("div", { className: "border-b-[1px] border-b-black bg-white px-6 py-4", children: /* @__PURE__ */ e.jsx(
      vx,
      {
        isPeriodCard: !!d,
        usedCount: (h == null ? void 0 : h.usedLicensePlates.length) ?? 0,
        maxCount: (h == null ? void 0 : h.maxNoOfChanges) ?? 5,
        usedLicensePlates: (h == null ? void 0 : h.usedLicensePlates) ?? [],
        nextPeriod: (h == null ? void 0 : h.nextPeriod) ?? "",
        description: d && d.endDateTime ? i("periodCard.usageHistory.description.short", {
          nextPeriod: wb(
            new Date(d.endDateTime),
            "yyyy-MM-dd"
          )
        }) : i("usageHistory.description.short"),
        longDescription: d ? /* @__PURE__ */ e.jsxs(
          he,
          {
            ns: "recognitions",
            i18nKey: "usageHistory.description.long",
            values: { resetDate: (h == null ? void 0 : h.nextPeriod) ?? "" },
            children: [
              /* @__PURE__ */ e.jsx(M, { intent: "label", weight: "light", gutter: !0 }),
              /* @__PURE__ */ e.jsx(M, { intent: "label", weight: "light", gutter: !0 })
            ]
          }
        ) : /* @__PURE__ */ e.jsxs(
          he,
          {
            ns: "recognitions",
            i18nKey: "periodCard.usageHistory.description.long",
            children: [
              /* @__PURE__ */ e.jsx(M, { intent: "label", weight: "light", gutter: !0 }),
              /* @__PURE__ */ e.jsx(M, { intent: "label", weight: "light", gutter: !0 })
            ]
          }
        )
      }
    ) })
  ] });
}, Tb = ({ data: t, labels: n }) => /* @__PURE__ */ e.jsxs(nn, { template: "two-column", children: [
  /* @__PURE__ */ e.jsx(yt, { children: /* @__PURE__ */ e.jsx(xn, { label: n.email, children: t.email }) }),
  /* @__PURE__ */ e.jsx(yt, { odd: !0, children: /* @__PURE__ */ e.jsx(xn, { label: n.contractNo, children: t.contractNo }) }),
  /* @__PURE__ */ e.jsx(yt, { children: /* @__PURE__ */ e.jsx(xn, { label: n.startDate, children: t.startDate }) }),
  /* @__PURE__ */ e.jsx(yt, { odd: !0, children: /* @__PURE__ */ e.jsx(xn, { label: n.nextPeriod, children: t.nextPeriod ?? "-" }) })
] }), Eb = ({
  onClose: t
}) => {
  const [n, r] = L(!1), { t: s } = V(["account", "common"], { nsMode: "fallback" }), a = (f) => {
    if (!((f == null ? void 0 : f.code) === 400))
      return r(!0);
  }, { mutateAsync: o, isLoading: i } = ke(
    ["changePasswordV2"],
    ({ Customer: f }) => f.changePasswordV2,
    {
      onError: (f) => a(f),
      onSuccess: t
    }
  ), {
    registerField: c,
    getError: l,
    handleSubmit: d,
    validate: u,
    resetData: m
  } = Se({
    namespace: "changePassword",
    onSubmit: (f) => o(f),
    onValidate: Hn(al.spa, s)
  });
  return Y(
    () => () => {
      r(!1), m();
    },
    []
  ), /* @__PURE__ */ e.jsx(
    Bt,
    {
      title: s("customerInformation.contactInformation.modal.title"),
      open: !0,
      onOpenChange: t,
      children: /* @__PURE__ */ e.jsx(
        "form",
        {
          onSubmit: Kt(u, d),
          onReset: t,
          children: /* @__PURE__ */ e.jsxs(ht, { className: "mb-4 gap-4", children: [
            n && /* @__PURE__ */ e.jsx(Le, { color: "negative", className: "col-span-full", children: s("errors.changePassword") }),
            /* @__PURE__ */ e.jsx(
              me,
              {
                ...c("oldPassword", {
                  type: "password",
                  required: !0
                }),
                label: s("form.labels.currentPassword"),
                error: l("oldPassword"),
                className: "col-span-full sm:col-span-4 md:col-span-6"
              }
            ),
            /* @__PURE__ */ e.jsx(
              me,
              {
                ...c("password", {
                  type: "password",
                  required: !0
                }),
                label: s("form.labels.newPassword"),
                error: l("password"),
                className: "col-span-full row-start-2 sm:col-span-4 md:col-span-6"
              }
            ),
            /* @__PURE__ */ e.jsx(
              me,
              {
                ...c("confirmPassword", {
                  type: "password",
                  required: !0
                }),
                label: s("form.labels.repeatPassword"),
                error: l("confirmPassword"),
                className: "col-span-full row-start-2 sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7"
              }
            ),
            /* @__PURE__ */ e.jsx("div", { className: "col-span-full my-2", children: /* @__PURE__ */ e.jsxs(Le, { color: "inform", children: [
              /* @__PURE__ */ e.jsx(M, { size: "sm", children: s(
                "customerInformation.accountInformation.changePassword.modal.passwordRequirements.title"
              ) }),
              /* @__PURE__ */ e.jsx("ul", { className: "pl-5", children: /* @__PURE__ */ e.jsxs(
                he,
                {
                  i18nKey: "customerInformation.accountInformation.changePassword.modal.passwordRequirements.content",
                  ns: "account",
                  children: [
                    /* @__PURE__ */ e.jsx(M, { size: "sm", as: "li" }),
                    /* @__PURE__ */ e.jsx(M, { size: "sm", as: "li" }),
                    /* @__PURE__ */ e.jsx(M, { size: "sm", as: "li" }),
                    /* @__PURE__ */ e.jsx(M, { size: "sm", as: "li" })
                  ]
                }
              ) })
            ] }) }),
            /* @__PURE__ */ e.jsxs("div", { className: "col-span-full flex justify-self-end", children: [
              /* @__PURE__ */ e.jsx(be, { intent: "text", type: "reset", children: s("action.cancel") }),
              /* @__PURE__ */ e.jsx(
                et,
                {
                  intent: "solid",
                  type: "submit",
                  isLoading: i,
                  loadingLabel: s("action.loading"),
                  children: s("action.save")
                }
              )
            ] })
          ] })
        }
      )
    }
  );
}, kb = () => {
  const {
    query: { contract: t },
    replace: n
  } = ve(), r = Ye(), { t: s } = V(["recognitions", "common"], {
    nsMode: "fallback"
  }), [a, o] = L(!1), [i, c] = L(!1), { customerInformation: l } = tt(), { data: d } = ur(), { data: u } = Ac(t), m = K(
    () => (u == null ? void 0 : u.paymentAgreement.firstName) || (l == null ? void 0 : l.firstName),
    [u == null ? void 0 : u.paymentAgreement.firstName, l == null ? void 0 : l.firstName]
  ), f = K(
    () => (u == null ? void 0 : u.paymentAgreement.lastName) || (l == null ? void 0 : l.lastName),
    [u == null ? void 0 : u.paymentAgreement.lastName, l == null ? void 0 : l.lastName]
  ), p = Q(() => (r.resetQueries({
    queryKey: xe.BusinessCommutersList
  }), n("/account/business/commuters")), [r, n]);
  return !u || !l ? null : /* @__PURE__ */ e.jsxs("div", { className: "py-5", children: [
    /* @__PURE__ */ e.jsx(de, { variant: "h1", children: `${m} ${f}` }),
    /* @__PURE__ */ e.jsx(
      Tb,
      {
        data: {
          contractNo: u.paymentAgreement.contractNo,
          email: u.paymentAgreement.commuterEmail,
          nextPeriod: u.paymentAgreement.nextPeriod,
          startDate: u.paymentAgreement.startDate
        },
        labels: {
          contractNo: s("form.labels.contractNo"),
          email: s("form.labels.email"),
          nextPeriod: s("form.labels.nextPeriodDate"),
          startDate: s("form.labels.startDate")
        }
      }
    ),
    (l == null ? void 0 : l.customerType) === "business" ? /* @__PURE__ */ e.jsx(
      be,
      {
        as: "button",
        intent: "outlined",
        color: "negative",
        className: "mt-4 hover:bg-red-600 hover:text-white",
        onClick: () => c(!0),
        children: s("action.cancelContract")
      }
    ) : /* @__PURE__ */ e.jsx(
      be,
      {
        as: "button",
        className: "mt-4",
        onClick: () => o(!0),
        children: s("action.changePassword")
      }
    ),
    /* @__PURE__ */ e.jsx(zt, { children: a ? /* @__PURE__ */ e.jsx(
      Eb,
      {
        onClose: () => o(!1)
      }
    ) : null }),
    i ? /* @__PURE__ */ e.jsx(
      ic,
      {
        contract: {
          ...u.paymentAgreement,
          agreementType: pe.OresundBusinessPendler
        },
        periodCard: d,
        onSuccess: p,
        customerType: In.businessCommuter,
        onClose: () => c(!1)
      }
    ) : null
  ] });
}, Ab = ({
  contractNo: t
}) => {
  const { t: n } = V(["recognitions", "account", "common"], {
    nsMode: "fallback"
  }), [r, s] = L(), [a, o] = L(), { data: i } = bt(!0, t), { data: c } = Ra(t), { discountAgreement: l, contractTypeTranslationKey: d } = Bf(t), { customerInformation: u } = tt(), m = K(
    () => (u == null ? void 0 : u.customerType) === In.businessCustomer,
    []
  );
  if (!i || !l) return null;
  const f = [
    pe.OresundBusinessPendler,
    pe.OresundPendler
  ].includes(l == null ? void 0 : l.agreementType);
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsxs(zt, { children: [
    /* @__PURE__ */ e.jsx(kb, {}),
    /* @__PURE__ */ e.jsxs("div", { className: "rounded-[15px] bg-neutral-100 px-4 py-6 sm:rounded-[23px] sm:px-8 md:rounded-[30px]", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "mb-4", children: [
        /* @__PURE__ */ e.jsx(M, { as: "h3", intent: "title", weight: "medium", className: "mb-2", children: `${n("discountAgreement.title")} - ${i.paymentAgreement.contractNo}` }),
        /* @__PURE__ */ e.jsx(M, { weight: "light", className: "mb-2", children: n("discountAgreement.description") })
      ] }),
      /* @__PURE__ */ e.jsx(
        sr,
        {
          preTitle: n("agreement.label.discountAgreement"),
          description: n(
            `agreementTypes.${l.agreementType}.description`
          ),
          title: /* @__PURE__ */ e.jsx(at, { contract: d }),
          actionBanner: m ? gc(c) : void 0,
          children: /* @__PURE__ */ e.jsx(
            ya,
            {
              contract: {
                ...i.paymentAgreement,
                contractType: "discount"
              },
              periodCard: c,
              actionsDisabled: !0,
              hideBillingInfo: !0
            }
          )
        }
      ),
      a ? /* @__PURE__ */ e.jsx(Le, { color: "inform", className: "mt-4", children: a }) : null,
      r ? /* @__PURE__ */ e.jsx(Le, { color: "negative", className: "mb-4", children: r }) : null,
      /* @__PURE__ */ e.jsx(
        Sb,
        {
          contract: d,
          className: "mt-4",
          intent: "secondary",
          onError: s,
          onInfo: o,
          isPendler: f
        }
      )
    ] })
  ] }) });
}, Ob = ({
  recognition: t,
  onMoreLocations: n,
  labels: r
}) => {
  const s = (o) => n({ replaceRecognition: t, isMoreLocations: o });
  n(void 0);
  const { locale: a } = ve();
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(Yt, { children: /* @__PURE__ */ e.jsx(
      Ut,
      {
        fallback: /* @__PURE__ */ e.jsx("div", { className: "flex", children: /* @__PURE__ */ e.jsx("div", { className: "w-9", children: /* @__PURE__ */ e.jsx(Tt, { "aria-label": r.loading }) }) }),
        children: /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(M, { as: "h4", children: r.title }) })
      }
    ) }),
    /* @__PURE__ */ e.jsx(
      It,
      {
        activeCancel: !0,
        onClose: () => {
          s(!1), xi("no", a);
        },
        cancelLabel: r.noButton,
        actionLabel: r.yesButton,
        action: () => {
          s(!0), xi("yes", a);
        }
      }
    )
  ] });
}, _b = ({ onIsSelectReading: t, isLoadingData: n, labels: r }) => {
  const { locale: s } = ve();
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(Yt, { children: /* @__PURE__ */ e.jsx(
      Ut,
      {
        fallback: /* @__PURE__ */ e.jsx("div", { className: "flex", children: /* @__PURE__ */ e.jsx("div", { className: "w-9", children: /* @__PURE__ */ e.jsx(Tt, { "aria-label": r.loading }) }) }),
        children: /* @__PURE__ */ e.jsxs("div", { children: [
          /* @__PURE__ */ e.jsx(M, { as: "h3", intent: "title", children: r.title }),
          /* @__PURE__ */ e.jsx(M, { className: "mt-5", children: r.descriptionMain }),
          /* @__PURE__ */ e.jsxs(Le, { className: "mt-4", children: [
            /* @__PURE__ */ e.jsx(
              M,
              {
                as: "h4",
                weight: "semibold",
                className: "text-primary-900",
                children: r.description
              }
            ),
            /* @__PURE__ */ e.jsx("ul", { className: "marker:text-primary-400 mt-2 list-disc pl-6", children: r.benefitsList })
          ] }),
          /* @__PURE__ */ e.jsx("div", { className: "pt-2", children: r.descriptionBottom })
        ] })
      }
    ) }),
    /* @__PURE__ */ e.jsx(
      It,
      {
        onClose: () => {
          t(!1), bi("bizz", s);
        },
        cancelLabel: r.btnKeepBusiness,
        actionLabel: r.btnSelRegNumReading,
        action: () => {
          t(!0), bi("numberplate", s);
        },
        loadingButton: !0,
        loadingLabel: r.loading,
        isLoading: n
      }
    )
  ] });
}, Rb = ({
  customerInformation: t,
  onOrderBiz: n,
  isLoadingData: r,
  labels: s,
  onError: a,
  asfinagInput: o
}) => {
  const [i, c] = L(), l = "addressdata", { address: d, zipCode: u, city: m } = t, { mutateAsync: f, isLoading: p } = ke(
    ["account", "address"],
    (P) => P.Customer.updateCustomerAddress,
    {
      onSuccess: () => c(!1),
      onError: () => a(!0)
    }
  ), b = (P) => {
    f(P);
  }, { registerField: h, getError: g, validate: v, handleSubmit: y } = Se({
    namespace: l,
    defaultValues: { address: d, zipCode: u, city: m },
    onSubmit: b
  }), [x, j, w] = He(
    l,
    "address",
    "zipCode",
    "city"
  );
  Y(() => a(!1), [i, a]);
  const { locale: C } = ve();
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(Yt, { children: /* @__PURE__ */ e.jsx(
      Ut,
      {
        fallback: /* @__PURE__ */ e.jsx("div", { className: "flex", children: /* @__PURE__ */ e.jsx("div", { className: "w-9", children: /* @__PURE__ */ e.jsx(Tt, { "aria-label": s.loading }) }) }),
        children: /* @__PURE__ */ e.jsxs(ht, { children: [
          /* @__PURE__ */ e.jsx(
            M,
            {
              as: "h3",
              intent: "title",
              className: "col-span-full sm:col-span-12 md:col-span-12",
              children: s.title
            }
          ),
          i ? /* @__PURE__ */ e.jsxs(
            Yr,
            {
              onSubmit: Kt(v, y),
              className: "col-span-full grid",
              children: [
                /* @__PURE__ */ e.jsx(
                  me,
                  {
                    className: "col-span-full mb-10 sm:col-span-12 md:col-span-12",
                    ...h("address"),
                    label: s.address,
                    error: g("address"),
                    required: !0
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  me,
                  {
                    className: "col-span-full mb-10 sm:col-span-6 md:col-span-6",
                    ...h("zipCode"),
                    label: s.zipCode,
                    error: g("zipCode"),
                    required: !0
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  me,
                  {
                    className: "col-span-full mb-10 sm:col-span-5 md:col-span-5 md:col-start-8",
                    ...h("city"),
                    label: s.city,
                    error: g("city"),
                    required: !0
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  et,
                  {
                    intent: "text",
                    type: "submit",
                    loadingLabel: s.loading,
                    isLoading: p,
                    children: s.btnRegSave
                  }
                )
              ]
            }
          ) : /* @__PURE__ */ e.jsxs("div", { className: "col-span-full grid", children: [
            /* @__PURE__ */ e.jsx(xs, { className: "col-span-full sm:col-span-12 md:col-span-12", children: x }),
            /* @__PURE__ */ e.jsx(xs, { className: "col-span-full sm:col-span-12 md:col-span-12", children: j }),
            /* @__PURE__ */ e.jsx(xs, { className: "col-span-full sm:col-span-12 md:col-span-12", children: w })
          ] }),
          /* @__PURE__ */ e.jsx("div", { className: "col-span-full sm:col-span-12 md:col-span-12", children: !i && /* @__PURE__ */ e.jsx(
            be,
            {
              onClick: () => c(!i),
              intent: "text",
              children: s.btnReg
            }
          ) }),
          o && /* @__PURE__ */ e.jsx("div", { className: "col-span-full sm:col-span-12 md:col-span-12", children: o })
        ] })
      }
    ) }),
    /* @__PURE__ */ e.jsx(
      It,
      {
        actionLabel: s.btnNewBizz,
        action: () => {
          n(), $f(C);
        },
        loadingButton: !0,
        loadingLabel: s.loading,
        isLoading: r,
        disabled: i
      }
    )
  ] });
}, Ui = ({
  onClear: t,
  labels: n
}) => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
  /* @__PURE__ */ e.jsx(Yt, { children: /* @__PURE__ */ e.jsx(
    Ut,
    {
      fallback: /* @__PURE__ */ e.jsx("div", { className: "flex", children: /* @__PURE__ */ e.jsx("div", { className: "w-9", children: /* @__PURE__ */ e.jsx(Tt, { "aria-label": n.loading }) }) }),
      children: /* @__PURE__ */ e.jsxs("div", { className: "col-span-full flex w-0 min-w-full items-start", children: [
        /* @__PURE__ */ e.jsx("div", { className: "inline-block rounded-full bg-green-500 p-8 text-4xl text-neutral-100", children: /* @__PURE__ */ e.jsx(ir, {}) }),
        /* @__PURE__ */ e.jsxs("div", { className: "pl-5", children: [
          /* @__PURE__ */ e.jsx(M, { as: "h3", intent: "title", children: n.title }),
          /* @__PURE__ */ e.jsx(M, { className: "pt-5", as: "p", children: n.description }),
          /* @__PURE__ */ e.jsx(M, { as: "p", className: "pt-2", children: n.oldDescription })
        ] })
      ] })
    }
  ) }),
  /* @__PURE__ */ e.jsx(It, { action: t, actionLabel: n.btnClear })
] }), Mb = ({
  onClose: t,
  recognition: n,
  isStoreBeltContract: r,
  customerInformation: s,
  contractNo: a,
  serialNumber: o
}) => {
  const [i, c] = L(!1), { t: l } = V(["recognitions", "common"], {
    nsMode: "fallback"
  }), { app: d, baseURL: u } = Ft(), f = ve().locale || "en", p = d === un.OresundPay ? ln({ locale: f, key: "faq", url: u }) : pa(f, "faq", u), [b, h] = L(), [g, v] = L(), [y, x] = L(), j = Q(() => {
    x(!0), h(g);
  }, [g]), { mutateAsync: w, isLoading: C } = ke(
    ["recognition", "replace"],
    ({ Recognition: q }) => q.replace,
    { onSuccess: j, onError: () => c(!0) }
  ), P = "replacebizz", { registerField: N, getError: R } = Se({
    namespace: P,
    defaultValues: { isAsfinag: !1 }
  }), [T] = He(P, "isAsfinag"), [z, D] = L(void 0), A = (q) => D(q), S = Q(
    (q) => {
      v(q), w({
        serialNumber: o,
        contractNo: a,
        convertToRegNo: q,
        isAsfinag: !!T
      });
    },
    [w, o, a]
  ), _ = () => S(!1), $ = (q) => {
    q ? S(!0) : h(!1);
  };
  return Y(() => c(!1), [b]), /* @__PURE__ */ e.jsxs(lr, { open: !0, ariaLabelledBy: "title", children: [
    /* @__PURE__ */ e.jsx(cr, { closeLabel: l("action.close"), onClose: t, children: /* @__PURE__ */ e.jsx(M, { as: "h3", children: l("replaceBizz.title") }) }),
    i && /* @__PURE__ */ e.jsx(Le, { color: "negative", children: l("errors.generic") }),
    z ? y ? /* @__PURE__ */ e.jsx(
      Ui,
      {
        onClear: t,
        labels: {
          loading: l("action.loading"),
          title: l(
            `replaceBizz.resultModal.${g ? "changedToRedTitle" : "newbizzOrderTitle"}`
          ),
          description: l(
            `replaceBizz.resultModal.${g ? "changedToRedDesc" : "newbizzOrderDesc"}`
          ),
          oldDescription: l("replaceBizz.resultModal.oldBusinessDesc"),
          btnClear: l("replaceBizz.resultModal.clear")
        }
      }
    ) : z != null && z.isMoreLocations || b === !1 ? /* @__PURE__ */ e.jsx(
      Rb,
      {
        customerInformation: s,
        recognition: n,
        asfinagInput: n != null && n.isHGV ? /* @__PURE__ */ e.jsx(
          me,
          {
            error: R("isAsfinag"),
            label: l("form.labels.asfinag"),
            ...N("isAsfinag", {
              type: "checkbox",
              value: "true"
            })
          }
        ) : void 0,
        onOrderBiz: _,
        isLoadingData: C,
        labels: {
          loading: l("action.loading"),
          title: l("replaceBizz.addressModal.title"),
          address: l("form.labels.address"),
          city: l("form.labels.city"),
          zipCode: l("form.labels.zipCode"),
          btnRegSave: l("replaceBizz.addressModal.btnRegSave"),
          btnReg: l("replaceBizz.addressModal.btnReg"),
          btnNewBizz: l("replaceBizz.addressModal.btnNewBizz")
        },
        onError: (q) => c(q)
      }
    ) : b ? /* @__PURE__ */ e.jsx(
      Ui,
      {
        onClear: t,
        labels: {
          loading: l("action.loading"),
          title: l("replaceBizz.resultModal.changedToRedTitle"),
          description: l("replaceBizz.resultModal.changedToRedDesc"),
          oldDescription: l("replaceBizz.resultModal.oldBusinessDesc"),
          btnClear: l("replaceBizz.resultModal.clear")
        }
      }
    ) : /* @__PURE__ */ e.jsx(
      _b,
      {
        onIsSelectReading: $,
        isLoadingData: C,
        labels: {
          loading: l("action.loading"),
          title: l("replaceBizz.regNumberModal.title"),
          descriptionMain: l(
            "replaceBizz.regNumberModal.descriptionMain"
          ),
          description: l("replaceBizz.regNumberModal.description"),
          benefitsList: /* @__PURE__ */ e.jsxs(he, { i18nKey: "replaceBizz.benefitsList", ns: "recognitions", children: [
            /* @__PURE__ */ e.jsx(
              M,
              {
                className: "text-primary-900 pb-2 pt-3",
                as: "li"
              }
            ),
            /* @__PURE__ */ e.jsx(M, { className: "text-primary-900 pb-2", as: "li" }),
            /* @__PURE__ */ e.jsx(M, { className: "text-primary-900 pb-2", as: "li" }),
            /* @__PURE__ */ e.jsx(M, { className: "text-primary-900 pb-2", as: "li" })
          ] }),
          descriptionBottom: /* @__PURE__ */ e.jsxs(
            he,
            {
              i18nKey: "replaceBizz.regNumberModal.descriptionBottom",
              ns: "recognitions",
              children: [
                /* @__PURE__ */ e.jsx(M, { className: "pt-5", as: "span", size: "sm" }),
                /* @__PURE__ */ e.jsx(
                  yn,
                  {
                    className: "text-primary-400 pl-1 text-[0.75rem]",
                    href: p,
                    target: "_blank"
                  }
                )
              ]
            }
          ),
          btnKeepBusiness: l(
            "replaceBizz.regNumberModal.btnKeepBusiness"
          ),
          btnSelRegNumReading: l(
            "replaceBizz.regNumberModal.btnSelRegNumReading"
          )
        }
      }
    ) : /* @__PURE__ */ e.jsx(
      Ob,
      {
        onMoreLocations: A,
        recognition: n,
        labels: {
          title: l(
            `replaceBizz.promptInfoModal.${r ? "storebelt" : "nonStorebelt"}`
          ),
          noButton: l("replaceBizz.promptInfoModal.btnNo"),
          yesButton: l("replaceBizz.promptInfoModal.btnYes"),
          loading: l("action.loading")
        }
      }
    )
  ] });
}, gC = () => {
  const t = ve(), { query: n } = t, [r, s] = L(!1), [a, o] = L(
    "bizz"
  ), { app: i } = Ft(), c = (P) => {
    o(P), s(!0);
  }, [l, d] = L(), [u, m] = L(), [f, p] = L(), [b, h] = L(), g = Q((P) => {
    const N = P && P.registrationNo && P.countryCode;
    p(P), h(N ? 2 : 1);
  }, []), { customerInformation: v } = tt(), y = (v == null ? void 0 : v.customerType) === In.affiliatePartner, x = (v == null ? void 0 : v.customerType) === In.businessCommuter, j = ["business", "business-commuter"].includes(
    (v == null ? void 0 : v.customerType) ?? ""
  ), w = _c(), C = [
    {
      labelKey: y ? "kmtoll.order.layout.title" : "action.orderBizz",
      icon: /* @__PURE__ */ e.jsx(cn, {}),
      action: () => {
        y ? t.push("./bizz/order") : j && i === un.OresundPay ? t.push("/account/vehicles/order-bizz") : c("bizz");
      }
    }
  ];
  return y || C.push({
    labelKey: "action.addRegNoPayment",
    icon: /* @__PURE__ */ e.jsx(cn, {}),
    action: () => c("alpr")
  }), /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsxs(Ut, { fallback: /* @__PURE__ */ e.jsx(Wl, { loadingLabel: "loading" }), children: [
    n.toast && /* @__PURE__ */ e.jsx(
      Sc,
      {
        registrationNumber: n.toast,
        onClose: () => Oc("toast", t)
      }
    ),
    /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-6", children: [
      /* @__PURE__ */ e.jsx(ux, { preambleKey: "myPaymentOptions.businessDescription" }),
      w && /* @__PURE__ */ e.jsx(Ab, { contractNo: w }),
      /* @__PURE__ */ e.jsx(
        Cd,
        {
          value: {
            onEditRecognition: m,
            onRemoveRecognition: d,
            onReplaceRecognition: g
          },
          children: /* @__PURE__ */ e.jsx(
            yd,
            {
              pageType: "vehicle",
              shouldTriggerModal: !1,
              actions: C
            }
          )
        }
      )
    ] }),
    /* @__PURE__ */ e.jsxs(zt, { children: [
      r && /* @__PURE__ */ e.jsx(
        ax,
        {
          preSelectedRecognitionType: a,
          onClose: () => s(!1)
        }
      ),
      u && /* @__PURE__ */ e.jsx(
        Fi,
        {
          onClose: () => m(void 0),
          activeRecognition: u,
          isExternalCustomer: jn(
            u.contract.provider
          ),
          contract: Wt[u.contract.agreementType]
        }
      ),
      l && /* @__PURE__ */ e.jsx(
        dx,
        {
          recognition: l,
          onClose: () => d(void 0)
        }
      ),
      f && (b === 1 ? /* @__PURE__ */ e.jsx(
        Fi,
        {
          onClose: () => p(void 0),
          onSuccessReplaceBizz: () => {
            h(2);
          },
          activeRecognition: f,
          isExternalCustomer: jn(
            f.contract.provider
          ),
          contract: Wt[f.contract.agreementType],
          replaceSerialNumber: f.serialNo
        }
      ) : b === 2 ? v && !x && /* @__PURE__ */ e.jsx(
        Mb,
        {
          onClose: () => {
            p(void 0), h(void 0);
          },
          recognition: f,
          isStoreBeltContract: f.isSBF,
          customerInformation: v,
          contractNo: f.contractNo,
          serialNumber: f.serialNo
        }
      ) : null)
    ] })
  ] }) });
}, Bc = kt({}), Ct = () => {
  const t = pt(Bc);
  if (!t)
    throw new Error("useFormContext must be used within the FormProvider");
  return t;
}, zb = ({ children: t }) => {
  const [n, r] = L({}), [s, a] = L(1), o = (l) => {
    a((d) => typeof l == "function" ? l(d) : l);
  }, i = (l) => {
    r({ ...l });
  }, c = (l) => {
    r((d) => ({ ...d, ...l }));
  };
  return /* @__PURE__ */ e.jsx(
    Bc.Provider,
    {
      value: {
        formData: n,
        setFormData: i,
        step: s,
        updateStep: o,
        updateFormData: c
      },
      children: t
    }
  );
}, Vc = ({ children: t }) => /* @__PURE__ */ e.jsx("div", { className: "pb-1", children: /* @__PURE__ */ e.jsx("span", { className: "block font-semibold uppercase text-neutral-600", children: t }) });
function so() {
  const { locale: t } = ve(), { t: n } = V(["common"]), { data: r } = De(
    xe.VehicleTypeList({ locale: t }),
    (o) => o.VehicleType.list(t || ""),
    { staleTime: 1 / 0 }
  ), s = ((r == null ? void 0 : r.vehicleTypes) || []).map((o) => ({
    id: n(`vehicleTypes.${o.id}`),
    label: n(`vehicleTypes.${o.label}`),
    value: o.value,
    uneceClass: o == null ? void 0 : o.uneceClass,
    vehicleGroup: o == null ? void 0 : o.vehicleGroup,
    weightCategory: o == null ? void 0 : o.weightCategory
  })), a = r == null ? void 0 : r.co2VehicleSubgroups;
  return { vehicleTypes: s, co2VehicleSubgroups: a };
}
const Db = {
  p: /* @__PURE__ */ e.jsx("p", { className: "pb-4 leading-relaxed last-of-type:pb-0" }),
  strong: /* @__PURE__ */ e.jsx("strong", { className: "font-semibold" })
}, Lb = Gt("", {
  variants: {
    intent: {
      default: "mt-8 max-w-3xl overflow-hidden rounded-lg bg-neutral-50 p-6"
    }
  },
  defaultVariants: {
    intent: "default"
  }
}), Fr = ({
  title: t = "",
  image: n,
  descriptionPhraseKey: r,
  className: s = "",
  intent: a
}) => /* @__PURE__ */ e.jsxs("div", { className: Lb({ intent: a, className: s }), children: [
  t && /* @__PURE__ */ e.jsx("h3", { className: "pb-4 text-3xl font-semibold", children: t }),
  /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-10 sm:flex-row", children: [
    /* @__PURE__ */ e.jsx("div", { className: "w-full flex-auto sm:w-2/3", children: r ? /* @__PURE__ */ e.jsx(
      he,
      {
        i18nKey: r,
        ns: "account",
        components: Db
      }
    ) : null }),
    n && /* @__PURE__ */ e.jsx("div", { className: "relative aspect-square h-full min-h-[100px] w-auto max-w-[300px] flex-auto overflow-hidden rounded-xl", children: /* @__PURE__ */ e.jsx(Wa, { src: n == null ? void 0 : n.src, alt: (n == null ? void 0 : n.alt) || "", fill: !0 }) })
  ] })
] }), qc = (t) => t.replace(/[- ]+/gi, "").toUpperCase(), fs = ({
  children: t,
  allowFull: n
}) => /* @__PURE__ */ e.jsx("div", { className: `flex flex-col gap-10 ${!n && "sm:max-w-xs"}`, children: t }), Wc = () => Q(
  (n, r) => {
    const s = {
      scrollIntoView: {
        behavior: "smooth",
        block: "start",
        inline: "nearest"
      },
      focus: { preventScroll: !0 },
      ...r
    };
    n != null && n.current && (n.current.scrollIntoView(s == null ? void 0 : s.scrollIntoView), n.current.focus(s == null ? void 0 : s.focus));
  },
  []
), ao = fn(
  (t, n) => /* @__PURE__ */ e.jsx(
    "input",
    {
      type: "radio",
      ...t,
      ref: n,
      className: `peer mr-4  grid h-6 w-6 appearance-none place-content-center items-center justify-center rounded-full border border-neutral-700 pr-4 text-base font-medium text-inherit outline-0 before:ml-4 before:block before:h-4 before:w-4 before:scale-0 before:rounded-full before:shadow-[inset_16px_16px_var(--osb-primary-800)] before:duration-100 before:ease-in-out before:content-[''] checked:before:scale-100 focus:ring-0 disabled:before:shadow-[inset_16px_16px_var(--osb-neutral-400)] ${t.className ?? ""}`
    }
  )
);
ao.displayName = "RadioOption";
const ia = (t) => /* @__PURE__ */ e.jsxs(
  "div",
  {
    className: " ring-primary-600 flex flex-row items-center rounded-lg p-2 focus-within:ring",
    style: {
      opacity: t.disabled ? 0.32 : 1
    },
    children: [
      /* @__PURE__ */ e.jsx(
        ao,
        {
          id: t.id,
          name: t.name,
          value: t.value,
          checked: t.checked,
          onChange: t.onChange,
          disabled: t.disabled
        }
      ),
      /* @__PURE__ */ e.jsx("label", { className: "text-sm text-neutral-900", htmlFor: t.id, children: t.label })
    ]
  }
), Hc = () => {
  const t = pt(Vl);
  if (!t)
    throw new Error(
      "useContentRequest must be used within an ContentRequestProvider"
    );
  const { contentRequest: n } = t;
  return n;
};
function Kn() {
  const t = pt(Bl);
  if (!t)
    throw new Error("useFlags must be used within an FlagsProvider");
  return new Map(Object.entries(t));
}
const Uc = {
  [Ke.Under3500kg]: { min: 0, max: 3500 },
  [Ke.Over3500kgUnder12000kg]: { min: 3501, max: 11999 },
  [Ke.Over12000kgToInfinity]: { min: 12e3, max: 1 / 0 },
  [Ke.Over35000kgToInfinity]: { min: 3501, max: 1 / 0 }
}, Gi = [
  "isAUTOPASS",
  "isASFINAG",
  "isGNSS"
], Gc = (t, n, r) => {
  const s = parseInt(t), { min: a, max: o } = r[n] || {};
  return s >= a && s <= o;
}, Ib = ({ isRoadTollDenmark: t = !1 }) => {
  var O, ae, ge, je, I, F, We, oe, le, _e, $e;
  const { updateStep: n, setFormData: r, updateFormData: s, formData: a } = Ct(), o = Hc(), { asPath: i } = ve(), [c, l] = L(!1), [d, u] = L(
    a.weightInterval ? a.weightInterval : Ke.Under3500kg
  ), { app: m } = Ft(), f = $t(!0), { vehicleTypes: p } = so(), [b, h] = L(
    a != null && a.country ? a.country : void 0
  ), [g, v] = L(!1), y = Wc(), x = Kn(), j = !!(x != null && x.get("toll-collect")), w = qe({
    contractNo: null,
    licensePlate: null,
    vehicleType: null
  }), {
    setValue: C,
    register: P,
    handleSubmit: N,
    formState: { errors: R },
    watch: T,
    clearErrors: z,
    setError: D
  } = Nn({
    defaultValues: {
      isAUTOPASS: !1,
      isASFINAG: !1,
      isGNSS: !1,
      isTollCollect: !1,
      isHGV: !1,
      customerNumber: "",
      ...a
    },
    resolver: Gn(Cu)
  });
  Y(() => {
    var ie;
    if (f && f.length > 0 && !(a != null && a.country)) {
      const ye = (ie = f == null ? void 0 : f[0]) == null ? void 0 : ie.value;
      h(ye), C("country", ye);
    }
  }, [f, C, a == null ? void 0 : a.country]);
  const A = qe(!1);
  Y(() => {
    t && !A.current && (A.current = !0, C("vehicleType", ys.HeavyTruckOver12Ton.toString()), C("isGNSS", !0), C("isASFINAG", !1), C("isAUTOPASS", !1), C("isHGV", !0), s({ showExtendedForm: !0 }), u(Ke.Over12000kgToInfinity));
  }, [t, C, s]);
  const { t: S } = V(["account", "common"], {
    nsMode: "fallback"
  }), _ = T("licensePlate"), $ = T("isAUTOPASS"), q = T("isASFINAG"), U = T("isGNSS"), W = T("isTollCollect");
  Y(() => {
    const ie = Object.keys(R)[0];
    ie && w.current[ie] && y({
      current: w.current[ie]
    });
  }, [R, y]);
  const G = async (ie) => {
    var Pe;
    const { country: ye, licensePlate: we } = ie;
    if (l(!0), !ie.isASFINAG && !ie.isTollCollect && !ie.isAUTOPASS && !ie.isGNSS) {
      D("root.enableCountries", {
        type: "manual",
        message: S("form.validations.enableCountries.required")
      }), l(!1);
      return;
    }
    const Ae = (Te = {}) => {
      r({
        ...ie,
        ...Te,
        //This is to let the next form step know which fields come from bilvision
        bilvisionFields: Object.keys(Te),
        //This is to let the next form step know which weights to accept in validation
        weightInterval: d,
        showExtendedForm: a == null ? void 0 : a.showExtendedForm,
        isASFINAG: ie.isGNSS ? !0 : ie.isASFINAG
      }), n(2);
    }, J = ["NO", "DK", "SE"];
    try {
      if (J.includes(ye)) {
        const Te = qc(we), te = await o(
          "vehicle-info",
          `countryCode=${ye}&regNo=${Te}`
        );
        if (!Gc(
          (te == null ? void 0 : te.grossWeight) || "0",
          d,
          Uc
        ))
          throw new Error("Invalid weight", { cause: "invalid_weight" });
        Ae(te);
      } else
        Ae();
    } catch (Te) {
      Te.cause === "invalid_weight" ? (D("vehicleType", {
        type: "manual",
        message: S("form.validations.weight.invalid")
      }), y({ current: (Pe = w.current) == null ? void 0 : Pe.vehicleType })) : Ae();
    } finally {
      l(!1);
    }
  };
  Y(() => {
    z("licensePlate");
  }, [_, z]);
  const ee = (ie) => {
    z("vehicleType");
    const ye = p.find(({ value: te }) => te === ie), we = (ye == null ? void 0 : ye.weightCategory) ?? Ke.Under3500kg, Ae = [
      ys.HeavyTruckOver12Ton,
      ys.HeavyTruck3_5To12Ton
    ].includes(parseInt(ie)), J = we === Ke.Over3500kgUnder12000kg || we === Ke.Over12000kgToInfinity || we === Ke.Over35000kgToInfinity, Pe = we === Ke.Over12000kgToInfinity, Te = W && we === Ke.Over12000kgToInfinity;
    C("vehicleType", ie), C("isHGV", J), C("isASFINAG", q && J), C("isGNSS", U && Pe), C("isTollCollect", Te), u(we), s({ isHGV: J, showExtendedForm: Ae });
  }, ue = (ie, ye) => {
    z(ie), C(ie, ye);
  }, ce = (ie, ye) => {
    z("contractNo"), C("contractNo", ie);
    const we = ye ? jn({ id: ye, name: "_provider" }) : !1;
    C("isASFINAG", q && !we), C("isGNSS", U && !we), C("isTollCollect", W && !we), v(we);
  }, re = (ie) => {
    const ye = ie.target.value, we = ie.target.name, Ae = ie.target.checked;
    we === "isTollCollect" && j ? C(we, Ae) : Gi.includes(ye) && (C(ye, !0), Gi.forEach((J) => {
      J !== ye && C(J, !1);
    }));
  }, se = i.lastIndexOf("/"), H = i.substring(0, se);
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("h2", { className: "mb-7 text-2xl font-semibold", children: S("singleOrderBizzFlow.order.basicVehicleInfo.title") }),
    /* @__PURE__ */ e.jsx("p", { children: S("singleOrderBizzFlow.order.basicVehicleInfo.description") }),
    /* @__PURE__ */ e.jsxs("form", { onSubmit: N(G), className: "mt-8 w-full ", children: [
      /* @__PURE__ */ e.jsxs(fs, { children: [
        /* @__PURE__ */ e.jsx(
          is,
          {
            ref: (ie) => w.current.contractNo = ie,
            hideProviders: !0,
            hideCommuter: !0,
            initialContractNo: T("contractNo"),
            onAgreementChange: (ie, ye) => ce(ie, ye),
            error: (O = R.contractNo) != null && O.message ? S(`${(ae = R.contractNo) == null ? void 0 : ae.message}`) : void 0
          }
        ),
        /* @__PURE__ */ e.jsxs("fieldset", { className: "flex flex-row", children: [
          /* @__PURE__ */ e.jsx("legend", { className: "block text-sm font-medium text-neutral-950", children: S("form.labels.licensePlate") }),
          /* @__PURE__ */ e.jsx(
            mt,
            {
              ...P("country", {
                required: S("form.validations.vehicleCountry.required")
              }),
              initialValue: b,
              options: f == null ? void 0 : f.map(({ value: ie }) => ({
                label: ie,
                value: ie
              })),
              classNames: {
                button: "border-r-0 rounded-r-none w-20",
                dropdown: "overflow-x-hidden"
              },
              error: (ge = R.country) != null && ge.message ? S(`${(je = R.country) == null ? void 0 : je.message}`) : void 0,
              onChange: (ie) => ue("country", ie)
            }
          ),
          /* @__PURE__ */ e.jsx(
            rt,
            {
              ...P("licensePlate"),
              ref: (ie) => w.current.licensePlate = ie,
              classNames: { wrapper: "w-full", input: "rounded-l-none" },
              icon: /* @__PURE__ */ e.jsx(Hr, { className: "h-4 w-4" }),
              error: t && R.vehicleType ? S("form.validations.weight.invalidRoadtaxDenmark") : (I = R.licensePlate) != null && I.message ? S(`${(F = R.licensePlate) == null ? void 0 : F.message}`) : void 0,
              defaultValue: a.licensePlate ? a.licensePlate : "",
              onChange: (ie) => {
                var ye, we;
                ue(
                  "licensePlate",
                  (we = (ye = ie == null ? void 0 : ie.target) == null ? void 0 : ye.value) == null ? void 0 : we.toUpperCase()
                );
              }
            }
          )
        ] }),
        !t && /* @__PURE__ */ e.jsx(
          mt,
          {
            ...P("vehicleType", {
              required: S("form.validations.vehicleType.required")
            }),
            label: `${S("form.labels.vehicleType")}`,
            ref: (ie) => w.current.vehicleType = ie,
            required: !0,
            placeholder: S("form.placeholders.vehicleType"),
            options: p == null ? void 0 : p.map(({ label: ie, value: ye, uneceClass: we }) => ({
              label: `${(we == null ? void 0 : we.join(", ")) || ""} - ${ie}`,
              value: ye
            })),
            initialValue: a.vehicleType ? a.vehicleType : "",
            error: (We = R.vehicleType) != null && We.message ? S(`${(oe = R.vehicleType) == null ? void 0 : oe.message}`) : void 0,
            onChange: (ie) => ee(ie)
          }
        ),
        (!t || m === un.Oresundsbron) && /* @__PURE__ */ e.jsxs("fieldset", { className: "", children: [
          /* @__PURE__ */ e.jsxs("legend", { className: "block text-sm text-neutral-950", children: [
            /* @__PURE__ */ e.jsx("p", { className: "mb-1 font-medium", children: S("form.labels.enableCountries") }),
            /* @__PURE__ */ e.jsx("p", { children: S("form.descriptions.enableCountries") })
          ] }),
          ((le = R.root) == null ? void 0 : le.enableCountries) && /* @__PURE__ */ e.jsx("span", { className: "text-red-500", children: ($e = (_e = R.root) == null ? void 0 : _e.enableCountries) == null ? void 0 : $e.message }),
          /* @__PURE__ */ e.jsxs("div", { className: "mt-4 flex flex-col gap-0.5", children: [
            /* @__PURE__ */ e.jsx(
              ia,
              {
                id: "isAUTOPASS",
                name: "enabledCountries",
                value: "isAUTOPASS",
                checked: $,
                onChange: re,
                label: S("form.labels.isAutopass")
              }
            ),
            /* @__PURE__ */ e.jsx(
              ia,
              {
                id: "isASFINAG",
                name: "enabledCountries",
                value: "isASFINAG",
                checked: q,
                disabled: g || ![
                  Ke.Over3500kgUnder12000kg,
                  Ke.Over12000kgToInfinity,
                  Ke.Over35000kgToInfinity
                ].includes(d),
                onChange: re,
                label: S("form.labels.isAsfinag")
              }
            ),
            /* @__PURE__ */ e.jsx(
              ia,
              {
                id: "isGNSS",
                name: "enabledCountries",
                value: "isGNSS",
                checked: U,
                disabled: ![Ke.Over12000kgToInfinity].includes(
                  d
                ) || g,
                onChange: re,
                label: S("form.labels.isGnss")
              }
            ),
            j && /* @__PURE__ */ e.jsx(
              vn,
              {
                ...P("isTollCollect"),
                onChange: re,
                disabled: d !== Ke.Over12000kgToInfinity || g,
                className: "mt-2",
                label: S("form.labels.isTollCollect")
              }
            )
          ] })
        ] })
      ] }),
      U && /* @__PURE__ */ e.jsx(
        Fr,
        {
          title: S(
            "singleOrderBizzFlow.order.basicVehicleInfo.details.roadTollDenmark.title"
          ),
          descriptionPhraseKey: "singleOrderBizzFlow.order.confirmation.details.roadTollDenmark.description"
        }
      ),
      W && /* @__PURE__ */ e.jsx(
        Fr,
        {
          title: S(
            "singleOrderBizzFlow.order.basicVehicleInfo.details.roadTollGermany.title"
          ),
          descriptionPhraseKey: "singleOrderBizzFlow.order.confirmation.details.roadTollGermany.description"
        }
      ),
      /* @__PURE__ */ e.jsx("hr", { className: "mt-8" }),
      /* @__PURE__ */ e.jsxs("div", { className: "my-4 flex items-center gap-4", children: [
        /* @__PURE__ */ e.jsx(
          yn,
          {
            href: H,
            className: "ml-auto pr-4 font-medium text-blue-700 underline",
            children: S("action.cancel")
          }
        ),
        /* @__PURE__ */ e.jsx(
          et,
          {
            as: "button",
            type: "submit",
            loadingLabel: S("action.loading"),
            isLoading: c,
            children: S("action.next")
          }
        )
      ] })
    ] })
  ] });
}, $b = ({
  bizzInfo: t
}) => {
  var z, D, A, S;
  const { updateStep: n, setFormData: r, formData: s } = Ct(), a = Hc(), { asPath: o } = ve(), [i, c] = L(!1), l = K(() => t.isGNSS ? Ke.Over12000kgToInfinity : t.isHGV ? Ke.Over35000kgToInfinity : Ke.Under3500kg, [t]), d = $t(!0), [u, m] = L(
    s != null && s.country ? s.country : void 0
  ), f = Wc(), p = qe({
    contractNo: null,
    licensePlate: null,
    vehicleType: null
  }), {
    setValue: b,
    register: h,
    handleSubmit: g,
    formState: { errors: v },
    watch: y,
    clearErrors: x,
    setError: j
  } = Nn({
    defaultValues: {
      ...s,
      contractNo: t.contractNo,
      isHGV: t.isHGV,
      customerNumber: t.customerNo,
      isASFINAG: t.isAsfinag,
      isGNSS: t.isGNSS,
      prevRegNo: t.registrationNo,
      contractLineNo: t.contractLineNo
    }
  });
  Y(() => {
    var _;
    if (d && d.length > 0 && !(s != null && s.country)) {
      const $ = (_ = d == null ? void 0 : d[0]) == null ? void 0 : _.value;
      m($), b("country", $);
    }
  }, [d, b, s == null ? void 0 : s.country]);
  const { t: w } = V(["account", "common"], {
    nsMode: "fallback"
  }), C = y("licensePlate");
  Y(() => {
    const _ = Object.keys(v)[0];
    _ && p.current[_] && f({
      current: p.current[_]
    });
  }, [v, f]);
  const P = async (_) => {
    var G;
    const { country: $, licensePlate: q } = _;
    if (c(!0), !_.isASFINAG && !_.isTollCollect && !_.isAUTOPASS && !_.isGNSS) {
      j("root.enableCountries", {
        type: "manual",
        message: w("form.validations.enableCountries.required")
      }), c(!1);
      return;
    }
    const U = (ee = {}) => {
      r({
        ..._,
        ...ee,
        //This is to let the next form step know which fields come from bilvision
        bilvisionFields: Object.keys(ee),
        //This is to let the next form step know which weights to accept in validation
        weightInterval: l,
        showExtendedForm: l !== Ke.Under3500kg,
        isASFINAG: _.isGNSS ? !0 : _.isASFINAG
      }), n(2);
    }, W = ["NO", "DK", "SE"];
    try {
      if (W.includes($)) {
        const ee = qc(q), ue = await a(
          "vehicle-info",
          `countryCode=${$}&regNo=${ee}`
        );
        if (!Gc(
          (ue == null ? void 0 : ue.grossWeight) || "0",
          l,
          Uc
        ))
          throw new Error("Invalid weight", { cause: "invalid_weight" });
        U(ue);
      } else
        U();
    } catch (ee) {
      ee.cause === "invalid_weight" ? (j("licensePlate", {
        type: "manual",
        message: w("form.validations.weight.invalid")
      }), f({ current: (G = p.current) == null ? void 0 : G.vehicleType })) : U();
    } finally {
      c(!1);
    }
  };
  Y(() => {
    x("licensePlate");
  }, [C, x]);
  const N = (_, $) => {
    x(_), b(_, $);
  }, R = o.lastIndexOf("/"), T = o.substring(0, R);
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("h2", { className: "mb-7 text-2xl font-semibold", children: w("singleOrderBizzFlow.order.basicVehicleInfo.title") }),
    /* @__PURE__ */ e.jsx("p", { className: "mb-10", children: w("singleOrderBizzFlow.order.basicVehicleInfo.description") }),
    /* @__PURE__ */ e.jsxs("div", { className: "flex items-center gap-4", children: [
      /* @__PURE__ */ e.jsx(ka, { className: "h-8 w-8" }),
      /* @__PURE__ */ e.jsx("span", { className: "block font-semibold uppercase text-neutral-600", children: w("singleOrderBizzFlow.order.basicVehicleInfo.bizz") })
    ] }),
    /* @__PURE__ */ e.jsxs("div", { className: "mb-7 flex gap-2", children: [
      /* @__PURE__ */ e.jsx("p", { className: "text-2xl font-semibold", children: t.serialNo }),
      /* @__PURE__ */ e.jsx(Lr, { status: "open" })
    ] }),
    /* @__PURE__ */ e.jsx("legend", { className: "block text-sm font-medium text-neutral-950", children: w("singleOrderBizzFlow.order.basicVehicleInfo.currentLPN") }),
    /* @__PURE__ */ e.jsx("p", { children: t.registrationNo }),
    /* @__PURE__ */ e.jsxs("form", { onSubmit: g(P), className: "mt-8 w-full ", children: [
      /* @__PURE__ */ e.jsx(fs, { children: /* @__PURE__ */ e.jsxs("fieldset", { className: "flex flex-row", children: [
        /* @__PURE__ */ e.jsx("legend", { className: "block text-sm font-medium text-neutral-950", children: w("form.labels.licensePlate") }),
        /* @__PURE__ */ e.jsx(
          mt,
          {
            ...h("country", {
              required: w("form.validations.vehicleCountry.required")
            }),
            initialValue: u,
            options: d == null ? void 0 : d.map(({ value: _ }) => ({
              label: _,
              value: _
            })),
            classNames: {
              button: "border-r-0 rounded-r-none w-20",
              dropdown: "overflow-x-hidden"
            },
            error: (z = v.country) != null && z.message ? w(`${(D = v.country) == null ? void 0 : D.message}`) : void 0,
            onChange: (_) => N("country", _)
          }
        ),
        /* @__PURE__ */ e.jsx(
          rt,
          {
            ...h("licensePlate"),
            ref: (_) => p.current.licensePlate = _,
            classNames: { wrapper: "w-full", input: "rounded-l-none" },
            icon: /* @__PURE__ */ e.jsx(Hr, { className: "h-4 w-4" }),
            error: (A = v.licensePlate) != null && A.message ? w(`${(S = v.licensePlate) == null ? void 0 : S.message}`) : void 0,
            defaultValue: s.licensePlate ? s.licensePlate : "",
            onChange: (_) => {
              var $, q;
              N(
                "licensePlate",
                (q = ($ = _ == null ? void 0 : _.target) == null ? void 0 : $.value) == null ? void 0 : q.toUpperCase()
              );
            }
          }
        )
      ] }) }),
      /* @__PURE__ */ e.jsx("hr", { className: "mt-8" }),
      /* @__PURE__ */ e.jsxs("div", { className: "my-4 flex items-center gap-4", children: [
        /* @__PURE__ */ e.jsx(
          yn,
          {
            href: T,
            className: "ml-auto pr-4 font-medium text-blue-700 underline",
            children: w("action.cancel")
          }
        ),
        /* @__PURE__ */ e.jsx(
          et,
          {
            as: "button",
            type: "submit",
            loadingLabel: w("action.loading"),
            isLoading: i,
            children: w("action.next")
          }
        )
      ] })
    ] })
  ] });
}, Fb = ({ title: t, value: n }) => /* @__PURE__ */ e.jsxs("div", { children: [
  /* @__PURE__ */ e.jsx("h2", { className: "text-sm ", children: t }),
  /* @__PURE__ */ e.jsx("p", { className: "break-words pt-1 font-medium capitalize text-neutral-950", children: n })
] }), Fn = ({ heading: t, subHeading: n, vehicleInfo: r, className: s }) => {
  const a = Math.ceil(r.length / 3);
  return /* @__PURE__ */ e.jsxs("div", { className: s, children: [
    /* @__PURE__ */ e.jsx("h1", { className: "mb-2 text-2xl font-medium", children: t }),
    /* @__PURE__ */ e.jsx("p", { className: "mb-4 text-base font-normal text-neutral-800 ", children: n }),
    /* @__PURE__ */ e.jsx(
      "div",
      {
        className: "grid grid-cols-1 gap-6 rounded-lg bg-neutral-50 p-6 sm:grid-cols-2 md:grid-cols-3",
        style: { gridTemplateRows: `repeat(${a}, minmax(0, 1fr))` },
        children: r.map((o, i) => /* @__PURE__ */ e.jsx(
          Fb,
          {
            title: o.title,
            value: o.value,
            className: o.className
          },
          i
        ))
      }
    )
  ] });
}, Ue = ({
  children: t,
  field: n,
  hideUnlessHGV: r
}) => {
  const { formData: s } = Ct(), a = !s.showExtendedForm && r, o = s.bilvisionFields.includes(n ?? "") || a;
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: !o && t });
}, Kc = (t) => /* @__PURE__ */ e.jsxs("div", { children: [
  t.label && /* @__PURE__ */ e.jsx("legend", { children: t.label }),
  /* @__PURE__ */ e.jsx("div", { className: "flex flex-col gap-4", children: t.children })
] }), Br = (t) => /* @__PURE__ */ e.jsxs(
  "div",
  {
    className: `ring-primary-600 rounded-lg border-2 p-4 focus-within:ring hover:ring ${t.disabled && "opacity-32 pointer-events-none"}`,
    "aria-disabled": t.disabled,
    children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex", children: [
        /* @__PURE__ */ e.jsx(
          ao,
          {
            className: "mt-3",
            onChange: t.onChange,
            checked: t.checked,
            id: t.keyValue,
            disabled: t.disabled,
            name: t.name,
            value: t.value
          }
        ),
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-3 pt-2", children: [
          /* @__PURE__ */ e.jsx("label", { htmlFor: t.keyValue, className: "text-3xl font-bold", children: t.label }),
          /* @__PURE__ */ e.jsx("p", { children: t.description ?? "" })
        ] })
      ] }),
      t.checked && t.children
    ]
  }
);
var Bb = {
  lessThanXSeconds: {
    one: "mindre end ét sekund",
    other: "mindre end {{count}} sekunder"
  },
  xSeconds: {
    one: "1 sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "ét halvt minut",
  lessThanXMinutes: {
    one: "mindre end ét minut",
    other: "mindre end {{count}} minutter"
  },
  xMinutes: {
    one: "1 minut",
    other: "{{count}} minutter"
  },
  aboutXHours: {
    one: "cirka 1 time",
    other: "cirka {{count}} timer"
  },
  xHours: {
    one: "1 time",
    other: "{{count}} timer"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dage"
  },
  aboutXWeeks: {
    one: "cirka 1 uge",
    other: "cirka {{count}} uger"
  },
  xWeeks: {
    one: "1 uge",
    other: "{{count}} uger"
  },
  aboutXMonths: {
    one: "cirka 1 måned",
    other: "cirka {{count}} måneder"
  },
  xMonths: {
    one: "1 måned",
    other: "{{count}} måneder"
  },
  aboutXYears: {
    one: "cirka 1 år",
    other: "cirka {{count}} år"
  },
  xYears: {
    one: "1 år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "over 1 år",
    other: "over {{count}} år"
  },
  almostXYears: {
    one: "næsten 1 år",
    other: "næsten {{count}} år"
  }
}, Vb = function(n, r, s) {
  var a, o = Bb[n];
  return typeof o == "string" ? a = o : r === 1 ? a = o.one : a = o.other.replace("{{count}}", String(r)), s != null && s.addSuffix ? s.comparison && s.comparison > 0 ? "om " + a : a + " siden" : a;
}, qb = {
  full: "EEEE 'den' d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd/MM/y"
}, Wb = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Hb = {
  full: "{{date}} 'kl'. {{time}}",
  long: "{{date}} 'kl'. {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Ub = {
  date: ft({
    formats: qb,
    defaultWidth: "full"
  }),
  time: ft({
    formats: Wb,
    defaultWidth: "full"
  }),
  dateTime: ft({
    formats: Hb,
    defaultWidth: "full"
  })
}, Gb = {
  lastWeek: "'sidste' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "'på' eeee 'kl.' p",
  other: "P"
}, Kb = function(n, r, s, a) {
  return Gb[n];
}, Yb = {
  narrow: ["fvt", "vt"],
  abbreviated: ["f.v.t.", "v.t."],
  wide: ["før vesterlandsk tidsregning", "vesterlandsk tidsregning"]
}, Qb = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. kvt.", "2. kvt.", "3. kvt.", "4. kvt."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, Xb = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mar.", "apr.", "maj", "jun.", "jul.", "aug.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januar", "februar", "marts", "april", "maj", "juni", "juli", "august", "september", "oktober", "november", "december"]
}, Jb = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
  abbreviated: ["søn.", "man.", "tir.", "ons.", "tor.", "fre.", "lør."],
  wide: ["søndag", "mandag", "tirsdag", "onsdag", "torsdag", "fredag", "lørdag"]
}, Zb = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  }
}, ev = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  }
}, tv = function(n, r) {
  var s = Number(n);
  return s + ".";
}, nv = {
  ordinalNumber: tv,
  era: Je({
    values: Yb,
    defaultWidth: "wide"
  }),
  quarter: Je({
    values: Qb,
    defaultWidth: "wide",
    argumentCallback: function(n) {
      return n - 1;
    }
  }),
  month: Je({
    values: Xb,
    defaultWidth: "wide"
  }),
  day: Je({
    values: Jb,
    defaultWidth: "wide"
  }),
  dayPeriod: Je({
    values: Zb,
    defaultWidth: "wide",
    formattingValues: ev,
    defaultFormattingWidth: "wide"
  })
}, rv = /^(\d+)(\.)?/i, sv = /\d+/i, av = {
  narrow: /^(fKr|fvt|eKr|vt)/i,
  abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
  wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
}, ov = {
  any: [/^f/i, /^(v|e)/i]
}, iv = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]. kvt\./i,
  wide: /^[1234]\.? kvartal/i
}, lv = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, cv = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
}, dv = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, uv = {
  narrow: /^[smtofl]/i,
  short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
}, mv = {
  narrow: [/^s/i, /^m/i, /^t/i, /^o/i, /^t/i, /^f/i, /^l/i],
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, fv = {
  narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
  any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
}, pv = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /midnat/i,
    noon: /middag/i,
    morning: /morgen/i,
    afternoon: /eftermiddag/i,
    evening: /aften/i,
    night: /nat/i
  }
}, hv = {
  ordinalNumber: ms({
    matchPattern: rv,
    parsePattern: sv,
    valueCallback: function(n) {
      return parseInt(n, 10);
    }
  }),
  era: Ze({
    matchPatterns: av,
    defaultMatchWidth: "wide",
    parsePatterns: ov,
    defaultParseWidth: "any"
  }),
  quarter: Ze({
    matchPatterns: iv,
    defaultMatchWidth: "wide",
    parsePatterns: lv,
    defaultParseWidth: "any",
    valueCallback: function(n) {
      return n + 1;
    }
  }),
  month: Ze({
    matchPatterns: cv,
    defaultMatchWidth: "wide",
    parsePatterns: dv,
    defaultParseWidth: "any"
  }),
  day: Ze({
    matchPatterns: uv,
    defaultMatchWidth: "wide",
    parsePatterns: mv,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ze({
    matchPatterns: fv,
    defaultMatchWidth: "any",
    parsePatterns: pv,
    defaultParseWidth: "any"
  })
}, gv = {
  code: "da",
  formatDistance: Vb,
  formatLong: Ub,
  formatRelative: Kb,
  localize: nv,
  match: hv,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Ki = {
  lessThanXSeconds: {
    standalone: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    },
    withPreposition: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    }
  },
  xSeconds: {
    standalone: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    },
    withPreposition: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    }
  },
  halfAMinute: {
    standalone: "halbe Minute",
    withPreposition: "halben Minute"
  },
  lessThanXMinutes: {
    standalone: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    },
    withPreposition: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    }
  },
  xMinutes: {
    standalone: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    },
    withPreposition: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    }
  },
  aboutXHours: {
    standalone: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    },
    withPreposition: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    }
  },
  xHours: {
    standalone: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    },
    withPreposition: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    }
  },
  xDays: {
    standalone: {
      one: "1 Tag",
      other: "{{count}} Tage"
    },
    withPreposition: {
      one: "1 Tag",
      other: "{{count}} Tagen"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    },
    withPreposition: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    }
  },
  xWeeks: {
    standalone: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    },
    withPreposition: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monate"
    },
    withPreposition: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monaten"
    }
  },
  xMonths: {
    standalone: {
      one: "1 Monat",
      other: "{{count}} Monate"
    },
    withPreposition: {
      one: "1 Monat",
      other: "{{count}} Monaten"
    }
  },
  aboutXYears: {
    standalone: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahre"
    },
    withPreposition: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahren"
    }
  },
  xYears: {
    standalone: {
      one: "1 Jahr",
      other: "{{count}} Jahre"
    },
    withPreposition: {
      one: "1 Jahr",
      other: "{{count}} Jahren"
    }
  },
  overXYears: {
    standalone: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahre"
    },
    withPreposition: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahren"
    }
  },
  almostXYears: {
    standalone: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahre"
    },
    withPreposition: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahren"
    }
  }
}, xv = function(n, r, s) {
  var a, o = s != null && s.addSuffix ? Ki[n].withPreposition : Ki[n].standalone;
  return typeof o == "string" ? a = o : r === 1 ? a = o.one : a = o.other.replace("{{count}}", String(r)), s != null && s.addSuffix ? s.comparison && s.comparison > 0 ? "in " + a : "vor " + a : a;
}, bv = {
  full: "EEEE, do MMMM y",
  // Montag, 7. Januar 2018
  long: "do MMMM y",
  // 7. Januar 2018
  medium: "do MMM y",
  // 7. Jan. 2018
  short: "dd.MM.y"
  // 07.01.2018
}, vv = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, yv = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, jv = {
  date: ft({
    formats: bv,
    defaultWidth: "full"
  }),
  time: ft({
    formats: vv,
    defaultWidth: "full"
  }),
  dateTime: ft({
    formats: yv,
    defaultWidth: "full"
  })
}, Cv = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: "P"
}, wv = function(n, r, s, a) {
  return Cv[n];
}, Nv = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"]
}, Pv = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
}, Ca = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"],
  wide: ["Januar", "Februar", "März", "April", "Mai", "Juni", "Juli", "August", "September", "Oktober", "November", "Dezember"]
}, Sv = {
  narrow: Ca.narrow,
  abbreviated: ["Jan.", "Feb.", "März", "Apr.", "Mai", "Juni", "Juli", "Aug.", "Sep.", "Okt.", "Nov.", "Dez."],
  wide: Ca.wide
}, Tv = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"]
}, Ev = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  }
}, kv = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  }
}, Av = function(n) {
  var r = Number(n);
  return r + ".";
}, Ov = {
  ordinalNumber: Av,
  era: Je({
    values: Nv,
    defaultWidth: "wide"
  }),
  quarter: Je({
    values: Pv,
    defaultWidth: "wide",
    argumentCallback: function(n) {
      return n - 1;
    }
  }),
  month: Je({
    values: Ca,
    formattingValues: Sv,
    defaultWidth: "wide"
  }),
  day: Je({
    values: Tv,
    defaultWidth: "wide"
  }),
  dayPeriod: Je({
    values: Ev,
    defaultWidth: "wide",
    formattingValues: kv,
    defaultFormattingWidth: "wide"
  })
}, _v = /^(\d+)(\.)?/i, Rv = /\d+/i, Mv = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
}, zv = {
  any: [/^v/i, /^n/i]
}, Dv = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
}, Lv = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Iv = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
}, $v = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^j[aä]/i, /^f/i, /^mär/i, /^ap/i, /^mai/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Fv = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
}, Bv = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
}, Vv = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
}, qv = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    // will never be matched. Afternoon is matched by `pm`
    evening: /abends/i,
    night: /nachts/i
    // will never be matched. Night is matched by `pm`
  }
}, Wv = {
  ordinalNumber: ms({
    matchPattern: _v,
    parsePattern: Rv,
    valueCallback: function(n) {
      return parseInt(n);
    }
  }),
  era: Ze({
    matchPatterns: Mv,
    defaultMatchWidth: "wide",
    parsePatterns: zv,
    defaultParseWidth: "any"
  }),
  quarter: Ze({
    matchPatterns: Dv,
    defaultMatchWidth: "wide",
    parsePatterns: Lv,
    defaultParseWidth: "any",
    valueCallback: function(n) {
      return n + 1;
    }
  }),
  month: Ze({
    matchPatterns: Iv,
    defaultMatchWidth: "wide",
    parsePatterns: $v,
    defaultParseWidth: "any"
  }),
  day: Ze({
    matchPatterns: Fv,
    defaultMatchWidth: "wide",
    parsePatterns: Bv,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ze({
    matchPatterns: Vv,
    defaultMatchWidth: "wide",
    parsePatterns: qv,
    defaultParseWidth: "any"
  })
}, Hv = {
  code: "de",
  formatDistance: xv,
  formatLong: jv,
  formatRelative: wv,
  localize: Ov,
  match: Wv,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Uv = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, Gv = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Kv = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Yv = {
  date: ft({
    formats: Uv,
    defaultWidth: "full"
  }),
  time: ft({
    formats: Gv,
    defaultWidth: "full"
  }),
  dateTime: ft({
    formats: Kv,
    defaultWidth: "full"
  })
}, Yi = {
  code: "en-GB",
  formatDistance: Lc,
  formatLong: Yv,
  formatRelative: Ic,
  localize: $c,
  match: Fc,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Qv = {
  lessThanXSeconds: {
    one: "mindre än en sekund",
    other: "mindre än {{count}} sekunder"
  },
  xSeconds: {
    one: "en sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "en halv minut",
  lessThanXMinutes: {
    one: "mindre än en minut",
    other: "mindre än {{count}} minuter"
  },
  xMinutes: {
    one: "en minut",
    other: "{{count}} minuter"
  },
  aboutXHours: {
    one: "ungefär en timme",
    other: "ungefär {{count}} timmar"
  },
  xHours: {
    one: "en timme",
    other: "{{count}} timmar"
  },
  xDays: {
    one: "en dag",
    other: "{{count}} dagar"
  },
  aboutXWeeks: {
    one: "ungefär en vecka",
    other: "ungefär {{count}} vecka"
  },
  xWeeks: {
    one: "en vecka",
    other: "{{count}} vecka"
  },
  aboutXMonths: {
    one: "ungefär en månad",
    other: "ungefär {{count}} månader"
  },
  xMonths: {
    one: "en månad",
    other: "{{count}} månader"
  },
  aboutXYears: {
    one: "ungefär ett år",
    other: "ungefär {{count}} år"
  },
  xYears: {
    one: "ett år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "över ett år",
    other: "över {{count}} år"
  },
  almostXYears: {
    one: "nästan ett år",
    other: "nästan {{count}} år"
  }
}, Xv = ["noll", "en", "två", "tre", "fyra", "fem", "sex", "sju", "åtta", "nio", "tio", "elva", "tolv"], Jv = function(n, r, s) {
  var a, o = Qv[n];
  return typeof o == "string" ? a = o : r === 1 ? a = o.one : s && s.onlyNumeric ? a = o.other.replace("{{count}}", String(r)) : a = o.other.replace("{{count}}", r < 13 ? Xv[r] : String(r)), s != null && s.addSuffix ? s.comparison && s.comparison > 0 ? "om " + a : a + " sedan" : a;
}, Zv = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "y-MM-dd"
}, ey = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, ty = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, ny = {
  date: ft({
    formats: Zv,
    defaultWidth: "full"
  }),
  time: ft({
    formats: ey,
    defaultWidth: "full"
  }),
  dateTime: ft({
    formats: ty,
    defaultWidth: "full"
  })
}, ry = {
  lastWeek: "'i' EEEE's kl.' p",
  yesterday: "'igår kl.' p",
  today: "'idag kl.' p",
  tomorrow: "'imorgon kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
}, sy = function(n, r, s, a) {
  return ry[n];
}, ay = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["före Kristus", "efter Kristus"]
}, oy = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1:a kvartalet", "2:a kvartalet", "3:e kvartalet", "4:e kvartalet"]
}, iy = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["jan.", "feb.", "mars", "apr.", "maj", "juni", "juli", "aug.", "sep.", "okt.", "nov.", "dec."],
  wide: ["januari", "februari", "mars", "april", "maj", "juni", "juli", "augusti", "september", "oktober", "november", "december"]
}, ly = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sö", "må", "ti", "on", "to", "fr", "lö"],
  abbreviated: ["sön", "mån", "tis", "ons", "tors", "fre", "lör"],
  wide: ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"]
}, cy = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "morg.",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt"
  },
  abbreviated: {
    am: "f.m.",
    pm: "e.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt"
  },
  wide: {
    am: "förmiddag",
    pm: "eftermiddag",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "eftermiddag",
    evening: "kväll",
    night: "natt"
  }
}, dy = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten"
  },
  abbreviated: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten"
  },
  wide: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgonen",
    afternoon: "på eftermiddagen",
    evening: "på kvällen",
    night: "på natten"
  }
}, uy = function(n, r) {
  var s = Number(n), a = s % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
      case 2:
        return s + ":a";
    }
  return s + ":e";
}, my = {
  ordinalNumber: uy,
  era: Je({
    values: ay,
    defaultWidth: "wide"
  }),
  quarter: Je({
    values: oy,
    defaultWidth: "wide",
    argumentCallback: function(n) {
      return n - 1;
    }
  }),
  month: Je({
    values: iy,
    defaultWidth: "wide"
  }),
  day: Je({
    values: ly,
    defaultWidth: "wide"
  }),
  dayPeriod: Je({
    values: cy,
    defaultWidth: "wide",
    formattingValues: dy,
    defaultFormattingWidth: "wide"
  })
}, fy = /^(\d+)(:a|:e)?/i, py = /\d+/i, hy = {
  narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
}, gy = {
  any: [/^f/i, /^[ev]/i]
}, xy = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](:a|:e)? kvartalet/i
}, by = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, vy = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
  wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
}, yy = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^maj/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, jy = {
  narrow: /^[smtofl]/i,
  short: /^(sö|må|ti|on|to|fr|lö)/i,
  abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
  wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
}, Cy = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, wy = {
  any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
}, Ny = {
  any: {
    am: /^f/i,
    pm: /^e/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgon/i,
    afternoon: /eftermiddag/i,
    evening: /kväll/i,
    night: /natt/i
  }
}, Py = {
  ordinalNumber: ms({
    matchPattern: fy,
    parsePattern: py,
    valueCallback: function(n) {
      return parseInt(n, 10);
    }
  }),
  era: Ze({
    matchPatterns: hy,
    defaultMatchWidth: "wide",
    parsePatterns: gy,
    defaultParseWidth: "any"
  }),
  quarter: Ze({
    matchPatterns: xy,
    defaultMatchWidth: "wide",
    parsePatterns: by,
    defaultParseWidth: "any",
    valueCallback: function(n) {
      return n + 1;
    }
  }),
  month: Ze({
    matchPatterns: vy,
    defaultMatchWidth: "wide",
    parsePatterns: yy,
    defaultParseWidth: "any"
  }),
  day: Ze({
    matchPatterns: jy,
    defaultMatchWidth: "wide",
    parsePatterns: Cy,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ze({
    matchPatterns: wy,
    defaultMatchWidth: "any",
    parsePatterns: Ny,
    defaultParseWidth: "any"
  })
}, Sy = {
  code: "sv",
  formatDistance: Jv,
  formatLong: ny,
  formatRelative: sy,
  localize: my,
  match: Py,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
const Yc = ({
  label: t,
  required: n,
  value: r,
  setStartDate: s,
  error: a
}) => {
  const [o, i] = L(r), [c, l] = L(Yi), [d, u] = L(!1), m = qe(null), { locale: f } = ve(), p = (g) => {
    g && (i(g), s(g), u(!1));
  }, b = () => {
    u(!d);
  };
  return Y(() => {
    l({
      sv: Sy,
      da: gv,
      en: Yi,
      de: Hv
    }[f || "en"]);
  }, [f]), Y(() => {
    const g = (v) => {
      m.current && !m.current.contains(v.target) && u(!1);
    };
    return d ? document.addEventListener("mouseup", g) : document.removeEventListener("mouseup", g), () => {
      document.removeEventListener("mouseup", g);
    };
  }, [d]), /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx("style", { children: `
    .rdp {
      --rdp-background-color: var(--colors-blue-200);
      --rdp-accent-color: var(--colors-blue-600);
      --rdp-cell-size: 45px;
    }
  ` }),
    /* @__PURE__ */ e.jsxs("div", { className: "relative w-80", children: [
      /* @__PURE__ */ e.jsx(
        rt,
        {
          label: t,
          defaultValue: o ? Dt(o, "yyyy-MM-dd") : "",
          readOnly: !0,
          onClick: b,
          required: n,
          error: a
        }
      ),
      /* @__PURE__ */ e.jsx(
        "button",
        {
          onClick: (g) => {
            g.preventDefault(), b();
          },
          className: "absolute right-3 top-11",
          children: /* @__PURE__ */ e.jsx(su, { width: 16, height: 16 })
        }
      )
    ] }),
    d && /* @__PURE__ */ e.jsx(
      "div",
      {
        ref: m,
        style: {
          position: "absolute",
          zIndex: 1,
          background: "white",
          border: "1px solid #ddd",
          marginTop: "85px"
        },
        children: /* @__PURE__ */ e.jsx(
          Xu,
          {
            id: "datepicker",
            numberOfMonths: 1,
            mode: "single",
            selected: o,
            onSelect: p,
            captionLayout: "dropdown",
            showOutsideDays: !0,
            fromDate: Mu(/* @__PURE__ */ new Date(), 50),
            toDate: /* @__PURE__ */ new Date(),
            locale: c,
            required: !0,
            modifiersClassNames: {
              day: "!text-red-600",
              range_middle: "!bg-primary-600 !rounded-none !text-white !rounded-r-none",
              range_start: "!bg-primary-600 !rounded-l-sm !text-white !rounded-r-none",
              range_end: "!bg-primary-600 !rounded-r-sm !text-white !rounded-l-none"
            }
          }
        )
      }
    )
  ] });
}, Vr = ({
  buffer: t,
  setBuffer: n,
  dataType: r,
  showError: s,
  clearErrors: a
}) => {
  const { t: o } = V(["account", "common"], {
    nsMode: "fallback"
  }), [i, c] = L(
    t ? {
      name: t == null ? void 0 : t.name,
      selectedFile: t
    } : null
  ), l = qe(null), d = (m) => {
    var p;
    const f = (p = m.target.files) == null ? void 0 : p[0];
    f && (n(f), a(), c({ name: f.name, selectedFile: f }));
  }, u = () => {
    c(null), n(void 0), a(), l.current && (l.current.value = "");
  };
  return /* @__PURE__ */ e.jsxs("div", { children: [
    /* @__PURE__ */ e.jsx("div", { children: o(`kmtoll.order.${r}.documentUpload`) }),
    /* @__PURE__ */ e.jsx("div", { className: "max-w-fit", children: /* @__PURE__ */ e.jsxs(
      et,
      {
        as: "button",
        loadingLabel: o("action.loading"),
        className: "mt-4 rounded",
        intent: "outlined",
        onClick: () => {
          var m;
          return (m = l.current) == null ? void 0 : m.click();
        },
        children: [
          /* @__PURE__ */ e.jsx(
            "input",
            {
              type: "file",
              accept: "application/pdf",
              id: "fileInput",
              ref: l,
              className: "hidden",
              onChange: d
            }
          ),
          /* @__PURE__ */ e.jsxs("span", { className: "flex items-center", children: [
            /* @__PURE__ */ e.jsx(au, { className: "mr-2" }),
            o(`kmtoll.order.${r}.documentUploadButton`)
          ] })
        ]
      }
    ) }),
    i && /* @__PURE__ */ e.jsxs("div", { className: "mt-6 flex items-center", children: [
      /* @__PURE__ */ e.jsx(ou, { className: "mr-2 cursor-pointer", onClick: u }),
      i.name
    ] }),
    s && /* @__PURE__ */ e.jsx(tr, { as: "div", id: "fileError", error: s })
  ] });
}, Qc = ({
  licensePlate: t,
  country: n,
  className: r
}) => /* @__PURE__ */ e.jsx("div", { className: r, children: /* @__PURE__ */ e.jsxs("div", { className: "border-licensePlateBlue flex w-fit items-center rounded-md border-4 ", children: [
  /* @__PURE__ */ e.jsx("div", { className: "bg-licensePlateBlue px-1 py-2 text-2xl font-medium text-white", children: n }),
  /* @__PURE__ */ e.jsx("div", { className: "font-licensePlate px-2 text-3xl", children: /* @__PURE__ */ e.jsx("h1", { children: t }) })
] }) }), Ty = 1048576, Ey = Ty * 10, ky = [
  "firstRegistrationDate",
  "grossWeight",
  "vinNo",
  "numberOfAxels",
  "fuelType",
  "euroEmissionNorm",
  "co2EmissionClass"
], Ay = ["fuelType", "euroEmissionNorm"], Oy = () => {
  var oe, le, _e, $e, ie, ye, we, Ae, J, Pe, Te, te;
  const { t } = V(["account", "common"], {
    nsMode: "fallback"
  }), n = Kn(), r = !!(n != null && n.get("toll-collect")), { formData: s, updateFormData: a, updateStep: o } = Ct(), [i, c] = L(!1), { fuelTypes: l, fuelTypeHybridIDs: d, emissionClasses: u, co2EmissionClasses: m } = At(), { co2VehicleSubgroups: f } = so(), {
    register: p,
    handleSubmit: b,
    setValue: h,
    formState: { errors: g },
    watch: v,
    clearErrors: y
  } = Nn({
    defaultValues: {
      ...s,
      fuelTypeId: (oe = s.fuelTypeId) == null ? void 0 : oe.toString(),
      grossWeight: ((le = s == null ? void 0 : s.grossWeight) == null ? void 0 : le.toString()) || "",
      co2EmissionClass: (s == null ? void 0 : s.co2EmissionClass) ?? Dn,
      co2VehicleGroup: (s == null ? void 0 : s.co2VehicleGroup) ?? Xe.Empty
    },
    resolver: Gn(
      s.showExtendedForm ? (
        // Use extended parser (tollCollectVehicleInfoHGVParserWithOptionalVinNo) if flagAllowTollCollect false
        r ? ol : il
      ) : ll
    )
  }), [x, j] = L(
    ((_e = s == null ? void 0 : s.co2EmissionClass) == null ? void 0 : _e.toString()) ?? "1"
  ), w = v("co2EmissionClass"), C = v("fuelTypeId"), P = v("numberOfAxels"), N = v("co2VehicleGroup"), [R, T] = L(
    s != null && s.firstRegistrationDate ? new Date(s.firstRegistrationDate) : void 0
  ), [z, D] = L(!1), [A, S] = L(
    s.vehicleInfoFile
  ), _ = !(s.bilvisionFields.length > 0) && !!s.showExtendedForm, [$, q] = L(
    void 0
  ), [U, W] = L(
    s.co2File
  ), [G, ee] = L(void 0), ue = w !== Dn && !!s.showExtendedForm, ce = K(() => {
    const B = C || s.fuelTypeId;
    if (B && (l == null ? void 0 : l.length) > 0) {
      const k = l.find(
        (X) => X.value === B
      );
      return k == null ? void 0 : k.tariffClassification;
    }
    return "";
  }, [C, s.fuelTypeId, l]), re = K(() => P === "2" ? [
    { label: Xe.Four, value: Xe.Four },
    { label: Xe.Five, value: Xe.Five }
  ] : P !== "" ? [
    { label: Xe.Nine, value: Xe.Nine },
    { label: Xe.Ten, value: Xe.Ten }
  ] : [], [P]);
  Y(() => {
    h("co2VehicleGroup", Xe.Empty);
  }, [P, h]), Y(() => {
    h("co2VehicleSubgroup", cl.Empty);
  }, [N, h]);
  const se = K(() => l.find((B) => B.value === C), [C, l]), H = ue && _ && U && A && (U == null ? void 0 : U.size) === (A == null ? void 0 : A.size), O = R && R < Dr, ae = async (B) => {
    q(void 0), ee(void 0), c(!0);
    const k = ["application/pdf"], X = (Ce, Ee, Fe, _t) => {
      if (Fe && !Ee)
        throw Ce(
          t(
            "singleOrderBizzFlow.order.additionalVehicleData.vehicleInfo.documentError"
          )
        ), "Document is missing: " + _t;
      if (A != null && A.size && A.size > Ey)
        throw Ce(
          t("form.validations.fileUpload.invalidSize", {
            maxSize: "10 MB"
          })
        ), "Invalid size: " + _t;
      if (Ee && !k.includes(Ee.type))
        throw Ce(t("form.validations.invalidFileType")), "Wrong file type: " + _t;
    };
    try {
      if (s.showExtendedForm && (X(ee, U, ue, "Co2"), X(
        q,
        A,
        _,
        "VehicleInfo"
      )), H) {
        c(!1);
        return;
      }
      const Ce = s.isHybrid !== void 0 ? !!s.isHybrid : d.includes(B.fuelTypeId);
      a({
        ...B,
        tariffClassification: ce,
        isHybrid: Ce,
        type: "bizz",
        co2File: U,
        vehicleInfoFile: A,
        fuelType: (s == null ? void 0 : s.bilvisionFields).length > 0 && (s == null ? void 0 : s.bilvisionFields).includes("fuelType") ? B == null ? void 0 : B.fuelType : se ?? ""
      }), o(3), c(!1);
    } catch {
      c(!1);
    }
  }, ge = (B) => {
    B && B < Dr ? (j(ze.Class_1), je("co2EmissionClass", Dn), D(!0)) : D(!1), I(), je("firstRegistrationDate", B.toString()), T(B);
  }, je = (B, k) => {
    I(), h(B, k), a({
      [B]: k
    });
  }, I = () => {
    y(), ee(void 0), q(void 0);
  }, F = (B) => {
    B === ze.Class_1 ? (je("co2EmissionClass", B), j(ze.Class_1)) : B === ze.Class_2 && (je("co2EmissionClass", B), j(ze.Class_2));
  }, We = (B) => {
    try {
      return Dt(new Date(B), "yyyy-MM-dd");
    } catch {
      return B;
    }
  };
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-8", children: [
    /* @__PURE__ */ e.jsx("h2", { className: "text-2xl font-semibold", children: t("singleOrderBizzFlow.order.additionalVehicleData.title") }),
    /* @__PURE__ */ e.jsx(
      Qc,
      {
        licensePlate: s.licensePlate,
        country: s.country
      }
    ),
    s.bilvisionFields.length > 0 && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(st, { colorMode: "success", className: "mt-10", children: t(
        "singleOrderBizzFlow.order.userFeedback.success.vehicleInfoFromBilVision"
      ) }),
      /* @__PURE__ */ e.jsx(
        Fn,
        {
          heading: t("singleOrderBizzFlow.order.summary.vehicleInfo.title"),
          vehicleInfo: s.bilvisionFields.filter(
            (B) => s.showExtendedForm ? ky.includes(B) : Ay.includes(B)
          ).map((B) => {
            const k = s[B];
            return {
              title: t(`form.labels.${B}`),
              value: B === "firstRegistrationDate" ? We(k) : k
            };
          })
        }
      )
    ] }),
    /* @__PURE__ */ e.jsxs("form", { onSubmit: b(ae), className: "w-full", children: [
      /* @__PURE__ */ e.jsxs(fs, { allowFull: !0, children: [
        /* @__PURE__ */ e.jsx(
          Ue,
          {
            field: "firstRegistrationDate",
            hideUnlessHGV: !0,
            children: /* @__PURE__ */ e.jsx(
              Yc,
              {
                label: t("form.labels.stateDateForRegistry"),
                required: !0,
                value: R,
                setStartDate: ge,
                error: g.firstRegistrationDate ? t("form.datePicker.reqiured") : void 0
              }
            )
          }
        ),
        /* @__PURE__ */ e.jsx(Ue, { field: "vinNo", hideUnlessHGV: !0, children: r && /* @__PURE__ */ e.jsx(
          rt,
          {
            ...p("vinNo"),
            label: `${t("form.labels.vinNo")}`,
            name: "vinNo",
            type: "string",
            className: "w-80",
            required: !0,
            error: g.vinNo ? t("form.validations.vinNo.length") : void 0,
            onChange: (B) => je("vinNo", B.target.value)
          }
        ) }),
        /* @__PURE__ */ e.jsx(
          Ue,
          {
            field: "grossWeight",
            hideUnlessHGV: !0,
            children: /* @__PURE__ */ e.jsx(
              rt,
              {
                ...p("grossWeight"),
                label: `${t("form.labels.vehicleGrossWeight")}`,
                name: "grossWeight",
                required: !0,
                type: "number",
                className: "w-80",
                error: ($e = g.grossWeight) != null && $e.message ? t((ie = g.grossWeight) == null ? void 0 : ie.message) : void 0,
                onChange: (B) => je("grossWeight", B.target.value)
              }
            )
          }
        ),
        /* @__PURE__ */ e.jsx(Ue, { field: "fuelTypeId", children: /* @__PURE__ */ e.jsx(
          mt,
          {
            ...p("fuelTypeId"),
            label: `${t("form.labels.fuelType")}`,
            required: !0,
            placeholder: t("form.placeholders.fuelType"),
            options: l.sort(
              (B, k) => B.label.localeCompare(k.label)
            ),
            className: "w-80",
            initialValue: C,
            error: (ye = g.fuelTypeId) != null && ye.message ? t("form.validations.fuelType.required") : void 0,
            onChange: (B) => je("fuelTypeId", B)
          }
        ) }),
        z && /* @__PURE__ */ e.jsx(st, { colorMode: "information", className: "mt-8", children: t(
          "singleOrderBizzFlow.order.additionalVehicleData.vehicleInfo.co2EmissionClass"
        ) }),
        /* @__PURE__ */ e.jsx(Ue, { field: "euroEmissionNorm", children: /* @__PURE__ */ e.jsx(
          mt,
          {
            ...p("euroEmissionNorm"),
            label: `${t("form.labels.euroEmissionNorm")}`,
            required: !0,
            placeholder: t("form.placeholders.euroEmissionNorm"),
            options: u,
            className: "w-80",
            initialValue: s.euroEmissionNorm ?? void 0,
            error: (we = g.euroEmissionNorm) != null && we.message ? t("form.validations.euroEmissionNorm.required") : void 0,
            onChange: (B) => je("euroEmissionNorm", B)
          }
        ) }),
        /* @__PURE__ */ e.jsx(
          Ue,
          {
            field: "numberOfAxels",
            hideUnlessHGV: !0,
            children: /* @__PURE__ */ e.jsxs("div", { className: "w-80", children: [
              /* @__PURE__ */ e.jsx(
                Rt.Root,
                {
                  className: "block gap-0 text-sm font-medium text-neutral-950",
                  name: "numberOfAxels",
                  onChange: (B) => je("numberOfAxels", B.target.value),
                  label: `${t("form.labels.numberOfAxels")}`,
                  required: !0,
                  value: P,
                  children: pl.map(({ label: B, value: k }) => /* @__PURE__ */ e.jsx(
                    Rt.Item,
                    {
                      label: B,
                      value: k,
                      className: "mx-[-0.5rem]"
                    },
                    B + k
                  ))
                }
              ),
              /* @__PURE__ */ e.jsx(
                tr,
                {
                  id: "numberOfAxels",
                  as: "div",
                  error: (Ae = g.numberOfAxels) != null && Ae.message ? t("form.validations.numberOfAxels.required") : void 0,
                  className: "w-80"
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ e.jsx(Ue, { hideUnlessHGV: !0, children: /* @__PURE__ */ e.jsx(Kc, { children: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx(
            Br,
            {
              label: t("form.labels.co2Class1"),
              value: ze.Class_1,
              keyValue: `CO2 class ${ze.Class_1} ${ze.Class_1}`,
              name: "co2Overview",
              checked: x === ze.Class_1,
              onChange: (B) => {
                F(B.target.value);
              }
            }
          ),
          /* @__PURE__ */ e.jsx(
            Br,
            {
              label: t("form.labels.co2Class2_5"),
              description: t("form.descriptions.co2Class2_5"),
              value: ze.Class_2,
              keyValue: `CO2 class ${ze.Class_2}, ${ze.Class_3}, ${ze.Class_4}, or ${ze.Class_5} ${ze.Class_2}+`,
              name: "co2Overview",
              disabled: O,
              checked: !!x && +x > +ze.Class_1,
              onChange: (B) => {
                F(B.target.value);
              },
              children: /* @__PURE__ */ e.jsxs("div", { className: "mt-14 flex flex-col gap-10 px-10", children: [
                /* @__PURE__ */ e.jsx(
                  Ue,
                  {
                    field: "co2EmissionClass",
                    hideUnlessHGV: !0,
                    children: /* @__PURE__ */ e.jsxs("div", { className: "w-80", children: [
                      /* @__PURE__ */ e.jsx(
                        Rt.Root,
                        {
                          className: "block gap-0 text-sm font-medium text-neutral-950",
                          name: "co2EmissionClass",
                          onChange: (B) => je(
                            "co2EmissionClass",
                            B.target.value
                          ),
                          label: `${t("form.placeholders.co2EmissionClass")}`,
                          value: w,
                          required: !0,
                          children: m.slice(1).map(({ label: B, value: k }) => /* @__PURE__ */ e.jsx(
                            Rt.Item,
                            {
                              label: B,
                              value: k,
                              disabled: O,
                              className: "mx-[-0.5rem]"
                            },
                            B + k
                          ))
                        }
                      ),
                      /* @__PURE__ */ e.jsx(
                        tr,
                        {
                          id: "co2EmissionClass",
                          as: "div",
                          error: w ? void 0 : t(
                            "form.validations.co2EmissionClass.required"
                          ),
                          className: "w-80"
                        }
                      )
                    ] })
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  Ue,
                  {
                    field: "specificCo2Emissions",
                    hideUnlessHGV: !0,
                    children: /* @__PURE__ */ e.jsx(
                      rt,
                      {
                        ...p("specificCo2Emissions"),
                        label: `${t("form.labels.specificCo2Emissions")}`,
                        description: `${t(
                          "form.descriptions.specificCo2Emissions"
                        )}`,
                        name: "specificCo2Emissions",
                        type: "string",
                        className: "w-80",
                        required: ue,
                        disabled: !ue,
                        error: g.specificCo2Emissions ? t(
                          "form.validations.specificCo2Emissions.required"
                        ) : void 0,
                        onChange: (B) => je(
                          "specificCo2Emissions",
                          B.target.value
                        )
                      }
                    )
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  Ue,
                  {
                    field: "co2VehicleGroup",
                    hideUnlessHGV: !0,
                    children: /* @__PURE__ */ e.jsx(
                      mt,
                      {
                        ...p("co2VehicleGroup"),
                        label: `${t("form.labels.co2VehicleGroup")}`,
                        required: ue,
                        disabled: !ue,
                        placeholder: t("form.placeholders.co2VehicleGroup"),
                        options: re,
                        className: "w-80",
                        resetValueOnOptionsChange: !0,
                        initialValue: s.co2VehicleGroup ?? void 0,
                        error: (J = g.co2VehicleGroup) != null && J.message ? t((Pe = g.co2VehicleGroup) == null ? void 0 : Pe.message) : void 0,
                        onChange: (B) => je("co2VehicleGroup", B)
                      }
                    )
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  Ue,
                  {
                    field: "co2VehicleSubgroup",
                    hideUnlessHGV: !0,
                    children: /* @__PURE__ */ e.jsx(
                      mt,
                      {
                        ...p("co2VehicleSubgroup"),
                        label: `${t("form.labels.co2VehicleSubgroup")}`,
                        required: ue,
                        disabled: !ue || !N,
                        placeholder: t(
                          "form.placeholders.co2VehicleSubgroup"
                        ),
                        options: (f == null ? void 0 : f[N]) ?? [],
                        className: "w-80",
                        resetValueOnOptionsChange: !0,
                        initialValue: s.co2VehicleSubgroup ?? void 0,
                        error: (Te = g.co2VehicleSubgroup) != null && Te.message ? t((te = g.co2VehicleSubgroup) == null ? void 0 : te.message) : void 0,
                        onChange: (B) => je("co2VehicleSubgroup", B)
                      }
                    )
                  }
                ),
                /* @__PURE__ */ e.jsxs("div", { children: [
                  /* @__PURE__ */ e.jsx("h2", { className: "text-2xl font-semibold", children: t(
                    "singleOrderBizzFlow.order.additionalVehicleData.supportingDocuments.title"
                  ) }),
                  /* @__PURE__ */ e.jsx("div", { className: "mt-3", children: t(
                    "singleOrderBizzFlow.order.additionalVehicleData.supportingDocuments.accpetedFormats"
                  ) })
                ] }),
                /* @__PURE__ */ e.jsx(
                  Vr,
                  {
                    buffer: s.co2File,
                    setBuffer: W,
                    showError: G,
                    dataType: "co2",
                    clearErrors: I
                  }
                )
              ] })
            }
          )
        ] }) }) }),
        _ && /* @__PURE__ */ e.jsxs("div", { children: [
          /* @__PURE__ */ e.jsx("h2", { className: "text-2xl font-semibold", children: t(
            "singleOrderBizzFlow.order.additionalVehicleData.supportingDocuments.title"
          ) }),
          /* @__PURE__ */ e.jsx("div", { className: "mt-3", children: t(
            "singleOrderBizzFlow.order.additionalVehicleData.supportingDocuments.accpetedFormats"
          ) })
        ] }),
        _ && /* @__PURE__ */ e.jsx(
          Vr,
          {
            buffer: s.vehicleInfoFile,
            setBuffer: S,
            showError: $,
            dataType: "vehicleInfo",
            clearErrors: I
          }
        ),
        H && /* @__PURE__ */ e.jsx(st, { colorMode: "error", children: t("kmtoll.order.vehicleInfo.sameDocumentError") })
      ] }),
      /* @__PURE__ */ e.jsxs("div", { children: [
        /* @__PURE__ */ e.jsx("hr", { className: "mt-8" }),
        /* @__PURE__ */ e.jsxs("div", { className: "mb-4 mt-8 flex items-center gap-4", children: [
          /* @__PURE__ */ e.jsx(
            be,
            {
              as: "button",
              intent: "outlined",
              onClick: () => o((B) => B - 1),
              children: t("action.back")
            }
          ),
          /* @__PURE__ */ e.jsx(
            Gr,
            {
              href: "/account/vehicles",
              className: "ml-auto pr-4 font-medium text-blue-700 underline",
              children: t("action.cancel")
            }
          ),
          /* @__PURE__ */ e.jsx(
            et,
            {
              as: "button",
              type: "submit",
              loadingLabel: t("action.loading"),
              isLoading: i,
              children: t("action.next")
            }
          )
        ] })
      ] })
    ] })
  ] }) });
}, _y = 1048576, Ry = _y * 10, My = [
  "firstRegistrationDate",
  "grossWeight",
  "vinNo",
  "numberOfAxels",
  "fuelType",
  "euroEmissionNorm",
  "co2EmissionClass"
], zy = ["fuelType", "euroEmissionNorm"], Dy = () => {
  var oe, le, _e, $e, ie, ye, we, Ae, J, Pe, Te, te, B;
  const { t } = V(["account", "common"], {
    nsMode: "fallback"
  }), n = Kn(), r = !!(n != null && n.get("toll-collect")), { formData: s, updateFormData: a, updateStep: o } = Ct(), [i, c] = L(!1), { fuelTypes: l, fuelTypeHybridIDs: d, emissionClasses: u, co2EmissionClasses: m } = At(), { co2VehicleSubgroups: f } = so(), {
    register: p,
    handleSubmit: b,
    setValue: h,
    formState: { errors: g },
    watch: v,
    clearErrors: y
  } = Nn({
    defaultValues: {
      ...s,
      fuelTypeId: (oe = s.fuelTypeId) == null ? void 0 : oe.toString(),
      grossWeight: ((le = s == null ? void 0 : s.grossWeight) == null ? void 0 : le.toString()) || "",
      co2EmissionClass: ((_e = s == null ? void 0 : s.co2EmissionClass) == null ? void 0 : _e.toString()) ?? Dn,
      co2VehicleGroup: (s == null ? void 0 : s.co2VehicleGroup) ?? Xe.Empty
    },
    resolver: Gn(
      s.showExtendedForm ? (
        // Use extended parser (tollCollectVehicleInfoHGVParserWithOptionalVinNo) if flagAllowTollCollect false
        r ? ol : il
      ) : ll
    )
  }), [x, j] = L(
    (($e = s == null ? void 0 : s.co2EmissionClass) == null ? void 0 : $e.toString()) ?? "1"
  ), w = v("co2EmissionClass"), C = v("fuelTypeId"), P = v("numberOfAxels"), N = v("co2VehicleGroup"), [R, T] = L(
    s != null && s.firstRegistrationDate ? new Date(s.firstRegistrationDate) : void 0
  ), [z, D] = L(!1), [A, S] = L(
    s.vehicleInfoFile
  ), _ = !(s.bilvisionFields.length > 0) && !!s.showExtendedForm, [$, q] = L(
    void 0
  ), [U, W] = L(
    s.co2File
  ), [G, ee] = L(void 0), ue = w !== Dn && !!s.showExtendedForm, ce = K(() => {
    const k = C || s.fuelTypeId;
    if (k && (l == null ? void 0 : l.length) > 0) {
      const X = l.find(
        (Ce) => Ce.value === k
      );
      return X == null ? void 0 : X.tariffClassification;
    }
    return "";
  }, [C, s.fuelTypeId, l]), re = K(() => P === "2" ? [
    { label: Xe.Four, value: Xe.Four },
    { label: Xe.Five, value: Xe.Five }
  ] : P !== "" ? [
    { label: Xe.Nine, value: Xe.Nine },
    { label: Xe.Ten, value: Xe.Ten }
  ] : [], [P]);
  Y(() => {
    h("co2VehicleGroup", Xe.Empty);
  }, [P, h]), Y(() => {
    h("co2VehicleSubgroup", cl.Empty);
  }, [N, h]);
  const se = K(() => l.find((k) => k.value === C), [C, l]), H = ue && _ && U && A && (U == null ? void 0 : U.size) === (A == null ? void 0 : A.size), O = R && R < Dr, ae = async (k) => {
    q(void 0), ee(void 0), c(!0);
    const X = ["application/pdf"], Ce = (Ee, Fe, _t, qt) => {
      if (_t && !Fe)
        throw Ee(
          t(
            "singleOrderBizzFlow.order.additionalVehicleData.vehicleInfo.documentError"
          )
        ), "Document is missing: " + qt;
      if (A != null && A.size && A.size > Ry)
        throw Ee(
          t("form.validations.fileUpload.invalidSize", {
            maxSize: "10 MB"
          })
        ), "Invalid size: " + qt;
      if (Fe && !X.includes(Fe.type))
        throw Ee(t("form.validations.invalidFileType")), "Wrong file type: " + qt;
    };
    try {
      if (s.showExtendedForm && (Ce(ee, U, ue, "Co2"), Ce(
        q,
        A,
        _,
        "VehicleInfo"
      )), H) {
        c(!1);
        return;
      }
      const Ee = s.isHybrid !== void 0 ? !!s.isHybrid : d.includes(k.fuelTypeId);
      a({
        ...k,
        tariffClassification: ce,
        isHybrid: Ee,
        type: "bizz",
        co2File: U,
        vehicleInfoFile: A,
        fuelType: (s == null ? void 0 : s.bilvisionFields).length > 0 && (s == null ? void 0 : s.bilvisionFields).includes("fuelType") ? k == null ? void 0 : k.fuelType : se ?? ""
      }), o(3), c(!1);
    } catch {
      c(!1);
    }
  }, ge = (k) => {
    k && k < Dr ? (j(ze.Class_1), je("co2EmissionClass", Dn), D(!0)) : D(!1), I(), je("firstRegistrationDate", k.toString()), T(k);
  }, je = (k, X) => {
    I(), h(k, X), a({
      [k]: X
    });
  }, I = () => {
    y(), ee(void 0), q(void 0);
  }, F = (k) => {
    k === ze.Class_1 ? (je("co2EmissionClass", k), j(ze.Class_1)) : k === ze.Class_2 && (je("co2EmissionClass", k), j(ze.Class_2));
  }, We = (k) => {
    try {
      return Dt(new Date(k), "yyyy-MM-dd");
    } catch {
      return k;
    }
  };
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-8", children: [
    /* @__PURE__ */ e.jsx("h2", { className: "text-2xl font-semibold", children: t("singleOrderBizzFlow.order.additionalVehicleData.title") }),
    /* @__PURE__ */ e.jsx(
      Qc,
      {
        licensePlate: s.licensePlate,
        country: s.country
      }
    ),
    s.bilvisionFields.length > 0 && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(st, { colorMode: "success", className: "mt-10", children: t(
        "singleOrderBizzFlow.order.userFeedback.success.vehicleInfoFromBilVision"
      ) }),
      /* @__PURE__ */ e.jsx(
        Fn,
        {
          heading: t("singleOrderBizzFlow.order.summary.vehicleInfo.title"),
          vehicleInfo: s.bilvisionFields.filter(
            (k) => s.showExtendedForm ? My.includes(k) : zy.includes(k)
          ).map((k) => {
            const X = s[k];
            return {
              title: t(`form.labels.${k}`),
              value: k === "firstRegistrationDate" ? We(X) : X
            };
          })
        }
      )
    ] }),
    /* @__PURE__ */ e.jsxs("form", { onSubmit: b(ae), className: "w-full", children: [
      /* @__PURE__ */ e.jsxs(fs, { allowFull: !0, children: [
        /* @__PURE__ */ e.jsx(
          Ue,
          {
            field: "firstRegistrationDate",
            hideUnlessHGV: !0,
            children: /* @__PURE__ */ e.jsx(
              Yc,
              {
                label: t("form.labels.stateDateForRegistry"),
                required: !0,
                value: R,
                setStartDate: ge,
                error: g.firstRegistrationDate ? t("form.datePicker.reqiured") : void 0
              }
            )
          }
        ),
        /* @__PURE__ */ e.jsx(Ue, { field: "vinNo", hideUnlessHGV: !0, children: r && /* @__PURE__ */ e.jsx(
          rt,
          {
            ...p("vinNo"),
            label: `${t("form.labels.vinNo")}`,
            name: "vinNo",
            type: "string",
            className: "w-80",
            required: !0,
            error: g.vinNo ? t("form.validations.vinNo.length") : void 0,
            onChange: (k) => je("vinNo", k.target.value)
          }
        ) }),
        /* @__PURE__ */ e.jsx(
          Ue,
          {
            field: "grossWeight",
            hideUnlessHGV: !0,
            children: /* @__PURE__ */ e.jsx(
              rt,
              {
                ...p("grossWeight"),
                label: `${t("form.labels.vehicleGrossWeight")}`,
                name: "grossWeight",
                required: !0,
                type: "number",
                className: "w-80",
                error: (ie = g.grossWeight) != null && ie.message ? t((ye = g.grossWeight) == null ? void 0 : ye.message) : void 0,
                onChange: (k) => je("grossWeight", k.target.value)
              }
            )
          }
        ),
        /* @__PURE__ */ e.jsx(Ue, { field: "fuelTypeId", children: /* @__PURE__ */ e.jsx(
          mt,
          {
            ...p("fuelTypeId"),
            label: `${t("form.labels.fuelType")}`,
            required: !0,
            placeholder: t("form.placeholders.fuelType"),
            options: l.sort(
              (k, X) => k.label.localeCompare(X.label)
            ),
            className: "w-80",
            initialValue: C,
            error: (we = g.fuelTypeId) != null && we.message ? t("form.validations.fuelType.required") : void 0,
            onChange: (k) => je("fuelTypeId", k)
          }
        ) }),
        z && /* @__PURE__ */ e.jsx(st, { colorMode: "information", className: "mt-8", children: t(
          "singleOrderBizzFlow.order.additionalVehicleData.vehicleInfo.co2EmissionClass"
        ) }),
        /* @__PURE__ */ e.jsx(Ue, { field: "euroEmissionNorm", children: /* @__PURE__ */ e.jsx(
          mt,
          {
            ...p("euroEmissionNorm"),
            label: `${t("form.labels.euroEmissionNorm")}`,
            required: !0,
            placeholder: t("form.placeholders.euroEmissionNorm"),
            options: u,
            className: "w-80",
            initialValue: s.euroEmissionNorm ?? void 0,
            error: (Ae = g.euroEmissionNorm) != null && Ae.message ? t("form.validations.euroEmissionNorm.required") : void 0,
            onChange: (k) => je("euroEmissionNorm", k)
          }
        ) }),
        /* @__PURE__ */ e.jsx(
          Ue,
          {
            field: "numberOfAxels",
            hideUnlessHGV: !0,
            children: /* @__PURE__ */ e.jsxs("div", { className: "w-80", children: [
              /* @__PURE__ */ e.jsx(
                Rt.Root,
                {
                  className: "block gap-0 text-sm font-medium text-neutral-950",
                  name: "numberOfAxels",
                  onChange: (k) => je("numberOfAxels", k.target.value),
                  label: `${t("form.labels.numberOfAxels")}`,
                  required: !0,
                  value: P,
                  children: pl.map(({ label: k, value: X }) => /* @__PURE__ */ e.jsx(
                    Rt.Item,
                    {
                      label: k,
                      value: X,
                      className: "mx-[-0.5rem]"
                    },
                    k + X
                  ))
                }
              ),
              /* @__PURE__ */ e.jsx(
                tr,
                {
                  id: "numberOfAxels",
                  as: "div",
                  error: (J = g.numberOfAxels) != null && J.message ? t("form.validations.numberOfAxels.required") : void 0,
                  className: "w-80"
                }
              )
            ] })
          }
        ),
        /* @__PURE__ */ e.jsx(Ue, { hideUnlessHGV: !0, children: /* @__PURE__ */ e.jsx(Kc, { children: /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx(
            Br,
            {
              label: t("form.labels.co2Class1"),
              value: ze.Class_1,
              keyValue: `CO2 class ${ze.Class_1} ${ze.Class_1}`,
              name: "co2Overview",
              checked: x === ze.Class_1,
              onChange: (k) => {
                F(k.target.value);
              }
            }
          ),
          /* @__PURE__ */ e.jsx(
            Br,
            {
              label: t("form.labels.co2Class2_5"),
              description: t("form.descriptions.co2Class2_5"),
              value: ze.Class_2,
              keyValue: `CO2 class ${ze.Class_2}, ${ze.Class_3}, ${ze.Class_4}, or ${ze.Class_5} ${ze.Class_2}+`,
              name: "co2Overview",
              disabled: O,
              checked: !!x && +x > +ze.Class_1,
              onChange: (k) => {
                F(k.target.value);
              },
              children: /* @__PURE__ */ e.jsxs("div", { className: "mt-14 flex flex-col gap-10 px-10", children: [
                /* @__PURE__ */ e.jsx(
                  Ue,
                  {
                    field: "co2EmissionClass",
                    hideUnlessHGV: !0,
                    children: /* @__PURE__ */ e.jsxs("div", { className: "w-80", children: [
                      /* @__PURE__ */ e.jsx(
                        Rt.Root,
                        {
                          className: "block gap-0 text-sm font-medium text-neutral-950",
                          name: "co2EmissionClass",
                          onChange: (k) => je(
                            "co2EmissionClass",
                            k.target.value
                          ),
                          label: `${t("form.placeholders.co2EmissionClass")}`,
                          value: w,
                          required: !0,
                          children: m.slice(1).map(({ label: k, value: X }) => /* @__PURE__ */ e.jsx(
                            Rt.Item,
                            {
                              label: k,
                              value: X,
                              disabled: O,
                              className: "mx-[-0.5rem]"
                            },
                            k + X
                          ))
                        }
                      ),
                      /* @__PURE__ */ e.jsx(
                        tr,
                        {
                          id: "co2EmissionClass",
                          as: "div",
                          error: w ? void 0 : t(
                            "form.validations.co2EmissionClass.required"
                          ),
                          className: "w-80"
                        }
                      )
                    ] })
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  Ue,
                  {
                    field: "specificCo2Emissions",
                    hideUnlessHGV: !0,
                    children: /* @__PURE__ */ e.jsx(
                      rt,
                      {
                        ...p("specificCo2Emissions"),
                        label: `${t("form.labels.specificCo2Emissions")}`,
                        description: `${t(
                          "form.descriptions.specificCo2Emissions"
                        )}`,
                        name: "specificCo2Emissions",
                        type: "string",
                        className: "w-80",
                        required: ue,
                        disabled: !ue,
                        error: g.specificCo2Emissions ? t(
                          "form.validations.specificCo2Emissions.required"
                        ) : void 0,
                        onChange: (k) => je(
                          "specificCo2Emissions",
                          k.target.value
                        )
                      }
                    )
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  Ue,
                  {
                    field: "co2VehicleGroup",
                    hideUnlessHGV: !0,
                    children: /* @__PURE__ */ e.jsx(
                      mt,
                      {
                        ...p("co2VehicleGroup"),
                        label: `${t("form.labels.co2VehicleGroup")}`,
                        required: ue,
                        disabled: !ue,
                        placeholder: t("form.placeholders.co2VehicleGroup"),
                        options: re,
                        className: "w-80",
                        resetValueOnOptionsChange: !0,
                        initialValue: s.co2VehicleGroup ?? void 0,
                        error: (Pe = g.co2VehicleGroup) != null && Pe.message ? t((Te = g.co2VehicleGroup) == null ? void 0 : Te.message) : void 0,
                        onChange: (k) => je("co2VehicleGroup", k)
                      }
                    )
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  Ue,
                  {
                    field: "co2VehicleSubgroup",
                    hideUnlessHGV: !0,
                    children: /* @__PURE__ */ e.jsx(
                      mt,
                      {
                        ...p("co2VehicleSubgroup"),
                        label: `${t("form.labels.co2VehicleSubgroup")}`,
                        required: ue,
                        disabled: !ue || !N,
                        placeholder: t(
                          "form.placeholders.co2VehicleSubgroup"
                        ),
                        options: (f == null ? void 0 : f[N]) ?? [],
                        className: "w-80",
                        resetValueOnOptionsChange: !0,
                        initialValue: s.co2VehicleSubgroup ?? void 0,
                        error: (te = g.co2VehicleSubgroup) != null && te.message ? t((B = g.co2VehicleSubgroup) == null ? void 0 : B.message) : void 0,
                        onChange: (k) => je("co2VehicleSubgroup", k)
                      }
                    )
                  }
                ),
                /* @__PURE__ */ e.jsxs("div", { children: [
                  /* @__PURE__ */ e.jsx("h2", { className: "text-2xl font-semibold", children: t(
                    "singleOrderBizzFlow.order.additionalVehicleData.supportingDocuments.title"
                  ) }),
                  /* @__PURE__ */ e.jsx("div", { className: "mt-3", children: t(
                    "singleOrderBizzFlow.order.additionalVehicleData.supportingDocuments.accpetedFormats"
                  ) })
                ] }),
                /* @__PURE__ */ e.jsx(
                  Vr,
                  {
                    buffer: s.co2File,
                    setBuffer: W,
                    showError: G,
                    dataType: "co2",
                    clearErrors: I
                  }
                )
              ] })
            }
          )
        ] }) }) }),
        _ && /* @__PURE__ */ e.jsxs("div", { children: [
          /* @__PURE__ */ e.jsx("h2", { className: "text-2xl font-semibold", children: t(
            "singleOrderBizzFlow.order.additionalVehicleData.supportingDocuments.title"
          ) }),
          /* @__PURE__ */ e.jsx("div", { className: "mt-3", children: t(
            "singleOrderBizzFlow.order.additionalVehicleData.supportingDocuments.accpetedFormats"
          ) })
        ] }),
        _ && /* @__PURE__ */ e.jsx(
          Vr,
          {
            buffer: s.vehicleInfoFile,
            setBuffer: S,
            showError: $,
            dataType: "vehicleInfo",
            clearErrors: I
          }
        ),
        H && /* @__PURE__ */ e.jsx(st, { colorMode: "error", children: t("kmtoll.order.vehicleInfo.sameDocumentError") })
      ] }),
      /* @__PURE__ */ e.jsxs("div", { children: [
        /* @__PURE__ */ e.jsx("hr", { className: "mt-8" }),
        /* @__PURE__ */ e.jsxs("div", { className: "mb-4 mt-8 flex items-center gap-4", children: [
          /* @__PURE__ */ e.jsx(
            be,
            {
              as: "button",
              intent: "outlined",
              onClick: () => o((k) => k - 1),
              children: t("action.back")
            }
          ),
          /* @__PURE__ */ e.jsx(
            Gr,
            {
              href: "/account/vehicles",
              className: "ml-auto pr-4 font-medium text-blue-700 underline",
              children: t("action.cancel")
            }
          ),
          /* @__PURE__ */ e.jsx(
            et,
            {
              as: "button",
              type: "submit",
              loadingLabel: t("action.loading"),
              isLoading: i,
              children: t("action.next")
            }
          )
        ] })
      ] })
    ] })
  ] }) });
};
var er = /* @__PURE__ */ ((t) => (t.reference = "reference", t.referenceTollCollect = "referenceTollCollect", t))(er || {});
const Xc = ({
  heading: t,
  obus: n,
  className: r,
  subHeading: s,
  register: a,
  errors: o,
  onChange: i
}) => {
  const { t: c } = V(["account", "common"], { nsMode: "fallback" });
  return /* @__PURE__ */ e.jsxs("div", { className: r, children: [
    /* @__PURE__ */ e.jsx("h1", { className: "mb-2 text-2xl font-medium", children: t }),
    /* @__PURE__ */ e.jsx("h2", { className: "mb-4 text-base font-normal text-neutral-800 ", children: s }),
    /* @__PURE__ */ e.jsx("div", { className: "flex flex-col gap-4", children: n.map((l) => /* @__PURE__ */ e.jsxs(
      "div",
      {
        className: "w-full rounded-lg border-2 border-blue-200",
        children: [
          /* @__PURE__ */ e.jsxs("div", { className: "flex flex-grow-0 items-center gap-4 bg-blue-50 px-3 py-3 sm:px-6 sm:py-3", children: [
            /* @__PURE__ */ e.jsx(ka, { className: "h-8 w-8 text-blue-800 sm:h-12 sm:w-12" }),
            /* @__PURE__ */ e.jsxs("div", { children: [
              /* @__PURE__ */ e.jsx("h2", { className: "text-base font-medium text-blue-800", children: l.title }),
              /* @__PURE__ */ e.jsx("p", { className: "pt-1 text-sm leading-3 text-blue-800", children: l.weightClass }),
              /* @__PURE__ */ e.jsx("p", { className: "pt-1 text-sm text-blue-800", children: l.info })
            ] })
          ] }),
          /* @__PURE__ */ e.jsx("div", { className: "sm-py-6 w-full px-3 sm:w-96 sm:px-6 sm:pb-6 sm:pt-2", children: /* @__PURE__ */ e.jsx(
            rt,
            {
              ...a(l.reference),
              label: c("tollcollect.order.summary.vehicleInfo.reference"),
              name: l.reference,
              placeholder: c(
                "tollcollect.order.summary.vehicleInfo.referenceMax"
              ),
              error: o[l.reference] ? c("form.validations.reference.long") : void 0,
              onChange: (d) => i(l.reference, d.target.value)
            }
          ) })
        ]
      },
      l.reference
    )) })
  ] });
}, Ly = (t) => {
  const n = Ye();
  V(["common"], {
    nsMode: "fallback"
  });
  const { mutateAsync: r, isLoading: s } = ke(
    ["useAddRecognitionWithDocument"],
    ({ Recognition: i }) => i.addRecognitionV2,
    {
      onSuccess: () => {
        n.invalidateQueries({
          queryKey: ["account", "recognitions"]
        });
      },
      onError: void 0
    }
  ), { mutateAsync: a, isLoading: o } = ke(
    ["recognitions", "add", "alpr"],
    ({ Recognition: i }) => i.addRecognition,
    {
      onSuccess: () => {
        n.invalidateQueries({
          queryKey: ["account", "recognitions"]
        });
      },
      onError: void 0
    }
  );
  return {
    addRecognitionWithFile: r,
    addRecognition: a,
    isLoadingBasic: o,
    isLoadingWithFile: s
  };
}, Iy = () => {
  const { addRecognition: t, addRecognitionWithFile: n } = Ly(), { fuelTypeHybridIDs: r } = At(), { t: s } = V("account"), a = Ye(), [o, i] = L(null), [c, l] = L(!1), d = async (m, f) => {
    l(!0);
    const p = m.isHybrid !== void 0 ? !!m.isHybrid : r.includes(m.fuelTypeId), {
      contractNo: b,
      grossWeight: h,
      licensePlate: g,
      country: v,
      isASFINAG: y,
      isCommercialVehicle: x,
      isGNSS: j,
      isTollCollect: w,
      firstRegistrationDate: C,
      vehicleType: P,
      vehicleInfoFile: N,
      co2File: R,
      co2VehicleGroup: T,
      specificCo2Emissions: z,
      co2VehicleSubgroup: D,
      numberOfAxels: A
    } = m, S = {
      co2EmissionClass: parseInt(m.co2EmissionClass) || void 0,
      type: "bizz",
      contractNo: b,
      regNo: g,
      reference: f.reference || "",
      countryCode: v,
      isHGV: parseInt(m.grossWeight) > 3500,
      emissionClass: parseInt(m.euroEmissionNorm) || void 0,
      isAsfinag: y,
      isCommercialVehicle: x,
      isGNSS: j,
      isHybrid: p,
      fuelType: parseInt(m.fuelTypeId) || void 0,
      grossWeight: parseInt(h) || void 0,
      firstRegistration: C ? Dt(new Date(C), "yyyy-MM-dd") : void 0,
      numberOfAxels: parseInt(A) || void 0,
      specificCo2Emissions: z ? parseFloat(z.replace(",", ".")) : void 0,
      co2VehicleGroup: T,
      co2VehicleSubgroup: D,
      vehicleType: P
    };
    try {
      if (await u(S, R, N), w) {
        const _ = {
          ...S,
          isTollCollect: w,
          reference: f.referenceTollCollect || ""
        };
        await u(_, R, N);
      }
      return a.invalidateQueries({
        queryKey: xe.Recognitions()
      }), a.invalidateQueries({
        queryKey: xe.Agreements({
          contractNo: m.contractNo
        })
      }), !0;
    } catch {
      return i(s("tollcollect.order.summary.submissionError")), !1;
    } finally {
      l(!1);
    }
  }, u = async (m, f, p) => {
    if (f || p) {
      const b = new FormData();
      b.append("data", JSON.stringify(m)), f && b.append("co2File", f), p && b.append("vehicleInfoFile", p), await n(b);
    } else
      await t(m);
  };
  return {
    submissionError: o,
    submissionIsLoading: c,
    handleRecognitionSubmission: d
  };
}, Jc = (t, n) => {
  const r = [];
  if (t.isASFINAG || t.isGNSS || t.isAUTOPASS) {
    const s = [
      t.isASFINAG ? n("singleOrderBizzFlow.order.summary.Obus.info.asFinag") : "",
      t.isGNSS ? n("singleOrderBizzFlow.order.summary.Obus.info.gnss") : "",
      t.isAUTOPASS ? n("singleOrderBizzFlow.order.summary.Obus.info.autopass") : ""
    ].filter(Boolean).map(
      (a, o, i) => o === i.length - 1 && i.length > 1 ? `${n("singleOrderBizzFlow.order.summary.Obus.info.and")} ${a}` : a
    ).join(", ");
    r.push({
      title: n("singleOrderBizzFlow.order.summary.Obus.title.ordinaryBizz"),
      weightClass: n(
        `singleOrderBizzFlow.order.summary.Obus.weight.${t.weightInterval}`
      ) || "",
      info: `${n(
        "singleOrderBizzFlow.order.summary.Obus.info.for"
      )} ${s}`,
      reference: er.reference,
      errors: er.reference
    });
  }
  return t.isTollCollect && r.push({
    title: n("singleOrderBizzFlow.order.summary.Obus.title.tollCollectBizz"),
    weightClass: n(
      `singleOrderBizzFlow.order.summary.Obus.weight.${t.weightInterval}`
    ) || "",
    info: `${n("singleOrderBizzFlow.order.summary.Obus.info.for")} ${n(
      "singleOrderBizzFlow.order.summary.Obus.info.tollCollect"
    )}`,
    reference: er.referenceTollCollect,
    errors: er.referenceTollCollect
  }), r;
}, Zc = ({
  heading: t,
  files: n = [],
  className: r
}) => /* @__PURE__ */ e.jsxs("div", { className: r, children: [
  /* @__PURE__ */ e.jsx("h1", { className: "mb-2 text-2xl font-medium", children: t }),
  /* @__PURE__ */ e.jsx("div", { className: "grid grid-cols-1 gap-4 rounded-lg bg-neutral-50 p-4 sm:grid-cols-2", children: n.map((s, a) => /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col items-start p-4 ", children: [
    /* @__PURE__ */ e.jsx("h2", { className: "text-sm", children: s.title }),
    /* @__PURE__ */ e.jsx("p", { className: "pt-1 font-medium text-neutral-950", children: s.fileName })
  ] }, a)) })
] }), $y = ({
  hasTollingAgreement: t,
  hasTollCollectAgreement: n
}) => {
  var ce, re, se;
  const { locale: r } = ve(), { updateStep: s, formData: a } = Ct(), {
    register: o,
    handleSubmit: i,
    formState: { errors: c },
    clearErrors: l
  } = Nn({
    resolver: Gn(dl)
  }), { t: d } = V(["account", "common"], {
    nsMode: "fallback"
  }), u = Kn(), m = !!(u != null && u.get("toll-collect")), p = (ce = $t().find(
    (H) => H.value === a.country
  )) == null ? void 0 : ce.key, [b, h] = L(!1), [g, v] = L(!1), [y, x] = L(!1), [j, w] = L(!1), [C, P] = L(!1), { customerInformation: N } = tt(), { handleRecognitionSubmission: R, submissionIsLoading: T, submissionError: z } = Iy(), { fuelTypes: D } = At(), A = !!a.isTollCollect && !n, S = !!a.isGNSS && !t, _ = async (H) => {
    P(!0), x(!1), w(!1);
    let O = !1;
    if (A && !H.acceptTollCollectTerms && (x(!0), O = !0), S && !H.acceptRoadTaxDenmarkTerms && (w(!0), O = !0), O) {
      P(!1);
      return;
    }
    await R(
      a,
      H
    ) && s(4), P(!1);
  }, $ = (H) => {
    if (typeof H == "string" || typeof H == "number") return H;
  }, q = (H) => {
    const O = D.find(
      (ae) => ae.value === (H == null ? void 0 : H.toString())
    );
    return O ? O.label : "";
  }, U = [
    {
      title: d("form.labels.firstName"),
      value: $(N == null ? void 0 : N.firstName)
    },
    {
      title: d("form.labels.lastName"),
      value: $(N == null ? void 0 : N.lastName)
    },
    {
      title: d("form.labels.email"),
      value: $(N == null ? void 0 : N.email)
    },
    ...N && "address" in N ? [
      {
        title: d("form.labels.address"),
        value: $(N.address)
      }
    ] : [],
    ...N && "phone" in N ? [
      {
        title: d("form.labels.phone"),
        value: $(
          N.phone ? `${N.phoneCode ?? ""} ${N.phone}` : void 0
        )
      }
    ] : []
  ].filter((H) => H.value), W = [
    {
      title: d("form.labels.reference"),
      value: $(a.reference)
    },
    {
      title: d("form.labels.licensePlate"),
      value: $(a.licensePlate)
    },
    {
      title: d("form.labels.registrationCountry"),
      value: p
    },
    {
      title: d("form.labels.firstRegistrationDate"),
      value: typeof a.firstRegistrationDate == "string" || a.firstRegistrationDate instanceof Date ? Dt(new Date(a.firstRegistrationDate), "yyyy-MM-dd") : ""
    },
    {
      title: d("form.labels.vinNo"),
      value: $(a.vinNo)
    },
    {
      title: d("form.labels.grossWeight"),
      value: $(a.grossWeight)
    },
    {
      title: d("form.labels.fuelType"),
      value: q(a.fuelTypeId)
    },
    {
      title: d("form.labels.euroEmissionNorm"),
      value: $(a.euroEmissionNorm)
    },
    {
      title: d("form.labels.co2EmissionClass"),
      value: $(a.co2EmissionClass)
    },
    {
      title: d("form.labels.specificCo2Emissions"),
      value: $(a.specificCo2Emissions)
    },
    {
      title: d("form.labels.vehicleGroup"),
      value: $(a.vehicleGroup)
    },
    {
      title: d("form.labels.vehicleSubGroup"),
      value: $(a.vehicleSubGroup)
    },
    {
      title: d("form.labels.numberOfAxels"),
      value: $(a.numberOfAxels)
    }
  ].filter((H) => H.value), G = [
    {
      title: d(
        "singleOrderBizzFlow.order.summary.uploadedDocuments.proofOfRegistration"
      ),
      fileName: (re = a.vehicleInfoFile) == null ? void 0 : re.name
    },
    {
      title: d("singleOrderBizzFlow.order.summary.uploadedDocuments.cifOrCoc"),
      fileName: (se = a.co2File) == null ? void 0 : se.name
    }
  ].filter((H) => H.fileName), ee = (H) => {
    l(H);
  }, ue = Jc(a, d);
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    C && /* @__PURE__ */ e.jsx(La, {}),
    /* @__PURE__ */ e.jsxs("form", { onSubmit: i(_), children: [
      /* @__PURE__ */ e.jsx("h2", { className: "text-4xl font-semibold leading-10 text-neutral-950", children: d("singleOrderBizzFlow.order.summary.title") }),
      /* @__PURE__ */ e.jsx("div", { className: "pt-6 text-base font-normal leading-[27px] text-neutral-500", children: d("singleOrderBizzFlow.order.summary.preamble") }),
      /* @__PURE__ */ e.jsx(
        Fn,
        {
          className: "mt-16",
          heading: d("singleOrderBizzFlow.order.summary.vehicleInfo.title"),
          vehicleInfo: W
        }
      ),
      G.length > 0 && /* @__PURE__ */ e.jsx(
        Zc,
        {
          className: "mt-16",
          heading: d(
            "singleOrderBizzFlow.order.summary.uploadedDocuments.title"
          ),
          files: G
        }
      ),
      /* @__PURE__ */ e.jsx(
        Xc,
        {
          className: "mt-16",
          heading: d("singleOrderBizzFlow.order.summary.Obus.heading"),
          obus: ue,
          register: o,
          errors: c,
          clearErrors: l,
          onChange: ee
        }
      ),
      /* @__PURE__ */ e.jsx(
        Fn,
        {
          className: "mt-16",
          heading: d("singleOrderBizzFlow.order.summary.customerInfo.title"),
          vehicleInfo: U
        }
      ),
      !!a.isTollCollect && m && /* @__PURE__ */ e.jsxs("div", { children: [
        /* @__PURE__ */ e.jsx("h3", { className: "mb-2 pt-16 text-2xl font-medium", children: d("singleOrderBizzFlow.order.summary.tollCollect.title") }),
        /* @__PURE__ */ e.jsx("div", { className: "text-base font-normal leading-[27px] text-neutral-500", children: d("singleOrderBizzFlow.order.summary.tollCollect.preamble") }),
        /* @__PURE__ */ e.jsx(
          rt,
          {
            ...o("tollCollectCustomerNumber"),
            className: "mt-6 w-full sm:w-96",
            label: d("singleOrderBizzFlow.order.summary.tollCollect.label")
          }
        )
      ] }),
      A || S && /* @__PURE__ */ e.jsxs("div", { children: [
        /* @__PURE__ */ e.jsx("h3", { className: "mb-2 pt-16 text-2xl font-medium", children: d("singleOrderBizzFlow.order.summary.acceptTerms.title") }),
        /* @__PURE__ */ e.jsx("div", { className: "text-base font-normal leading-[27px] text-neutral-500", children: d("singleOrderBizzFlow.order.summary.acceptTerms.preamble") })
      ] }),
      /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-3", children: [
        A && /* @__PURE__ */ e.jsx(
          vn,
          {
            ...o("acceptTollCollectTerms"),
            error: y ? d("form.validations.termsOfAgreement.required") : void 0,
            className: "mt-8",
            onChange: () => {
              v(!g), y && x(!1);
            },
            label: /* @__PURE__ */ e.jsx(
              he,
              {
                i18nKey: "singleOrderBizzFlow.order.summary.acceptTerms.terms.tollCollect",
                ns: "account",
                children: /* @__PURE__ */ e.jsx(
                  "a",
                  {
                    onClick: (H) => {
                      H.stopPropagation(), window.open(
                        `/pdfs/${r}/terms/terms.pdf`,
                        "_blank"
                      );
                    },
                    className: "cursor-pointer underline"
                  }
                )
              }
            )
          }
        ),
        S && /* @__PURE__ */ e.jsx(
          vn,
          {
            ...o("acceptRoadTaxDenmarkTerms"),
            error: j ? d("form.validations.termsOfAgreement.required") : void 0,
            onChange: () => {
              h(!b), j && w(!1);
            },
            label: /* @__PURE__ */ e.jsx(
              he,
              {
                i18nKey: "singleOrderBizzFlow.order.summary.acceptTerms.terms.roadTaxDenmark",
                ns: "account",
                children: /* @__PURE__ */ e.jsx(
                  "a",
                  {
                    onClick: (H) => {
                      H.stopPropagation(), window.open(
                        `/pdfs/${r}/terms/terms.pdf`,
                        "_blank"
                      );
                    },
                    className: "cursor-pointer underline"
                  }
                )
              }
            )
          }
        ),
        z && /* @__PURE__ */ e.jsx(st, { className: "mt-8", colorMode: "error", children: z })
      ] }) }),
      /* @__PURE__ */ e.jsx("hr", { className: "mt-8" }),
      /* @__PURE__ */ e.jsxs("div", { className: "mb-4 mt-8 flex items-center gap-4", children: [
        /* @__PURE__ */ e.jsx(
          be,
          {
            as: "button",
            intent: "outlined",
            onClick: () => s((H) => H - 1),
            children: d("action.back")
          }
        ),
        /* @__PURE__ */ e.jsx(
          Gr,
          {
            href: "/account/vehicles",
            className: "ml-auto pr-4 font-medium text-blue-700 underline",
            children: d("action.cancel")
          }
        ),
        /* @__PURE__ */ e.jsx(
          et,
          {
            as: "button",
            type: "submit",
            loadingLabel: d("action.loading"),
            isLoading: T,
            children: d("action.order")
          }
        )
      ] })
    ] })
  ] });
}, Fy = (t) => {
  const n = Ye();
  V(["common"], {
    nsMode: "fallback"
  });
  const { mutateAsync: r, isLoading: s } = ke(
    ["useUpdateRecognitionWithDocument"],
    ({ Recognition: a }) => a.updateRecognitionV2,
    {
      onSuccess: () => {
        n.invalidateQueries({
          queryKey: ["account", "recognitions"]
        });
      },
      onError: void 0
    }
  );
  return {
    updateRecognitionWithFile: r,
    isLoading: s
  };
}, By = () => {
  const { updateRecognitionWithFile: t } = Fy(), { fuelTypeHybridIDs: n } = At(), { t: r } = V("account"), s = Ye(), [a, o] = L(null), [i, c] = L(!1), l = async (u, m) => {
    c(!0);
    const f = u.isHybrid !== void 0 ? !!u.isHybrid : n.includes(u.fuelTypeId), {
      contractNo: p,
      grossWeight: b,
      licensePlate: h,
      country: g,
      isASFINAG: v,
      isCommercialVehicle: y,
      isGNSS: x,
      isTollCollect: j,
      firstRegistrationDate: w,
      vehicleType: C,
      vehicleInfoFile: P,
      co2File: N,
      co2VehicleGroup: R,
      specificCo2Emissions: T,
      co2VehicleSubgroup: z,
      numberOfAxels: D,
      vehicleIdentificationNumber: A,
      licensePlateCertificate: S
    } = u, _ = {
      contractNo: p,
      contractLineNo: parseInt(u.contractLineNo),
      changes: {
        co2EmissionClass: parseInt(u.co2EmissionClass) || void 0,
        type: "bizz",
        registrationNo: h,
        reference: m.reference || "",
        countryCode: g,
        isHGV: parseInt(u.grossWeight) > 3500,
        emissionClass: parseInt(u.euroEmissionNorm) || void 0,
        isAsfinag: v,
        isCommercialVehicle: y,
        isGNSS: x,
        isHybrid: f,
        fuelType: parseInt(u.fuelTypeId) || void 0,
        vehicleMaxLadenWeight: parseInt(b) || void 0,
        firstRegistration: w ? Dt(new Date(w), "yyyy-MM-dd") : void 0,
        numberOfAxels: parseInt(D) || void 0,
        specificCo2Emissions: T ? parseFloat(T.replace(",", ".")) : void 0,
        vehicleGroup: R,
        vehicleSubgroup: z,
        vehicleType: C,
        vehicleIdentificationNumber: A,
        licensePlateCertificate: S
      }
    };
    try {
      if (await d(_, N, P), j) {
        const $ = {
          ..._,
          isTollCollect: j,
          reference: m.referenceTollCollect || ""
        };
        await d($, N, P);
      }
      return s.invalidateQueries({
        queryKey: xe.Recognitions()
      }), s.invalidateQueries({
        queryKey: xe.Agreements({
          contractNo: u.contractNo
        })
      }), !0;
    } catch {
      return o(r("tollcollect.order.summary.submissionError")), !1;
    } finally {
      c(!1);
    }
  }, d = async (u, m, f) => {
    if (m || f) {
      const p = new FormData();
      p.append("data", JSON.stringify(u)), m && p.append("co2File", m), f && p.append("vehicleInfoFile", f), await t(p);
    } else
      await t(u);
  };
  return {
    submissionError: a,
    submissionIsLoading: i,
    handleRecognitionUpdate: l
  };
}, Vy = ({
  hasTollingAgreement: t,
  hasTollCollectAgreement: n
}) => {
  var ce, re, se;
  const { locale: r } = ve(), { updateStep: s, formData: a } = Ct(), {
    register: o,
    handleSubmit: i,
    formState: { errors: c },
    clearErrors: l
  } = Nn({
    resolver: Gn(dl)
  }), { t: d } = V(["account", "common"], {
    nsMode: "fallback"
  }), u = Kn(), m = !!(u != null && u.get("toll-collect")), p = (ce = $t().find(
    (H) => H.value === a.country
  )) == null ? void 0 : ce.key, [b, h] = L(!1), [g, v] = L(!1), [y, x] = L(!1), [j, w] = L(!1), [C, P] = L(!1), { customerInformation: N } = tt(), { handleRecognitionUpdate: R, submissionIsLoading: T, submissionError: z } = By(), { fuelTypes: D } = At(), A = !!a.isTollCollect && !n, S = !!a.isGNSS && !t, _ = async (H) => {
    P(!0), x(!1), w(!1);
    let O = !1;
    if (A && !H.acceptTollCollectTerms && (x(!0), O = !0), S && !H.acceptRoadTaxDenmarkTerms && (w(!0), O = !0), O) {
      P(!1);
      return;
    }
    await R(
      a,
      H
    ) && s(4), P(!1);
  }, $ = (H) => {
    if (typeof H == "string" || typeof H == "number") return H;
  }, q = (H) => {
    const O = D.find(
      (ae) => ae.value === (H == null ? void 0 : H.toString())
    );
    return O ? O.label : "";
  }, U = [
    {
      title: d("form.labels.firstName"),
      value: $(N == null ? void 0 : N.firstName)
    },
    {
      title: d("form.labels.lastName"),
      value: $(N == null ? void 0 : N.lastName)
    },
    {
      title: d("form.labels.email"),
      value: $(N == null ? void 0 : N.email)
    },
    ...N && "address" in N ? [
      {
        title: d("form.labels.address"),
        value: $(N.address)
      }
    ] : [],
    ...N && "phone" in N ? [
      {
        title: d("form.labels.phone"),
        value: $(
          N.phone ? `${N.phoneCode ?? ""} ${N.phone}` : void 0
        )
      }
    ] : []
  ].filter((H) => H.value), W = [
    {
      title: d("form.labels.reference"),
      value: $(a.reference)
    },
    {
      title: d("form.labels.licensePlate"),
      value: $(a.licensePlate)
    },
    {
      title: d("form.labels.registrationCountry"),
      value: p
    },
    {
      title: d("form.labels.firstRegistrationDate"),
      value: typeof a.firstRegistrationDate == "string" || a.firstRegistrationDate instanceof Date ? Dt(new Date(a.firstRegistrationDate), "yyyy-MM-dd") : ""
    },
    {
      title: d("form.labels.vinNo"),
      value: $(a.vinNo)
    },
    {
      title: d("form.labels.grossWeight"),
      value: $(a.grossWeight)
    },
    {
      title: d("form.labels.fuelType"),
      value: q(a.fuelTypeId)
    },
    {
      title: d("form.labels.euroEmissionNorm"),
      value: $(a.euroEmissionNorm)
    },
    {
      title: d("form.labels.co2EmissionClass"),
      value: $(a.co2EmissionClass)
    },
    {
      title: d("form.labels.specificCo2Emissions"),
      value: $(a.specificCo2Emissions)
    },
    {
      title: d("form.labels.vehicleGroup"),
      value: $(a.vehicleGroup)
    },
    {
      title: d("form.labels.vehicleSubGroup"),
      value: $(a.vehicleSubGroup)
    },
    {
      title: d("form.labels.numberOfAxels"),
      value: $(a.numberOfAxels)
    }
  ].filter((H) => H.value), G = [
    {
      title: d(
        "singleOrderBizzFlow.order.summary.uploadedDocuments.proofOfRegistration"
      ),
      fileName: (re = a.vehicleInfoFile) == null ? void 0 : re.name
    },
    {
      title: d("singleOrderBizzFlow.order.summary.uploadedDocuments.cifOrCoc"),
      fileName: (se = a.co2File) == null ? void 0 : se.name
    }
  ].filter((H) => H.fileName), ee = (H) => {
    l(H);
  }, ue = Jc(a, d);
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    C && /* @__PURE__ */ e.jsx(La, {}),
    /* @__PURE__ */ e.jsxs("form", { onSubmit: i(_), children: [
      /* @__PURE__ */ e.jsx("h2", { className: "text-4xl font-semibold leading-10 text-neutral-950", children: d("singleOrderBizzFlow.order.summary.title") }),
      /* @__PURE__ */ e.jsx("div", { className: "pt-6 text-base font-normal leading-[27px] text-neutral-500", children: d("singleOrderBizzFlow.order.summary.preamble") }),
      /* @__PURE__ */ e.jsx(
        y0,
        {
          oldPlate: a.prevRegNo,
          newPlate: a.licensePlate
        }
      ),
      /* @__PURE__ */ e.jsx(
        Fn,
        {
          className: "mt-16",
          heading: d("singleOrderBizzFlow.order.summary.vehicleInfo.title"),
          vehicleInfo: W
        }
      ),
      G.length > 0 && /* @__PURE__ */ e.jsx(
        Zc,
        {
          className: "mt-16",
          heading: d(
            "singleOrderBizzFlow.order.summary.uploadedDocuments.title"
          ),
          files: G
        }
      ),
      /* @__PURE__ */ e.jsx(
        Xc,
        {
          className: "mt-16",
          heading: d("singleOrderBizzFlow.order.summary.Obus.heading"),
          obus: ue,
          register: o,
          errors: c,
          clearErrors: l,
          onChange: ee
        }
      ),
      /* @__PURE__ */ e.jsx(
        Fn,
        {
          className: "mt-16",
          heading: d("singleOrderBizzFlow.order.summary.customerInfo.title"),
          vehicleInfo: U
        }
      ),
      !!a.isTollCollect && m && /* @__PURE__ */ e.jsxs("div", { children: [
        /* @__PURE__ */ e.jsx("h3", { className: "mb-2 pt-16 text-2xl font-medium", children: d("singleOrderBizzFlow.order.summary.tollCollect.title") }),
        /* @__PURE__ */ e.jsx("div", { className: "text-base font-normal leading-[27px] text-neutral-500", children: d("singleOrderBizzFlow.order.summary.tollCollect.preamble") }),
        /* @__PURE__ */ e.jsx(
          rt,
          {
            ...o("tollCollectCustomerNumber"),
            className: "mt-6 w-full sm:w-96",
            label: d("singleOrderBizzFlow.order.summary.tollCollect.label")
          }
        )
      ] }),
      A || S && /* @__PURE__ */ e.jsxs("div", { children: [
        /* @__PURE__ */ e.jsx("h3", { className: "mb-2 pt-16 text-2xl font-medium", children: d("singleOrderBizzFlow.order.summary.acceptTerms.title") }),
        /* @__PURE__ */ e.jsx("div", { className: "text-base font-normal leading-[27px] text-neutral-500", children: d("singleOrderBizzFlow.order.summary.acceptTerms.preamble") })
      ] }),
      /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-3", children: [
        A && /* @__PURE__ */ e.jsx(
          vn,
          {
            ...o("acceptTollCollectTerms"),
            error: y ? d("form.validations.termsOfAgreement.required") : void 0,
            className: "mt-8",
            onChange: () => {
              v(!g), y && x(!1);
            },
            label: /* @__PURE__ */ e.jsx(
              he,
              {
                i18nKey: "singleOrderBizzFlow.order.summary.acceptTerms.terms.tollCollect",
                ns: "account",
                children: /* @__PURE__ */ e.jsx(
                  "a",
                  {
                    onClick: (H) => {
                      H.stopPropagation(), window.open(
                        `/pdfs/${r}/terms/terms.pdf`,
                        "_blank"
                      );
                    },
                    className: "cursor-pointer underline"
                  }
                )
              }
            )
          }
        ),
        S && /* @__PURE__ */ e.jsx(
          vn,
          {
            ...o("acceptRoadTaxDenmarkTerms"),
            error: j ? d("form.validations.termsOfAgreement.required") : void 0,
            onChange: () => {
              h(!b), j && w(!1);
            },
            label: /* @__PURE__ */ e.jsx(
              he,
              {
                i18nKey: "singleOrderBizzFlow.order.summary.acceptTerms.terms.roadTaxDenmark",
                ns: "account",
                children: /* @__PURE__ */ e.jsx(
                  "a",
                  {
                    onClick: (H) => {
                      H.stopPropagation(), window.open(
                        `/pdfs/${r}/terms/terms.pdf`,
                        "_blank"
                      );
                    },
                    className: "cursor-pointer underline"
                  }
                )
              }
            )
          }
        ),
        z && /* @__PURE__ */ e.jsx(st, { className: "mt-8", colorMode: "error", children: z })
      ] }) }),
      /* @__PURE__ */ e.jsx("hr", { className: "mt-8" }),
      /* @__PURE__ */ e.jsxs("div", { className: "mb-4 mt-8 flex items-center gap-4", children: [
        /* @__PURE__ */ e.jsx(
          be,
          {
            as: "button",
            intent: "outlined",
            onClick: () => s((H) => H - 1),
            children: d("action.back")
          }
        ),
        /* @__PURE__ */ e.jsx(
          Gr,
          {
            href: "/account/vehicles",
            className: "ml-auto pr-4 font-medium text-blue-700 underline",
            children: d("action.cancel")
          }
        ),
        /* @__PURE__ */ e.jsx(
          et,
          {
            as: "button",
            type: "submit",
            loadingLabel: d("action.loading"),
            isLoading: T,
            children: d("action.order")
          }
        )
      ] })
    ] })
  ] });
}, qy = () => {
  const { push: t } = ve(), { formData: n } = Ct(), { isTollCollect: r, isGNSS: s } = n || {}, { t: a } = V(["account", "common"], { nsMode: "fallback" });
  return /* @__PURE__ */ e.jsxs("div", { className: "flex max-w-2xl flex-col gap-10", children: [
    /* @__PURE__ */ e.jsx("h2", { className: "text-4xl font-semibold leading-10 text-neutral-950", children: a("singleOrderBizzFlow.order.confirmation.title") }),
    /* @__PURE__ */ e.jsx("div", { className: "text-base font-normal leading-[27px] text-neutral-500", children: a("singleOrderBizzFlow.order.confirmation.preamble") }),
    /* @__PURE__ */ e.jsx(
      st,
      {
        colorMode: "success",
        hideIcon: !0,
        title: a("singleOrderBizzFlow.order.confirmation.feedback.title"),
        children: a("singleOrderBizzFlow.order.confirmation.feedback.description")
      }
    ),
    s && /* @__PURE__ */ e.jsx(
      Fr,
      {
        title: a(
          "singleOrderBizzFlow.order.confirmation.details.roadTollDenmark.title"
        ),
        descriptionPhraseKey: "singleOrderBizzFlow.order.confirmation.details.roadTollDenmark.description"
      }
    ),
    r && /* @__PURE__ */ e.jsx(
      Fr,
      {
        title: a(
          "singleOrderBizzFlow.order.confirmation.details.roadTollGermany.title"
        ),
        descriptionPhraseKey: "singleOrderBizzFlow.order.details.confirmation.roadTollGermany.description"
      }
    ),
    /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
      be,
      {
        onClick: () => t("/account/vehicles/"),
        className: "max-w-fit",
        children: a("action.close")
      }
    ) })
  ] });
}, Wy = () => {
  const { push: t } = ve(), { t: n } = V(["account", "common"], { nsMode: "fallback" });
  return /* @__PURE__ */ e.jsxs("div", { className: "flex max-w-2xl flex-col gap-10", children: [
    /* @__PURE__ */ e.jsx("h2", { className: "text-4xl font-semibold leading-10 text-neutral-950", children: n("singleOrderBizzFlow.order.confirmation.title") }),
    /* @__PURE__ */ e.jsx(st, { colorMode: "success", hideIcon: !0, children: n("singleOrderBizzFlow.order.confirmation.vehicleChange.description") }),
    /* @__PURE__ */ e.jsx("div", { children: /* @__PURE__ */ e.jsx(
      be,
      {
        onClick: () => t("/account/vehicles/"),
        className: "max-w-fit",
        children: n("action.close")
      }
    ) })
  ] });
}, Hy = () => {
  const { step: t, formData: n } = Ct(), { t: r } = V("account"), { data: s } = bt(
    !1,
    n.contractNo
  ), { pathname: a } = ve();
  Y(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [t]);
  const o = () => {
    switch (t) {
      case 2:
        return /* @__PURE__ */ e.jsx(Oy, {});
      case 3:
        return /* @__PURE__ */ e.jsx(
          $y,
          {
            hasTollingAgreement: (s == null ? void 0 : s.tollingAgreementSigned) || !1,
            hasTollCollectAgreement: (s == null ? void 0 : s.tollCollectAgreementSigned) || !1
          }
        );
      case 4:
        return /* @__PURE__ */ e.jsx(qy, {});
      default:
        return /* @__PURE__ */ e.jsx(
          Ib,
          {
            isRoadTollDenmark: a === "/account/bizz/order"
          }
        );
    }
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "mt-4 pt-8", children: [
    /* @__PURE__ */ e.jsx(Vc, { children: r("singleOrderBizzFlow.pretitle") }),
    o()
  ] });
}, Uy = ({ index: t, stepText: n, isPrevStep: r }) => {
  const { step: s, updateStep: a } = Ct(), o = s === t + 1;
  return /* @__PURE__ */ e.jsx(
    "button",
    {
      className: `flex h-full flex-1 flex-col after:h-1 after:w-full after:shadow after:content-['']
        ${r ? "cursor-pointer after:bg-green-600" : "after:bg-neutral-300"} 
        ${o ? "after:bg-neutral-500" : ""}
        `,
      onClick: () => {
        r && a(t + 1);
      },
      disabled: !r,
      children: /* @__PURE__ */ e.jsxs("div", { className: "flex h-full items-center md:px-2", children: [
        /* @__PURE__ */ e.jsx(
          "div",
          {
            className: `mr-2 flex w-6 flex-[0_0_1.2rem] items-center justify-center rounded-full text-xs md:h-8 md:flex-[0_0_2rem] md:text-base 
            ${r ? "border-2 border-green-700 bg-green-100 text-green-700" : o ? "border-2 border-neutral-500 text-neutral-500" : "border border-neutral-400 text-neutral-500"} 
          `,
            children: r ? /* @__PURE__ */ e.jsx(ir, { width: 11 }) : t + 1
          }
        ),
        /* @__PURE__ */ e.jsx("span", { className: "text-xs text-black md:text-sm", children: n })
      ] })
    }
  );
}, Gy = ({
  index: t,
  stepText: n,
  isPrevStep: r,
  lastStep: s,
  cutoffStep: a
}) => {
  const { step: o, updateStep: i } = Ct(), c = o === t + 1;
  return /* @__PURE__ */ e.jsx(
    "div",
    {
      className: `flex h-full flex-col
        ${r && a !== o ? "after:bg-green-600" : "after:bg-neutral-300"} 
        ${c ? "after:bg-neutral-500" : ""}
        ${s ? "" : "flex-1"}
        `,
      children: /* @__PURE__ */ e.jsxs("div", { className: "flex h-full w-full items-center gap-2 px-1", children: [
        /* @__PURE__ */ e.jsxs(
          "button",
          {
            className: " h-18 flex w-12 flex-[0_0_3rem] flex-col items-center gap-1 md:w-14 md:flex-[0_0_3.5rem]",
            onClick: () => {
              r && a !== o && i(t + 1);
            },
            disabled: !r || a === o,
            children: [
              /* @__PURE__ */ e.jsx(
                "div",
                {
                  className: `flex w-10 flex-[0_0_2.5rem] items-center justify-center rounded-full text-xs font-semibold md:w-12 md:flex-[0_0_3rem] md:text-base 
                ${r || a === o ? "border-4 border-green-600 bg-green-600 text-white" : c ? "border-4 border-green-600" : "border-4 border-neutral-300"} 
              `,
                  children: r || a === o ? /* @__PURE__ */ e.jsx(ir, { width: 18 }) : t + 1
                }
              ),
              /* @__PURE__ */ e.jsx("span", { className: "h-5 w-24 text-center text-xs font-semibold text-black md:text-sm", children: n })
            ]
          }
        ),
        !s && /* @__PURE__ */ e.jsxs("div", { className: " flex w-full flex-col items-center gap-1", children: [
          /* @__PURE__ */ e.jsx(
            "div",
            {
              className: "flex h-8 w-full items-center justify-center md:h-10",
              children: /* @__PURE__ */ e.jsx(
                "div",
                {
                  className: `h-1 w-full rounded-md ${r ? "bg-green-600" : "bg-neutral-300"}`
                }
              )
            }
          ),
          /* @__PURE__ */ e.jsx("span", { className: "invisible h-5 w-0 text-center text-xs text-black md:text-sm", children: n })
        ] })
      ] })
    }
  );
};
var ed = /* @__PURE__ */ ((t) => (t[t.Rectangle = 0] = "Rectangle", t[t.Circle = 1] = "Circle", t))(ed || {});
const Ky = ({
  stepTexts: t,
  className: n,
  stepVariant: r = 0,
  cutoffStep: s
}) => {
  const { step: a } = Ct();
  return /* @__PURE__ */ e.jsxs("div", { className: `flex flex-wrap items-center ${n ?? ""}`, children: [
    r === 0 && t.map((o, i) => /* @__PURE__ */ e.jsx(
      Uy,
      {
        stepText: o,
        index: i,
        isPrevStep: a > i + 1
      },
      i
    )),
    r === 1 && t.map((o, i) => /* @__PURE__ */ e.jsx(
      Gy,
      {
        stepText: o,
        index: i,
        isPrevStep: a > i + 1,
        lastStep: t.length - 1 === i,
        cutoffStep: s
      },
      i
    ))
  ] });
}, Yy = ({ bizzno: t }) => {
  const { step: n, formData: r } = Ct(), { t: s } = V("account"), { data: a } = bt(
    !1,
    r.contractNo
  ), o = rc().recognitions.find(
    (c) => c.serialNo === t
  );
  Y(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [n]);
  const i = () => {
    switch (n) {
      case 2:
        return /* @__PURE__ */ e.jsx(Dy, {});
      case 3:
        return /* @__PURE__ */ e.jsx(
          Vy,
          {
            hasTollingAgreement: (a == null ? void 0 : a.tollingAgreementSigned) || !1,
            hasTollCollectAgreement: (a == null ? void 0 : a.tollCollectAgreementSigned) || !1
          }
        );
      case 4:
        return /* @__PURE__ */ e.jsx(Wy, {});
      default:
        return o ? /* @__PURE__ */ e.jsx($b, { bizzInfo: o }) : null;
    }
  };
  return /* @__PURE__ */ e.jsxs("div", { className: "mt-4 pt-8", children: [
    /* @__PURE__ */ e.jsx(Vc, { children: s("singleOrderBizzFlow.editPretitle") }),
    i()
  ] });
}, td = () => {
  const { t } = V(["account", "common"], {
    nsMode: "fallback"
  }), { query: n } = ve();
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsxs(zb, { children: [
    /* @__PURE__ */ e.jsx(
      Ky,
      {
        stepTexts: [
          t("singleOrderBizzFlow.progressBar.steps.basicVehicleInfo"),
          t("singleOrderBizzFlow.progressBar.steps.additionalVehicleData"),
          t("singleOrderBizzFlow.progressBar.steps.summary"),
          t("singleOrderBizzFlow.progressBar.steps.confirmation")
        ],
        stepVariant: ed.Circle,
        cutoffStep: 4
      }
    ),
    /* @__PURE__ */ e.jsx("hr", { className: "mt-8" }),
    n.bizz ? /* @__PURE__ */ e.jsx(Yy, { bizzno: n.bizz }) : /* @__PURE__ */ e.jsx(Hy, {})
  ] }) });
}, xC = () => /* @__PURE__ */ e.jsx(td, {}), bC = () => {
  const t = ve(), { query: n, push: r } = t, s = t.locale || "sv", { t: a } = V(["account", "common", "recognitions"], {
    nsMode: "fallback"
  }), { data: o, error: i } = Ma(!1), { app: c, oresundPayBase: l } = Ft(), d = c === un.OresundPay && ln({
    locale: s,
    key: "installationGuide",
    url: l
  }), u = c === un.OresundPay && ln({
    locale: s,
    key: "prePaid",
    url: l
  }), m = o == null ? void 0 : o.filter(
    (f) => f.paymentAgreement.agreementType !== "Oresund_Business_Pendler"
  );
  return i ? /* @__PURE__ */ e.jsx(Lt, { variant: "error", children: a("agreement.error.notFound") }) : m ? m.length === 0 ? /* @__PURE__ */ e.jsx(lt, { children: /* @__PURE__ */ e.jsx(
    Ka,
    {
      status: {
        backgroundColor: "bg-red-300",
        translationKey: "dashboard.inactive"
      }
    }
  ) }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    n.toast && /* @__PURE__ */ e.jsx(
      Sc,
      {
        registrationNumber: n.toast,
        onClose: () => Oc("toast", t)
      }
    ),
    /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-6", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-6", children: [
        /* @__PURE__ */ e.jsx(M, { as: "span", className: "max-w-3xl", children: a("kmtoll.landing.layout.preamble") }),
        /* @__PURE__ */ e.jsxs("div", { className: "flex flex-col gap-4 text-sm sm:gap-6 sm:text-base lg:flex-row lg:gap-12", children: [
          /* @__PURE__ */ e.jsx(
            yn,
            {
              href: u || "#",
              className: "font-semibold text-blue-700 underline",
              children: a("kmtoll.landing.layout.prePaidTicketLinkText")
            }
          ),
          /* @__PURE__ */ e.jsx(
            yn,
            {
              className: "font-semibold text-blue-700 underline",
              href: d || "#",
              children: a("kmtoll.landing.layout.bizzInstallationGuideLinkText")
            }
          )
        ] })
      ] }),
      m.length > 0 && /* @__PURE__ */ e.jsx(Cd, { value: {}, children: /* @__PURE__ */ e.jsx(
        yd,
        {
          pageType: "kmtoll",
          productType: "GNSS",
          actions: [
            {
              labelKey: "kmtoll.order.layout.title",
              action: () => r("./bizz/order"),
              icon: /* @__PURE__ */ e.jsx(cn, {})
            }
          ],
          hideCommuter: !0
        }
      ) })
    ] })
  ] }) : /* @__PURE__ */ e.jsx(
    lt,
    {
      p: "spacing.600",
      display: "flex",
      sx: { justifyContent: "center", alignContent: "center" },
      children: /* @__PURE__ */ e.jsx(lt, { sx: { width: "45px" }, children: /* @__PURE__ */ e.jsx(Tt, { "aria-label": a("action.loading") }) })
    }
  );
}, vC = () => {
  const { t } = Zi(["account", "common"], {
    nsMode: "fallback"
  }), { data: n, error: r } = Ma(!0), s = n == null ? void 0 : n.filter(
    (a) => a.paymentAgreement.agreementType !== "Oresund_Business_Pendler"
  );
  return r ? /* @__PURE__ */ e.jsx(Lt, { variant: "error", children: t("agreement.error.notFound") }) : s ? s.length === 0 ? /* @__PURE__ */ e.jsx(lt, { children: /* @__PURE__ */ e.jsx(
    Ka,
    {
      status: {
        backgroundColor: "bg-red-300",
        translationKey: "dashboard.inactive"
      }
    }
  ) }) : /* @__PURE__ */ e.jsx(td, {}) : /* @__PURE__ */ e.jsx(
    lt,
    {
      p: "spacing.600",
      display: "flex",
      sx: { justifyContent: "center", alignContent: "center" },
      children: /* @__PURE__ */ e.jsx(lt, { sx: { width: "45px" }, children: /* @__PURE__ */ e.jsx(Tt, { "aria-label": t("action.loading") }) })
    }
  );
};
var Zt = /* @__PURE__ */ ((t) => (t.error = "error", t.hide = "hide", t.newCodeSent = "newCodeSent", t))(Zt || {});
const nd = (t) => Object.keys(t).filter((n) => n !== "country" && !!t[n]).length === 0, Qy = gt.fromPath()([
  "contact",
  "phoneCode"
]), Xy = gt.fromPath()([
  "phoneCode"
]), Jy = gt.fromPath()([
  "contactInformation",
  "phoneCode"
]), Zy = ({
  status: t,
  errorText: n,
  ns: r
}) => {
  const { t: s } = V(r, {
    nsMode: "fallback"
  }), a = (i) => {
    switch (i) {
      case pe.ACCOUNT_BLOCKED.value:
        return s("codeVerification.verificationError.accountBlocked");
      case pe.CODE_LENGTH_INVALID.value:
        return s("codeVerification.verificationError.pastedCodeInvalid");
      default:
        return s("codeVerification.verificationError.default");
    }
  };
  return (() => {
    const i = "flex items-center text-xs py-3 px-4";
    switch (t) {
      case Zt.newCodeSent:
        return /* @__PURE__ */ e.jsxs("div", { className: `${i} bg-green-100 text-green-800`, children: [
          /* @__PURE__ */ e.jsx(ir, { className: "mr-4" }),
          " ",
          s("codeVerification.newCodeSent")
        ] });
      case Zt.error:
        return /* @__PURE__ */ e.jsxs("div", { className: `${i} bg-red-100 text-red-700`, children: [
          /* @__PURE__ */ e.jsx(rl, { className: "mr-4" }),
          " ",
          a(n)
        ] });
      default:
        return /* @__PURE__ */ e.jsx(e.Fragment, {});
    }
  })();
}, rd = ({ namespace: t, titleTranslationKey: n, ns: r, isBusiness: s }) => {
  const { resetAuthentication: a } = sn(), { mutateAsync: o } = ke(
    ["customer", "code"],
    (A) => A.Customer.verifyCodeV2,
    {
      retry: 0,
      onMutate: () => {
        a();
      }
    }
  ), i = ke(
    ["customer", "verify"],
    (A) => A.Customer.verifyCustomerV2,
    {
      retry: 0
    }
  ), { t: c } = V(r, {
    nsMode: "fallback"
  }), { getData: l } = Se({
    namespace: "contactInformation"
  }), { getData: d } = Se({
    namespace: "contactInformation"
  }), u = () => s ? d().contact.email : l().email, [m, f] = L(["", "", "", "", "", ""]), [p, b] = L(
    Zt.hide
  ), [h, g] = L(""), v = Q(
    (A) => async (S) => {
      try {
        const _ = await o(S);
        return A(_);
      } catch (_) {
        return g(_.error), A({
          token: ""
        });
      }
    },
    [o]
  ), y = async (A) => {
    b(Zt.hide);
    const _ = await v((q) => ({
      code: !q.token || q.token === "" ? c("form.validations.code.invalid") : void 0
    }))({
      code: `${A.code}`,
      email: u()
    }), $ = Object.values(_);
    for (const q of $)
      if (q)
        return b(Zt.error), _;
    j("codeVerified", "true", "boolean");
  }, {
    registerField: x,
    setFieldData: j,
    getError: w,
    validate: C,
    isValid: P,
    isActive: N,
    stepNr: R
  } = Se({
    namespace: t,
    onValidate: y
  }), T = () => !!(!N || !P || m.includes("")), z = () => /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    [0, 1, 2, 3, 4, 5].map((A) => /* @__PURE__ */ e.jsx(
      "input",
      {
        value: m[A],
        id: `code-verification-input-${A}`,
        className: "h-20 w-16 rounded-3xl border-2 border-gray-500 p-2.5 text-center text-4xl",
        disabled: !N,
        onChange: (S) => {
          var $;
          const _ = m.map((q, U) => A == U ? S.target.value : q);
          f(_), A < 5 && S.target.value !== "" && (($ = document.getElementById(`code-verification-input-${A + 1}`)) == null || $.focus());
        },
        maxLength: 1,
        onPaste: (S) => {
          S.preventDefault();
          const _ = S.clipboardData.getData("text/plain");
          if (_ === "") {
            b(Zt.error), g(pe.CODE_LENGTH_INVALID.value);
            return;
          }
          const $ = _.trim();
          if ($.length < 6 || $.length > 7) {
            b(Zt.error), g(pe.CODE_LENGTH_INVALID.value);
            return;
          }
          f(Array.from($));
        }
      },
      A
    )),
    /* @__PURE__ */ e.jsx(
      me,
      {
        className: "hidden h-20 w-16 rounded-3xl border-2 border-gray-500 p-2.5 text-center text-4xl",
        ...x("code"),
        label: "",
        error: w("code"),
        required: !0,
        hidden: !0,
        value: m.join("")
      }
    )
  ] }), D = async () => {
    var A;
    f(["", "", "", "", "", ""]), await i.mutateAsync({ email: u() }), (A = document.getElementById("code-verification-input-0")) == null || A.focus(), b(Zt.newCodeSent);
  };
  return Y(() => {
    j("code", m.join(""), "string");
  }, [m, j]), /* @__PURE__ */ e.jsxs(Vt, { nr: R, title: c(n), id: t, children: [
    /* @__PURE__ */ e.jsx(ne, { className: "col-span-full mb-1 mt-1", children: /* @__PURE__ */ e.jsx(M, { intent: "label", size: "lg", children: c("codeVerification.verifyText") }) }),
    z(),
    /* @__PURE__ */ e.jsx(ne, { className: "col-span-full mb-1", children: /* @__PURE__ */ e.jsx(
      Zy,
      {
        status: p,
        errorText: h,
        ns: r
      }
    ) }),
    /* @__PURE__ */ e.jsx(ne, { className: "col-span-full mb-1", children: /* @__PURE__ */ e.jsx(
      be,
      {
        intent: "text",
        className: "pl-0 text-blue-600 underline",
        onClick: () => D(),
        children: c("codeVerification.sendNewCode")
      }
    ) }),
    /* @__PURE__ */ e.jsx(
      kn,
      {
        loadingLabel: c("action.loading"),
        namespace: t,
        onClick: C(),
        disabled: T()
      }
    )
  ] });
}, ej = ({ onSuccess: t, onError: n, tokenInformation: r }) => {
  const { data: s, error: a, isError: o, isLoading: i, refetch: c } = De(
    xe.ReepayTokenDetail(r),
    (d) => d.Reepay.token(r),
    {
      enabled: !1,
      staleTime: 0,
      refetchOnMount: !1
    }
  );
  Y(() => {
    c();
  }, []), Y(() => {
    a && n(a);
  }, [a, n]);
  const l = Q(
    (d) => t(d, s == null ? void 0 : s.session),
    [s == null ? void 0 : s.session, t]
  );
  return !s && !o || i ? /* @__PURE__ */ e.jsx("div", { className: "item-center text-primary-400 col-span-full flex h-[600px] items-center justify-center text-5xl md:col-span-6 md:col-start-4", children: /* @__PURE__ */ e.jsx(
    "svg",
    {
      className: "animate-spin",
      fill: "currentColor",
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        }
      )
    }
  ) }) : /* @__PURE__ */ e.jsx(vc, { onSuccess: l, token: s == null ? void 0 : s.token });
}, wt = Vn(() => ({
  isPasswordSet: !1,
  payWithCreditCard: !1
})), sd = (t) => wt.setState((n) => ({ ...n, data: t })), oo = (t) => wt.setState((n) => ({ ...n, resp: t, error: void 0 })), Bn = (t) => wt.setState((n) => ({ ...n, error: t, resp: void 0 })), tj = () => wt.setState((t) => ({ ...t, isPasswordSet: !0 })), io = () => wt.setState((t) => ({ ...t, payWithCreditCard: !0 })), ad = (t) => wt.setState((n) => ({ ...n, token: t })), od = () => wt.setState(() => ({
  isPasswordSet: !1,
  payWithCreditCard: !1,
  data: void 0,
  resp: void 0,
  error: void 0,
  token: void 0
})), Qi = (t) => (n) => t[n](), wa = "---", Na = (t, n) => `${t}${wa}${n}`, bn = (t) => {
  if (typeof t != "string")
    return "";
  if (!t.includes(wa))
    return t;
  const n = t.split(wa);
  return n.length > 0 ? n[0] : "";
}, Yn = () => {
  const t = pt(ql);
  if (!t)
    throw new Error(
      "useContractsStore must be used within a ContractsStoreProvider"
    );
  const {
    getContracts: n,
    reset: r,
    setMainContract: s,
    discountMainContract: a,
    removeDiscountMainContract: o
  } = t;
  return {
    getContracts: n,
    reset: r,
    setMainContract: s,
    discountMainContract: a,
    removeDiscountMainContract: o
  };
}, nj = gt.fromProp()("paymentMethod"), rj = gt.fromPath()(["termsOfAgreement", "currency"]), sj = gt.fromProp()("contactInformation"), aj = gt.fromProp()("contractType"), oj = gt.fromPath()([
  "termsOfAgreement",
  "campaignCode"
]), ij = gt.fromPath()([
  "payment",
  "paymentEntries"
]), lj = (t) => ij.get(t).some((s) => s.weightClass === "true") ? "true" : "false", cj = (t) => t ? lj(t) : void 0, dj = (t) => t ? aj.get(t) : void 0, uj = (t) => t ? rj.get(t) : void 0;
function mj(t) {
  return !!t && typeof t == "object" && "commuter" in t && !!t.commuter;
}
const fj = (t) => {
  if (!t) return;
  const n = sj.get(t);
  if (!n || !mj(n)) return;
  const r = n;
  if (r.commuter)
    return r.commuter.startDate;
}, pj = (t) => t ? oj.get(t) : void 0, hj = (t, n) => (r) => {
  if (r)
    return nj.set({
      method: "card",
      card: { data: { ...t, error: "" }, session: n }
    })(r);
}, id = () => {
  const { data: t } = wt(), [n, r] = L(!1), { getContracts: s } = Yn(), { contracts: a } = s(), o = (m) => (f) => {
    const p = f;
    oo(p), ad(p.code);
    let b = {
      email: "",
      firstName: "",
      lastName: "",
      phone: "",
      phoneCode: ""
    };
    m.contactInformation.contact ? b = m.contactInformation.contact : b = m.contactInformation, Ua(), Ha(
      {
        transaction_id: p.orderNo,
        value: `${a.map((g) => g.prices).flat().filter(
          (g) => g.currency === m.termsOfAgreement.currency
        ).reduce((g, v) => g + v.priceInclVat, 0)}`,
        currency: m.termsOfAgreement.currency,
        coupon: m.termsOfAgreement.campaignCode,
        items: a.map((h) => ({
          // See ticket 7308
          item_name: Qi({
            Oresund_Business_Pendler: () => "OresundCommuter",
            Oresund_Business: () => "OresundBusiness",
            OresundPAYBusiness: () => "OresundPay",
            OresundPendler: () => "OresundCommuter",
            OresundPAY: () => "OresundPay",
            Storebelt: () => "Storebelt"
          })(
            h.value
          ),
          item_category: Qi({
            Oresund_Business_Pendler: () => "Business",
            Oresund_Business: () => "Business",
            OresundPAYBusiness: () => "Business",
            OresundPendler: () => "Private",
            OresundPAY: () => "Private",
            Storebelt: () => "Private"
          })(
            h.value
          ),
          item_variant: "OperatorSignup",
          quantity: "1",
          price: (() => {
            var v;
            const g = (v = h.prices.find(
              (y) => y.currency === m.termsOfAgreement.currency
            )) == null ? void 0 : v.priceInclVat;
            return g ? `${g}` : "";
          })()
        }))
      },
      {
        email: b.email,
        firstName: b.firstName,
        lastName: b.lastName,
        phone: `+${m.contactInformation.phoneCode}${m.contactInformation.phone}`,
        city: m.contactInformation.city,
        address1: m.contactInformation.address,
        zipCode: m.contactInformation.zipCode,
        company: m.contactInformation.companyName ?? "",
        country: m.contactInformation.country
      }
    ), m.subscribeToClub && If(m.contractType);
  }, i = (m) => {
    ro(m) && Bn(m);
  }, { mutateAsync: c } = ke(
    ["signup"],
    (m) => m.Customer.signup,
    {
      onError: i,
      onSuccess: o(t),
      onSettled: () => r(!1)
    }
  ), l = K(() => {
    try {
      const m = cj(t), f = uj(t), p = dj(t), b = pj(t), h = fj(t);
      if (m === void 0 || f === void 0 || p === void 0)
        throw Error("token - required prop is undefined");
      return {
        isHGV: m,
        currency: f,
        identity: p,
        campaignCode: b,
        startDate: h
      };
    } catch {
      Bn({ code: 500, error: "no signup data initialized" });
      return;
    }
  }, [t]), d = Q((m) => m && (wu(m) ? {
    ...m,
    contactInformation: {
      ...m.contactInformation,
      ...Xy.modify(bn)(
        m.contactInformation
      ),
      ...Qy.modify(bn)(
        m.contactInformation
      )
    }
  } : Jy.modify(bn)(m)), []), u = Q(
    async (m, f) => {
      var g, v, y, x, j;
      if (!t) return;
      const p = {
        ...t,
        subscribeToClub: t.subscribeToClub || {},
        paymentAgreement: {
          bizzNumber: ((g = t.paymentAgreement) == null ? void 0 : g.bizzNumber) || "",
          country: ((v = t.paymentAgreement) == null ? void 0 : v.country) || "SE",
          licensePlate: ((y = t.paymentAgreement) == null ? void 0 : y.licensePlate) || "",
          oresundsPay: ((x = t.paymentAgreement) == null ? void 0 : x.oresundsPay) || "true",
          paymentProvider: ((j = t.paymentAgreement) == null ? void 0 : j.paymentProvider) || ""
        }
      }, b = d(p), h = hj(m, f)(b);
      h && (r(!0), await c(h));
    },
    [t, c, d]
  );
  return n ? /* @__PURE__ */ e.jsx(ne, { className: "item-center col-span-full flex h-[600px] items-center justify-center text-5xl md:col-span-6 md:col-start-4", children: /* @__PURE__ */ e.jsx(
    "svg",
    {
      className: "animate-spin",
      fill: "currentColor",
      width: "1em",
      height: "1em",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
        }
      )
    }
  ) }) : /* @__PURE__ */ e.jsx(
    ej,
    {
      tokenInformation: l,
      onError: i,
      onSuccess: u
    }
  );
}, gj = ({ title: t, ns: n, transKey: r, className: s, listMode: a }) => /* @__PURE__ */ e.jsxs(Le, { className: s, children: [
  /* @__PURE__ */ e.jsx(M, { children: t }),
  a && /* @__PURE__ */ e.jsx(ne, { as: "ul", className: "mt-2 list-disc pl-6", children: /* @__PURE__ */ e.jsxs(he, { i18nKey: r, ns: n, children: [
    /* @__PURE__ */ e.jsx(M, { as: "li" }),
    /* @__PURE__ */ e.jsx(M, { as: "li" }),
    /* @__PURE__ */ e.jsx(M, { as: "li" }),
    /* @__PURE__ */ e.jsx(M, { as: "li" })
  ] }) })
] }), xj = ({
  icon: t,
  text: n,
  onSelect: r,
  selected: s,
  id: a
}) => /* @__PURE__ */ e.jsxs(
  "div",
  {
    onClick: (o) => r(a),
    className: "flex h-10 flex-row items-center border-t-orange-50 [&:nth-child(n+1)]:border-t-2",
    children: [
      /* @__PURE__ */ e.jsxs("div", { className: "flex w-10/12 flex-row items-center justify-start gap-2", children: [
        /* @__PURE__ */ e.jsx("div", { className: "flex h-10 w-10 items-center justify-center", children: t }),
        /* @__PURE__ */ e.jsx(M, { children: n })
      ] }),
      /* @__PURE__ */ e.jsx("div", { className: "flex w-2/12 flex-row items-center justify-center gap-2", children: s === a ? /* @__PURE__ */ e.jsx(ir, {}) : null })
    ]
  }
), bj = ({ onChange: t, items: n }) => {
  const [r, s] = L(n[0].id), a = (o) => {
    s(o), t(o);
  };
  return /* @__PURE__ */ e.jsx("div", { className: "w-64 cursor-pointer rounded-lg border-2 border-solid md:w-96", children: n.map((o, i) => /* @__PURE__ */ e.jsx(
    xj,
    {
      icon: o.icon,
      text: o.text,
      onSelect: a,
      selected: r,
      id: o.id
    },
    o.id
  )) });
}, vj = ({ className: t, height: n = "3em", width: r = "3em" }) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    version: "1.1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 619.2 513",
    width: r,
    height: n,
    className: t,
    children: [
      /* @__PURE__ */ e.jsxs("g", { children: [
        /* @__PURE__ */ e.jsx(
          "path",
          {
            fill: "#193E4F",
            d: "M251.3,263.4l13.2-83.2c-5.2,0-14.1,0-14.1,0c-6.6,0-15.1-3.7-17.6-10.5c-0.8-2.3-2.7-10.2,8.2-17.9   c3.9-2.7,6.4-5.7,6.9-8c0.5-2.4-0.1-4.5-1.8-6.1c-2.4-2.3-7.1-3.6-13.1-3.6c-10.1,0-17.2,5.8-17.9,10c-0.5,3.1,1.9,5.6,4,7.2   c6.3,4.7,7.8,11.5,3.9,17.9c-4,6.6-12.7,10.9-22,11c0,0-9.2,0-14.4,0c-1.2,8.1-20.8,132.3-22.3,142.1h77.8   C242.8,318,246.4,294.5,251.3,263.4L251.3,263.4z"
          }
        ),
        /* @__PURE__ */ e.jsxs("g", { children: [
          /* @__PURE__ */ e.jsx(
            "path",
            {
              fill: "#193E4F",
              d: "M160.1,351.1H192c13.6,0,16.9,6.9,15.9,13.2c-0.8,5.1-4.3,8.9-10.3,11.4c7.6,2.9,10.6,7.4,9.5,14.5    c-1.4,8.9-9.1,15.5-19.2,15.5h-36.3L160.1,351.1z M181.2,373.7c6.2,0,9.1-3.3,9.7-7.2c0.6-4.2-1.3-7.1-7.5-7.1h-5.5l-2.2,14.3    H181.2z M177.8,397.2c6.4,0,10.1-2.6,11-7.9c0.7-4.6-1.9-7.3-8.1-7.3h-6.2l-2.4,15.3H177.8z"
            }
          ),
          /* @__PURE__ */ e.jsx(
            "path",
            {
              fill: "#193E4F",
              d: "M251.8,406.1c-8.3,0.6-12.3-0.3-14.3-3.9c-4.4,2.7-9.3,4.1-14.5,4.1c-9.4,0-12.7-4.9-11.8-10.3    c0.4-2.6,1.9-5.1,4.3-7.2c5.2-4.5,18-5.1,23-8.5c0.4-3.8-1.1-5.2-5.8-5.2c-5.5,0-10.1,1.8-18,7.2l1.9-12.4    c6.8-4.9,13.4-7.2,21-7.2c9.7,0,18.3,4,16.7,14.6l-1.9,12c-0.7,4.2-0.5,5.5,4.2,5.6L251.8,406.1z M237.4,387.2    c-4.4,2.8-12.6,2.3-13.5,8.1c-0.4,2.7,1.3,4.7,4,4.7c2.6,0,5.8-1.1,8.4-2.9c-0.2-1-0.1-2,0.2-3.9L237.4,387.2z"
            }
          ),
          /* @__PURE__ */ e.jsx(
            "path",
            {
              fill: "#193E4F",
              d: "M267.3,363.4h16.6l-0.9,5.5c5.3-4.5,9.3-6.2,14.5-6.2c9.3,0,13.6,5.7,12.1,15l-4.3,27.9h-16.6l3.6-23.1    c0.7-4.2-0.6-6.2-3.8-6.2c-2.6,0-5,1.4-7.3,4.5l-3.8,24.7h-16.6L267.3,363.4z"
            }
          ),
          /* @__PURE__ */ e.jsx(
            "path",
            {
              fill: "#193E4F",
              d: "M322.6,351.1h16.6l-4.2,26.8l15.9-14.5h20.5l-20.4,18l16.4,24.2h-20.9L333.9,386h-0.2l-3,19.5h-16.6    L322.6,351.1z"
            }
          )
        ] }),
        /* @__PURE__ */ e.jsx("path", { fill: "#193E4F", d: "M381.3,351.1h19.1l-8.4,54.5h-19.1L381.3,351.1z" }),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            fill: "#193E4F",
            d: "M409.7,351.1H437c21.1,0,27.2,15.3,25.2,28c-1.9,12.4-11.7,26.5-30.2,26.5h-30.8L409.7,351.1z M427.4,392.6   c9.3,0,14.4-4.6,15.9-14.3c1.1-7.2-1.1-14.3-11.4-14.3h-5.1l-4.4,28.6H427.4z"
          }
        ),
        /* @__PURE__ */ e.jsx(
          "path",
          {
            fill: "#193E4F",
            d: "M355.9,107.5h-79.5l-10.6,67.3l13.5,0c7.4,0,14.4-3.4,17.4-8.3c1-1.6,1.4-3,1.4-4.3c0-2.8-1.9-4.9-3.8-6.3   c-5.2-3.9-6.3-8-6.3-10.9c0-0.6,0-1.1,0.1-1.6c1.1-7.1,10.7-14.8,23.4-14.8c7.6,0,13.4,1.8,16.9,5.1c3.1,2.9,4.3,7,3.4,11.3   c-1.1,5.1-6.2,9.3-9.1,11.4c-7.7,5.4-6.7,10.1-6.2,11.5c1.6,4.2,7.7,6.9,12.4,6.9h20.6c0,0,0,0,0,0.1c28,0.2,43,13.1,38.3,43.1   c-4.4,27.9-25.8,39.9-51.3,40.1l-10.1,64.4h14.9c62.9,0,114.3-40.4,124.4-104.2C478.2,139.1,427.9,107.5,355.9,107.5z"
          }
        )
      ] }),
      /* @__PURE__ */ e.jsx("rect", { fill: "none", width: "619.2", height: "513" })
    ]
  }
), yj = ({ height: t = "3em", width: n = "3em" }) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    width: n,
    height: t,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ e.jsx(
        "mask",
        {
          id: "prefix__a",
          style: {
            maskType: "alpha"
          },
          maskUnits: "userSpaceOnUse",
          x: 0,
          y: 0,
          width: 23,
          height: 24,
          children: /* @__PURE__ */ e.jsx("path", { d: "M0 0h24v24H0z" })
        }
      ),
      /* @__PURE__ */ e.jsx("g", { mask: "url(#prefix__a)", children: /* @__PURE__ */ e.jsx("path", { d: "M12 12c-1.1 0-2.042-.392-2.825-1.175C8.392 10.042 8 9.1 8 8s.392-2.042 1.175-2.825C9.958 4.392 10.9 4 12 4s2.042.392 2.825 1.175C15.608 5.958 16 6.9 16 8s-.392 2.042-1.175 2.825C14.042 11.608 13.1 12 12 12Zm6 8H6c-.55 0-1.02-.196-1.412-.587A1.927 1.927 0 0 1 4 18v-.8c0-.567.146-1.088.438-1.563A2.914 2.914 0 0 1 5.6 14.55a14.866 14.866 0 0 1 3.15-1.163A13.776 13.776 0 0 1 12 13c1.1 0 2.183.129 3.25.387 1.067.259 2.117.646 3.15 1.163.483.25.87.612 1.162 1.087.292.475.438.996.438 1.563v.8c0 .55-.196 1.021-.587 1.413A1.928 1.928 0 0 1 18 20ZM6 18h12v-.8a.943.943 0 0 0-.137-.5.977.977 0 0 0-.363-.35c-.9-.45-1.808-.788-2.725-1.013a11.615 11.615 0 0 0-5.55 0c-.917.225-1.825.563-2.725 1.013a.97.97 0 0 0-.5.85v.8Zm6-8c.55 0 1.021-.196 1.413-.588C13.804 9.021 14 8.55 14 8c0-.55-.196-1.02-.587-1.412A1.927 1.927 0 0 0 12 6c-.55 0-1.02.196-1.412.588A1.923 1.923 0 0 0 10 8c0 .55.196 1.02.588 1.412.391.392.862.588 1.412.588Z" }) })
    ]
  }
), ld = ({ ns: t }) => {
  const { resetAuthentication: n } = sn(), { t: r } = V([t, "common"], { nsMode: "fallback" }), { resp: s, token: a } = wt(), [o, i] = L(!1), [c, l] = L(1), d = ve(), { mutateAsync: u, isError: m } = ke(
    ["password", "set", "V2"],
    (y) => y.Customer.setPasswordV2(a),
    {
      onMutate: () => i(!0),
      onSettled: (y, x) => {
        c === 1 || (i(!1), x || tj());
      }
    }
  ), f = (y = 20) => {
    const x = () => {
      const C = [
        { start: 48, end: 57 },
        // Numbers (0-9)
        { start: 65, end: 90 },
        // Uppercase letters (A-Z)
        { start: 97, end: 122 },
        // Lowercase letters (a-z)
        { start: 33, end: 47 },
        // Symbols (! to /)
        { start: 58, end: 64 },
        // Symbols (: to @)
        { start: 91, end: 96 },
        // Symbols ([ to `)
        { start: 123, end: 126 }
        // Symbols ({ to ~)
      ], P = C[Math.floor(Math.random() * C.length)], N = Math.floor(Math.random() * (P.end - P.start + 1)) + P.start;
      return String.fromCharCode(N);
    };
    let j = "";
    for (let C = 0; C < y; C++)
      j += x();
    return Nu.safeParse({
      password: j,
      confirmPassword: j
    }).success || (j = f()), j;
  }, {
    registerField: p,
    isValid: b,
    handleSubmit: h,
    validate: g,
    getError: v
  } = Se({
    namespace: "setPassword",
    onValidate: Hn(al.spa, r),
    onSubmit: async (y) => {
      const x = c === 1, j = f(), w = await u({
        password: x ? j : y.password,
        confirmPassword: x ? j : y.confirmPassword
      });
      if (n(), x) {
        const C = d.locale;
        await d.replace(
          `/api/auth/login?locale=${C}&source=sebankid&nonce=${w.nonce}&returnUrl=${d.asPath}`
        );
      }
    }
  });
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(M, { as: "h1", intent: "headline", className: "col-span-full", children: r("form.sections.password.title") }),
    /* @__PURE__ */ e.jsx(M, { className: "col-span-full", children: r("form.sections.password.description") }),
    /* @__PURE__ */ e.jsxs(nt.Root, { as: "form", onSubmit: h, className: "col-span-8", children: [
      /* @__PURE__ */ e.jsx(nt.Content, { as: ht, children: /* @__PURE__ */ e.jsx(
        bj,
        {
          items: [
            {
              text: r("authenticationMethods.bankId"),
              icon: /* @__PURE__ */ e.jsx(vj, { height: "2.5em", width: "2.5em" }),
              id: 1
            },
            {
              text: r("authenticationMethods.usernameAndPassword"),
              icon: /* @__PURE__ */ e.jsx(
                yj,
                {
                  height: "2.5em",
                  width: "2.5em"
                }
              ),
              id: 2
            }
          ],
          onChange: (y) => l(y)
        }
      ) }),
      /* @__PURE__ */ e.jsx(nt.Content, { as: ht, children: c === 1 ? /* @__PURE__ */ e.jsx(ne, { className: "col-span-full flex", children: /* @__PURE__ */ e.jsx(et, { loadingLabel: r("action.loading"), type: "submit", children: r("action.bankIdContinue") }) }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        m && /* @__PURE__ */ e.jsx(Le, { className: "col-span-full", color: "negative", children: r("errors.savePassword") }),
        /* @__PURE__ */ e.jsx(
          Pt,
          {
            label: r("form.labels.customerNo"),
            className: "col-span-full",
            children: s == null ? void 0 : s.customerNo
          }
        ),
        /* @__PURE__ */ e.jsx(
          me,
          {
            className: "col-span-full sm:col-span-4 md:col-span-6",
            ...p("password"),
            label: r("form.labels.password"),
            error: v("password"),
            disabled: o,
            type: "password",
            required: !0
          }
        ),
        /* @__PURE__ */ e.jsx(
          me,
          {
            className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7",
            ...p("confirmPassword"),
            label: r("form.labels.repeatPassword"),
            error: v("confirmPassword"),
            disabled: o,
            type: "password",
            required: !0
          }
        ),
        /* @__PURE__ */ e.jsx(
          gj,
          {
            listMode: !0,
            className: "col-span-full",
            title: r("passwordRequirement.title"),
            ns: "common",
            transKey: "passwordRequirement.description"
          }
        ),
        /* @__PURE__ */ e.jsx(ne, { className: "col-span-full flex justify-end", children: /* @__PURE__ */ e.jsx(
          et,
          {
            loadingLabel: r("action.loading"),
            type: "submit",
            disabled: !b || o || m,
            onClick: () => g()(),
            isLoading: o,
            children: r("action.savePassword")
          }
        ) })
      ] }) })
    ] })
  ] });
}, jj = gt.fromPath()(["contractType"]), Cj = (t) => (t == null ? void 0 : t.payment.paymentEntries.filter(
  (n) => !!n.licensePlate && n.paymentOptions === "bizz"
)) ?? [], wj = (t) => (t == null ? void 0 : t.payment.paymentEntries.filter(
  (n) => !!n.licensePlate && n.paymentOptions !== "bizz"
)) ?? [], Nj = (t) => (t == null ? void 0 : t.payment.paymentEntries.filter(
  (n) => n.paymentOptions === "bizz"
).length) ?? !1, Pj = (t) => {
  if (t) {
    const n = jj.get(t), r = Ga(n);
    return r ? /* @__PURE__ */ e.jsx(at, { contract: r }) : "";
  } else
    return "";
}, qr = ({ ns: t }) => {
  const { t: n } = V([t, "common"], { nsMode: "fallback" }), { data: r } = wt(), s = K(() => Cj(r), [r]), a = K(() => wj(r), [r]), o = K(() => Pj(r), [r]), i = K(() => Nj(r), [r]), c = K(
    () => {
      var f;
      return ((f = r == null ? void 0 : r.paymentMethod) == null ? void 0 : f.method) === "invoice";
    },
    [r]
  ), [l, d] = a, [u, m] = s;
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      M,
      {
        as: "h1",
        intent: "headline",
        className: "col-span-full md:col-start-3 md:col-end-11",
        children: r ? /* @__PURE__ */ e.jsx(he, { ns: t, i18nKey: "form.sections.confirmation.title", children: o }) : n("form.sections.confirmation.shortTitle")
      }
    ),
    /* @__PURE__ */ e.jsxs(
      du,
      {
        className: "col-span-full md:col-start-3 md:col-end-11",
        transparent: !1,
        children: [
          r && /* @__PURE__ */ e.jsx(M, { intent: "title", className: "mb-2", children: n("form.sections.confirmation.readyToDrive.title") }),
          c ? /* @__PURE__ */ e.jsx(M, { className: i ? "mb-2" : "mb-4", children: n("form.sections.confirmation.readyToDrive.invoice") }) : r ? /* @__PURE__ */ e.jsx(M, { className: i ? "mb-2" : "mb-4", children: /* @__PURE__ */ e.jsx(
            he,
            {
              ns: t,
              i18nKey: "form.sections.confirmation.readyToDrive.description",
              values: {
                count: a.length,
                licensePlate: l == null ? void 0 : l.licensePlate,
                secondLicensePlate: d == null ? void 0 : d.licensePlate
              },
              children: /* @__PURE__ */ e.jsx(M, { as: "span", weight: "bold", className: "uppercase" })
            }
          ) }) : null,
          s.length ? /* @__PURE__ */ e.jsx(M, { className: "mb-4", children: /* @__PURE__ */ e.jsx(
            he,
            {
              ns: t,
              i18nKey: "form.sections.confirmation.readyToDrive.registerBizz",
              values: {
                count: s.length,
                licensePlate: u == null ? void 0 : u.licensePlate,
                secondLicensePlate: m == null ? void 0 : m.licensePlate
              },
              children: /* @__PURE__ */ e.jsx(M, { as: "span", weight: "bold", className: "mb-4 uppercase" })
            }
          ) }) : i ? /* @__PURE__ */ e.jsx(M, { className: "mb-4", children: n("form.sections.confirmation.readyToDrive.bizz") }) : null,
          /* @__PURE__ */ e.jsx(M, { intent: "title", className: "mb-2", children: n("form.sections.confirmation.myAccount.title") }),
          /* @__PURE__ */ e.jsx(M, { className: "mb-4", children: /* @__PURE__ */ e.jsx(
            he,
            {
              ns: t,
              i18nKey: "form.sections.confirmation.myAccount.description",
              children: /* @__PURE__ */ e.jsx(jt, { href: "/account/login" })
            }
          ) }),
          /* @__PURE__ */ e.jsx(ne, { className: "flex justify-end", children: /* @__PURE__ */ e.jsx(be, { as: jt, href: "/account/login", underline: !1, children: n("action.myAccount") }) })
        ]
      }
    )
  ] });
}, Sj = ({
  namespace: t,
  defaultValues: n,
  labels: r,
  countryOptions: s,
  phoneCodeOptions: a,
  placeholders: o,
  disableNameChange: i
}) => {
  const { registerField: c, getError: l, isActive: d } = Se({
    namespace: t,
    defaultValues: n
  });
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      me,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...c("firstName"),
        label: r.firstName,
        error: l("firstName"),
        disabled: i || !d,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      me,
      {
        className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7",
        ...c("lastName"),
        label: r.lastName,
        error: l("lastName"),
        disabled: i || !d,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      Oe,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...c("country"),
        label: r.country,
        options: s.map((u) => ({ ...u, label: u.key })),
        placeholder: o.country,
        error: l("country"),
        disabled: !d,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(ne, { className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7" }),
    /* @__PURE__ */ e.jsx(
      me,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...c("zipCode"),
        label: r.zipCode,
        error: l("zipCode"),
        disabled: !d,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      me,
      {
        className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7",
        ...c("city"),
        label: r.city,
        error: l("city"),
        disabled: !d,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      me,
      {
        className: "col-span-full",
        ...c("address"),
        label: r.address,
        error: l("address"),
        disabled: !d,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      Oe,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...c("phoneCode"),
        label: r.phoneCode,
        options: a.map((u, m) => ({
          value: Na(u.value, m),
          label: u.key
        })),
        placeholder: o.phoneCode,
        error: l("phoneCode"),
        disabled: !d,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      me,
      {
        className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7",
        ...c("phone"),
        label: r.phone,
        error: l("phone"),
        disabled: !d,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      me,
      {
        className: "col-span-full",
        ...c("email"),
        label: r.email,
        error: l("email"),
        disabled: !d,
        required: !0
      }
    )
  ] });
}, Tj = ({
  labels: t,
  namespace: n,
  title: r,
  defaultValues: s,
  countryOptions: a = [],
  phoneCodeOptions: o = [],
  onValidate: i,
  placeholders: c
}) => {
  const { validate: l, isValid: d, isActive: u, stepNr: m } = Se({
    namespace: n,
    title: r,
    defaultValues: s,
    onValidate: i
  });
  return /* @__PURE__ */ e.jsxs(Vt, { nr: m, title: r, id: n, children: [
    /* @__PURE__ */ e.jsx(
      Sj,
      {
        namespace: n,
        placeholders: c,
        labels: t,
        countryOptions: a,
        phoneCodeOptions: o
      }
    ),
    /* @__PURE__ */ e.jsx(
      kn,
      {
        loadingLabel: t.loading,
        namespace: n,
        onClick: l(),
        disabled: !u || !d
      }
    )
  ] });
};
function cd() {
  const { mutateAsync: t } = ke(
    ["customer", "verify"],
    (r) => r.Customer.verifyCustomerV2,
    {
      retry: 0
    }
  );
  return Q(
    (r) => async (s) => {
      try {
        const a = await t(s);
        return r(a);
      } catch {
        return r({
          success: !1
        });
      }
    },
    [t]
  );
}
function dd() {
  const { mutateAsync: t } = ke(
    ["customer", "validate"],
    (r) => r.Customer.validate
  );
  return Q(
    (r) => async (s) => {
      try {
        const a = await t(s);
        return r(a);
      } catch {
        return;
      }
    },
    [t]
  );
}
function ud() {
  const { mutateAsync: t } = ke(
    ["phone", "validate"],
    (r) => r.Phone.validate
  );
  return Q(
    (r) => async (s) => {
      try {
        await t({
          ...s,
          phoneCode: bn(s.phoneCode)
        });
        return;
      } catch {
        return r;
      }
    },
    [t]
  );
}
const Ej = (t) => (n) => [...n].sort((r, s) => {
  const a = hl(
    (i) => i.country
  ).compare(r, s);
  if (a !== 0) return a;
  const o = gl((i) => i.country)(
    t
  ).compare(r, s);
  return o !== 0 ? o : xl((i) => i.countryName).compare(r, s);
});
function md() {
  const { locale: t } = ve(), { data: n } = De(
    xe.PhoneCodeList({ locale: t }),
    (r) => r.Phone.phoneCodeList(t || "")
  );
  return K(() => n ? Ej(t || "")(n) : [], [n, t]);
}
const lo = Tn(), kj = lo("country", "phoneCode", "phone"), Aj = lo("cpr", "email"), Oj = lo("email"), _j = ({
  namespace: t,
  titleTranslationKey: n,
  ns: r
}) => {
  const s = dd(), a = ud(), o = cd(), i = $t(), c = md(), { locale: l } = ve(), { t: d } = V(r, {
    nsMode: "fallback"
  }), u = Q(
    (g) => (v) => {
      if (v && St("phone")(v)) {
        const y = kj(g);
        return a({
          phone: d("form.validations.phone.invalid")
        })(y);
      }
    },
    [d, a]
  ), m = Q(
    (g) => async (v) => {
      const y = Aj(g);
      return await s((j) => ({
        email: j.email && St("email")(v) ? d("form.validations.email.exist") : void 0
      }))(y);
    },
    [s, d]
  ), f = Q(
    (g) => async (v) => {
      const y = Oj(g), j = await o(
        (C) => ({
          email: !C.success && St("email")(v) ? d("form.validations.email.exist") : void 0
        })
      )(y), w = Object.values(j);
      for (const C of w)
        if (C)
          return j;
    },
    [o, d]
  ), p = Q(
    async (g) => {
      const v = Pu.spa, y = await rn(v, d)(g);
      return await cs(
        async (C) => await u(g)(C),
        async (C) => await m(g)(C)
      )(y);
    },
    [d, u, m]
  ), b = Q(
    async (g) => {
      const v = await p(g);
      return v || await f(g)();
    },
    [p, f]
  ), h = c.find(
    (g) => g.country === dn(l || "")
  );
  return /* @__PURE__ */ e.jsx(
    Tj,
    {
      namespace: t,
      title: d(n),
      defaultValues: {
        country: dn(l || ""),
        phoneCode: h == null ? void 0 : h.value
      },
      labels: {
        firstName: d("form.labels.firstName"),
        lastName: d("form.labels.lastName"),
        cpr: d("form.labels.cpr"),
        city: d("form.labels.city"),
        address: d("form.labels.address"),
        email: d("form.labels.email"),
        zipCode: d("form.labels.zipCode"),
        phone: d("form.labels.phone"),
        phoneCode: d("form.labels.phoneCode"),
        country: d("form.labels.country"),
        loading: d("action.loading")
      },
      placeholders: {
        country: d("form.placeholders.country"),
        phoneCode: d("form.placeholders.phoneCode")
      },
      countryOptions: i,
      phoneCodeOptions: c,
      onValidate: b
    }
  );
}, Rj = {
  paymentOptions: "licensePlate"
}, Mj = ({
  labels: t,
  countryOptions: n = [],
  weightClassOptions: r = [],
  fuelTypeOptions: s = [],
  emissionClassOptions: a = [],
  onAdd: o,
  onValidate: i,
  onCancel: c,
  displayCancel: l,
  placeholders: d,
  disableForm: u,
  defaultValues: m,
  vehicleColors: f
}) => {
  const p = K(
    () => ({ ...Rj, ...m }),
    [m]
  ), b = "alpr", {
    registerField: h,
    getError: g,
    getData: v,
    validate: y,
    isValid: x,
    isDirty: j,
    resetSelectedData: w,
    setPartialData: C,
    resetFieldErrors: P,
    setFieldErrors: N
  } = Se({
    namespace: b,
    onValidate: i,
    defaultValues: p
  }), { t: R } = V(["privateSignUp", "businessSignUp", "common"], {
    nsMode: "fallback"
  }), [T, z, D, A] = He(
    b,
    "country",
    "licensePlate",
    "fuelType",
    "emissionClass"
  ), [S, _] = L(), [$, q] = L(), [U, W] = L(), {
    data: G,
    error: ee,
    isFetching: ue
  } = Jr($), ce = Pn();
  Y(() => W(ee), [ee]), Y(() => W(null), [z]), Y(() => _(G), [G]), Y(() => _(void 0), [z, T]), Y(() => q(void 0), [T]), Y(() => {
    D === "5" && A && C({
      emissionClass: void 0
    });
  }, [D, C, A]);
  const re = Q(() => {
    w([
      "make",
      "model",
      "color",
      "weightClass",
      "hybrid",
      "fuelType",
      "emissionClass"
    ]);
  }, [w]), se = Q(() => {
    re(), P(), q(void 0);
  }, [P, re]), H = Q(
    async (ae) => {
      const ge = T;
      if (!ge || !ae) {
        q({ licensePlate: ae, country: ge });
        return;
      }
      try {
        if (await ce({
          licensePlate: t.licensePlateExist
        })({
          licensePlate: ae,
          country: ge
        }))
          q({ licensePlate: ae, country: ge });
        else
          throw new Error("Validation failed");
      } catch (je) {
        N(je), re();
      }
    },
    [
      q,
      T,
      ce,
      t,
      N,
      re
    ]
  );
  Y(() => {
    hr(
      pr(z),
      T
    ) && H(z);
  }, [z, T, H]), Y(() => se, [T, se]), Y(
    () => wc(
      S,
      C,
      se,
      a
    ),
    [S, C, se]
  );
  const O = Q(async () => {
    await y()() && o(v());
  }, [y, v, o]);
  return /* @__PURE__ */ e.jsx(nt.Root, { className: "col-span-full", children: /* @__PURE__ */ e.jsx(nt.Content, { children: /* @__PURE__ */ e.jsxs(ht, { children: [
    /* @__PURE__ */ e.jsx(
      me,
      {
        ...h("alprName"),
        label: t.alprName,
        className: "col-span-full sm:col-span-4 md:col-span-12",
        error: g("alprName"),
        disabled: u
      }
    ),
    /* @__PURE__ */ e.jsx(
      Oe,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...h("country"),
        label: t.country,
        groupedOptions: n.map((ae) => {
          var ge;
          return {
            children: ae.children,
            group: { label: (ge = ae.group) != null && ge.label ? R(ae.group.label) : void 0 }
          };
        }),
        placeholder: d.country,
        error: g("country"),
        disabled: u,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      me,
      {
        ...h("licensePlate"),
        label: t.licensePlate,
        className: "col-span-full sm:col-start-5 md:col-span-6 md:col-start-7",
        error: g("licensePlate"),
        disabled: u,
        required: !0
      }
    ),
    U ? /* @__PURE__ */ e.jsx(ne, { className: "col-span-full bg-white", children: /* @__PURE__ */ e.jsx(Le, { className: "col-span-full mb-2", children: t.noVehicleInfo }) }) : null,
    /* @__PURE__ */ e.jsx(ne, { className: "col-span-full", children: /* @__PURE__ */ e.jsx(M, { as: "h6", size: "lg", className: "mb-0", children: t.volVehicleInfo }) }),
    /* @__PURE__ */ e.jsx(
      me,
      {
        ...h("make"),
        label: t.make,
        className: "col-span-full sm:col-span-4 md:col-span-6",
        error: g("make"),
        disabled: u || !!(S != null && S.make)
      }
    ),
    /* @__PURE__ */ e.jsx(
      me,
      {
        ...h("model"),
        label: t.model,
        className: "col-span-full sm:col-span-4 md:col-span-6",
        error: g("model"),
        disabled: u || !!(S != null && S.model)
      }
    ),
    /* @__PURE__ */ e.jsx(
      Oe,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...h("color"),
        label: t.color,
        placeholder: d.color,
        options: f,
        placeholderDisabled: !1,
        error: g("color"),
        disabled: u || !!(S != null && S.color)
      }
    ),
    /* @__PURE__ */ e.jsx(
      Oe,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...h("weightClass"),
        label: t.weightClass,
        options: r,
        placeholder: d.weightClass,
        placeholderDisabled: !1,
        error: g("weightClass"),
        disabled: u || (S == null ? void 0 : S.isHGV) !== void 0
      }
    ),
    /* @__PURE__ */ e.jsx(
      Oe,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...h("fuelType"),
        label: t.fuelType,
        options: s,
        placeholder: d.fuelType,
        placeholderDisabled: !1,
        error: g("fuelType"),
        disabled: u || !!(S != null && S.fuelType)
      }
    ),
    /* @__PURE__ */ e.jsx(
      Oe,
      {
        className: "col-span-full sm:col-start-5 md:col-span-6 md:col-start-7",
        ...h("emissionClass"),
        label: t.emissionClass,
        options: a,
        error: g("emissionClass"),
        placeholder: d.emissionClass,
        placeholderDisabled: !1,
        disabled: u || !!(S != null && S.euroEmissionNorm) || D === "5"
      }
    ),
    /* @__PURE__ */ e.jsx(
      me,
      {
        ...h("hybrid", {
          type: "checkbox",
          value: "true"
        }),
        label: t.hybrid,
        className: "col-span-full sm:col-start-5 md:col-span-6",
        error: g("hybrid"),
        disabled: u || (S == null ? void 0 : S.isHybrid) !== void 0
      }
    ),
    /* @__PURE__ */ e.jsxs(ne, { className: "col-span-full mt-2 flex justify-end", children: [
      l ? /* @__PURE__ */ e.jsx(be, { intent: "text", onClick: c, className: "mr-auto", children: t.cancel }) : null,
      /* @__PURE__ */ e.jsx(
        be,
        {
          intent: "outlined",
          onClick: O,
          disabled: !x || !j || ue,
          children: t.add
        }
      )
    ] })
  ] }) }) });
}, fd = ({
  labels: t,
  licensePlate: n,
  alprName: r,
  paymentOptions: s,
  onRemove: a,
  disabled: o
}) => /* @__PURE__ */ e.jsx(nt.Root, { className: "col-span-full", children: /* @__PURE__ */ e.jsxs(nt.Content, { className: "flex flex-row items-center justify-between", children: [
  /* @__PURE__ */ e.jsx(ne, { className: "pr-5", children: /* @__PURE__ */ e.jsx(sl, { className: "text-primary-400 text-2xl" }) }),
  /* @__PURE__ */ e.jsxs(ne, { className: "flex-1", children: [
    /* @__PURE__ */ e.jsx(
      Pt,
      {
        label: Ii(r) ? t.licensePlate : t.alprName,
        children: Ii(r) ? n : r
      }
    ),
    s === "bizz" ? /* @__PURE__ */ e.jsx(Pt, { label: t.bizz, children: t.bizzOrdered }) : null
  ] }),
  /* @__PURE__ */ e.jsx(ne, { className: "flex flex-row items-center", children: /* @__PURE__ */ e.jsx(
    be,
    {
      startIcon: /* @__PURE__ */ e.jsx(or, {}),
      iconSize: "lg",
      color: "neutral",
      intent: "text",
      "aria-label": t.remove,
      onClick: a,
      disabled: o
    }
  ) })
] }) }), zj = {
  paymentEntries: []
}, Dj = ({
  title: t,
  namespace: n,
  description: r,
  labels: s,
  countryOptions: a,
  bvSupportCountries: o,
  weightClassOptions: i,
  emissionClassOptions: c,
  fuelTypeOptions: l,
  maxEntries: d,
  onAlprValidation: u,
  onValidate: m,
  useOnOtherPlacesDisclaimer: f,
  placeholders: p,
  vehicleColors: b
}) => {
  const [h, g] = L(!0), [v, y] = L(0), {
    stepNr: x,
    setData: j,
    getData: w,
    validate: C,
    isValid: P,
    isActive: N,
    transformData: R
  } = Se({
    namespace: n,
    title: t,
    defaultValues: zj,
    onValidate: m
  }), T = Q(
    (S) => {
      j((_) => {
        const $ = [..._.paymentEntries || []];
        return $.splice(v, 1, S), {
          paymentEntries: $
        };
      }), g(!1);
    },
    [g, j, v]
  ), z = Q(
    (S) => {
      R((_) => {
        const q = { paymentEntries: [
          ..._.paymentEntries.slice(0, S),
          ..._.paymentEntries.slice(S + 1)
        ] };
        return q.paymentEntries.length === 0 && g(!0), q;
      });
    },
    [R, g]
  ), D = Q(() => {
    y((S) => S + 1), g(!0);
  }, [y, g]), A = w().paymentEntries || [];
  return /* @__PURE__ */ e.jsxs(Vt, { nr: x, title: t, id: n, children: [
    /* @__PURE__ */ e.jsx(ne, { className: "col-span-full", children: r }),
    A.map((S, _) => /* @__PURE__ */ e.jsx(
      fd,
      {
        labels: s,
        ...S,
        onRemove: () => z(_),
        disabled: !N
      },
      _
    )),
    h ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(ne, { className: "col-span-full bg-white", children: /* @__PURE__ */ e.jsx(vo.Root, { type: "single", collapsible: !0, children: /* @__PURE__ */ e.jsx(
        vo.Item,
        {
          label: s.useInNorway,
          value: "content",
          border: !1,
          className: "px-4",
          children: /* @__PURE__ */ e.jsx(Le, { className: "col-span-full mb-2", children: f })
        }
      ) }) }),
      /* @__PURE__ */ e.jsx(zt, { children: /* @__PURE__ */ e.jsx(
        Mj,
        {
          onValidate: u,
          labels: s,
          onCancel: () => g(!1),
          countryOptions: a,
          bvSupportCountries: o,
          weightClassOptions: i,
          emissionClassOptions: c,
          fuelTypeOptions: l,
          onAdd: T,
          displayCancel: A.length > 0,
          placeholders: p,
          disableForm: !N,
          vehicleColors: b
        }
      ) })
    ] }) : null,
    A.length + 1 <= d && !h ? /* @__PURE__ */ e.jsx(
      be,
      {
        startIcon: /* @__PURE__ */ e.jsx(cn, {}),
        intent: "text",
        onClick: D,
        disabled: !N,
        children: s.addMore
      }
    ) : null,
    /* @__PURE__ */ e.jsx(
      kn,
      {
        loadingLabel: s.loading,
        namespace: n,
        onClick: C(),
        disabled: !N || !P || !A.length || h
      }
    )
  ] });
}, Lj = Tn()("licensePlate", "country"), Ij = gt.fromNullableProp()("paymentEntries", []), $j = ({
  namespace: t,
  titleTranslationKey: n,
  ns: r
}) => {
  const s = Zr(), a = vl(), o = At(), i = Pn(), { locale: c } = ve(), { t: l } = V(r, {
    nsMode: "fallback"
  }), { getData: d } = Se({
    namespace: t,
    title: l(n)
  }), u = Q(
    (h) => async (g) => {
      if (g && !St("licensePlate")(g))
        return;
      const v = Lj(h);
      if (!(!v.country || !v.licensePlate))
        return await i({
          licensePlate: l("form.validations.licensePlate.exist")
        })(v);
    },
    [l, i]
  ), m = Q(
    (h) => () => {
      if (Ij.get(d()).some((y) => y.licensePlate === h.licensePlate))
        return { licensePlate: l("form.validations.licensePlate.unique") };
    },
    [d, l]
  ), f = Q(
    async (h) => {
      const g = await rn(ul.spa, l)(h);
      return await cs(
        async () => m(h)(),
        async (j) => u(h)(j)
      )(g);
    },
    [u, l, m]
  ), p = ds.map((h) => ({
    label: l(`vehicleColors.${h}`),
    value: h
  })), b = {
    namespace: t,
    title: l(n),
    description: /* @__PURE__ */ e.jsxs(he, { i18nKey: "form.sections.payment.description", ns: r, children: [
      /* @__PURE__ */ e.jsx(M, { className: "mb-4" }),
      /* @__PURE__ */ e.jsx(M, { size: "sm" })
    ] }),
    defaultCountry: dn(c || ""),
    onAlprValidation: f,
    countryOptions: a,
    bvSupportCountries: s,
    maxEntries: 2,
    labels: {
      make: l("form.labels.make"),
      model: l("form.labels.model"),
      color: l("form.labels.color"),
      alprName: l("form.labels.alprName"),
      vehicleSearch: l("action.search"),
      licensePlate: l("form.labels.licensePlate"),
      country: l("form.labels.country"),
      fuelType: l("form.labels.fuelType"),
      emissionClass: l("form.labels.emissionClass"),
      weightClass: l("form.labels.weightClass"),
      useInNorway: l("form.labels.useInNorway"),
      add: l("form.labels.add"),
      hybrid: l("form.labels.hybrid"),
      addMore: l("form.labels.addMore"),
      cancel: l("action.cancel"),
      remove: l("action.remove"),
      loading: l("action.loading"),
      volVehicleInfo: l("form.labels.vlinfo"),
      noVehicleInfo: l("form.validations.licensePlate.notfound"),
      loadingSearch: l("action.loading"),
      licensePlateExist: l("form.validations.licensePlate.exist"),
      // not used in private
      bizz: "",
      isSBF: "",
      bizzOrdered: ""
    },
    placeholders: {
      weightClass: l("form.placeholders.weightClass"),
      country: l("form.placeholders.country"),
      emissionClass: l("form.placeholders.emissionClass"),
      fuelType: l("form.placeholders.fuelType"),
      color: l("form.placeholders.color")
    },
    useOnOtherPlacesDisclaimer: l(
      "form.sections.payment.disclaimers.useInNorway"
    ),
    fuelTypeOptions: o.fuelTypes,
    weightClassOptions: [
      { label: l("weightClasses.light"), value: "false" },
      { label: l("weightClasses.heavy"), value: "true" }
    ],
    emissionClassOptions: o.emissionClasses,
    vehicleColors: p
  };
  return /* @__PURE__ */ e.jsx(Dj, { ...b });
};
function pd(t, n) {
  const { getContracts: r, setMainContract: s } = Yn(), { contracts: a, main: o } = r(), { locale: i } = ve(), { data: c } = De(
    xe.ContractTypeList({ type: t, locale: i }),
    (l) => l.Contract.contractTypeList({ type: t, locale: i || "" })
  );
  return Y(() => {
    if (!c)
      return;
    const l = c.filter((u) => u.value === n);
    if (!l.length)
      return;
    const [d] = l;
    s({
      ...d,
      prices: l.map(({ currency: u, price: m, priceInclVat: f }) => ({
        currency: u,
        price: m,
        priceInclVat: f
      }))
    });
  }, [c, n]), { contracts: a, main: o };
}
const hd = ({
  children: t,
  onSubmit: n,
  continueLabel: r,
  editLabel: s,
  submitLabel: a,
  push: o
}) => {
  const { visibleChildren: i, handleSubmit: c, setLabels: l, activeStep: d } = Oa({
    onSubmit: n,
    children: t
  }), u = qe("");
  return Y(() => {
    l(r, a, s);
  }, [r, s, l, a]), Y(() => {
    (async () => {
      i.length !== 1 && u.current !== d && (o && await o(`#${d}`), u.current = d);
    })();
  }, [d, o, i.length]), /* @__PURE__ */ e.jsx(ne, { as: "form", onSubmit: c, children: i });
}, gd = ({ total: t, contract: n, ns: r }) => {
  const { t: s } = V([r, "common"], { nsMode: "fallback" }), a = vs(mu.getActiveStep), o = vs(yo.getAvailableSteps), i = vs(yo.getSkippedSteps), c = K(() => o.findIndex(
    (u) => u.namespace === a
  ), [a, o]), l = K(() => o.map((d, u) => ({
    ...d,
    active: u <= c && !i.some((m) => m.step === d.namespace) && d.completed || u >= c && !i.some((m) => m.step === d.namespace) && d.completed || c === u,
    completed: d.completed
  })), [c, o, i]);
  return /* @__PURE__ */ e.jsxs(nt.Root, { as: "aside", className: "sticky top-[10vh] ml-auto max-w-[350px]", children: [
    /* @__PURE__ */ e.jsx(nt.Header, { className: "bg-primary-800", children: /* @__PURE__ */ e.jsx(
      M,
      {
        intent: "title",
        size: "lg",
        color: "white",
        as: "h3",
        className: "pb-1 pt-3 text-center",
        children: n ? /* @__PURE__ */ e.jsx(he, { ns: r, i18nKey: "form.sections.progress.title", children: /* @__PURE__ */ e.jsx(at, { contract: "oresundPay" }) }) : null
      }
    ) }),
    /* @__PURE__ */ e.jsxs(nt.Content, { children: [
      /* @__PURE__ */ e.jsx(M, { as: "h4", className: "sr-only", id: "form-progress-title", children: s("form.sections.progress.stepsTitle") }),
      /* @__PURE__ */ e.jsx(Rr.Root, { "aria-labelledby": "form-progress-title", children: l.map(
        ({ namespace: d, titleTranslationKey: u, active: m, completed: f }, p) => /* @__PURE__ */ e.jsx(
          Rr.Item,
          {
            nr: p + 1,
            active: m,
            completed: f,
            children: m ? /* @__PURE__ */ e.jsx(
              ne,
              {
                as: "a",
                href: `#${d}`,
                "aria-current": a === d ? "page" : void 0,
                children: s(u)
              }
            ) : s(u)
          },
          d
        )
      ) })
    ] }),
    /* @__PURE__ */ e.jsxs(nt.Footer, { className: "border-t", children: [
      /* @__PURE__ */ e.jsx(M, { intent: "title", size: "sm", as: "h4", children: s("form.sections.progress.orderTitle") }),
      /* @__PURE__ */ e.jsxs(ne, { as: "ol", children: [
        /* @__PURE__ */ e.jsxs(ne, { as: "li", className: "mt-4 flex justify-between", children: [
          /* @__PURE__ */ e.jsx(M, { className: "text-primary-800", children: /* @__PURE__ */ e.jsx(at, { contract: "oresundPay" }) }),
          /* @__PURE__ */ e.jsx(M, { className: "text-primary-800", children: n.value })
        ] }),
        /* @__PURE__ */ e.jsxs(ne, { as: "li", className: "mt-4 flex justify-between border-t pt-4", children: [
          /* @__PURE__ */ e.jsx(M, { children: t.label }),
          /* @__PURE__ */ e.jsx(M, { children: t.value })
        ] })
      ] })
    ] })
  ] });
}, Fj = ({
  namespace: t,
  title: n,
  currencyOptions: r,
  labels: s,
  onValidate: a,
  defaultValues: o,
  helpText: i,
  contracts: c,
  total: l,
  placeholders: d
}) => {
  const [u, m] = He(
    t,
    "agreement",
    "campaignCode",
    "currency"
  ), f = K(
    () => ({
      ...o,
      currency: m || (o == null ? void 0 : o.currency)
    }),
    [m, o]
  ), { stepNr: p, registerField: b, validate: h, isValid: g, isActive: v } = Se({
    namespace: t,
    title: n,
    onValidate: a,
    defaultValues: f
  }), y = K(() => u === "true", [u]);
  return /* @__PURE__ */ e.jsxs(Vt, { title: n, nr: p, id: t, children: [
    /* @__PURE__ */ e.jsx(
      Oe,
      {
        ...b("currency"),
        className: "col-span-full sm:col-span-4 md:col-span-6",
        label: s.currency,
        placeholder: d.currency,
        options: r,
        disabled: !v
      }
    ),
    /* @__PURE__ */ e.jsxs(ne, { className: "col-span-full mb-6 mt-8", children: [
      /* @__PURE__ */ e.jsx(M, { intent: "title", className: "mb-3", children: s.yourOrder }),
      /* @__PURE__ */ e.jsx(M, { intent: "label", size: "sm", children: s.contract }),
      /* @__PURE__ */ e.jsxs(ne, { as: "ul", children: [
        c.map(({ label: x, value: j }, w) => /* @__PURE__ */ e.jsxs(ne, { as: "li", className: "my-3 flex flex-row justify-between", children: [
          /* @__PURE__ */ e.jsx(M, { children: /* @__PURE__ */ e.jsx(at, { contract: x }) }),
          /* @__PURE__ */ e.jsx(M, { children: j })
        ] }, w)),
        /* @__PURE__ */ e.jsxs(
          ne,
          {
            as: "li",
            className: "border-primary-400 flex flex-row justify-between border-t-2 py-3",
            children: [
              /* @__PURE__ */ e.jsx(M, { children: s.total }),
              /* @__PURE__ */ e.jsx(M, { children: l })
            ]
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ e.jsx(
      me,
      {
        ...b("agreement", { type: "checkbox", value: "true" }),
        className: "col-span-full",
        label: s.agreement,
        required: !0,
        disabled: !v
      }
    ),
    /* @__PURE__ */ e.jsx(M, { size: "sm", className: "col-span-full", children: i }),
    /* @__PURE__ */ e.jsx(
      kn,
      {
        loadingLabel: s.loading,
        namespace: t,
        onClick: h(),
        disabled: !v || !g || !y
      }
    )
  ] });
}, Xi = (t, n, r) => {
  const s = t.find((o) => o.currency === n);
  return ss(
    (s == null ? void 0 : s.priceInclVat) || 0,
    r,
    n
  );
}, xd = ({ namespace: t, titleTranslationKey: n, contractType: r, ns: s }) => {
  const { locale: a } = ve(), { t: o } = V(s, {
    nsMode: "fallback"
  }), { getContracts: i } = Yn(), { contracts: c, main: l } = i(), [d] = He("termsOfAgreement", "currency"), u = K(
    () => d || tn(a || ""),
    [d, a]
  ), m = K(() => c.map((p) => {
    const b = Ga(p.value), h = Xi(p.prices, u, a);
    return {
      value: o("price.yearly", {
        price: h || ""
      }),
      label: b ?? "",
      discount: !1
    };
  }) ?? [], [c, a, u, o]);
  return /* @__PURE__ */ e.jsx(
    Fj,
    {
      namespace: t,
      title: o(n),
      defaultValues: { currency: tn(a || "") },
      contracts: m,
      total: o("price.yearly", {
        price: Xi(l.prices, u, a)
      }),
      labels: {
        loading: o("action.loading"),
        campaignCode: o("action.campaignCode"),
        agreement: o("form.labels.termsOfAgreement"),
        currency: o("form.labels.currency"),
        total: o("signup.total"),
        yourOrder: o("form.sections.termsOfAgreement.subTitle"),
        contract: o("form.labels.contract")
      },
      placeholders: {
        currency: o("form.placeholders.currency")
      },
      currencyOptions: [
        { label: "SEK", value: "SEK" },
        { label: "DKK", value: "DKK" }
      ],
      helpText: /* @__PURE__ */ e.jsx(os, { type: r }),
      onValidate: Hn(Su.spa)
    }
  );
}, Bj = () => {
  const { locale: t } = ve(), { main: n } = pd("private", pe.OresundPAY), r = ["privateSignUp", "businessSignUp", "common"], { t: s } = V(r, {
    nsMode: "fallback"
  }), { push: a, asPath: o } = ve(), i = (u) => {
    const m = {
      ...u,
      isSBF: "false",
      contactInformation: {
        ...u.contactInformation,
        phoneCode: bn(u.contactInformation.phoneCode)
      },
      contractType: n.value,
      payment: {
        paymentEntries: (u.payment.paymentEntries || []).filter(
          (f) => !nd(f)
        )
      },
      subscribeToClub: {},
      paymentAgreement: {
        ...u.paymentAgreement,
        oresundsPay: "true"
      }
    };
    sd(m), io();
  }, [c] = He("termsOfAgreement", "currency"), l = K(
    () => c || tn(t || ""),
    [c, t]
  ), d = Q(
    (u) => a(`${o.split("#")[0]}${u}`, void 0, {
      scroll: !1,
      shallow: !0
    }),
    [a, o]
  );
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(M, { intent: "label", className: "col-span-full mb-8", children: s("form.requiredFields") }),
    /* @__PURE__ */ e.jsx(ne, { className: "col-span-full md:col-span-8", children: /* @__PURE__ */ e.jsxs(
      hd,
      {
        onSubmit: i,
        continueLabel: s("action.continue"),
        submitLabel: s("action.pay"),
        editLabel: s("action.edit"),
        push: d,
        children: [
          /* @__PURE__ */ e.jsx(
            _j,
            {
              namespace: "contactInformation",
              ns: r,
              titleTranslationKey: "form.sections.contactInformation.title"
            }
          ),
          /* @__PURE__ */ e.jsx(
            rd,
            {
              namespace: "codeVerification",
              ns: r,
              titleTranslationKey: "form.sections.codeVerification.title",
              isBusiness: !1
            }
          ),
          /* @__PURE__ */ e.jsx(
            $j,
            {
              namespace: "payment",
              titleTranslationKey: "form.sections.payment.title",
              ns: r
            }
          ),
          /* @__PURE__ */ e.jsx(
            xd,
            {
              namespace: "termsOfAgreement",
              titleTranslationKey: "form.sections.termsOfAgreement.title",
              ns: r,
              contractType: pe.OresundPAY
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ e.jsx(ne, { className: "relative hidden md:col-span-4 md:col-start-9 md:block", children: /* @__PURE__ */ e.jsx(
      gd,
      {
        total: {
          label: s("signup.total"),
          value: s("price.yearly", {
            price: `0,00 ${l}`
          })
        },
        contract: {
          label: n.value,
          value: s("price.yearly", {
            price: `0,00 ${l}`
          })
        },
        ns: "privateSignUp"
      }
    ) })
  ] });
}, bd = () => {
  const { t } = V(["error", "common"], {
    nsMode: "fallback"
  });
  return /* @__PURE__ */ e.jsxs(ne, { className: "col-span-full flex flex-col items-center gap-4 pb-8", children: [
    /* @__PURE__ */ e.jsx(Ta, { className: "text-6xl text-red-400" }),
    /* @__PURE__ */ e.jsx(M, { intent: "headline", className: "text-center", children: t("internalError.title") }),
    /* @__PURE__ */ e.jsx(M, { intent: "body", className: "text-center", children: t("internalError.description") })
  ] });
}, Vj = (t, n) => t ? n ? /* @__PURE__ */ e.jsx(qr, { ns: "privateSignUp" }) : /* @__PURE__ */ e.jsx(ld, { ns: "privateSignUp" }) : null, qj = (t, n) => t && !n ? /* @__PURE__ */ e.jsx(id, {}) : null, yC = () => {
  const { error: t, resp: n, isPasswordSet: r, payWithCreditCard: s } = wt(), { reset: a } = Yn(), { query: o } = ve(), i = o.complete === "1", { setBannerVisible: c } = Da(), l = K(() => {
    if (i)
      return c(!1), /* @__PURE__ */ e.jsx(qr, { ns: "privateSignUp" });
    if (t)
      return /* @__PURE__ */ e.jsx(bd, {});
    const d = qj(s, n);
    if (d)
      return d;
    const u = Vj(n, r);
    return u || (c(!1), /* @__PURE__ */ e.jsx(Bj, {}));
  }, [t, s, n, r, i]);
  return Y(
    () => () => {
      od(), a();
    },
    []
  ), /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(zt, { children: /* @__PURE__ */ e.jsx(ht, { className: "md:gap-x-20", children: l }) }),
    /* @__PURE__ */ e.jsx(
      eo,
      {
        strategy: "lazyOnload",
        src: "https://checkout.reepay.com/checkout.js"
      }
    )
  ] });
}, Wj = gt.fromProp()("paymentMethod"), Hj = gt.fromProp()(
  "invoice"
), Uj = gt.fromProp()("ignoreEvaluation"), Gj = Wj.modify((t) => (t == null ? void 0 : t.method) === "invoice" ? (Hj.modify(Uj.set("true")), {
  ...t,
  invoice: {
    ...t.invoice,
    ignoreEvaluation: "true"
  }
}) : t), Kj = (t) => {
  ro(t) && Bn(t);
}, Yj = (t) => oo(t), Qj = ({ status: t }) => {
  const { reload: n } = ve(), [r, s] = L(!1), { mutateAsync: a } = ke(
    ["signup"],
    (d) => d.Customer.signup,
    {
      onError: Kj,
      onSuccess: Yj,
      onSettled: () => s(!1)
    }
  ), { t: o } = V(["businessSignUp", "common"], {
    nsMode: "fallback"
  }), { data: i } = wt(), c = Q(async () => {
    if (!i) {
      Bn({ code: 500, error: "no signup data initialized" });
      return;
    }
    const d = Gj(i);
    s(!0), await a(d);
  }, [i, a]), l = Q(() => {
    io(), Bn(void 0);
  }, []);
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      M,
      {
        className: "col-span-full row-start-1 sm:col-span-6 sm:col-start-2 md:col-start-4",
        as: "h1",
        intent: "headline",
        children: o(t === kr ? "form.sections.creditEvaluation.yellow.title" : "form.sections.creditEvaluation.red.title")
      }
    ),
    /* @__PURE__ */ e.jsx(ne, { className: "col-span-full row-start-2 sm:col-span-6 sm:col-start-2 md:col-start-4", children: /* @__PURE__ */ e.jsx(
      he,
      {
        ns: "businessSignUp",
        i18nKey: t === kr ? "form.sections.creditEvaluation.yellow.description" : "form.sections.creditEvaluation.red.description",
        children: /* @__PURE__ */ e.jsx(M, { gutter: !0 })
      }
    ) }),
    /* @__PURE__ */ e.jsxs(ne, { className: "col-span-full row-start-3 flex flex-col sm:col-span-6 sm:col-start-2 sm:flex-row-reverse sm:justify-end md:col-start-4", children: [
      t === kr ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx(
          et,
          {
            isLoading: r,
            loadingLabel: o("action.loading"),
            onClick: c,
            className: "ml-auto mr-auto sm:ml-0 sm:mr-0",
            children: o("action.continueEvaluation")
          }
        ),
        /* @__PURE__ */ e.jsx(
          be,
          {
            onClick: l,
            intent: "outlined",
            className: "ml-auto mr-auto mt-4 sm:mr-8 sm:mt-0",
            children: o("action.payWithCard")
          }
        )
      ] }) : null,
      t === Nc ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
        /* @__PURE__ */ e.jsx(
          be,
          {
            onClick: l,
            className: "ml-auto mr-auto sm:ml-0 sm:mr-0",
            children: o("action.payWithCard")
          }
        ),
        /* @__PURE__ */ e.jsx(
          be,
          {
            onClick: () => n(),
            color: "negative",
            className: "ml-auto mr-auto mt-4 sm:mr-8 sm:mt-0",
            children: o("action.cancel")
          }
        )
      ] }) : null
    ] })
  ] });
}, Xj = ({
  namespace: t,
  defaultValues: n,
  labels: r,
  countryOptions: s,
  phoneCodeOptions: a,
  placeholders: o,
  disableNameChange: i
}) => {
  const { registerField: c, getError: l, isActive: d } = Se({
    namespace: t,
    defaultValues: n
  }), [u] = He(t, "country");
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(
      me,
      {
        className: "col-span-full",
        ...c("companyName"),
        label: r.companyName,
        error: l("companyName"),
        disabled: i || !d,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      Oe,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...c("country"),
        label: r.country,
        options: s.map((m) => ({ ...m, label: m.key })),
        placeholder: o.country,
        error: l("country"),
        disabled: !d,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      me,
      {
        className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7",
        ...c("vatno"),
        label: r.vatno,
        error: l("vatno"),
        disabled: i || !d,
        required: !0
      }
    ),
    u === "DK" ? /* @__PURE__ */ e.jsx(
      me,
      {
        className: "col-span-full",
        ...c("ean"),
        label: r.ean,
        error: l("ean"),
        disabled: !d
      }
    ) : null,
    /* @__PURE__ */ e.jsx(
      me,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...c("zipCode"),
        label: r.zipCode,
        error: l("zipCode"),
        disabled: !d,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      me,
      {
        className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7",
        ...c("city"),
        label: r.city,
        error: l("city"),
        disabled: !d,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      me,
      {
        className: "col-span-full",
        ...c("address"),
        label: r.address,
        error: l("address"),
        disabled: !d,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      Oe,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...c("phoneCode"),
        label: r.phoneCode,
        options: a.map((m, f) => ({
          value: Na(m.value, f),
          label: m.key
        })),
        placeholder: o.phoneCode,
        error: l("phoneCode"),
        disabled: !d,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      me,
      {
        className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7",
        ...c("phone"),
        label: r.phone,
        error: l("phone"),
        disabled: !d,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(M, { className: "col-span-full mt-16", children: r.contactPersonLabel }),
    /* @__PURE__ */ e.jsx(
      me,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...c("contact.firstName"),
        label: r.contact.firstName,
        error: l("contact.firstName"),
        disabled: !d,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      me,
      {
        className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7",
        ...c("contact.lastName"),
        label: r.contact.lastName,
        error: l("contact.lastName"),
        disabled: !d,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      me,
      {
        className: "col-span-full",
        ...c("contact.email"),
        label: r.contact.email,
        error: l("contact.email"),
        disabled: !d,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      Oe,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...c("contact.phoneCode"),
        label: r.contact.phoneCode,
        options: a.map((m, f) => ({
          value: Na(m.value, f),
          label: m.key
        })),
        placeholder: o.phoneCode,
        error: l("contact.phoneCode"),
        disabled: !d,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      me,
      {
        className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7",
        ...c("contact.phone"),
        label: r.contact.phone,
        error: l("contact.phone"),
        disabled: !d,
        required: !0
      }
    )
  ] });
}, Jj = ({
  labels: t,
  namespace: n,
  title: r,
  defaultValues: s,
  countryOptions: a = [],
  phoneCodeOptions: o = [],
  onValidate: i,
  placeholders: c,
  commuter: l,
  vatnoExist: d,
  disclaimers: u
}) => {
  const {
    registerField: m,
    getError: f,
    validate: p,
    isValid: b,
    isActive: h,
    stepNr: g,
    resetFieldError: v
  } = Se({
    namespace: n,
    title: r,
    defaultValues: s,
    onValidate: i
  }), [y] = He(n, "bypassVatno");
  Y(() => {
    y !== "true" && v("vatno");
  }, [y, v]);
  const x = Kn(), j = !!(x != null && x.get("showPendlareStartDate"));
  return /* @__PURE__ */ e.jsxs(Vt, { nr: g, title: r, id: n, children: [
    /* @__PURE__ */ e.jsx(
      Xj,
      {
        namespace: n,
        labels: t,
        countryOptions: a,
        phoneCodeOptions: o,
        placeholders: c
      }
    ),
    l ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(M, { className: "col-span-full mt-16", children: t.commuterLabel }),
      /* @__PURE__ */ e.jsx(
        me,
        {
          className: "col-span-full sm:col-span-4 md:col-span-6",
          ...m("commuter.firstName"),
          label: t.commuter.firstName,
          error: f("commuter.firstName"),
          disabled: !h,
          required: !0
        }
      ),
      /* @__PURE__ */ e.jsx(
        me,
        {
          className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7",
          ...m("commuter.lastName"),
          label: t.commuter.lastName,
          error: f("commuter.lastName"),
          disabled: !h,
          required: !0
        }
      ),
      /* @__PURE__ */ e.jsx(
        me,
        {
          className: "col-span-full sm:col-span-4 md:col-span-6",
          ...m("commuter.email"),
          label: t.commuter.email,
          error: f("commuter.email"),
          disabled: !h,
          required: !0
        }
      ),
      j ? /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsx(
        me,
        {
          className: "col-span-full sm:col-span-4 md:col-span-6",
          ...m("commuter.startDate", { type: "date" }),
          label: t.commuter.startDate,
          error: f("commuter.startDate"),
          disabled: !h,
          required: !0
        }
      ) }) : null
    ] }) : null,
    d && !l ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(Le, { className: "col-span-full", children: u.vatno }),
      /* @__PURE__ */ e.jsx(
        me,
        {
          className: "col-span-full",
          ...m("bypassVatno", {
            type: "checkbox",
            value: "true"
          }),
          label: t.bypassVatno,
          disabled: !h
        }
      )
    ] }) : null,
    d && l ? /* @__PURE__ */ e.jsx(Le, { className: "col-span-full", children: u.vatnoCommuter }) : null,
    /* @__PURE__ */ e.jsx(
      kn,
      {
        loadingLabel: t.loading,
        namespace: n,
        onClick: p(),
        disabled: !h || !b
      }
    )
  ] });
}, Wr = Tn(), vd = Tn(), Zj = Wr("country", "phoneCode", "phone"), e0 = Wr("vatno"), t0 = vd("email"), n0 = (t) => {
  const n = Wr("contact")(t), r = n == null ? void 0 : n.contact;
  if (r) {
    const { phoneCode: s, phone: a } = vd("phoneCode", "phone")(r), o = Wr("country")(t);
    return { phoneCode: s, phone: a, ...o };
  }
}, r0 = ({
  namespace: t,
  titleTranslationKey: n,
  ns: r
}) => {
  const s = ud(), a = dd(), o = $t(), i = md(), { locale: c } = ve(), [l, d] = L(!1), u = cd(), { t: m } = V(r, {
    nsMode: "fallback"
  }), f = Q(
    (x) => async (j) => {
      if (j && St("phone")(j)) {
        const w = Zj(x);
        return await s({
          phone: m("form.validations.phone.invalid")
        })(w);
      }
    },
    [m, s]
  ), p = Q(
    (x) => async (j) => {
      if (j && St("contact.phone")(j)) {
        const w = n0(x);
        if (w)
          return await s({
            "contact.phone": m("form.validations.phone.invalid")
          })(w);
      }
    },
    [s, m]
  ), b = Q(
    (x) => async (j) => {
      if (j && St("contact.phone")(j)) {
        const w = e0(x);
        if (w) {
          const C = w.vatno ? m("form.validations.vatno.exist") : void 0, P = await a(() => ({
            vatno: C
          }))(w);
          if (w.vatno ? d(!0) : d(!1), P)
            return {
              ...P,
              vatno: x.bypassVatno === "true" ? void 0 : P.vatno
            };
        }
      }
    },
    [a, m]
  ), h = Q(
    async (x) => {
      const j = await rn(
        Tu.spa,
        m
      )(x);
      return await cs(
        async (R) => await f(x)(R),
        async (R) => await p(x)(R),
        async (R) => await b(x)(R)
      )(j);
    },
    [m, f, b]
  ), g = Q(
    (x) => async (j) => {
      const w = t0(x.contact), P = await u((R) => ({
        email: !R.success && St("email")(j) ? m("form.validations.email.exist") : void 0
      }))(w), N = Object.values(P);
      for (const R of N)
        if (R)
          return P;
    },
    [u, m]
  ), v = Q(
    async (x) => {
      const j = await h(x);
      return j || await g(x)();
    },
    [h, g]
  ), y = i.find(
    (x) => x.country === dn(c || "")
  );
  return /* @__PURE__ */ e.jsx(
    Jj,
    {
      namespace: t,
      title: m(n),
      defaultValues: {
        country: dn(c || ""),
        phoneCode: y == null ? void 0 : y.value,
        contact: {
          phoneCode: y == null ? void 0 : y.value
        },
        commuter: {}
      },
      vatnoExist: l,
      labels: {
        companyName: m("form.labels.companyName"),
        vatno: m("form.labels.vatno"),
        ean: m("form.labels.ean"),
        city: m("form.labels.city"),
        address: m("form.labels.address"),
        zipCode: m("form.labels.zipCode"),
        phone: m("form.labels.phone"),
        phoneCode: m("form.labels.phoneCode"),
        country: m("form.labels.country"),
        contact: {
          firstName: m("form.labels.firstName"),
          lastName: m("form.labels.lastName"),
          phoneCode: m("form.labels.phoneCode"),
          email: m("form.labels.email"),
          phone: m("form.labels.phone")
        },
        commuter: {
          email: m("form.labels.email"),
          firstName: m("form.labels.firstName"),
          lastName: m("form.labels.lastName"),
          startDate: m("form.labels.startDate")
        },
        commuterLabel: m("form.labels.commuter"),
        contactPersonLabel: m("form.labels.contactPerson"),
        loading: m("action.loading"),
        bypassVatno: m("form.labels.bypassVatno")
      },
      disclaimers: {
        vatno: /* @__PURE__ */ e.jsx(
          he,
          {
            i18nKey: "form.sections.contactInformation.disclaimers.vatno",
            ns: r,
            children: /* @__PURE__ */ e.jsx(M, {})
          }
        ),
        vatnoCommuter: /* @__PURE__ */ e.jsx(
          he,
          {
            i18nKey: "form.sections.contactInformation.disclaimers.vatnoCommuter",
            ns: r,
            children: /* @__PURE__ */ e.jsx(M, {})
          }
        )
      },
      placeholders: {
        country: m("form.placeholders.country"),
        phoneCode: m("form.placeholders.phoneCode")
      },
      countryOptions: o,
      phoneCodeOptions: i,
      onValidate: v
    }
  );
}, s0 = {
  paymentOptions: "licensePlate",
  weightClass: "false"
}, a0 = ({
  labels: t,
  countryOptions: n = [],
  bvSupportCountries: r,
  weightClassOptions: s = [],
  fuelTypeOptions: a = [],
  emissionClassOptions: o = [],
  onAdd: i,
  onValidate: c,
  onCancel: l,
  displayCancel: d,
  placeholders: u,
  disableForm: m,
  defaultValues: f,
  vehicleColors: p
}) => {
  const b = K(
    () => ({ ...s0, ...f }),
    [f]
  ), h = "alpr", {
    registerField: g,
    getError: v,
    getData: y,
    validate: x,
    isValid: j,
    isDirty: w,
    transformData: C,
    resetSelectedData: P,
    setPartialData: N,
    resetFieldErrors: R,
    setFieldErrors: T
  } = Se({
    namespace: h,
    onValidate: c,
    defaultValues: b
  }), [z, D] = He(
    h,
    "country",
    "licensePlate"
  ), [A, S] = L(), [_, $] = L(), [q, U] = L(), {
    data: W,
    error: G,
    isFetching: ee
  } = Jr(A), ue = Pn();
  Y(() => $(G), [G]), Y(() => $(null), [D]), Y(() => U(W), [W]), Y(() => U(void 0), [D, z]), Y(() => S(void 0), [z]);
  const ce = Q(() => {
    P([
      "make",
      "model",
      "color",
      "weightClass",
      "hybrid",
      "fuelType",
      "emissionClass"
    ]);
  }, [P]), re = Q(() => {
    ce(), R(), S(void 0);
  }, [R, ce]);
  Y(() => re, [z, re]), Y(
    () => wc(
      q,
      N,
      re,
      o
    ),
    [q, N, re]
  );
  const se = Q(async () => {
    if (await x()())
      i(y());
    else
      return;
  }, [x, y, i]), H = Q(
    async (O) => {
      const ae = z;
      if (!ae || !O) {
        S({ licensePlate: O, country: ae });
        return;
      }
      try {
        if (await ue({
          licensePlate: t.licensePlateExist
        })({
          licensePlate: O,
          country: ae
        }))
          S({ licensePlate: O, country: ae });
        else
          throw new Error("Validation failed");
      } catch (ge) {
        T(ge), ce();
      }
    },
    [
      S,
      z,
      ue,
      t,
      T,
      ce
    ]
  );
  return Y(() => {
    hr(
      pr(D),
      z
    ) && H(D);
  }, [D, z, H]), /* @__PURE__ */ e.jsx(nt.Root, { className: "col-span-full", children: /* @__PURE__ */ e.jsx(nt.Content, { children: /* @__PURE__ */ e.jsxs(ht, { children: [
    /* @__PURE__ */ e.jsx(
      me,
      {
        ...g("alprName"),
        label: t.alprName,
        className: "col-span-full sm:col-span-4 md:col-span-12",
        error: v("alprName"),
        disabled: m
      }
    ),
    /* @__PURE__ */ e.jsx(
      Oe,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...g("country"),
        label: t.country,
        options: n.map((O) => ({
          label: O.key,
          value: O.value,
          key: O.value
        })),
        placeholder: u.country,
        error: v("country"),
        disabled: m,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      me,
      {
        ...g("licensePlate"),
        label: t.licensePlate,
        className: "col-span-full sm:col-start-5 md:col-span-6 md:col-start-7",
        error: v("licensePlate"),
        disabled: m,
        required: !0
      }
    ),
    _ ? /* @__PURE__ */ e.jsx(ne, { className: "col-span-full bg-white", children: /* @__PURE__ */ e.jsx(Le, { className: "col-span-full mb-2", children: t.noVehicleInfo }) }) : null,
    /* @__PURE__ */ e.jsx(ne, { className: "col-span-full", children: /* @__PURE__ */ e.jsx(M, { as: "h6", size: "lg", className: "mb-0", children: t.volVehicleInfo }) }),
    /* @__PURE__ */ e.jsx(
      me,
      {
        ...g("make"),
        label: t.make,
        className: "col-span-full sm:col-span-4 md:col-span-6",
        error: v("make"),
        disabled: m || !!(q != null && q.make)
      }
    ),
    /* @__PURE__ */ e.jsx(
      me,
      {
        ...g("model"),
        label: t.model,
        className: "col-span-full sm:col-span-4 md:col-span-6",
        error: v("model"),
        disabled: m || !!(q != null && q.model)
      }
    ),
    /* @__PURE__ */ e.jsx(
      Oe,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...g("color"),
        label: t.color,
        options: p,
        placeholderDisabled: !1,
        placeholder: u.color,
        error: v("color"),
        disabled: m || !!(q != null && q.color)
      }
    ),
    /* @__PURE__ */ e.jsx(
      Oe,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...g("weightClass"),
        label: t.weightClass,
        options: s,
        placeholder: u.weightClass,
        error: v("weightClass"),
        placeholderDisabled: !1,
        disabled: m || (q == null ? void 0 : q.isHGV) !== void 0,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      Oe,
      {
        className: "col-span-full sm:col-start-5 md:col-span-6",
        ...g("fuelType"),
        label: t.fuelType,
        options: a,
        placeholder: u.fuelType,
        placeholderDisabled: !1,
        error: v("fuelType"),
        disabled: m || !!(q != null && q.fuelType)
      }
    ),
    /* @__PURE__ */ e.jsx(
      Oe,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...g("emissionClass"),
        label: t.emissionClass,
        options: o,
        error: v("emissionClass"),
        placeholderDisabled: !1,
        placeholder: u.emissionClass,
        disabled: m || !!(q != null && q.euroEmissionNorm)
      }
    ),
    /* @__PURE__ */ e.jsx(
      me,
      {
        ...g("hybrid", {
          type: "checkbox",
          value: "true"
        }),
        label: t.hybrid,
        className: "col-span-full sm:col-start-5 md:col-span-6",
        error: v("hybrid"),
        disabled: m || (q == null ? void 0 : q.isHybrid) !== void 0
      }
    ),
    /* @__PURE__ */ e.jsx(
      me,
      {
        name: "orderBizz",
        type: "checkbox",
        value: "true",
        label: t.orderBizz,
        className: "col-span-full sm:col-start-5 md:col-span-6",
        onChange: (O) => {
          const ae = O.target.checked;
          C(ae ? (ge) => ({
            ...ge,
            paymentOptions: "bizz"
          }) : (ge) => ({
            ...ge,
            paymentOptions: "licensePlate"
          }));
        },
        disabled: m
      }
    ),
    /* @__PURE__ */ e.jsxs(ne, { className: "col-span-full mt-2 flex justify-end", children: [
      d ? /* @__PURE__ */ e.jsx(
        be,
        {
          intent: "text",
          onClick: l,
          className: "mr-auto",
          disabled: m,
          children: t.cancel
        }
      ) : null,
      /* @__PURE__ */ e.jsx(
        be,
        {
          intent: "outlined",
          onClick: se,
          disabled: !j || !w || m || ee,
          className: "ml-auto",
          children: t.add
        }
      )
    ] })
  ] }) }) });
}, o0 = {
  paymentEntries: []
}, i0 = ({
  title: t,
  namespace: n,
  description: r,
  labels: s,
  countryOptions: a,
  bvSupportCountries: o,
  weightClassOptions: i,
  emissionClassOptions: c,
  fuelTypeOptions: l,
  maxEntries: d,
  onAlprValidation: u,
  onValidate: m,
  useOnOtherPlacesDisclaimer: f,
  placeholders: p,
  defaultCountry: b,
  maxEntriesDisclaimer: h,
  skipAlprDisclaimer: g,
  vehicleColors: v
}) => {
  const [y, x] = L(""), { stepNr: j, getData: w, validate: C, isValid: P, isActive: N, transformData: R } = Se({
    namespace: n,
    title: t,
    defaultValues: o0,
    onValidate: m
  }), T = w().paymentEntries || [], [z, D] = L(() => T.length === 0), [A, S] = L(0), _ = Q(
    (U) => {
      R((W) => ({
        paymentEntries: (() => {
          const G = W.paymentEntries || [];
          return G.splice(A, 1, U), G;
        })()
      })), D(!1);
    },
    // eslint-disable-next-line
    [D, A]
  ), $ = Q(
    (U) => R((W) => {
      const ee = [...W.paymentEntries || []];
      return ee.splice(U, 1), ee.length === 0 && D(!0), {
        paymentEntries: ee.length ? ee : W.paymentEntries
      };
    }),
    // eslint-disable-next-line
    [D]
  ), q = Q(() => {
    S((U) => U + 1), D(!0);
  }, [S, D]);
  return /* @__PURE__ */ e.jsxs(Vt, { nr: j, title: t, id: n, children: [
    /* @__PURE__ */ e.jsx(ne, { className: "col-span-full", children: r }),
    T.map((U, W) => /* @__PURE__ */ e.jsx(
      fd,
      {
        labels: s,
        ...U,
        onRemove: () => $(W),
        disabled: !N
      },
      W
    )),
    z ? /* @__PURE__ */ e.jsx(zt, { children: /* @__PURE__ */ e.jsx(
      a0,
      {
        onValidate: u,
        labels: s,
        onCancel: () => D(!1),
        countryOptions: a,
        bvSupportCountries: o,
        weightClassOptions: i,
        emissionClassOptions: c,
        fuelTypeOptions: l,
        onAdd: _,
        displayCancel: T.length > 0,
        useOnOtherPlacesDisclaimer: f,
        placeholders: p,
        disableForm: !N || y === "true",
        defaultValues: { country: b },
        vehicleColors: v
      }
    ) }) : null,
    T.length + 1 <= d && !z ? /* @__PURE__ */ e.jsx(
      be,
      {
        startIcon: /* @__PURE__ */ e.jsx(cn, {}),
        intent: "text",
        onClick: q,
        disabled: !N,
        className: "w-fit",
        children: s.addMore
      }
    ) : null,
    T.length >= d ? /* @__PURE__ */ e.jsx(Le, { className: "col-span-full", children: h }) : null,
    z && /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
      /* @__PURE__ */ e.jsx(
        me,
        {
          className: "col-span-full",
          type: "checkbox",
          name: "skip-entries",
          value: "true",
          disabled: !N || T.length > 0,
          checked: y === "true",
          onChange: () => x((U) => U === "true" ? "false" : "true"),
          label: s.skipAlpr
        }
      ),
      y === "true" ? /* @__PURE__ */ e.jsx(Le, { className: "col-span-full ", children: /* @__PURE__ */ e.jsx(M, { size: "sm", children: g }) }) : null
    ] }),
    /* @__PURE__ */ e.jsx(
      kn,
      {
        loadingLabel: s.loading,
        namespace: n,
        onClick: C(),
        disabled: (!N || !P || !T.length || z) && y !== "true"
      }
    )
  ] });
}, l0 = Tn()("licensePlate", "country"), Ji = gt.fromNullableProp()("paymentEntries", []), c0 = (t) => t.find((n) => n.weightClass === "true"), d0 = ({
  namespace: t,
  titleTranslationKey: n,
  ns: r
}) => {
  const s = Zr(), a = vl(), o = At(), i = Pn(), { discountMainContract: c, removeDiscountMainContract: l, getContracts: d } = Yn(), { t: u } = V(r, {
    nsMode: "fallback"
  }), { getData: m } = Se({
    namespace: t,
    title: u(n)
  }), f = Q(
    (v) => async (y) => {
      if (y && !St("licensePlate")(y))
        return;
      const x = l0(v);
      if (!(!x.country || !x.licensePlate))
        return await i({
          licensePlate: u("form.validations.licensePlate.exist")
        })(x);
    },
    [u, i]
  ), p = Q(
    (v) => () => {
      if (Ji.get(m()).some((j) => j.licensePlate === v.licensePlate))
        return { licensePlate: u("form.validations.licensePlate.unique") };
    },
    [m, u]
  ), b = Q(
    async (v) => {
      const y = await rn(ul.spa, u)(v);
      return await cs(
        async () => p(v)(),
        async (C) => f(v)(C)
      )(y);
    },
    [f, u, p]
  );
  Y(() => {
    const v = Ji.get(m());
    c0(v) ? c({
      currency: d().main.prices[0].currency,
      price: 0,
      contractType: d().main.value,
      productCode: "",
      priceInclVAT: 0
    }) : l();
  }, [m]);
  const h = ds.map((v) => ({
    label: u(`vehicleColors.${v}`),
    value: v
  })), g = {
    namespace: t,
    title: u(n),
    description: /* @__PURE__ */ e.jsxs(he, { i18nKey: "form.sections.payment.description", ns: r, children: [
      /* @__PURE__ */ e.jsx(M, { className: "mb-4" }),
      /* @__PURE__ */ e.jsx(M, { size: "sm" })
    ] }),
    maxEntriesDisclaimer: /* @__PURE__ */ e.jsx(
      he,
      {
        i18nKey: "form.sections.payment.disclaimers.numberOfEntries",
        ns: r,
        children: /* @__PURE__ */ e.jsx(M, { as: "span", weight: "medium" })
      }
    ),
    skipAlprDisclaimer: u("form.sections.payment.disclaimers.skipAlpr"),
    onAlprValidation: b,
    countryOptions: a.flatMap((v) => v.children).map(({ key: v, value: y }) => ({ key: v, value: y })),
    bvSupportCountries: s,
    maxEntries: 2,
    commuter: !1,
    labels: {
      skipAlpr: u("form.labels.skipAlpr"),
      licensePlate: u("form.labels.licensePlate"),
      country: u("form.labels.country"),
      fuelType: u("form.labels.fuelType"),
      emissionClass: u("form.labels.emissionClass"),
      weightClass: u("form.labels.weightClass"),
      useInNorway: u("form.labels.useInNorway"),
      add: u("form.labels.add"),
      hybrid: u("form.labels.hybrid"),
      addMore: u("form.labels.addMore"),
      cancel: u("action.cancel"),
      remove: u("action.remove"),
      loading: u("action.loading"),
      orderBizz: u("form.labels.orderBizz"),
      bizzOrdered: u("form.sections.payment.disclaimers.bizzOrdered"),
      bizz: u("form.labels.bizz"),
      vehicleSearch: u("action.search"),
      make: u("form.labels.make"),
      model: u("form.labels.model"),
      color: u("form.labels.color"),
      alprName: u("form.labels.alprName"),
      volVehicleInfo: u("form.labels.vlinfo"),
      noVehicleInfo: u("form.validations.licensePlate.notfound"),
      licensePlateExist: u("form.validations.licensePlate.exist"),
      loadingSearch: u("action.loading"),
      // Not used
      isSBF: ""
    },
    placeholders: {
      weightClass: u("form.placeholders.weightClass"),
      country: u("form.placeholders.country"),
      emissionClass: u("form.placeholders.emissionClass"),
      fuelType: u("form.placeholders.fuelType"),
      color: u("form.placeholders.color")
    },
    useOnOtherPlacesDisclaimer: u(
      "form.sections.payment.disclaimers.useInNorway"
    ),
    fuelTypeOptions: o.fuelTypes,
    weightClassOptions: [
      { label: u("weightClasses.light"), value: "false" },
      { label: u("weightClasses.heavy"), value: "true" }
    ],
    emissionClassOptions: o.emissionClasses,
    vehicleColors: h
  };
  return /* @__PURE__ */ e.jsx(i0, { ...g });
}, u0 = ({ namespace: t, labels: n, countryOptions: r = [], placeholders: s }) => {
  const { registerField: a, getError: o, isActive: i } = Se({ namespace: t });
  return /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(M, { intent: "title", className: "col-span-full mt-2", children: n.paperInvoiceTitle }),
    /* @__PURE__ */ e.jsx(M, { intent: "label", size: "sm", className: "col-span-full", children: n.requiredFields }),
    /* @__PURE__ */ e.jsx(
      me,
      {
        className: "col-span-full",
        ...a("invoice.attentionName"),
        error: o("invoice.attentionName"),
        label: n.attentionName,
        required: !0,
        disabled: !i
      }
    ),
    /* @__PURE__ */ e.jsx(
      Oe,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...a("invoice.country"),
        label: n.country,
        options: r.map((c) => ({ ...c, label: c.key })),
        placeholder: s.country,
        error: o("invoice.country"),
        disabled: !i,
        required: !0
      }
    ),
    /* @__PURE__ */ e.jsx(
      me,
      {
        className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7",
        ...a("invoice.address"),
        label: n.address,
        error: o("invoice.address"),
        required: !0,
        disabled: !i
      }
    ),
    /* @__PURE__ */ e.jsx(
      me,
      {
        className: "col-span-full sm:col-span-4 md:col-span-6",
        ...a("invoice.zipCode"),
        error: o("invoice.zipCode"),
        label: n.zipCode,
        required: !0,
        disabled: !i
      }
    ),
    /* @__PURE__ */ e.jsx(
      me,
      {
        className: "col-span-full sm:col-span-4 sm:col-start-5 md:col-span-6 md:col-start-7",
        ...a("invoice.city"),
        error: o("invoice.city"),
        label: n.city,
        required: !0,
        disabled: !i
      }
    )
  ] });
}, m0 = ({ labels: t, namespace: n, countryOptions: r, placeholders: s, disclaimers: a }) => {
  const { locale: o } = ve(), { registerField: i, getError: c, isActive: l } = Se({
    namespace: n
  }), { transformData: d } = Se({
    namespace: "termsOfAgreement"
  }), [u, m] = He(
    n,
    "invoice.sendToEmail",
    "invoice.displayInEuro"
  ), f = K(() => u === "true" ? /* @__PURE__ */ e.jsx(
    me,
    {
      ...i("invoice.email"),
      className: "col-span-full sm:col-span-4 md:col-span-6",
      type: "email",
      error: c("invoice.email"),
      required: !0,
      label: t.email
    }
  ) : u === "false" ? /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(Le, { className: "col-span-full", children: /* @__PURE__ */ e.jsx(M, { size: "sm", children: a.paper }) }),
    /* @__PURE__ */ e.jsx(
      u0,
      {
        namespace: n,
        labels: t,
        countryOptions: r,
        placeholders: s
      }
    )
  ] }) : null, [
    t,
    i,
    u,
    n,
    r,
    s,
    c,
    a
  ]);
  return Y(() => {
    d(m === "true" ? (p) => ({ ...p, currency: "DKK" }) : (p) => ({
      ...p,
      currency: tn(o || "")
    }));
  }, [m, o]), /* @__PURE__ */ e.jsxs(ht, { children: [
    /* @__PURE__ */ e.jsx(Le, { className: "col-span-full", children: /* @__PURE__ */ e.jsx(M, { size: "sm", children: a.invoice }) }),
    /* @__PURE__ */ e.jsxs(
      Rt.Root,
      {
        ...i("invoice.sendToEmail"),
        label: t.invoiceDelivery,
        required: !0,
        className: "col-span-full",
        children: [
          /* @__PURE__ */ e.jsx(
            Rt.Item,
            {
              label: t.sendToEmail.true,
              value: "true",
              disabled: !l
            }
          ),
          /* @__PURE__ */ e.jsx(
            Rt.Item,
            {
              label: t.sendToEmail.false,
              value: "false",
              disabled: !l
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ e.jsx(
      me,
      {
        className: "col-span-full",
        ...i("invoice.displayInEuro", {
          type: "checkbox",
          value: "true"
        }),
        label: t.displayInEuro,
        error: c("invoice.displayInEuro"),
        disabled: !l
      }
    ),
    f
  ] });
}, f0 = ({
  namespace: t,
  title: n,
  defaultValues: r,
  onValidate: s,
  labels: a,
  description: o,
  countryOptions: i,
  placeholders: c,
  disclaimers: l
}) => {
  const { registerField: d, getError: u, isActive: m, isValid: f, validate: p, stepNr: b } = Se({ namespace: t, title: n, defaultValues: r, onValidate: s }), [h] = He(t, "method");
  return /* @__PURE__ */ e.jsxs(Vt, { nr: b, title: n, id: t, children: [
    /* @__PURE__ */ e.jsx(M, { className: "col-span-full", children: o }),
    /* @__PURE__ */ e.jsxs(
      bs.Root,
      {
        ...d("method"),
        className: "col-span-full",
        direction: "col",
        label: a.chooseMethod,
        required: !0,
        children: [
          /* @__PURE__ */ e.jsx(
            bs.Expander,
            {
              label: a.method.card,
              value: "card",
              transparent: !0,
              disabled: !m
            }
          ),
          /* @__PURE__ */ e.jsx(
            bs.Expander,
            {
              label: a.method.invoice,
              value: "invoice",
              disabled: !m,
              children: /* @__PURE__ */ e.jsx(nt.Root, { className: "mt-4", children: /* @__PURE__ */ e.jsx(nt.Content, { children: /* @__PURE__ */ e.jsx(
                m0,
                {
                  labels: a,
                  namespace: t,
                  countryOptions: i,
                  placeholders: c,
                  disclaimers: l
                }
              ) }) })
            }
          )
        ]
      }
    ),
    u("method") !== void 0 ? /* @__PURE__ */ e.jsx(Le, { className: "col-span-full", color: "negative", children: u("method") }) : null,
    /* @__PURE__ */ e.jsx(
      kn,
      {
        loadingLabel: a.loading,
        namespace: t,
        onClick: p(),
        disabled: !m || !f || !h
      }
    )
  ] });
}, p0 = ({
  namespace: t,
  titleTranslationKey: n,
  ns: r
}) => {
  const s = $t(), { t: a } = V(r, {
    nsMode: "fallback"
  }), [o, i, c, l] = He(
    "contactInformation",
    "address",
    "country",
    "city",
    "zipCode"
  ), d = K(
    () => ({
      address: o,
      country: i,
      city: c,
      zipCode: l,
      sendToEmail: "true",
      displayInEuro: ""
    }),
    [o, i, c, l]
  );
  return /* @__PURE__ */ e.jsx(
    f0,
    {
      namespace: t,
      title: a(n),
      description: a("form.sections.paymentMethod.description"),
      defaultValues: {
        invoice: d
      },
      labels: {
        address: a("form.labels.address"),
        email: a("form.labels.email"),
        city: a("form.labels.city"),
        method: {
          invoice: a("form.labels.invoice"),
          card: a("form.labels.card")
        },
        country: a("form.labels.country"),
        attentionName: a("form.labels.attentionName"),
        zipCode: a("form.labels.zipCode"),
        useInvoiceAddress: a("form.labels.useInvoiceAddress"),
        displayInEuro: a("form.labels.displayInEuro"),
        sendToEmail: {
          true: a("form.labels.sendByEmail"),
          false: a("form.labels.sendByMail")
        },
        loading: a("action.loading"),
        requiredFields: a("form.requiredFields"),
        chooseMethod: a("form.labels.chooseMethod"),
        invoiceDelivery: a("form.labels.invoiceDelivery"),
        paperInvoiceTitle: a("form.sections.paymentMethod.paperInvoiceTitle")
      },
      countryOptions: s,
      disclaimers: {
        invoice: /* @__PURE__ */ e.jsx(
          he,
          {
            i18nKey: "form.sections.paymentMethod.disclaimers.invoice",
            ns: r,
            children: /* @__PURE__ */ e.jsx(M, { as: "span", weight: "medium", size: "sm" })
          }
        ),
        paper: a("form.sections.paymentMethod.disclaimers.paper")
      },
      placeholders: {
        country: a("form.placeholders.country")
      },
      onValidate: async (u) => {
        if (u.method !== "invoice")
          return;
        const m = await Hn(Eu.spa)(u.invoice);
        return m ? Object.entries(
          m
        ).reduce(
          (p, [b, h]) => ({
            ...p,
            [`invoice.${b}`]: h
          }),
          {}
        ) : void 0;
      }
    }
  );
}, h0 = (t) => {
  if (ro(t))
    Bn(t);
  else
    return {};
}, g0 = () => {
  const [t, n] = L(!1), { locale: r } = ve(), { setBannerVisible: s } = Da(), { main: a } = pd("business", pe.OresundPAYBusiness), { push: o, asPath: i } = ve(), { mutateAsync: c } = ke(
    ["signup"],
    (y) => y.Customer.signup,
    {
      onMutate: () => {
        n(!0), s(!1);
      },
      onSuccess: (y) => {
        oo(y), ad(y.code);
      },
      onError: h0
    }
  ), l = ["businessSignUp", "common"], { t: d } = V(l, {
    nsMode: "fallback"
  }), u = Q((y) => {
    if (!y)
      return y;
    const x = y.contactInformation, j = {
      ...x,
      phoneCode: bn(x.phoneCode),
      contact: {
        ...x.contact,
        phoneCode: bn(x.contact.phoneCode)
      }
    };
    return {
      ...y,
      contactInformation: {
        ...j,
        bypassVatno: x.bypassVatno === !0 ? "true" : x.bypassVatno === !1 ? "false" : void 0
      }
    };
  }, []), m = (y) => {
    const x = {
      ...y,
      contractType: a.value,
      payment: {
        paymentEntries: (y.payment.paymentEntries || []).filter(
          (w) => !nd(w)
        )
      },
      paymentMethod: !y.paymentMethod || Object.keys(y.paymentMethod).length === 0 ? void 0 : y.paymentMethod
    };
    return (async (w) => {
      var N;
      const C = {
        ...w,
        subscribeToClub: {},
        paymentAgreement: { oresundsPay: "true" }
      }, P = u(C);
      if (sd(P), ((N = w.paymentMethod) == null ? void 0 : N.method) === "card")
        io();
      else {
        const R = await c(u(C));
        let T = {
          email: "",
          firstName: "",
          lastName: "",
          phone: "",
          phoneCode: ""
        };
        w.contactInformation.contact ? T = w.contactInformation.contact : T = w.contactInformation, Ua(), Ha(
          {
            transaction_id: R.orderNo,
            value: f(
              a.prices,
              w.termsOfAgreement.currency
            ),
            currency: w.termsOfAgreement.currency,
            coupon: void 0,
            items: [
              {
                item_name: p(a.value),
                item_category: "Business",
                item_variant: "OperatorSignup",
                quantity: "1",
                price: b(a.prices, w.termsOfAgreement.currency)
              }
            ]
          },
          {
            email: T.email,
            firstName: T.firstName,
            lastName: T.lastName,
            phone: `+${w.contactInformation.phoneCode}${w.contactInformation.phone}`,
            city: w.contactInformation.city,
            address1: w.contactInformation.address,
            zipCode: w.contactInformation.zipCode,
            company: w.contactInformation.companyName ?? "",
            country: w.contactInformation.country
          }
        );
      }
    })(x);
  }, f = (y, x) => y.filter((j) => j.currency === x).reduce((j, w) => j + w.price, 0).toString(), p = (y) => {
    switch (y) {
      case "OresundPAYBusiness":
      case "OresundPAY":
        return "OresundPay";
      default:
        return "";
    }
  }, b = (y, x) => {
    const j = y.find((w) => w.currency === x);
    return j ? `${j.price}` : "";
  }, [h] = He("termsOfAgreement", "currency"), g = K(
    () => h || tn(r || ""),
    [h, r]
  ), v = Q(
    (y) => o(`${i.split("#")[0]}${y}`, void 0, {
      scroll: !1,
      shallow: !0
    }),
    [o, i]
  );
  return t ? /* @__PURE__ */ e.jsx(ne, { className: "item-center col-span-full flex h-[600px] items-center justify-center text-5xl md:col-span-6 md:col-start-4", children: /* @__PURE__ */ e.jsx(Ur, { label: d("action.loading") }) }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(M, { intent: "label", className: "col-span-full mb-8", children: d("form.requiredFields") }),
    /* @__PURE__ */ e.jsx(ne, { className: "col-span-full md:col-span-8 ", children: /* @__PURE__ */ e.jsxs(
      hd,
      {
        onSubmit: m,
        continueLabel: d("action.continue"),
        submitLabel: d("action.pay"),
        editLabel: d("action.edit"),
        push: v,
        children: [
          /* @__PURE__ */ e.jsx(
            r0,
            {
              namespace: "contactInformation",
              titleTranslationKey: "form.sections.contactInformation.title",
              ns: l
            }
          ),
          /* @__PURE__ */ e.jsx(
            rd,
            {
              namespace: "codeVerification",
              ns: l,
              titleTranslationKey: "form.sections.codeVerification.title",
              isBusiness: !0
            }
          ),
          /* @__PURE__ */ e.jsx(
            d0,
            {
              namespace: "payment",
              titleTranslationKey: "form.sections.payment.title",
              ns: l
            }
          ),
          /* @__PURE__ */ e.jsx(
            p0,
            {
              namespace: "paymentMethod",
              titleTranslationKey: "form.sections.paymentMethod.title",
              ns: l
            }
          ),
          /* @__PURE__ */ e.jsx(
            xd,
            {
              namespace: "termsOfAgreement",
              titleTranslationKey: "form.sections.termsOfAgreement.title",
              contractType: pe.OresundPAYBusiness,
              ns: l
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ e.jsx(ne, { className: "hidden md:col-span-4 md:col-start-9 md:block", children: /* @__PURE__ */ e.jsx(
      gd,
      {
        total: {
          label: d("signup.total"),
          value: d("price.yearly", {
            price: (() => {
              const x = (a.prices || []).find(
                (j) => j.currency === g
              );
              return x ? ss(
                x.price || 0,
                r,
                g
              ) : "";
            })()
          })
        },
        contract: {
          label: a.value,
          value: d("price.yearly", {
            price: `0,00 ${g}`
          })
        },
        ns: "businessSignUp"
      }
    ) })
  ] });
}, jC = () => {
  const { error: t, resp: n, isPasswordSet: r, payWithCreditCard: s } = wt(), { reset: a } = Yn(), { query: o } = ve(), { setBannerVisible: i } = Da(), c = o.complete === "1", l = K(() => {
    if (c)
      return i(!1), /* @__PURE__ */ e.jsx(qr, { ns: "privateSignUp" });
    if (t) {
      const d = t.error && kg(t.error) ? /* @__PURE__ */ e.jsx(Qj, { status: t.error }) : /* @__PURE__ */ e.jsx(bd, {});
      if (d) return d;
    }
    return s && !n ? /* @__PURE__ */ e.jsx(id, {}) : n ? r ? /* @__PURE__ */ e.jsx(qr, { ns: "businessSignUp" }) : /* @__PURE__ */ e.jsx(ld, { ns: "businessSignUp" }) : (i(!1), /* @__PURE__ */ e.jsx(g0, {}));
  }, [t, n, r, s]);
  return Y(
    () => () => {
      od(), a();
    },
    []
  ), /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
    /* @__PURE__ */ e.jsx(zt, { children: /* @__PURE__ */ e.jsx(ht, { className: "md:gap-x-20", children: l }) }),
    /* @__PURE__ */ e.jsx(
      eo,
      {
        strategy: "lazyOnload",
        src: "https://checkout.reepay.com/checkout.js"
      }
    )
  ] });
};
function x0() {
  const { data: t, isLoading: n } = De(
    xe.BizzStatuses(),
    ({ Recognitions: r }) => r.bizzStatuses(),
    { keepPreviousData: !0 }
  );
  return {
    data: t,
    isLoading: n
  };
}
const b0 = 20, yd = ({
  actions: t,
  productType: n,
  pageType: r,
  hideCommuter: s = !0,
  shouldTriggerModal: a = !0
}) => {
  var q;
  const [o, i] = L(""), { t: c } = V(["account", "common", "recognitions"], {
    nsMode: "fallback"
  }), { data: l } = x0(), [d, u] = L([]), [m, f] = L([]), [p, b] = L(!1), [h, g] = L(null), {
    query: { contract: v }
  } = ve(), { data: y } = bt(), x = (q = y == null ? void 0 : y.paymentAgreement) != null && q.provider ? jn(y.paymentAgreement.provider) : !0, j = () => {
    b(!1);
  }, w = () => {
    h && h(), b(!1);
  }, { recognitions: C, totalRecognitions: P, loading: N, page: R, pages: T, setPage: z } = $a(b0, {
    searchText: o,
    status: d,
    agreements: v ? [v] : m,
    productType: n
  }), D = (U) => {
    U !== o && (i(U), z(1));
  }, A = o !== "" || d.length > 0 || m.length > 0, S = (l == null ? void 0 : l.map(({ label: U, value: W }) => ({
    value: W,
    label: c(`kmtoll.landing.bizzList.bizzStatus.${U}`)
  }))) || [], _ = $m(
    N,
    C.length,
    A,
    r
  ), $ = (U) => {
    switch (U) {
      case "loading":
        return /* @__PURE__ */ e.jsx("div", { className: "flex items-center justify-center", children: /* @__PURE__ */ e.jsx(Wn, {}) });
      case "newBizz":
        return /* @__PURE__ */ e.jsx(oi, { mode: "newBizz", pageType: r });
      case "emptyBizzList":
        return /* @__PURE__ */ e.jsx(oi, { mode: "emptyBizzList", pageType: r });
      case "displayBizzList":
        return /* @__PURE__ */ e.jsx(
          Kf,
          {
            recognitions: C,
            currentPage: R,
            totalPages: T,
            setPage: z
          }
        );
    }
  };
  return /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsxs("div", { className: "bg rounded-xl ", children: [
    (_ === "displayBizzList" || _ === "emptyBizzList") && /* @__PURE__ */ e.jsxs("div", { children: [
      l && /* @__PURE__ */ e.jsx(
        Va,
        {
          hits: P,
          labelKey: "recognitions.label",
          hideCommuter: s,
          search: {
            query: o,
            setSearch: D,
            labelKey: "action.search",
            descriptionKey: "form.labels.searchDescription"
          },
          setAgreements: f,
          otherFilters: [
            {
              labelKey: "form.labels.filterOrderStatus",
              multiSelect: !0,
              options: S,
              setValue: u,
              mode: "bizzStatus"
            }
          ]
        }
      ),
      /* @__PURE__ */ e.jsxs("div", { className: "mb-2 mt-6 flex flex-col items-end justify-end sm:mb-2 sm:mt-4 md:flex-row md:justify-end", children: [
        !x && (t == null ? void 0 : t.map((U) => /* @__PURE__ */ e.jsx(
          be,
          {
            startIcon: U.icon,
            type: "button",
            intent: "text",
            className: "font-medium underline",
            onClick: () => {
              var W;
              a ? (b(!0), g(() => U.action || null)) : (W = U.action) == null || W.call(U);
            },
            children: c(U.labelKey)
          },
          U.labelKey
        ))),
        a && /* @__PURE__ */ e.jsx(
          Jl,
          {
            isOpen: p,
            onClose: j,
            onContinue: w
          }
        ),
        /* @__PURE__ */ e.jsx(Df, { activeAgreements: m })
      ] })
    ] }),
    $(_)
  ] }) });
}, jd = kt(
  void 0
), Cd = ({
  children: t,
  value: n
}) => /* @__PURE__ */ e.jsx(jd.Provider, { value: n, children: t }), v0 = () => {
  const t = pt(jd);
  if (t === void 0)
    throw new Error("useRecognition must be used within a RecognitionProvider");
  return t;
}, y0 = ({ oldPlate: t, newPlate: n }) => {
  const { t: r } = V("account");
  return /* @__PURE__ */ e.jsxs("div", { className: "mt-16", children: [
    /* @__PURE__ */ e.jsx("h1", { className: "mb-2 text-2xl font-medium", children: r("singleOrderBizzFlow.vehicleChangeSummary.title") }),
    /* @__PURE__ */ e.jsxs("div", { className: "flex flex-wrap items-center gap-4", children: [
      /* @__PURE__ */ e.jsxs("div", { className: "rounded bg-red-50 p-8", children: [
        /* @__PURE__ */ e.jsx("p", { className: "text-sm", children: r("singleOrderBizzFlow.vehicleChangeSummary.oldPlateHeader") }),
        /* @__PURE__ */ e.jsx("p", { className: "text-sm font-bold", children: t })
      ] }),
      /* @__PURE__ */ e.jsx(iu, { className: "h-8 w-8" }),
      /* @__PURE__ */ e.jsxs("div", { className: "rounded bg-green-50 p-8", children: [
        /* @__PURE__ */ e.jsx("p", { className: "text-sm", children: r("singleOrderBizzFlow.vehicleChangeSummary.newPlateHeader") }),
        /* @__PURE__ */ e.jsx("p", { className: "text-sm font-bold", children: n })
      ] })
    ] })
  ] });
}, j0 = ({
  customerInformation: t
}) => {
  const { t: n } = V(["common", "account"], {
    nsMode: "fallback"
  }), r = ve(), { locale: s } = r, [a, o] = L(null), [i, c] = L(!0), { setVerifyContactDetailsDate: l } = Cl();
  Y(() => {
    o({
      phone: t && "phone" in t ? t.phone : "",
      email: (t == null ? void 0 : t.email) || "",
      address: t && "address" in t ? t.address : ""
    });
  }, [t]);
  const d = async (m) => {
    c(!1), m ? await l() : r.push(`/${s}/account/customerInformation?modal=edit`);
  }, u = a ? /* @__PURE__ */ e.jsx(e.Fragment, { children: /* @__PURE__ */ e.jsxs("address", { className: "text-type-secondary not-italic leading-loose", children: [
    /* @__PURE__ */ e.jsxs("p", { children: [
      /* @__PURE__ */ e.jsxs("span", { className: "font-semibold", children: [
        n("form.labels.phone"),
        ": "
      ] }),
      a.phone
    ] }),
    /* @__PURE__ */ e.jsxs("p", { children: [
      /* @__PURE__ */ e.jsxs("span", { className: "font-semibold", children: [
        n("form.labels.email"),
        ": "
      ] }),
      a.email
    ] }),
    /* @__PURE__ */ e.jsxs("p", { children: [
      /* @__PURE__ */ e.jsxs("span", { className: "font-semibold", children: [
        n("form.labels.address"),
        ": "
      ] }),
      a.address
    ] })
  ] }) }) : (
    // Skeleton loader
    /* @__PURE__ */ e.jsxs("div", { className: "text-type-secondary flex animate-pulse flex-col gap-[18px]", children: [
      /* @__PURE__ */ e.jsx("div", { className: "h-5 w-1/2 rounded bg-gray-200" }),
      /* @__PURE__ */ e.jsx("div", { className: "h-5 w-2/5 rounded bg-gray-200" }),
      /* @__PURE__ */ e.jsx("div", { className: "h-5 w-3/4 rounded bg-gray-200" })
    ] })
  );
  return /* @__PURE__ */ e.jsx(
    Xl,
    {
      cancelText: n("confirmContactDetails.buttons.update"),
      confirmText: n("confirmContactDetails.buttons.confirm"),
      content: u,
      confirmColor: "primary",
      title: n("confirmContactDetails.title"),
      onAction: d,
      open: i
    }
  );
}, CC = () => {
  const { contactDetailsNeedsValidation: t } = Cl(), { customerInformation: n } = tt({ suspense: !1 }), r = (n == null ? void 0 : n.customerType) === In.privateCustomer;
  return t && r ? /* @__PURE__ */ e.jsx(j0, { customerInformation: n }) : null;
};
export {
  Ja as AgreementCardTitle,
  ya as AgreementDetails,
  df as AgreementFilter,
  Uh as AgreementView,
  lC as Agreements,
  eC as AppCommonProvider,
  jl as BannerContext,
  J0 as BannerVisibilityProvider,
  yd as BizzList,
  vC as BizzOrder,
  bC as BizzOrderLanding,
  mC as BusinessCommuters,
  Xj as BusinessContactInformationCommonFields,
  jC as BusinessSignUp,
  Q0 as Button,
  vn as Checkbox,
  rd as CodeVerification,
  Zy as CodeVerificationResponseBanner,
  Wg as CommuterList,
  dC as CorporateGroupSideMenu,
  uC as DebitCard,
  X0 as DemoButton,
  Z0 as DemoWelcome,
  Yy as EditForm,
  Va as FiltersComponent,
  rt as InputField,
  iC as Invoices,
  La as LoadingScreen,
  Wn as LoadingSpinner,
  Ia as MultiSelect,
  un as NextApp,
  Qr as NextRouterContext,
  Hy as OrderForm,
  Sj as PrivateContactInformationFields,
  yC as PrivateSignUp,
  Ky as ProgressBar,
  gC as RecognitionLanding,
  Cd as RecognitionListContextProvider,
  wl as SearchInput,
  mt as Select,
  Sc as Toast,
  xC as TollCollect,
  td as TollCollectComponent,
  he as Trans,
  za as TranslationContext,
  tC as TripsView,
  st as UserFeedback,
  y0 as VehicleChangeSummary,
  Zt as VerificationCodeResponseStatus,
  CC as VerifyContactDetails,
  xi as acceptReplaceBizz,
  Qy as businessPhoneCode,
  Xy as businessPrivatePhoneCode,
  gl as byCountryLocale,
  hl as byPromotedCountries,
  xl as byString,
  bi as choiceReplaceBizz,
  ta as clickReplaceBizz,
  $f as confirmReplaceBizz,
  cC as convertContractToContractListItem,
  $p as createAvailableSBF,
  fC as createText,
  Zh as filterCommuters,
  tg as filterPaymentType,
  eg as filterProviders,
  ng as formatAgreementOption,
  rr as formatPrice,
  pa as getBridgeLinks,
  Ga as getContractTranslationKey,
  ua as getDateOrToday,
  dn as getDefaultCountry,
  tn as getDefaultCurrency,
  rg as getFilteredAgreementOptions,
  ln as getLink,
  nx as getLocale,
  Ip as getPeriodCardStatus,
  hC as getRedirectPath,
  bf as getRequiredFields,
  pC as isBvSupportCountry,
  nd as isEntryEmpty,
  Lp as isInvoicePaymentType,
  rm as isServer,
  gp as links,
  nC as pageView,
  Tn as pick,
  Jy as privatePhoneCode,
  Ha as purchase,
  Oc as removeQueryParam,
  gc as renderBanner,
  Ua as resetPurchase,
  pr as sanitizeLicenseplate,
  sC as sendContactForm,
  aC as sendCorporateForm,
  oC as sendOpenClubVoucherModal,
  If as subscribeToNewsLetterOnPurchase,
  ss as toCurrency,
  Gm as toDateTime,
  Km as toSafeTime,
  Wt as translationMap,
  bt as useAgreementGroup,
  Ma as useAgreementGroupList,
  Da as useBannerVisibility,
  hn as useContractNo,
  og as useCorporateGroup,
  $t as useCountries,
  Zr as useCountriesBvSupport,
  vl as useCountriesOptGroups,
  im as useCountryName,
  tt as useCustomerInformation,
  At as useEmissionClasses,
  lm as useInvoiceStatuses,
  Xr as usePaymentAgreementList,
  ur as usePeriodCard,
  Ra as usePeriodCardByContract,
  v0 as useRecognitionListContext,
  V as useTranslation,
  Pn as useValidateAlpr,
  Jr as useVehicleInformation,
  Cl as useVerifyContactDetailsDate,
  yl as useWindowSize,
  Hn as validate,
  hr as validateLicenseplateFormat,
  rn as validateT,
  ds as veColorList,
  rC as webMetric
};
